
export default [
  {
    "id": 1,
    "shikenId": 1,
    "no": 1,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "ファイナンシャル・プランナー（以下「FP」という）の顧客に対する行為に関する次の記述のうち、職業倫理や関連法規に照らし、最も適切なものはどれか。(2023.01)",
    "choice1": "顧客から住宅ローンについて相談を受けたFPのAさんは、顧客から預かった給与所得の源泉徴収票のコピーを、顧客に紹介する予定の不動産会社の担当者に顧客の同意を得ないまま渡した。",
    "choice2": "顧客から外貨預金での資金運用について相談を受けたFPのBさんは、円安ドル高がこの先ずっと続くため、円預金の大半をドル預金に移すべきだとアドバイスをした。",
    "choice3": "顧客から老後に受け取ることができる年金について相談を受けたFPのCさんは、社会保険労務士の資格を有していないものの、顧客の「ねんきん定期便」に記載されている年金見込額を用いて、繰り下げた場合の年金受給額を試算した。",
    "choice4": "顧客から所得税の確定申告について相談を受けたFPのDさんは、税理士の資格を有していないものの、顧客の要望に応じて確定申告書の作成を代行した。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "FPと関連法規",
    "important": ""
  },
  {
    "id": 2,
    "shikenId": 1,
    "no": 2,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "ライフプランニングにおける各種係数を用いた必要額の算出に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、算出に当たっては下記＜資料＞の係数を乗算で使用し、手数料や税金等については考慮しないものとする。(2024.01)<br> <br> ・Aさんが60歳から65歳になるまでの5年間、年率2％で複利運用しながら、毎年200万円を受け取る場合、60歳時点の元金として（ア）が必要となる。<br> ・Bさんが45歳から毎年一定額を積み立てながら年率2％で複利運用し、15年後の60歳時に1,000万円を準備する場合、毎年の積立金額は（イ）となる。<br><img src='/img/1_2.jpg'/>",
    "choice1": "（ア）9,057,000円　（イ）578,000円",
    "choice2": "（ア）9,057,000円　（イ）778,000円",
    "choice3": "（ア）9,427,000円　（イ）578,000円",
    "choice4": "（ア）9,427,000円　（イ）778,000円",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "各種係数",
    "important": ""
  },
  {
    "id": 3,
    "shikenId": 1,
    "no": 3,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "公的医療保険に関する次の記述のうち、最も適切なものはどれか。(2024.09)",
    "choice1": "退職により健康保険の被保険者資格を喪失した者が、その資格を喪失した際に傷病手当金の支給を受けている場合、資格喪失日の前日まで継続して2ヵ月以上の被保険者期間があれば、傷病手当金の支給期間を限度として、退職後も引き続きその支給を受けることができる。",
    "choice2": "健康保険の任意継続被保険者に係る保険料は、その全額を任意継続被保険者が負担する。",
    "choice3": "健康保険や国民健康保険の被保険者が70歳に達すると、原則として、その被保険者資格を喪失し、後期高齢者医療制度の被保険者となる。",
    "choice4": "後期高齢者医療制度の被保険者が保険医療機関等の窓口で支払う一部負担金（自己負担額）の割合は、当該被保険者の所得金額の多寡にかかわらず、1割とされている。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的医療保険",
    "important": ""
  },
  {
    "id": 4,
    "shikenId": 1,
    "no": 4,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "雇用保険の育児休業給付および介護休業給付に関する次の記述のうち、最も不適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。(2023.05)",
    "choice1": "育児休業給付金は、子が1歳に達した日後の期間について休業することが特に必要と認められる場合、最長で子が1歳2ヵ月に達する日の前日まで支給される。",
    "choice2": "育児休業給付金に係る支給単位期間において支払われた賃金額が、休業開始時賃金日額に支給日数を乗じて得た額の80％相当額以上である場合、当該支給単位期間について育児休業給付金は支給されない。",
    "choice3": "被保険者が、一定の状態にある家族を介護するための休業をした場合、同一の対象家族について、通算3回かつ93日の介護休業を限度として、介護休業給付金が支給される。",
    "choice4": "複数の被保険者が、同一の対象家族について同時に介護休業を取得した場合、それぞれの被保険者に介護休業給付金が支給される。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "雇用保険",
    "important": ""
  },
  {
    "id": 5,
    "shikenId": 1,
    "no": 5,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "公的年金に関する次の記述のうち、最も適切なものはどれか。(2022.05)",
    "choice1": "国民年金の第1号被保険者は、日本国内に住所を有する20歳以上60歳未満の自営業者や学生などのうち、日本国籍を有する者のみが該当する。",
    "choice2": "老齢厚生年金の受給権者が老齢厚生年金の繰下げ支給の申出をする場合、老齢基礎年金の繰下げ支給の申出を同時に行わなければならない。",
    "choice3": "老齢厚生年金の額に加給年金額が加算されるためには、原則として、厚生年金保険の被保険者期間が10年以上であり、かつ、その受給権者によって生計を維持されている一定の要件を満たす配偶者または子がいる必要がある。",
    "choice4": "産前産後休業を取得している厚生年金保険の被保険者の厚生年金保険料は、所定の手続きにより、被保険者負担分と事業主負担分がいずれも免除される。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的年金に関する記述",
    "important": ""
  },
  {
    "id": 6,
    "shikenId": 1,
    "no": 6,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "国民年金基金、小規模企業共済および中小企業退職金共済に関する次の記述のうち、最も適切なものはどれか。(2023.05)",
    "choice1": "国民年金基金の加入員が死亡以外の事由で加入員資格を喪失した場合、それまでの加入期間に応じた解約返戻金が支払われる。",
    "choice2": "小規模企業共済の掛金月額は、5,000円から10万円までの範囲内で、500円単位で選択することができる。",
    "choice3": "中小企業退職金共済の掛金は、事業主と被共済者の合意に基づき、事業主と被共済者が折半して負担することができる。",
    "choice4": "中小企業退職金共済の被共済者が退職後3年以内に、中小企業退職金共済の退職金を請求せずに再就職して再び被共済者となった場合、所定の要件を満たせば、前の企業での掛金納付月数を再就職した企業での掛金納付月数と通算することができる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "国民年金基金等",
    "important": ""
  },
  {
    "id": 7,
    "shikenId": 1,
    "no": 7,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "遺族厚生年金に関する次の記述のうち、最も不適切なものはどれか。(2022.05)",
    "choice1": "厚生年金保険の被保険者が死亡したことにより支給される遺族厚生年金の額は、死亡した者の厚生年金保険の被保険者期間が300月未満の場合、300月とみなして計算する。",
    "choice2": "遺族厚生年金の額（中高齢寡婦加算額および経過的寡婦加算額を除く）は、原則として、死亡した者の厚生年金保険の被保険者記録を基に計算された老齢厚生年金の報酬比例部分の3分の2相当額である。",
    "choice3": "厚生年金保険の被保険者である夫が死亡し、夫の死亡当時に子のいない40歳以上65歳未満の妻が遺族厚生年金の受給権を取得した場合、妻が65歳に達するまでの間、妻に支給される遺族厚生年金には中高齢寡婦加算額が加算される。",
    "choice4": "配偶者が死亡したことにより遺族厚生年金の受給権を取得した65歳以上の受給権者について、その受給権者が受給することができる老齢厚生年金の額が当該遺族厚生年金の額を上回る場合、当該遺族厚生年金の全部が支給停止される。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "遺族厚生年金",
    "important": ""
  },
  {
    "id": 8,
    "shikenId": 1,
    "no": 8,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "リタイアメントプランニング等に関する次の記述のうち、最も不適切なものはどれか。(2023.09)",
    "choice1": "金融機関のリバースモーゲージには、一般に、利用者が死亡し、担保物件の売却代金により借入金を返済した後も債務が残った場合に、利用者の相続人がその返済義務を負う「リコース型」と、返済義務を負わない「ノンリコース型」がある。",
    "choice2": "高齢者の居住の安定確保に関する法律に定める「サービス付き高齢者向け住宅」に入居した者は、「状況把握サービス」や「生活相談サービス」を受けることができる。",
    "choice3": "将来、本人の判断能力が不十分になった場合に備えて、あらかじめ本人が選任した者と締結する任意後見契約は、公正証書によらない場合であっても有効である。",
    "choice4": "確定拠出年金の加入者が、老齢給付金を60歳から受給するためには、通算加入者等期間が10年以上なければならない。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "リタイアメントプランニング",
    "important": ""
  },
  {
    "id": 9,
    "shikenId": 1,
    "no": 9,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "住宅ローンの一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。(2024.05)",
    "choice1": "固定金利選択型の住宅ローンでは、一般に、固定金利期間終了後に適用される金利について、変動金利または固定金利のいずれかを選択することができる。",
    "choice2": "住宅ローンの返済方式では、借入額や返済期間等の他の条件が同一であれば、元金均等返済方式よりも元利均等返済方式の方が総返済額は多い。",
    "choice3": "住宅ローンの一部繰上げ返済では、繰上げ返済額や金利等の他の条件が同一であれば、毎回の返済額を変えずに返済期間を短縮する返済期間短縮型よりも返済期間を変えずに毎回の返済額を少なくする返済額軽減型の方が支払利息の軽減効果は大きい。",
    "choice4": "住宅ローンの借換えに際して、現在借入れをしている金融機関の抵当権を抹消し、借換先の金融機関の抵当権を新たに設定する場合、登録免許税等の諸費用が必要となる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "住宅ローンの一般的な特徴",
    "important": ""
  },
  {
    "id": 10,
    "shikenId": 1,
    "no": 10,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "決算書に基づく経営分析指標に関する次の記述のうち、最も適切なものはどれか。(2022.05)",
    "choice1": "損益分岐点比率は、実際の売上高に対する損益分岐点売上高の割合を示したものであり、一般に、この数値が低い方が企業の収益性が高いと判断される。",
    "choice2": "自己資本比率は、総資本に対する自己資本の割合を示したものであり、一般に、この数値が低い方が財務の健全性が高いと判断される。",
    "choice3": "固定長期適合率は、自己資本に対する固定資産の割合を示したものであり、一般に、この数値が低い方が財務の健全性が高いと判断される。",
    "choice4": "ROEは、自己資本に対する当期純利益の割合を示したものであり、一般に、この数値が低い方が経営の効率性が高いと判断される。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "中小企業の資金調達",
    "important": ""
  },
  {
    "id": 11,
    "shikenId": 1,
    "no": 11,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "少額短期保険に関する次の記述のうち、最も適切なものはどれか。(2023.01)",
    "choice1": "少額短期保険は、低発生率保険および経過措置を適用している少額短期保険業者が引き受ける保険契約を除き、被保険者1人につき加入できる保険金額の合計額は1,000万円が上限である。",
    "choice2": "少額短期保険の保険期間は、生命保険、傷害疾病保険および損害保険のいずれも1年が上限である。",
    "choice3": "少額短期保険では、保険期間の満了時に満期返戻金を受け取ることができる。",
    "choice4": "少額短期保険業者が取り扱う保険契約は、保障内容に応じて、生命保険契約者保護機構または損害保険契約者保護機構のいずれかの保護の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "少額短期保険",
    "important": ""
  },
  {
    "id": 12,
    "shikenId": 1,
    "no": 12,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、特約については考慮しないものとする。(2024.01)",
    "choice1": "外貨建て終身保険では、死亡保険金を円貨で受け取る場合、受け取る金額は為替相場によって変動する。",
    "choice2": "変額保険（終身型）では、資産の運用実績に応じて死亡保険金額が変動するが、契約時に定めた保険金額（基本保険金額）は保証される。",
    "choice3": "こども保険（学資保険）では、契約者（＝保険料負担者）が死亡した場合であっても、保険契約は継続し、被保険者である子の成長に合わせて祝金（学資金）等を受け取ることができる。",
    "choice4": "低解約返戻金型終身保険では、他の契約条件が同一であれば、低解約返戻金型ではない終身保険と比較して、保険料払込期間満了後も解約返戻金額が低く設定されている。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 13,
    "shikenId": 1,
    "no": 13,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "個人年金保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。(2025.01)",
    "choice1": "確定年金では、年金受取開始日前に被保険者が死亡した場合、死亡給付金受取人が契約時に定められた年金受取総額と同額の死亡給付金を受け取ることができる。",
    "choice2": "10年保証期間付終身年金では、被保険者の性別以外の契約条件が同一である場合、保険料は男性の方が女性よりも高くなる。",
    "choice3": "MVA（市場価格調整）機能を有する変額個人年金保険では、市場金利に応じた運用資産の価格変動が解約返戻金額等に反映され、一般に、解約時の市場金利が契約時と比較して上昇した場合には解約返戻金額が減少する。",
    "choice4": "外貨建て個人年金保険では、円換算支払特約を付加することで、当該保険契約の締結後から年金や解約返戻金、死亡給付金を受け取るまでの為替リスクを回避することができる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "個人年金保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 14,
    "shikenId": 1,
    "no": 14,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "生命保険の税金に関する次の記述のうち、最も不適切なものはどれか。なお、いずれも契約者（＝保険料負担者）および保険金受取人は個人であるものとする。(2023.09)",
    "choice1": "契約者と被保険者が同一人である養老保険において、被保険者の相続人ではない者が受け取った死亡保険金は、相続税の課税対象となる。",
    "choice2": "契約者と被保険者が同一人である終身保険において、被保険者がリビング・ニーズ特約に基づいて受け取る特約保険金は、非課税となる。",
    "choice3": "契約者と年金受取人が同一人である個人年金保険において、年金受取人が毎年受け取る年金は、所得税における公的年金等控除の対象となる。",
    "choice4": "契約から10年を経過した一時払養老保険を解約して契約者が受け取る解約返戻金は、所得税において総合課税の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険の税金",
    "important": ""
  },
  {
    "id": 15,
    "shikenId": 1,
    "no": 15,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "法人を契約者（＝保険料負担者）とする生命保険等に係る保険料の経理処理に関する次の記述のうち、最も不適切なものはどれか。なお、いずれの保険契約も保険料は年払いかつ全期払いで、2023年10月に締結したものとする。(2023.05)",
    "choice1": "被保険者が役員・従業員全員、死亡保険金受取人および満期保険金受取人が法人である養老保険の支払保険料は、その全額を資産に計上する。",
    "choice2": "被保険者が役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を損金の額に算入することができる。",
    "choice3": "被保険者が役員、給付金受取人が法人である解約返戻金のない医療保険の支払保険料は、その全額を損金の額に算入することができる。",
    "choice4": "被保険者が役員、死亡保険金受取人が法人で、最高解約返戻率が60％である定期保険（保険期間30年、年払保険料100万円）の支払保険料は、保険期間の前半4割相当期間においては、その40％相当額を資産に計上し、残額を損金の額に算入することができる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "法人の生命保険の経理処理",
    "important": ""
  },
  {
    "id": 16,
    "shikenId": 1,
    "no": 16,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。(2024.05)",
    "choice1": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って車庫入れを誘導していた記名被保険者の配偶者に接触してケガをさせた場合、対人賠償保険の補償の対象となる。",
    "choice2": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って通行人が連れていたペットの犬に接触してケガをさせ、法律上の損害賠償責任を負った場合、対物賠償保険の補償の対象となる。",
    "choice3": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って衣料品販売店の店舗に衝突した場合、店舗の復旧期間中の休業損害は、対物賠償保険の補償の対象となる。",
    "choice4": "豪雨による洪水で被保険自動車が水没して被った損害は、一般条件の車両保険の補償の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "自動車保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 17,
    "shikenId": 1,
    "no": 17,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "住宅用建物および家財を保険の対象とする火災保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、特約については考慮しないものとする。(2022.09)",
    "choice1": "火災保険の保険料は、対象となる住宅用建物の構造により、M構造、T構造、H構造の3つに区分されて算定される。",
    "choice2": "保険金額が2,000万円（保険価額と同額）の火災保険に加入した後、火災により住宅用建物が損害を被り、損害保険金1,000万円が支払われた場合、保険契約は継続するが、保険期間満了日までの保険金額が1,000万円に減額される。",
    "choice3": "火災保険では、隣家の火災の消火活動により住宅用建物に収容されている家財が損壊した場合、補償の対象となる。",
    "choice4": "火災保険では、雪災により住宅用建物の屋根が損壊して100万円の損害が発生した場合、補償の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "火災保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 18,
    "shikenId": 1,
    "no": 18,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "傷害保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、特約および記載のない事項については考慮しないものとする。(2024.09)",
    "choice1": "普通傷害保険では、被保険者が自動車を運転中に他の自動車と衝突してケガをした場合、被保険者の過失割合にかかわらず補償の対象となる。",
    "choice2": "普通傷害保険では、海外旅行中に地震により倒壊した建物の下敷きになりケガをした場合、補償の対象となる。",
    "choice3": "交通事故傷害保険では、デパートのエスカレーターに搭乗中の事故によりケガをした場合、補償の対象となる。",
    "choice4": "国内旅行傷害保険では、被保険者が旅行中の飲食により細菌性食中毒を発症した場合、補償の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "傷害保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 19,
    "shikenId": 1,
    "no": 19,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "第三分野の保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、記載のない特約については考慮しないものとする。(2024.01)",
    "choice1": "所得補償保険では、勤務先企業の倒産によって失業した場合、保険金は支払われない。",
    "choice2": "更新型の医療保険では、保険期間中に入院給付金を受け取った場合、保険契約を更新することができない。",
    "choice3": "先進医療特約では、契約時点において先進医療に該当していた治療であれば、療養を受けた時点において先進医療に該当しない場合であっても、保険金の支払対象となる。",
    "choice4": "がん保険では、通常、180日間または6ヵ月間の免責期間が設けられている。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "第三分野の保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 20,
    "shikenId": 1,
    "no": 20,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "損害保険を利用した事業活動のリスク管理に関する次の記述のうち、最も不適切なものはどれか。(2023.01)",
    "choice1": "製造業を営む事業者が、従業員が就業中や通勤途上でケガをする場合に備えて、すべての従業員を被保険者として普通傷害保険に就業中のみの危険補償特約を付帯して契約した。",
    "choice2": "貸しビル業を営む事業者が、所有するビル内に設置した機械が火災により損害を被る場合に備えて、機械保険を契約した。",
    "choice3": "レストランを営む事業者が、フロア担当従業員が誤って来店客の衣服を汚損する場合に備えて、施設所有（管理）者賠償責任保険を契約した。",
    "choice4": "小型家電製品を製造する事業者が、製造した製品の欠陥が原因で顧客がケガをする場合に備えて、生産物賠償責任保険（PL保険）を契約した。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "損害保険を利用した事業活動のリスク管理",
    "important": ""
  },
  {
    "id": 21,
    "shikenId": 1,
    "no": 21,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "為替相場や金利の変動要因等に関する次の記述のうち、最も不適切なものはどれか。(2023.05)",
    "choice1": "日本の物価が米国と比較して相対的に上昇することは、一般に円高米ドル安の要因となる。",
    "choice2": "米国が政策金利を引き上げ、日本と米国との金利差が拡大することは、一般に円安米ドル高の要因となる。",
    "choice3": "日本の対米貿易赤字が拡大することは、一般に円安米ドル高の要因となる。",
    "choice4": "日本銀行が、国債買入オペによって長期国債（利付国債）を買い入れ、金融市場に資金を供給することは、一般に市中金利の低下要因となる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "為替相場や金利の変動要因等",
    "important": ""
  },
  {
    "id": 22,
    "shikenId": 1,
    "no": 22,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "上場投資信託（ETF）の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。(2024.09)",
    "choice1": "ETFを市場で売却する際には、信託財産留保額はかからない。",
    "choice2": "ETFを証券取引所の立会時間中に売買する場合、成行注文や指値注文が可能である。",
    "choice3": "インバース型ETFは、日経平均株価などの指標の日々の変動率に一定の正の倍数を乗じて算出される指数に連動した運用成果を目指して運用されるETFである。",
    "choice4": "東京証券取引所には、指標連動型ETFの銘柄だけでなく、アクティブ運用型ETFの銘柄も上場されている。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "上場投資信託(ETF)の特徴",
    "important": ""
  },
  {
    "id": 23,
    "shikenId": 1,
    "no": 23,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "公募株式投資信託の費用に関する次の記述のうち、最も不適切なものはどれか。(2024.01)",
    "choice1": "購入時手数料がかからない投資信託は、一般に、ノーロード型（ノーロードファンド）と呼ばれる。",
    "choice2": "運用管理費用（信託報酬）は投資信託の銘柄ごとに定められており、一般に、インデックス型投資信託よりもアクティブ型投資信託の方が高い傾向がある。",
    "choice3": "会計監査に必要な費用（監査報酬）や組入有価証券に係る売買委託手数料は、信託財産から支出されるため、受益者（投資家）の負担となる。",
    "choice4": "信託財産留保額は、長期に投資信託を保有する投資家との公平性を確保するための費用であり、すべての投資信託に設定されている。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "公募株式投資信託の費用",
    "important": ""
  },
  {
    "id": 24,
    "shikenId": 1,
    "no": 24,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "固定利付債券の利回り（単利・年率）と価格との関係に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、手数料、経過利子、税金等については考慮しないものとし、計算結果は表示単位の小数点以下第3位を四捨五入するものとする。(2022.09)<br><br>表面利率が1.00％で、償還までの残存期間が5年の固定利付債券を、額面100円当たり102円で購入した投資家が、2年後に、額面100円当たり101円で売却した。この場合の所有期間利回りは（ア）であり、償還期限まで5年間保有した場合の最終利回りよりも（イ）。",
    "choice1": "（ア）0.49％　（イ）高い",
    "choice2": "（ア）0.49％　（イ）低い",
    "choice3": "（ア）0.59％　（イ）高い",
    "choice4": "（ア）0.59％　（イ）低い",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "固定利付債券の利回りと価格との関係",
    "important": ""
  },
  {
    "id": 25,
    "shikenId": 1,
    "no": 25,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "東京証券取引所の市場区分等に関する次の記述のうち、最も適切なものはどれか。(2023.09)",
    "choice1": "スタンダード市場は、「多くの機関投資家の投資対象になりうる規模の時価総額（流動性）を持ち、より高いガバナンス水準を備え、投資者との建設的な対話を中心に据えて持続的な成長と中長期的な企業価値の向上にコミットする企業向けの市場」である。",
    "choice2": "プライム市場は、「高い成長可能性を実現するための事業計画及びその進捗の適時・適切な開示が行われ一定の市場評価が得られる一方、事業実績の観点から相対的にリスクが高い企業向けの市場｣である。",
    "choice3": "スタンダード市場の上場会社がプライム市場へ市場区分の変更をするためには、プライム市場の新規上場基準と同様の基準に基づく審査を受ける必要がある。",
    "choice4": "東証株価指数（TOPIX）は、プライム市場、スタンダード市場およびグロース市場の全銘柄を対象として算出されている。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "東京証券取引所の市場区分",
    "important": ""
  },
  {
    "id": 26,
    "shikenId": 1,
    "no": 26,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "外貨建ての金融商品の一般的な特徴等に関する次の記述のうち、最も不適切なものはどれか。(2024.05)",
    "choice1": "外貨預金の払戻し時において、預金者が外貨を円貨に換える場合に適用される為替レートは、預入金融機関が提示する対顧客直物電信買相場（TTB）である。",
    "choice2": "外貨預金は、その金額の多寡にかかわらず、預金保険制度による保護の対象とならない。",
    "choice3": "為替予約を締結していない外貨定期預金を満期時に円貨で払い戻した結果生じた為替差益は、一時所得として所得税の課税対象となる。",
    "choice4": "外貨建てMMFは、主に外国の格付けの高い公社債やコマーシャル・ペーパー（CP）などの短期金融商品を投資対象として運用される外貨建ての投資信託である。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "外貨建ての金融商品の一般的な特徴",
    "important": ""
  },
  {
    "id": 27,
    "shikenId": 1,
    "no": 27,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "オプション取引の一般的な特徴に関する次の記述のうち、最も適切なものはどれか。(2025.01)",
    "choice1": "コール・オプションは「原資産を権利行使価格で売る権利」であり、プット・オプションは「原資産を権利行使価格で買う権利」である。",
    "choice2": "権利行使期間中であればいつでも権利行使が可能なものをヨーロピアン・オプションといい、満期日（権利行使日）においてのみ権利行使が可能なものをアメリカン・オプションという。",
    "choice3": "コール・オプションの買い手の最大利益とプット・オプションの買い手の最大利益は、いずれもプレミアム（オプション料）の額となる。",
    "choice4": "コール・オプションおよびプット・オプションは、他の条件が同一であれば、いずれもボラティリティが上昇するほど、プレミアム（オプション料）は高くなる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "オプション取引の一般的な特徴",
    "important": ""
  },
  {
    "id": 28,
    "shikenId": 1,
    "no": 28,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "下記＜資料＞に基づくファンドAとファンドBの過去5年間の運用パフォーマンスの比較評価に関する次の記述の空欄（ア）、（イ）にあてはまる語句または数値の組み合わせとして、最も適切なものはどれか。(2024.05)<br> <br><img src='/img/1_28.jpg'/><br><br> ファンドの運用パフォーマンスに係る評価指標の一つとして、シャープレシオがある。無リスク金利を全期間にわたり1.0％とし、＜資料＞の数値により、ファンドAのシャープレシオの値を算出すると、（ア）となる。同様にファンドBのシャープレシオの値を算出したうえで、両ファンドの運用パフォーマンスを比較すると、過去5年間は（イ）の方が効率的な運用であったと判断される。",
    "choice1": "（ア）2.0　（イ）ファンドA",
    "choice2": "（ア）2.0　（イ）ファンドB",
    "choice3": "（ア）2.5　（イ）ファンドA",
    "choice4": "（ア）2.5　（イ）ファンドB",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "運用パフォーマンスの比較評価",
    "important": ""
  },
  {
    "id": 29,
    "shikenId": 1,
    "no": 29,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "上場株式等の譲渡および配当等（一定の大口株主等が受けるものを除く）に係る税金に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、NISA（少額投資非課税制度）により投資収益が非課税となる口座をNISA口座という。(2024.01)",
    "choice1": "上場株式の配当に係る配当所得の金額について、総合課税を選択して所得税の確定申告をした場合、特定口座内で生じた上場株式等に係る譲渡損失の金額と損益通算することができる。",
    "choice2": "NISA口座で保有する上場株式の配当金を非課税扱いにするためには、配当金の受取方法として株式数比例配分方式を選択しなければならない。",
    "choice3": "上場株式等に係る配当所得等の金額と損益通算してもなお控除しきれない上場株式等に係る譲渡損失の金額は、所得税の確定申告をすることにより、翌年以後3年間にわたって繰り越すことができる。",
    "choice4": "NISA口座で取得した上場株式等を売却したことにより生じた損失の金額については、特定口座内で保有する上場株式等の配当等に係る配当所得の金額と損益通算することができない。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "上場株式等の譲渡および配当等に係る税金",
    "important": ""
  },
  {
    "id": 30,
    "shikenId": 1,
    "no": 30,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "金融商品の取引等に係る各種法令に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、「金融サービスの提供に関する法律」を金融サービス提供法、「犯罪による収益の移転防止に関する法律」を犯罪収益移転防止法という。(2023.01)",
    "choice1": "金融商品取引法では、金融商品取引契約を締結しようとする金融商品取引業者等は、あらかじめ顧客（特定投資家を除く）に契約締結前交付書面を交付しなければならないとされているが、顧客から交付を要しない旨の意思表示があった場合、その交付義務は免除される。",
    "choice2": "金融サービス提供法では、金融サービス仲介業の登録を受けた事業者は、銀行、証券、保険、貸金業の分野のサービスを仲介することができるが、特定の金融機関に所属し、その指導および監督を受けなければならないとされている。",
    "choice3": "消費者契約法では、事業者の不適切な行為によって、消費者が誤認や困惑をし、それによって消費者契約の申込みまたはその承諾の意思表示をした場合、消費者は、当該契約によって生じた損害について賠償を請求することができるとされている。",
    "choice4": "犯罪収益移転防止法では、金融機関等の特定事業者が顧客と特定業務に係る取引を行った場合、特定事業者は、原則として、直ちに当該取引に関する記録を作成し、当該取引の行われた日から7年間保存しなければならないとされている。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "金融商品の取引等に係る各種法令",
    "important": ""
  },
  {
    "id": 31,
    "shikenId": 1,
    "no": 31,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "所得税の基本的な仕組みに関する次の記述のうち、最も不適切なものはどれか。(2023.09)",
    "choice1": "所得税では、原則として、納税者本人の申告により納付すべき税額が確定し、この確定した税額を納付する申告納税制度が採用されている。",
    "choice2": "所得税の納税義務を負うのは居住者のみであり、非居住者が所得税の納税義務を負うことはない。",
    "choice3": "所得税では、課税対象となる所得を10種類に区分し、それぞれの所得の種類ごとに定められた計算方法により所得の金額を計算する。",
    "choice4": "所得税額の計算において課税総所得金額に乗じる税率は、課税総所得金額が大きくなるにつれて段階的に税率が高くなる超過累進税率が採用されている。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の基本的な仕組み",
    "important": ""
  },
  {
    "id": 32,
    "shikenId": 1,
    "no": 32,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "所得税における各種所得の金額の計算方法に関する次の記述のうち、最も不適切なものはどれか。(2023.05)",
    "choice1": "利子所得の金額は、「利子等の収入金額－元本を取得するために要した負債の利子の額」の算式により計算される。",
    "choice2": "不動産所得の金額は、原則として、「不動産所得に係る総収入金額－必要経費」の算式により計算される。",
    "choice3": "一時所得の金額は、「一時所得に係る総収入金額－その収入を得るために支出した金額－特別控除額」の算式により計算される。",
    "choice4": "退職所得の金額は、特定役員退職手当等および短期退職手当等に係るものを除き、「（退職手当等の収入金額－退職所得控除額）×1／2」の算式により計算される。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税における各種所得の金額の計算方法",
    "important": ""
  },
  {
    "id": 33,
    "shikenId": 1,
    "no": 33,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "所得税の損益通算に関する次の記述のうち、最も適切なものはどれか。(2024.01)",
    "choice1": "先物取引に係る雑所得の金額の計算上生じた損失の金額は、不動産所得の金額と損益通算することができる。",
    "choice2": "業務用車両を譲渡したことによる譲渡所得の金額の計算上生じた損失の金額は、事業所得の金額と損益通算することができる。",
    "choice3": "不動産所得の金額の計算上生じた損失の金額のうち、不動産所得を生ずべき土地の取得に要した負債の利子の額に相当する部分の金額は、事業所得の金額と損益通算することができる。",
    "choice4": "生命保険の解約返戻金を受け取ったことによる一時所得の金額の計算上生じた損失の金額は、不動産所得の金額と損益通算することができる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の損益通算",
    "important": ""
  },
  {
    "id": 34,
    "shikenId": 1,
    "no": 34,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "所得税における住宅借入金等特別控除（以下「住宅ローン控除」という）に関する次の記述のうち、最も不適切なものはどれか。なお、2023年10月に住宅ローンを利用して住宅を取得したものとする。(2024.05)",
    "choice1": "住宅ローン控除の適用を受けるためには、原則として、その対象となる家屋を取得等した日から6ヵ月以内に自己の居住の用に供さなければならない。",
    "choice2": "住宅ローン控除の対象となる家屋は、床面積の2分の1以上に相当する部分がもっぱら自己の居住の用に供されるものに限られる。",
    "choice3": "住宅ローン控除の対象となる借入金は、契約による償還期間が10年以上のものに限られる。",
    "choice4": "住宅ローン控除は、納税者が給与所得者である場合、住宅を取得して居住の用に供した年分から年末調整により適用を受けることができる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "住宅借入金等特別控除",
    "important": ""
  },
  {
    "id": 35,
    "shikenId": 1,
    "no": 35,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "法人税の仕組みに関する次の記述のうち、最も適切なものはどれか。(2022.09)",
    "choice1": "法人税の納税地は、原則として、その法人の代表者の住所または居所の所在地である。",
    "choice2": "法人税の各事業年度の所得の金額は、その事業年度の益金の額からその事業年度の損金の額を控除した金額である。",
    "choice3": "期末資本金の額等が1億円以下の一定の中小法人に対する法人税の税率は、所得金額のうち年1,000万円以下の部分について軽減税率が適用される。",
    "choice4": "法人税の確定申告書は、原則として、各事業年度終了の日の翌日から1ヵ月以内に、納税地の所轄税務署長に提出しなければならない。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "法人税の仕組み",
    "important": ""
  },
  {
    "id": 36,
    "shikenId": 1,
    "no": 36,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "法人税における減価償却に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢において、当期とは2025年4月1日以降の会計期間を1年とする事業年度とする。(2025.05)",
    "choice1": "法人が減価償却費を損金の額に算入するにあたっては、確定した決算において償却費として損金経理することが要件とされている。",
    "choice2": "法人が2016年4月1日以後に取得した建物、建物附属設備および構築物については、「減価償却資産の償却方法の届出書」の提出の有無にかかわらず、定額法を選択することはできず、定率法しか認められない。",
    "choice3": "当期に取得価額が10万円未満の減価償却資産を取得して事業の用に供した場合、その使用可能期間の長短にかかわらず、原則として、当期においてその取得価額の全額を損金経理により損金の額に算入することができる。",
    "choice4": "当期に取得価額が10万円以上20万円未満の減価償却資産を取得して事業の用に供した場合、原則として、当期以後3年間にわたってその取得価額の3分の1相当額を損金経理により損金の額に算入することができる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "法人税における減価償却",
    "important": ""
  },
  {
    "id": 37,
    "shikenId": 1,
    "no": 37,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "消費税に関する次の記述のうち、最も不適切なものはどれか。(2023.01)",
    "choice1": "基準期間における課税売上高が1,000万円を超える法人は、消費税の免税事業者となることができない。",
    "choice2": "特定期間における給与等支払額の合計額および課税売上高がいずれも1,000万円を超える法人は、消費税の免税事業者となることができない。",
    "choice3": "基準期間における課税売上高が5,000万円を超える課税事業者は、簡易課税制度の適用を受けることができない。",
    "choice4": "消費税の免税事業者が「消費税課税事業者選択届出書」を提出して消費税の課税事業者となったときは、事業を廃止した場合を除き、原則として3年間は消費税の免税事業者に戻ることができない。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "消費税",
    "important": ""
  },
  {
    "id": 38,
    "shikenId": 1,
    "no": 38,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。(2023.09)",
    "choice1": "会社が役員に対して無利息で金銭の貸付けを行った場合、原則として、通常収受すべき利息に相当する金額が、その会社の所得金額の計算上、益金の額に算入される。",
    "choice2": "会社が役員からの借入金について債務免除を受けた場合、その債務免除を受けた金額が、その会社の所得金額の計算上、益金の額に算入される。",
    "choice3": "役員が所有する土地を適正な時価の2分の1未満の価額で会社に譲渡した場合、その役員は、適正な時価の2分の1に相当する金額により当該土地を譲渡したものとして譲渡所得の計算を行う。",
    "choice4": "役員が会社の所有する社宅に無償で居住している場合、原則として、通常の賃貸料相当額が、その役員の給与所得の収入金額に算入される。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "会社と役員間の取引",
    "important": ""
  },
  {
    "id": 39,
    "shikenId": 1,
    "no": 39,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "決算書の見方に関する次の記述のうち、最も不適切なものはどれか。(2023.09)",
    "choice1": "損益計算書の営業利益の額は、売上総利益の額から販売費及び一般管理費の額を差し引いた額である。",
    "choice2": "損益計算書の税引前当期純利益の額は、経常利益の額に営業外損益の額を加算・減算した額である。",
    "choice3": "流動比率（％）は、「流動資産÷流動負債×100」の算式で計算される。",
    "choice4": "自己資本比率（％）は、「自己資本÷総資産×100」の算式で計算される。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "決算書の見方",
    "important": ""
  },
  {
    "id": 40,
    "shikenId": 1,
    "no": 40,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "消費税の適格請求書等保存方式（インボイス制度）に関する次の記述のうち、最も不適切なものはどれか。(2024.09)",
    "choice1": "消費税の免税事業者が適格請求書発行事業者の登録を受けると、消費税の課税事業者となる。",
    "choice2": "適格請求書発行事業者の登録に係る効力は、事業者が登録の通知を受けた日にかかわらず、適格請求書発行事業者登録簿に登載された日から生じる。",
    "choice3": "適格請求書発行事業者が、適格請求書に代えて適格簡易請求書を交付するためには、消費税の簡易課税制度の適用を受ける必要がある。",
    "choice4": "適格請求書には、適格請求書発行事業者の氏名または名称および登録番号や税率ごとに区分した消費税額等の記載が必要とされる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "適格請求書等保存方式（インボイス制度）",
    "important": ""
  },
  {
    "id": 41,
    "shikenId": 1,
    "no": 41,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "不動産鑑定評価基準における不動産の鑑定評価に関する次の記述のうち、最も不適切なものはどれか。(2022.09)",
    "choice1": "不動産の価格を求める鑑定評価の基本的な手法は、原価法、取引事例比較法および収益還元法に大別され、鑑定評価に当たっては、対象不動産に係る市場の特性等を考慮し、これらのうち最も適した1つの手法に限定して適用することとされている。",
    "choice2": "最有効使用の原則は、不動産の効用が最高度に発揮される可能性に最も富む使用を前提として把握される価格を標準として不動産の価格が形成されるとする原則である。",
    "choice3": "原価法は、価格時点における対象不動産の再調達原価を求め、この再調達原価について減価修正を行って対象不動産の価格を求める手法である。",
    "choice4": "収益還元法は、対象不動産が賃貸用不動産である場合だけでなく、自用の不動産であっても、賃貸を想定することにより適用されるものであるとされている。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産鑑定評価",
    "important": ""
  },
  {
    "id": 42,
    "shikenId": 1,
    "no": 42,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "不動産売買の契約に係る民法の規定に関する次の記述のうち、最も不適切なものはどれか。なお、特約については考慮しないものとする。(2024.05)",
    "choice1": "売買契約の締結後、買主の責めに帰すことのできない事由により、当該契約の目的物の引渡債務の全部が履行不能となった場合、買主は、履行の催告をすることなく、直ちに契約の解除をすることができる。",
    "choice2": "売主が種類または品質に関して契約の内容に適合しない目的物を買主に引き渡した場合において、買主がその不適合を知った時から1年以内にその旨を売主に通知しないときは、売主が引渡しの時にその不適合を知っていたとしても、買主は、その不適合を理由として契約の解除をすることができない。",
    "choice3": "売買の目的物である建物が、その売買契約の締結から当該建物の引渡しまでの間に、地震により全壊した場合、買主は、売主に対して建物代金の支払いを拒むことができる。",
    "choice4": "買主が売主に解約手付を交付した場合、売主は、買主が契約の履行に着手する前であれば、受領した手付の倍額を買主に対して現実に提供することにより、契約の解除をすることができる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産売買の契約に係る民法の規定",
    "important": ""
  },
  {
    "id": 43,
    "shikenId": 1,
    "no": 43,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、同法第38条による定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。また、記載された特約以外のものについては考慮しないものとする。(2022.09)",
    "choice1": "普通借家契約において存続期間を1年未満に定めた場合、その存続期間は1年とみなされる。",
    "choice2": "期間の定めがある普通借家契約において、賃借人は、正当の事由がなければ、賃貸人に対し、更新しない旨の通知をすることができない。",
    "choice3": "定期借家契約は、もっぱら居住の用に供する建物に限られ、事業の用に供する建物については締結することができない。",
    "choice4": "定期借家契約において、その賃料が、近傍同種の建物の賃料に比較して不相当となっても、賃貸借期間中は増減額させないこととする特約をした場合、その特約は有効である。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "借地借家法（借家）",
    "important": ""
  },
  {
    "id": 44,
    "shikenId": 1,
    "no": 44,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "借地借家法に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、同法第22条の借地権を一般定期借地権といい、第22条から第24条の定期借地権等以外の借地権を普通借地権という。(2023.09)",
    "choice1": "普通借地権の設定契約において、期間の定めがないときは、存続期間は30年とされる。",
    "choice2": "普通借地権の存続期間が満了した時点で借地上に建物が存在しない場合は、借地権者が契約の更新を請求しても、従前の契約と同一の条件で契約が更新されたものとはみなされない。",
    "choice3": "一般定期借地権の設定契約において、存続期間は30年とすることができる。",
    "choice4": "一般定期借地権の設定契約は、公正証書による等書面（電磁的記録による場合を含む）によってしなければならない。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "借地借家法（借地）",
    "important": ""
  },
  {
    "id": 45,
    "shikenId": 1,
    "no": 45,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。(2024.01)",
    "choice1": "すべての都市計画区域について、都市計画に市街化区域と市街化調整区域の区域区分を定めなければならない。",
    "choice2": "都市計画区域のうち、市街化調整区域は、おおむね10年以内に優先的かつ計画的に市街化を図るべき区域である。",
    "choice3": "開発許可を受けた開発区域内の土地においては、開発工事完了の公告があるまでの間は、原則として、建築物を建築することができない。",
    "choice4": "市街化調整区域内において、農業を営む者の居住の用に供する建築物の建築を目的として行う開発行為は、開発許可を受ける必要がある。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "都市計画法",
    "important": ""
  },
  {
    "id": 46,
    "shikenId": 1,
    "no": 46,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も適切なものはどれか。(2024.09)",
    "choice1": "建築基準法第42条第2項により道路境界線とみなされる線と道路との間の敷地の部分（セットバック部分）は、建築物を建築することができないが、建蔽率および容積率を算定する際の敷地面積に算入することができる。",
    "choice2": "準防火地域内に準耐火建築物を建築する場合、建蔽率の制限について緩和措置の適用を受けることができる。",
    "choice3": "建築物の敷地が2つの異なる用途地域にわたる場合、その建築物の全部について、敷地の過半の属する用途地域の建蔽率の制限が適用される。",
    "choice4": "敷地の前面道路の幅員が12ｍ未満である建築物の建蔽率は、原則として、「都市計画で定められた建蔽率」と「前面道路の幅員に一定の数値を乗じて得たもの」とのいずれか低い方が上限となる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "建築基準法の規定",
    "important": ""
  },
  {
    "id": 47,
    "shikenId": 1,
    "no": 47,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。(2023.01)",
    "choice1": "区分所有者は、敷地利用権が数人で有する所有権その他の権利である場合、規約に別段の定めがない限り、敷地利用権を専有部分と分離して処分することができる。",
    "choice2": "区分所有者は、規約に別段の定めがない限り、集会の議決によって管理者を選任し、または解任することができる。",
    "choice3": "集会においては、区分所有者および議決権の各5分の4以上の多数により建替え決議をすることができる。",
    "choice4": "共用部分に対する区分所有者の共有持分は、規約に別段の定めがない限り、各共有者が有する専有部分の床面積の割合による。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "区分所有法",
    "important": ""
  },
  {
    "id": 48,
    "shikenId": 1,
    "no": 48,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "不動産の取得に係る税金に関する次の記述のうち、最も適切なものはどれか。(2023.01)",
    "choice1": "不動産取得税は、相続により不動産を取得した場合は課されるが、贈与により不動産を取得した場合は課されない。",
    "choice2": "一定の要件を満たす戸建て住宅（認定長期優良住宅を除く）を新築した場合、不動産取得税の課税標準の算定に当たっては、1戸につき最高1,200万円を価格から控除することができる。",
    "choice3": "登録免許税は、贈与により不動産を取得した場合の所有権移転登記では課されない。",
    "choice4": "登録免許税は、建物を新築した場合の建物表題登記であっても課される。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の取得に係る税金",
    "important": ""
  },
  {
    "id": 49,
    "shikenId": 1,
    "no": 49,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "個人が土地を譲渡した場合の譲渡所得に関する次の記述のうち、最も不適切なものはどれか。(2024.01)",
    "choice1": "土地の譲渡に係る所得については、その土地を譲渡した日の属する年の1月1日における所有期間が10年以下の場合、短期譲渡所得に区分される。",
    "choice2": "譲渡所得の金額の計算上、譲渡した土地の取得費が不明な場合には、譲渡収入金額の5％相当額を取得費とすることができる。",
    "choice3": "相続（限定承認に係るものを除く）により取得した土地を譲渡した場合、その土地の所有期間を判定する際の取得の時期は、被相続人の取得の時期が引き継がれる。",
    "choice4": "土地を譲渡する際に支出した仲介手数料は、譲渡所得の金額の計算上、譲渡費用に含まれる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "個人が土地を譲渡した場合の譲渡所得",
    "important": ""
  },
  {
    "id": 50,
    "shikenId": 1,
    "no": 50,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "不動産の有効活用の手法の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。(2025.01)",
    "choice1": "等価交換方式における全部譲渡方式は、土地所有者が土地の全部をデベロッパーに譲渡し、その対価としてその土地上にデベロッパーが建設した建物およびその土地の一部を譲り受ける方式である。",
    "choice2": "建設協力金方式は、土地所有者が建設する建物を貸し付ける予定のテナント等から、建設費相当額の全部または一部を借り受けて建物を建設する方式である。",
    "choice3": "定期借地権方式では、土地所有者は土地を一定期間貸し付けることにより地代収入を得ることができ、当該土地上に建設される建物の建設資金を負担する必要はない。",
    "choice4": "事業受託方式は、土地の有効活用の企画、建設会社の選定や当該土地上に建設された建物の管理・運営等を土地所有者の依頼を受けたデベロッパーが行う手法であり、土地所有者は建設資金を調達する必要はなく、建物の所有名義はデベロッパーとなる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の有効活用",
    "important": ""
  },
  {
    "id": 51,
    "shikenId": 1,
    "no": 51,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "民法上の贈与に関する次の記述のうち、最も適切なものはどれか。(2023.01)",
    "choice1": "書面によらない贈与は、その履行の終わった部分についても、各当事者が解除をすることができる。",
    "choice2": "定期贈与とは、贈与者が受贈者に対して定期的に財産を給付することを目的とする贈与をいい、贈与者または受贈者のいずれか一方が生存している限り、その効力を失うことはない。",
    "choice3": "負担付贈与では、受贈者がその負担である義務を履行しない場合において、贈与者が相当の期間を定めてその履行の催告をし、その期間内に履行がない場合、原則として、贈与者は、当該贈与の契約の解除をすることができる。",
    "choice4": "死因贈与では、民法の遺贈に関する規定が準用され、贈与者のみの意思表示により成立し、贈与者の死亡によって効力が生じる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "民法上の贈与",
    "important": ""
  },
  {
    "id": 52,
    "shikenId": 1,
    "no": 52,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "相続時精算課税制度（以下「本制度」という）に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。(2024.09)",
    "choice1": "父からの財産の贈与について本制度を選択した子は、その選択をした年分以後、所定の手続きにより、その父から受ける財産の贈与について暦年課税に変更することができる。",
    "choice2": "父からの財産の贈与について本制度を選択した子は、同一年中に母から受けた財産の贈与についても本制度が適用され、母からの贈与について暦年課税により贈与税額を計算することはできない。",
    "choice3": "父からの財産の贈与について子が本制度を選択しようとする場合、贈与者の年齢に係る要件はあるが、受贈者の年齢に係る要件はない。",
    "choice4": "父からの財産の贈与について子が本制度を選択しようとする場合、その適用の対象となる贈与財産の種類や贈与回数について制限はない。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続時精算課税制度",
    "important": ""
  },
  {
    "id": 53,
    "shikenId": 1,
    "no": 53,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "民法上の遺言に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。(2024.05)",
    "choice1": "公正証書遺言の作成において、遺言者の配偶者は証人として立ち会うことができない。",
    "choice2": "自筆証書遺言の作成に当たって、自筆証書にこれと一体のものとして添付する財産目録をパソコンで作成する場合、その財産目録への署名および押印は不要である。",
    "choice3": "同一の遺言者による公正証書遺言と自筆証書遺言について、それぞれの内容が異なっている場合、その異なっている部分については、作成日付の新しい遺言の内容が効力を有する。",
    "choice4": "自筆証書遺言書保管制度により法務局（遺言書保管所）に保管されている自筆証書遺言は、遺言者の相続開始後、家庭裁判所の検認が不要である。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "民法上の遺言",
    "important": ""
  },
  {
    "id": 54,
    "shikenId": 1,
    "no": 54,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "遺産の分割に関する次の記述のうち、最も不適切なものはどれか。(2023.05)",
    "choice1": "共同相続人は、一定の場合を除き、遺産の全部ではなく一部の分割内容のみを定めた遺産分割協議書を作成することができる。",
    "choice2": "換価分割は、共同相続人が相続により取得した財産の全部または一部を金銭に換価し、その換価代金を共同相続人の間で分割する方法である。",
    "choice3": "代償分割は、現物分割を困難とする事由がある場合に、共同相続人が家庭裁判所に申し立て、その審判を受けることにより認められる分割方法である。",
    "choice4": "相続人が代償分割により他の相続人から交付を受けた代償財産は、相続税の課税対象となる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "遺産の分割",
    "important": ""
  },
  {
    "id": 55,
    "shikenId": 1,
    "no": 55,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "任意後見制度に関する次の記述のうち、最も不適切なものはどれか。(2024.09)",
    "choice1": "任意後見制度では、本人が十分な判断能力を有しているときに、本人が、任意後見人となる者や委任する事務を契約によりあらかじめ定めておくことができる。",
    "choice2": "任意後見契約は、所定の様式の公正証書によってしなければならない。",
    "choice3": "任意後見契約は、本人の判断能力が低下して事理を弁識する能力が不十分な状況となった時からその効力が生じる。",
    "choice4": "任意後見監督人は家庭裁判所により選任されるが、任意後見人の配偶者、直系血族および兄弟姉妹は任意後見監督人となることができない。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "任意後見制度",
    "important": ""
  },
  {
    "id": 56,
    "shikenId": 1,
    "no": 56,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "相続税の納税に関する次の記述のうち、最も不適切なものはどれか。(2023.01)",
    "choice1": "相続により土地を取得した者がその相続に係る相続税について延納を申請する場合、一定の要件を満たせば、その相続により取得した土地以外の土地を延納の担保として提供することができる。",
    "choice2": "相続税は金銭による一括納付が原則であるが、一括納付や延納による金銭の納付が困難な場合、納税義務者は、その納付を困難とする金額を限度に物納を申請することができる。",
    "choice3": "物納に充てることができる財産の種類には順位があり、不動産と上場株式はいずれも第1順位に分類されている。",
    "choice4": "「小規模宅地等についての相続税の課税価格の計算の特例」の適用を受けた宅地等を物納する場合の収納価額は、特例適用前の価額である。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の納税",
    "important": ""
  },
  {
    "id": 57,
    "shikenId": 1,
    "no": 57,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "下記＜親族関係図＞において、Aさんの相続が開始した場合の相続税額の計算における遺産に係る基礎控除額として、最も適切なものはどれか。なお、Cさんは相続の放棄をしている。また、Eさんは、Aさんの普通養子（特別養子縁組以外の縁組による養子）である。(2023.05)<br><img src='/img/1_57.jpg'/>",
    "choice1": "4,200万円",
    "choice2": "4,800万円",
    "choice3": "5,400万円",
    "choice4": "6,000万円",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "遺産に係る基礎控除額",
    "important": ""
  },
  {
    "id": 58,
    "shikenId": 1,
    "no": 58,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "宅地の相続税評価額の算定方法等に関する次の記述のうち、最も適切なものはどれか。(2024.01)",
    "choice1": "宅地の評価方法には、路線価方式と倍率方式があり、どちらの方式を採用するかについては、納税者が任意に選択することができる。",
    "choice2": "倍率方式は、固定資産税評価額に国税局長が一定の地域ごとに定める倍率を乗じて計算した金額によって評価する方式である。",
    "choice3": "正面と側方に路線がある宅地（角地）を路線価方式によって評価する場合、原則として、それぞれの路線価に奥行価格補正率を乗じた価額を比較し、低い方の路線価が正面路線価となる。",
    "choice4": "路線価は、路線に面する標準的な宅地の1坪当たりの価額であり、千円単位で表示される。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "宅地の相続税評価額の算定方法",
    "important": ""
  },
  {
    "id": 59,
    "shikenId": 1,
    "no": 59,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "Aさんの相続が開始した場合の相続税額の計算における下記＜資料＞の甲宅地の評価に関する次の記述のうち、最も適切なものはどれか。なお、記載のない事項については考慮しないものとする。(2023.09)<br><img src='/img/1_59.jpg'/>",
    "choice1": "長男が相続により甲宅地を取得した場合、貸宅地として評価する。",
    "choice2": "長男が相続により甲宅地を取得した場合、自用地として評価する。",
    "choice3": "妻が相続により甲宅地を取得した場合、貸宅地として評価する。",
    "choice4": "妻が相続により甲宅地を取得した場合、貸家建付地として評価する。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続財産の評価（不動産）",
    "important": ""
  },
  {
    "id": 60,
    "shikenId": 1,
    "no": 60,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "中小企業における経営の承継の円滑化に関する法律による「遺留分に関する民法の特例」（以下「本特例」という）に関する次の記述のうち、最も不適切なものはどれか。(2024.05)",
    "choice1": "会社事業後継者が本特例の適用を受けるためには、遺留分を有する旧代表者の推定相続人および会社事業後継者全員の書面による合意が必要である。",
    "choice2": "本特例の適用を受けることにより、会社事業後継者が旧代表者から贈与により取得した自社株式について、その価額を、遺留分を算定するための財産の価額に算入しないことができる。",
    "choice3": "本特例の適用を受けることにより、会社事業後継者が旧代表者から贈与により取得した自社株式について、遺留分を算定するための財産の価額に算入すべき価額を、本特例の適用に係る合意をした時点の価額とすることができる。",
    "choice4": "本特例の対象となる会社事業後継者は、旧代表者の親族に限られる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "遺留分に関する民法の特例",
    "important": ""
  },
  {
    "id": 61,
    "shikenId": 3,
    "no": 1,
    "answerType": 4,
    "groupId": 0,
    "answer": "789048,1322015,58632,1804747",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_61.png'/>",
    "question2": "Ａさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（2026年度価額）を計算した次の〈計算の手順〉の空欄①～④に入る最も適切な数値を答えなさい。なお、計算にあたっては、《設例》の〈Ａさんとその家族に関する資料〉および下記の〈資料〉に基づくこと。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"802bb2d0-bd97-45ea-be21-6667f32d172f\" src='/img/3_1_1775904848475602.png'>",
    "choice1": "円",
    "choice2": "円",
    "choice3": "円",
    "choice4": "円",
    "choice5": "2409 設例改",
    "categoryName": "ライフ",
    "rontenName": "老齢基礎年金・老齢厚生年金の年金額",
    "important": ""
  },
  {
    "id": 62,
    "shikenId": 3,
    "no": 2,
    "answerType": 6,
    "groupId": 0,
    "answer": "チ,ホ,ロ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_61.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、老後の年金収入を増やす方法として確定拠出年金の個人型年金（以下、「個人型年金」という）について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ 「個人型年金は、加入者の指図により掛金を運用し、その運用結果に基づく給付を受け取る制度です。個人型年金には、税制上の優遇措置が講じられており、支払った掛金は、その全額を所得税の（ ① ）として総所得金額等から控除することができます。また、老齢給付金を年金で受給する場合、当該給付金は雑所得として所得税の課税対象となり、雑所得の金額の計算上、当該給付金に係る収入金額から公的年金等控除額を控除することができます。なお、国民年金の第３号被保険者である妻Ｂさんは、個人型年金に加入することが（ ② ）」<br>Ⅱ 「個人型年金は、原則として、60歳になるまで資産を引き出すことができません。なお、60歳から老齢給付金を受給するためには、通算加入者等期間が（ ③ ）年以上必要となります」<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"6c09a4b0-673f-4e29-9de4-a3a838797fdc\" src='/img/3_2_1775904849700812.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "2409 設例改",
    "categoryName": "ライフ",
    "rontenName": "確定拠出年金の個人型年金",
    "important": ""
  },
  {
    "id": 63,
    "shikenId": 3,
    "no": 3,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_61.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、国民年金の学生納付特例制度（以下、「本制度」という）について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「長男Ｃさんが、2026年12月以降の大学生である期間について本制度の適用を受けるためには、Ａさんの前年所得が一定金額以下である必要があります」",
    "choice2": "「本制度の適用を受けた期間について国民年金保険料の追納がない場合、その期間は老齢基礎年金の受給資格期間には算入されません。本制度の適用を受けた期間に係る保険料について追納することができるのは、追納の承認を受けた月の前10年以内とされています」",
    "choice3": "「長男Ｃさんが本制度の適用を受け、その後、本制度の適用を受けた期間に係る保険料をＡさんが長男Ｃさんの代わりに支払った場合、その支払った保険料は、所得税において、Ａさんの社会保険料控除の対象となります」",
    "choice4": "",
    "choice5": "2409 設例改",
    "categoryName": "ライフ",
    "rontenName": "学生納付特例制度",
    "important": ""
  },
  {
    "id": 64,
    "shikenId": 3,
    "no": 4,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_64.png'/>",
    "question2": "Ｍさんは、Ａさんと長女Ｃさんに対して、株式取引のルール等について説明した。<br>Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「国内株式市場における代表的な株価指標である日経平均株価は、東京証券取引所のスタンダード市場に上場している銘柄のうち、代表的な225銘柄を対象とした修正平均型の株価指標です」",
    "choice2": "「上場株式の注文方法のうち、指値注文では、高い値段の買い注文が低い値段の買い注文に優先して売買が成立し、同じ値段の買い注文については、寄付や引けなどを除き、先に出された注文が後に出された注文に優先して売買が成立します」",
    "choice3": "「Ｘ社株式の次回の配当を受け取るためには、普通取引の場合、権利確定日の２営業日前である本年６月28日（水）までに買付けを行い、権利確定日に株主として株主名簿に記載される必要があります」",
    "choice4": "",
    "choice5": "2305 設例改",
    "categoryName": "金融",
    "rontenName": "株式取引のルール等",
    "important": ""
  },
  {
    "id": 65,
    "shikenId": 3,
    "no": 5,
    "answerType": 4,
    "groupId": 0,
    "answer": "10.83,2.23",
    "score": "2,2",
    "question1": "<img src='/img/setsu_64.png'/>",
    "question2": "《設例》のデータに基づいて算出される次の①、②を答えなさい。<br>〈答〉は表示単位の小数点以下第３位を四捨五入し、小数点以下第２位までを解答すること。<br>① Ｘ社株式のＰＥＲ<br>② Ｙ社株式のＰＢＲ",
    "choice1": "倍",
    "choice2": "倍",
    "choice3": "",
    "choice4": "",
    "choice5": "2305 設例改",
    "categoryName": "金融",
    "rontenName": "PERとPBRの計算",
    "important": ""
  },
  {
    "id": 66,
    "shikenId": 3,
    "no": 6,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_64.png'/>",
    "question2": "Ｍさんは、Ａさんと長女Ｃさんに対して、《設例》のデータに基づいて、株式の投資指標等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「 一般に、ＲＯＥの数値が高いほうが経営の効率性が高いと判断されます。ＲＯＥは、Ｙ社のほうがⅩ社よりも高くなっています」",
    "choice2": "「 株主への利益還元の大きさに着目した指標として、配当性向があります。配当性向は、Ⅹ社のほうがＹ社よりも高くなっています」",
    "choice3": "「 株式投資において、ＰＥＲやＰＢＲ等が低い銘柄など、企業の業績や財務内容等からみて株価が割安と判断される銘柄に投資する手法は、一般に、グロース投資と呼ばれます」",
    "choice4": "",
    "choice5": "2305 設例改",
    "categoryName": "金融",
    "rontenName": "株式の投資指標等",
    "important": ""
  },
  {
    "id": 67,
    "shikenId": 3,
    "no": 7,
    "answerType": 6,
    "groupId": 0,
    "answer": "ヘ,ル,イ,ホ",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_67.png'/>",
    "question2": "所得税における医療費控除に関する以下の文章の空欄①～④に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を答えなさい。<br><br>「通常の医療費控除は、その年分の総所得金額等の合計額が200万円以上である場合、その年中に自己または自己と生計を一にする配偶者等のために支払った医療費の総額から保険金などで補填される金額を控除した金額が（ ① ）円を超えるときは、その超える部分の金額（最高（ ② ）円）を総所得金額等から控除することができます。<br>また、通常の医療費控除との選択適用となるセルフメディケーション税制（医療費控除の特例）は、定期健康診断や予防接種などの一定の取組みを行っている者が自己または自己と生計を一にする配偶者等のために特定一般用医薬品等購入費を支払った場合、その年中に支払った特定一般用医薬品等購入費の総額から保険金などで補填される金額を控除した金額が（ ③ ）円を超えるときは、その超える部分の金額（最高（ ④ ）円）を総所得金額等から控除することができます」<br><br><img data-image-id=\"I2\"  data-asset-scope=\"data_check\" data-asset-id=\"5e971cb9-e839-4214-bdd1-0d488d0e7fb3\" src='/img/3_7_1775904849926462.png'><br><img data-image-id=\"I3\"  data-asset-scope=\"data_check\" data-asset-id=\"f343e260-eb63-4d92-af24-ca1539a4ebbf\" src='/img/3_7_1775904850453450.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル|ヲ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "2301 設例改",
    "categoryName": "タックス",
    "rontenName": "医療費控除に関する数値",
    "important": ""
  },
  {
    "id": 68,
    "shikenId": 3,
    "no": 8,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_67.png'/>",
    "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものに<br>は○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「Ａさんは、配偶者控除の適用を受けることはできませんが、配偶者特別控除の適用を受けることができます」",
    "choice2": "「Ａさんが適用を受けることができる扶養控除の控除額は、101万円です」",
    "choice3": "「Ａさんが医療費控除の適用を受けるためには、所得税の確定申告が必要です。年末調整では医療費控除の適用を受けることができません」",
    "choice4": "",
    "choice5": "2301 設例改",
    "categoryName": "タックス",
    "rontenName": "所得税の課税",
    "important": ""
  },
  {
    "id": 69,
    "shikenId": 3,
    "no": 9,
    "answerType": 4,
    "groupId": 0,
    "answer": "700,640",
    "score": "1,2",
    "question1": "<img src='/img/setsu_67.png'/>",
    "question2": "Ａさんの本年分の所得金額について、次の①、②を答えなさい。<br>なお、①の計算上、Ａさんが所得金額調整控除の適用対象者に該当している場合、所得金額調整控除額を控除すること。また、〈答〉は万円単位とすること。<br><br>① 総所得金額に算入される給与所得の金額<br>② 総所得金額<br><br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"6a0f8a2d-de51-420b-a4fb-8a37e300bd98\" src='/img/3_9_1775904850678357.png'>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "",
    "choice4": "",
    "choice5": "2301 設例改",
    "categoryName": "タックス",
    "rontenName": "所得金額の計算",
    "important": ""
  },
  {
    "id": 70,
    "shikenId": 3,
    "no": 10,
    "answerType": 4,
    "groupId": 0,
    "answer": "600,1800",
    "score": "2,2",
    "question1": "<img src='/img/setsu_70.png'/>",
    "question2": "甲土地上に耐火建築物を建築する場合における次の①、②を答えなさい。〈答〉は㎡単位とすること。<br>① 建蔽率の上限となる建築面積<br>② 容積率の上限となる延べ面積",
    "choice1": "㎡",
    "choice2": "㎡",
    "choice3": "",
    "choice4": "",
    "choice5": 2401,
    "categoryName": "不動産",
    "rontenName": "建築面積と延べ面積の上限",
    "important": ""
  },
  {
    "id": 71,
    "shikenId": 3,
    "no": 11,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_70.png'/>",
    "question2": "定期借地権方式による甲土地の有効活用に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「定期借地権方式は、事業者等に対して甲土地を一定期間賃貸する手法です。仮に、Ａさんが甲土地に事業用定期借地権を設定する場合、その契約は公正証書によってしなければなりません」",
    "choice2": "「事業用定期借地権は、ドラッグストアやコンビニ等の店舗だけでなく、賃貸マンションや老人ホーム等の居住用の施設を有する建物を建築する場合にも設定することができます」",
    "choice3": "「甲土地に建物譲渡特約付借地権を設定した場合、その設定後30年以上を経過した日に、Ａさんが甲土地上の建物を借地権者から買い取ったときは、借地契約が終了します。買い取った建物は賃貸することで家賃収入を得ることができますが、建物の維持管理の状態などによっては、十分な収益が見込めない可能性があります」",
    "choice4": "",
    "choice5": 2401,
    "categoryName": "不動産",
    "rontenName": "定期借地権方式による土地の有効活用",
    "important": ""
  },
  {
    "id": 72,
    "shikenId": 3,
    "no": 12,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_70.png'/>",
    "question2": "定期借地権方式により甲土地を有効活用する場合の課税等に関する次の記述①～③<br>について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「Ａさんが甲土地に定期借地権を設定した場合、甲土地上の建物については借地権者が、甲土地については借地権割合に基づきＡさんと借地権者が、それぞれ固定資産税の納税義務者となります」",
    "choice2": "「Ａさんが甲土地に事業用定期借地権を設定し、その存続期間中にＡさんの相続が開始した場合、相続税額の計算上、甲土地は貸家建付地として評価されます」",
    "choice3": "「Ａさんが甲土地に事業用定期借地権を設定した場合、当該借地契約は、借地権者から申出があっても更新することはできませんが、Ａさんと借地権者の合意のもと、借地借家法で定められた事業用定期借地権の存続期間内で存続期間を延長することや、存続期間満了時において再契約することは可能です」",
    "choice4": "",
    "choice5": 2401,
    "categoryName": "不動産",
    "rontenName": "土地を有効活用する場合の課税等",
    "important": ""
  },
  {
    "id": 73,
    "shikenId": 3,
    "no": 13,
    "answerType": 6,
    "groupId": 0,
    "answer": "ホ,チ,ヌ,ロ",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_73.png'/>",
    "question2": "Ａさんの相続に関する以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ 「遺言により、自宅および現預金等を妻Ｂさん、Ｘ社株式を長男Ｃさんに相続させた場合、長女Ｄさんの遺留分を侵害するおそれがあります。仮に、遺留分を算定するための財産の価額を３億円とした場合、長女Ｄさんの遺留分の金額は、（ ① ）万円となります」<br>Ⅱ 「遺言は、自筆証書遺言や公正証書遺言などの種類によって作成方式が異なっており、公正証書遺言の作成にあたっては、証人２人以上の立会いが必要とされています。仮に、Ａさんの公正証書遺言を作成する場合、妻Ｂさんおよび長男Ｃさんは証人となることが（ ② ）。なお、作成した公正証書遺言は、Ａさんの相続開始後、家庭裁判所における検認が（ ③ ）です」<br>Ⅲ 「妻Ｂさんが自宅建物とその敷地を相続により取得し、当該敷地（相続税評価額7,000万円）について、特定居住用宅地等として限度面積まで『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、相続税の課税価格に算入すべき当該敷地の価額は（ ④ ）万円となります」<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"44bc63c1-a4c8-4502-9ac5-812298dcf16f\" src='/img/3_13_1775904850987768.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "2409改",
    "categoryName": "相続",
    "rontenName": "相続等に関する語句または数値",
    "important": ""
  },
  {
    "id": 74,
    "shikenId": 3,
    "no": 14,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_73.png'/>",
    "question2": "「直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税」（以下、「本制度」という）に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「本制度の適用を受けるためには、取得等した住宅用家屋の床面積が50㎡以上200㎡以下でなければならず、また、その家屋の床面積の２分の１以上に相当する部分が受贈者の居住の用に供されるものである必要があります」",
    "choice2": "「長女Ｄさんが、Ａさんおよび妻Ｂさんのそれぞれから住宅取得等資金の贈与を受けてマンションを購入し、本制度の適用を受ける場合、当該マンションが一定の省エネ等住宅に該当するときは、Ａさんおよび妻Ｂさんから贈与を受けた資金について、それぞれ1,000万円を限度として贈与税が非課税となります」",
    "choice3": "「長女Ｄさんが、Ａさんから贈与を受けた住宅取得等資金について本制度の適用を受け、その後、Ａさんの相続が開始した場合、本制度の適用を受けたことにより贈与税が非課税とされた金額を相続税の課税価格に加算する必要はありません」",
    "choice4": "",
    "choice5": "2409改",
    "categoryName": "相続",
    "rontenName": "住宅取得等資金の贈与の非課税",
    "important": ""
  },
  {
    "id": 75,
    "shikenId": 3,
    "no": 15,
    "answerType": 4,
    "groupId": 0,
    "answer": "4800,800,3900",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_73.png'/>",
    "question2": "現時点（本年９月８日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を答えなさい。なお、課税遺産総額（相続税の課税価格の合計額－遺産に係る基礎控除額）は２億円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"111627be-7e6c-4b26-88f6-a3c834a8994e\" src='/img/3_15_1775904851225407.png'><br><img data-image-id=\"I2\"  data-asset-scope=\"data_check\" data-asset-id=\"986ccce0-8009-48c2-9220-6f3b9e9240a3\" src='/img/3_15_1775904851596405.png'>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "2409改",
    "categoryName": "相続",
    "rontenName": "相続税の総額",
    "important": ""
  },
  {
    "id": 76,
    "shikenId": 4,
    "no": 1,
    "answerType": 4,
    "groupId": 0,
    "answer": "797874,1164764,49806,1638670",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_76.png'/>",
    "question2": "Ａさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（2026年度価額）を計算した次の＜計算の手順＞の空欄①～④に入る最も適切な数値を答えなさい。計算にあたっては、《設例》の＜Ａさん夫妻に関する資料＞および下記の＜資料＞に基づくこと。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"3d1ec558-95de-441a-841d-1b109acede0a\" src='/img/4_1_1775918321089841.png'>",
    "choice1": "円",
    "choice2": "円",
    "choice3": "円",
    "choice4": "円",
    "choice5": "2305 設例改",
    "categoryName": "ライフ",
    "rontenName": "年金額の計算",
    "important": ""
  },
  {
    "id": 77,
    "shikenId": 4,
    "no": 2,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_76.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、Ａさん夫妻が受給することができる公的年金制度からの老齢給付について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「Ａさんは特別支給の老齢厚生年金を受給することができませんが、妻Ｂさんは64歳から報酬比例部分のみの特別支給の老齢厚生年金を受給することができます」",
    "choice2": "「仮に、Ａさんが60歳０カ月で老齢基礎年金および老齢厚生年金の繰上げ支給を請求した場合の減額率は24％となります。繰上げ支給を請求した場合は、一生涯減額された年金額を受け取ることになります」",
    "choice3": "「Ａさんが希望すれば、66歳以後、老齢基礎年金および老齢厚生年金の繰下げ支給の申出をすることができます。Ａさんの場合、繰下げの上限年齢は70歳です」",
    "choice4": "",
    "choice5": "2305 設例改",
    "categoryName": "ライフ",
    "rontenName": "公的年金制度からの老齢給付",
    "important": ""
  },
  {
    "id": 78,
    "shikenId": 4,
    "no": 3,
    "answerType": 6,
    "groupId": 0,
    "answer": "ニ,イ,チ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_76.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、雇用保険の高年齢雇用継続基本給付金および在職老齢年金について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ 「ＡさんがＸ社の継続雇用制度を利用して、60歳以後も引き続きＸ社に勤務し、かつ、60歳以後の各月（支給対象月）に支払われた賃金額（みなし賃金を含む）が60歳到達時の賃金月額の（ ① ）％未満となる場合、Ａさんは、所定の手続により、原則として、高年齢雇用継続基本給付金を受給することができます。<br>高年齢雇用継続基本給付金の額は、支給対象月ごとに、その月に支払われた賃金額の低下率に応じて、一定の方法により算定されますが、賃金額が60歳到達時の賃金月額の61％未満となる場合、原則として、当該金額は賃金額の（ ② ）％に相当する額になります」<br>Ⅱ 「Ａさんが、65歳以後も引き続き厚生年金保険の被保険者としてＸ社に勤務し、かつ、65歳から老齢厚生年金を受給する場合、Ａさんの老齢厚生年金の報酬比例部分の額に基づく基本月額と総報酬月額相当額との合計額が（ ③ ）（支給停止調整額、2026年度価額）以下のときは調整が行われず、老齢厚生年金は全額支給されます」<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"3b23a856-dd64-4c14-9087-c2636a46ff22\" src='/img/4_3_1775918322022306.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "2305 設例改",
    "categoryName": "ライフ",
    "rontenName": "高年齢雇用継続基本給付金等",
    "important": ""
  },
  {
    "id": 79,
    "shikenId": 4,
    "no": 4,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_79.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、公的年金制度からの給付および公的介護保険からの保険給付について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。なお、各記述において、ほかに必要とされる要件等は満たしていることとする。",
    "choice1": "「Ａさんが死亡した場合、妻Ｂさんに対して、遺族厚生年金が支給されます。遺族厚生年金の額は、原則として、Ａさんの厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の３分の２相当額になります」",
    "choice2": "「Ａさんが病気やケガで重度の障害状態となり、その障害の程度が障害等級１級と認定された場合、Ａさんは障害厚生年金を受給することができますが、Ａさんには子どもがいないため、障害基礎年金を受給することはできません」",
    "choice3": "「Ａさんのような公的介護保険の第２号被保険者は、要介護状態または要支援状態となった原因が特定疾病によって生じたものでなければ、公的介護保険からの保険給付は受けられません。特定疾病の具体例として、末期がん、脳血管疾患、初老期における認知症などが挙げられます」",
    "choice4": "",
    "choice5": 2401,
    "categoryName": "保険（個人）",
    "rontenName": "公的年金制度・公的介護保険",
    "important": ""
  },
  {
    "id": 80,
    "shikenId": 4,
    "no": 5,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,1,1,2",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_79.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の内容等について説明した。Ｍさんが説明した次の記述①～④について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「Ａさんが死亡した場合、妻Ｂさんに支払われる死亡保険金額は、600万円となります。Ａさんが死亡した場合の必要保障額を算出し、準備すべき死亡保障の額を確認したうえで、死亡保険金額をご検討ください」",
    "choice2": "「Ａさんが病気やケガで重度の障害状態となって働けなくなった場合、Ａさんの収入が減るだけでなく、妻Ｂさんの仕事にも影響がでることが想定されます。現在提案を受けている生活介護収入保障特約など、重い障害や介護に備えることができる保障を準備することは検討に値します」",
    "choice3": "「がん等の重度疾病については、再発のリスクがあり、治療期間も長期にわたるケースがあります。そのため、重度疾病の保障を準備する際には、再発時の保障の有無や、保険金等が支払われる疾病の種類および状態を確認する必要があります」",
    "choice4": "「Ａさんが厚生労働大臣により定められた先進医療による療養を受けたとき、その先進医療の技術に係る費用と同額を先進医療給付金として受け取ることができます。ただし、先進医療特約の対象は入院を伴った治療のみであり、外来での治療は対象外となります」",
    "choice5": 2401,
    "categoryName": "保険（個人）",
    "rontenName": "生命保険の内容等",
    "important": ""
  },
  {
    "id": 81,
    "shikenId": 4,
    "no": 6,
    "answerType": 6,
    "groupId": 0,
    "answer": "ニ,ロ,リ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_79.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の課税関係について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ 「支払保険料のうち、終身保険特約および定期保険特約に係る保険料は一般の生命保険料控除の対象となります。他方、生活介護収入保障特約、重度疾病保障特約および総合医療特約等に係る保険料は介護医療保険料控除の対象となります。それぞれの適用限度額は、所得税で（ ① ）円、住民税で（ ② ）円です」<br>Ⅱ 「被保険者であるＡさんが入院給付金などを請求することができない特別な事情がある場合には、指定代理請求人である妻ＢさんがＡさんに代わって請求することができます。妻Ｂさんが指定代理請求人として受け取る入院給付金は、（ ③ ）となります」<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"32f0751b-f989-4ecb-9fff-06d87a6f566c\" src='/img/4_6_1775918322285228.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2401,
    "categoryName": "保険（個人）",
    "rontenName": "生命保険の課税関係",
    "important": ""
  },
  {
    "id": 82,
    "shikenId": 4,
    "no": 7,
    "answerType": 4,
    "groupId": 0,
    "answer": "1500,1750",
    "score": "1,2",
    "question1": "<img src='/img/setsu_82.png'/>",
    "question2": "仮に、将来Ｘ社がＡさんに役員退職金5,000万円を支給した場合、Ａさんが受け取る役員退職金について、次の①、②を答えなさい。〈答〉は万円単位とすること。なお、Ａさんの役員在任期間（勤続年数）を29年６カ月とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。<br>① 退職所得控除額<br>② 退職所得の金額",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "",
    "choice4": "",
    "choice5": 2405,
    "categoryName": "保険（法人）",
    "rontenName": "退職所得の金額",
    "important": ""
  },
  {
    "id": 83,
    "shikenId": 4,
    "no": 8,
    "answerType": 6,
    "groupId": 0,
    "answer": "イ,ニ,チ,ル",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_82.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、中小企業退職金共済制度（以下、「中退共」という）について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>「中退共は、中小企業の事業主が勤労者退職金共済機構と雇用者（従業員）を被共済者とする退職金共済契約を締結して、退職金を社外に積み立てる共済制度です。<br>掛金は、被共済者１人につき、月額5,000円から３万円までの範囲内から選択し、（ ① ）負担します。なお、短時間労働者（パートタイマー等）は、月額2,000円から加入することができ、役員は原則として加入することができません。<br>また、中退共に新たに加入する事業主に対して、原則として、掛金月額の（ ② ）（被共済者１人ごとに5,000円が上限）を加入後４カ月目から（ ③ ）、国が助成する制度があります。<br>被共済者が中途（生存）退職したときの退職金は、勤労者退職金共済機構から（ ④ ）支給されます」<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"7029a832-6d40-4d63-8800-8e29e4078f53\" src='/img/4_8_1775918322789014.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2405,
    "categoryName": "保険（法人）",
    "rontenName": "中小企業退職金共済制度",
    "important": ""
  },
  {
    "id": 84,
    "shikenId": 4,
    "no": 9,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_82.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、〈資料〉の養老保険（福利厚生プラン）について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「福利厚生プランの保険料は、その全額を福利厚生費として損金の額に算入します」",
    "choice2": "「福利厚生プランは、原則として、役員・従業員全員を被保険者とする等の普遍的加入でなければなりませんので、制度導入後に入社した従業員について加入漏れがないように注意してください」",
    "choice3": "「死亡保険金が被保険者の遺族に支払われた場合、Ｘ社は当該保険契約に係る資産計上額を取り崩し、当該金額を雑損失として損金の額に算入します」",
    "choice4": "",
    "choice5": 2405,
    "categoryName": "保険（法人）",
    "rontenName": "養老保険（福利厚生プラン）",
    "important": ""
  },
  {
    "id": 85,
    "shikenId": 4,
    "no": 10,
    "answerType": 6,
    "groupId": 0,
    "answer": "ヘ,イ,ホ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_85.png'/>",
    "question2": "所得税における医療費控除に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を答えなさい。<br><br>「通常の医療費控除は、その年分の総所得金額等の合計額が200万円以上である納税者の場合、その年中に支払った医療費の総額（保険金等により補填される金額を除く）が（ ① ）円を超えるときは、その超える部分の金額（最高200万円）を総所得金額等から控除することができます。<br>また、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）では、定期健康診断や予防接種などの一定の取組みを行っている納税者が自己または自己と生計を一にする配偶者等のために特定一般用医薬品等購入費を支払った場合、その額（保険金等により補填される金額を除く）が（ ② ）円を超えるときは、その超える部分の金額（最高（ ③ ）円）を総所得金額等から控除することができます」<br><br><br><img data-image-id=\"I3\"  data-asset-scope=\"data_check\" data-asset-id=\"09df4609-8adb-4ac2-bf48-2d2ab8eb1606\" src='/img/4_10_1775918323133284.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "2409 設例改",
    "categoryName": "タックス",
    "rontenName": "医療費控除に関する数値",
    "important": ""
  },
  {
    "id": 86,
    "shikenId": 4,
    "no": 11,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_85.png'/>",
    "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「一時払養老保険は金融類似商品に該当するため、Ａさんが受け取った満期保険金に係る保険差益は源泉分離課税の対象となります」",
    "choice2": "「 Ａさんが通常の医療費控除の適用を受けた場合、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）の適用を受けることはできません」",
    "choice3": "「Ａさんが適用を受けることができる配偶者控除の控除額は、38万円です」",
    "choice4": "",
    "choice5": "2409 設例改",
    "categoryName": "タックス",
    "rontenName": "所得税の課税に関する記述",
    "important": ""
  },
  {
    "id": 87,
    "shikenId": 4,
    "no": 12,
    "answerType": 4,
    "groupId": 0,
    "answer": "6720000,630000,352500",
    "score": "1,1,2",
    "question1": "<img src='/img/setsu_85.png'/>",
    "question2": "Ａさん本年分の所得税の算出税額を計算した下記の表の空欄①～④に入る最も適切な数値を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-id=\"87e9cb98-d339-4b48-b0e6-ff3f45d2322b\" src='/img/4_12_1775918323766509.png' /><br><img data-image-id=\"I2\" data-asset-id=\"ad143e48-73ae-41e7-8534-e86888e9e35b\" src='/img/4_12_1775918324222628.png' style='width:520px' /><br><img data-image-id=\"I3\" data-asset-id=\"49d9327a-8195-4092-8e09-4c4416658017\" src='/img/4_12_1775918324515786.png' style='width:400px' />",
    "choice1": "円",
    "choice2": "円",
    "choice3": "円",
    "choice4": "",
    "choice5": "2409 設例改",
    "categoryName": "タックス",
    "rontenName": "所得税の算出税額",
    "important": ""
  },
  {
    "id": 88,
    "shikenId": 4,
    "no": 13,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_88.png'/>",
    "question2": "遺言に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。",
    "choice1": "「自筆証書遺言は、その遺言の全文および財産目録をパソコンで作成し、日付および氏名を自書して押印することで作成することができます」",
    "choice2": "「自筆証書遺言は、所定の手続により、法務局（遺言書保管所）に保管することができます。法務局に保管された自筆証書遺言は、遺言者の相続開始時に、家庭裁判所の検認が不要となります」",
    "choice3": "「公正証書遺言は、証人２人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人がこれを筆記して作成しますが、推定相続人が証人になることはできません」",
    "choice4": "",
    "choice5": 2309,
    "categoryName": "相続",
    "rontenName": "遺言に関する記述",
    "important": ""
  },
  {
    "id": 89,
    "shikenId": 4,
    "no": 14,
    "answerType": 6,
    "groupId": 0,
    "answer": "チ,ホ,ル,ロ",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_88.png'/>",
    "question2": "Ａさんの相続に関する以下の文章の空欄①～④に入る最も適切な語句を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ 「遺言により、自宅および現預金等を妻Ｂさん、Ｘ社関連の資産を長男Ｃさんに相続させた場合、二男Ｄさんの遺留分を侵害するおそれがあります。仮に、遺留分を算定するための財産の価額が６億円の場合、二男Ｄさんの遺留分の金額は、（ ① ）となります」<br>Ⅱ 「長男ＣさんがＸ社本社敷地を相続により取得し、当該敷地について、特定同族会社事業用宅地等として『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、当該敷地（相続税評価額8,000万円）について、相続税の課税価格に算入すべき価額を（ ② ）とすることができます。なお、自宅敷地とＸ社本社敷地について、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けようとする場合、（ ③ ）」<br>Ⅲ 「Ａさんが加入している一時払終身保険の死亡保険金は、みなし相続財産として相続税の課税対象となります。Ａさんの相続開始後、妻Ｂさんが受け取る死亡保険金2,000万円のうち、相続税の課税価格に算入される金額は、（ ④ ）となります」<br><img data-image-id=\"I1\" data-asset-id=\"052454b8-2252-4554-bfdf-127bebff4096\" src='/img/4_14_1775918324850567.png' />",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2309,
    "categoryName": "相続",
    "rontenName": "相続に関する語句",
    "important": ""
  },
  {
    "id": 90,
    "shikenId": 4,
    "no": 15,
    "answerType": 4,
    "groupId": 0,
    "answer": "4800,2820,13110",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_88.png'/>",
    "question2": "現時点（本年９月10日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を答えなさい。なお、相続税の課税価格の合計額は５億円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-id=\"6af55f64-919e-402a-a341-90a01bba6b35\" src='/img/4_15_1775918325144265.png' /><br><img data-image-id=\"I2\" data-asset-id=\"e74e7209-f83b-4916-b388-e4e704df4807\" src='/img/4_15_1775918325414732.png' />",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": 2309,
    "categoryName": "相続",
    "rontenName": "相続税の総額",
    "important": ""
  },
  {
    "id": 91,
    "shikenId": 2,
    "no": 1,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,2,2,1",
    "score": "1,1,1,1",
    "question1": "ファイナンシャル・プランナー（以下「ＦＰ」という）が、ファイナンシャル・プランニング業務を行ううえで関連業法等を順守することが重要である。ＦＰの行為に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択しなさい。",
    "question2": "",
    "choice1": "社会保険労務士資格を有していないＦＰが、顧客が持参した「ねんきん定期便」を基に、有償で公的年金の受給見込み額を計算した。",
    "choice2": "弁護士資格を有していないＦＰが、報酬を得て顧客の離婚問題における交渉代理人となり、ＦＰ業務の一環として法律的な判断に基づいて相手方との交渉を代行した。",
    "choice3": "投資助言・代理業の登録を受けていないＦＰが、独自の景気見通しを基に、有償で具体的な投資時期等を判断し、助言を行った。",
    "choice4": "税理士資格を有していないＦＰが、相続対策を検討している顧客に対し、有料の相談業務において、仮定の事例に基づく一般的な解説を行った。",
    "choice5": 2209,
    "categoryName": "ライフ",
    "rontenName": "FPと関連業法",
    "important": ""
  },
  {
    "id": 92,
    "shikenId": 2,
    "no": 2,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "「消費者契約法」に関する次の記述のうち、最も不適切なものはどれか。",
    "question2": "",
    "choice1": "消費者が、商品を購入せずに退去したい旨を申し出たが、認められずに困惑して契約した場合で、購入場所が事業者の店舗であるときは、当該契約は取り消すことができる。",
    "choice2": "「販売した商品は、いかなる理由があっても、後から返品・キャンセルはできません」とした契約条項は無効である。",
    "choice3": "消費者契約法では、個人および法人を保護の対象としている。",
    "choice4": "消費者の努力義務として、契約に際して事業者から提供された情報を活用し、契約内容を理解することが求められている。",
    "choice5": 2209,
    "categoryName": "ライフ",
    "rontenName": "消費者契約法",
    "important": ""
  },
  {
    "id": 93,
    "shikenId": 2,
    "no": 3,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "下記＜証券口座の概要＞に関する次の記述のうち、最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"b4253555-ea4e-4408-b1dd-5a751aa1821e\" src='/img/2_3_1776848339760968.png'>",
    "question2": "",
    "choice1": "金融商品取引業者等は、（ａ）のみを選択している個人投資家に対して、その口座内での１年間の取引をまとめて取引報告書を交付しなければならない。",
    "choice2": "年初の売却で（ｂ）を選択した場合、同年中の２度目以降の売却の際に（ｃ）に変更できない。",
    "choice3": "（ｃ）を選択した場合、ほかの金融商品取引業者等に開設している特定口座における損益と通算することはできない。",
    "choice4": "（ｄ）の非課税投資枠を超えた取引は、（ａ）で取引しなければならない。",
    "choice5": 2309,
    "categoryName": "金融",
    "rontenName": "証券口座の種類",
    "important": ""
  },
  {
    "id": 94,
    "shikenId": 2,
    "no": 4,
    "answerType": 8,
    "groupId": 1,
    "answer": "1,10,6,2",
    "score": "1,1,1,1",
    "question1": "個人向け国債（変動１０年）に関する下表の空欄（ア）～（エ）にあてはまる適切な語句または数値を語群の中から選び、その番号を選択しなさい。なお、同じ番号を何度選んでもよいこととする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"4d66ec94-2252-40a7-81ff-bf279bbdeab4\" src='/img/2_4_1776848340418561.png'><br><img data-image-id=\"I2\"  data-asset-scope=\"content_extraction\" data-asset-id=\"119a555e-e171-490b-a16f-fb0a1384f937\" src='/img/2_4_1776848340908948.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8|9|10",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2309,
    "categoryName": "金融",
    "rontenName": "個人向け国債",
    "important": ""
  },
  {
    "id": 95,
    "shikenId": 2,
    "no": 5,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 2,
    "question1": "馬場さんは、特定口座で保有しているＨＧ投資信託（追加型国内公募株式投資信託）の収益分配金を本年６月に受け取った。ＨＧ投資信託の運用状況が下記＜資料＞のとおりである場合、次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"84b6294a-ac49-4d54-980f-4dc43591e8e6\" src='/img/2_5_1776848341263430.png'>",
    "question2": "",
    "choice1": "（ア）１３,６００円 （イ）される",
    "choice2": "（ア）１４,１００円 （イ）される",
    "choice3": "（ア）１３,６００円 （イ）されない",
    "choice4": "（ア）１４,１００円 （イ）されない",
    "choice5": 2309,
    "categoryName": "金融",
    "rontenName": "収益分配金の課税関係",
    "important": ""
  },
  {
    "id": 96,
    "shikenId": 2,
    "no": 6,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "藤原さんは、勤務先に企業年金がないため、ＨＴ社を運営管理機関とする個人型確定拠出年金（以下「ｉＤｅＣｏ」という）に加入することを検討しており、下記＜資料＞を示してＦＰの小山さんに質問をした。小山さんの説明のうち、最も不適切なものはどれか。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"6815c3f6-6d45-4116-8374-90b94fee0b4e\" src='/img/2_6_1776848341879890.png'>",
    "question2": "",
    "choice1": "「ＨＴ社が扱う商品の中から１つだけを運用商品として、選択することはできません。」",
    "choice2": "「選択した運用商品は、ｉＤｅＣｏ加入中、原則として、いつでも変更することができます。」",
    "choice3": "「運用商品のうち投資信託には、国内株式型や国内債券型など投資対象となる資産によって分類されるものもありますが、バランス型のように複数資産を組み合わせたものもあります。」",
    "choice4": "「運用商品には、保険商品や定期預金等の元本確保型商品があり、所定の利息が上乗せされますが、金利情勢によっては利息額を手数料が上回る場合もあります。」",
    "choice5": 2309,
    "categoryName": "金融",
    "rontenName": "個人型確定拠出年金",
    "important": ""
  },
  {
    "id": 97,
    "shikenId": 2,
    "no": 7,
    "answerType": 9,
    "groupId": 0,
    "answer": 1494948,
    "score": 3,
    "question1": "雅之さんが取引をしている国内の証券会社から送付された本年分の特定口座年間取引報告書（抜粋）が下記＜資料＞のとおりである場合、翌年に繰り越すことのできる上場株式等の譲渡失の金額（上限）を計算しなさい。なお、雅之さんはこの他に有価証券取引は行っておらず、前年以前から繰り越された上場株式等の譲渡損失はないものとする。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"d8b4b785-9a05-4f04-b81d-73fe7f6c4446\" src='/img/2_7_1776848342536646.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2405,
    "categoryName": "金融",
    "rontenName": "特定口座年間取引報告書",
    "important": ""
  },
  {
    "id": 98,
    "shikenId": 2,
    "no": 8,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "建築基準法に従い、下記＜資料＞の土地に耐火建築物を建てる場合、建築面積の最高限度（ア）と延べ面積（床面積の合計）の最高限度（イ）の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない条件は一切考慮しないこと。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"1f654eb5-c42c-43bb-9148-d876bd818520\" src='/img/2_8_1776848343544421.png'>",
    "question2": "",
    "choice1": "（ア）１６２㎡ （イ）１０８０㎡",
    "choice2": "（ア）１８９㎡ （イ） ８６４㎡",
    "choice3": "（ア）１６２㎡ （イ） ８６４㎡",
    "choice4": "（ア）１８９㎡ （イ）１０８０㎡",
    "choice5": 2209,
    "categoryName": "不動産",
    "rontenName": "建築面積と延べ面積の最高限度",
    "important": ""
  },
  {
    "id": 99,
    "shikenId": 2,
    "no": 9,
    "answerType": 8,
    "groupId": 1,
    "answer": "1,2,4,5",
    "score": "1,1,1,1",
    "question1": "羽田さんは、所有しているアパートを貸すに当たり、ＦＰの近藤さんに借家契約の説明を受けた。借地借家法に基づく借家契約に関する下表の空欄（ア）～（エ）に入る最も適切な語句を語群の中から選びなさい。なお、同じ語句を何度選んでもよいこととする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"d1b8f73e-56db-4e9f-b6cb-566ae135cc4f\" src='/img/2_9_1776848344088157.png'><br><img data-image-id=\"I2\" / data-asset-scope=\"content_extraction\" data-asset-id=\"0b3a4bfb-9bf6-449d-b4b2-e7335b427d3d\" src='/img/2_9_1776848344544036.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2209,
    "categoryName": "不動産",
    "rontenName": "借家契約",
    "important": ""
  },
  {
    "id": 100,
    "shikenId": 2,
    "no": 10,
    "answerType": 8,
    "groupId": 1,
    "answer": "4,2,7",
    "score": "1,1,1",
    "question1": "飯田さんは、１００㎡ほどの土地付き中古一戸建て住宅の購入を検討しており、ＦＰで税理士でもある浅見さんに不動産にかかる税金について質問をした。下記の空欄（ア）～（ウ）に入る適切な語句を語群の中から選びなさい。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"3abd1b8e-9a8f-46af-8195-070cf440d285\" src='/img/2_10_1776848344986885.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2209,
    "categoryName": "不動産",
    "rontenName": "不動産にかかる税金",
    "important": ""
  },
  {
    "id": 101,
    "shikenId": 2,
    "no": 11,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "下記＜資料＞は、天野さんが購入を検討している投資用マンションの概要である。この物件の表面利回り（年利）と実質利回り（年利）の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない事項については一切考慮しないこととし、計算結果については小数点以下第３位を四捨五入すること。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"956722f9-f748-493a-85dc-65b6a23b8f74\" src='/img/2_11_1776848345942106.png'>",
    "question2": "",
    "choice1": "表面利回り（年利）：５.２０％ 実質利回り（年利）：３.８８％",
    "choice2": "表面利回り（年利）：５.２０％ 実質利回り（年利）：０.４０％",
    "choice3": "表面利回り（年利）：４.２０％ 実質利回り（年利）：３.８８％",
    "choice4": "表面利回り（年利）：４.２０％ 実質利回り（年利）：０.４０％",
    "choice5": 2209,
    "categoryName": "不動産",
    "rontenName": "表面利回りと実質利回り",
    "important": ""
  },
  {
    "id": 102,
    "shikenId": 2,
    "no": 12,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "雅之さんの父の三郎さんは老人ホームへの入居を検討しているため、ＦＰで税理士でもある飯田さんに所有する自宅の売却について相談をした。下記＜資料＞に基づく三郎さんの自宅の売却に係る所得税および住民税に関する次の記述の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、「居住用財産を譲渡した場合の３,０００万円の特別控除」および「居住用財産を譲渡した場合の長期譲渡所得の軽減税率の特例」の適用要件は満たしており、これらの適用を受けるものとする。また、所得控除その他記載のない事項については一切考慮しないものとする。<br><img data-asset-scope=\"data_check\" data-asset-id=\"44994352-5f89-43ef-a29f-99161f7b5efa\" src='/img/2_12_1776848346498586.png'>",
    "question2": "",
    "choice1": "（ア）２００万円 （イ）１０％ （ウ）４％",
    "choice2": "（ア）２００万円 （イ）１５％ （ウ）５％",
    "choice3": "（ア）６００万円 （イ）１０％ （ウ）５％",
    "choice4": "（ア）６００万円 （イ）１５％ （ウ）４％",
    "choice5": 2405,
    "categoryName": "不動産",
    "rontenName": "譲渡所得の特例",
    "important": ""
  },
  {
    "id": 103,
    "shikenId": 2,
    "no": 13,
    "answerType": 9,
    "groupId": 1,
    "answer": "22,72,30",
    "score": "1,1,1",
    "question1": "井上隆也さん（３８歳）が加入の提案を受けた生命保険の保障内容は下記＜資料＞のとおりである。<br>この生命保険に加入した場合、次の記述の空欄（ア）～（ウ）にあてはまる数値を解答欄に入力しなさい。なお、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"380f0d19-1641-40d1-bebb-3f888219717d\" src='/img/2_13_1776848347380492.png'><br><br>・ 井上さんが骨折により８日間継続して入院し、その間に約款所定の公的医療保険の対象となる手術を受け、退院から１ヵ月後に肺炎で５日間継続して入院した場合、保険会社から支払われる保険金・給付金の合計は（ ア ）万円である。<br>・ 井上さんが初めて上皮内がん（上皮内新生物）と診断され、治療のため５日間継続して入院し、その間に約款所定の公的医療保険の対象となる手術を１回受けた場合、保険会社から支払われる保険金・給付金の合計は（ イ ）万円である。<br>・ 井上さんがケガにより医師の指示に基づき自宅で４０日間療養し、当該期間について公的医療保険の在宅患者診療・指導料が算定されている場合、保険会社から支払われる保険金・給付金の合計は（ ウ ）万円である。",
    "question2": "",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": 2401,
    "categoryName": "リスク",
    "rontenName": "生命保険の補償内容",
    "important": ""
  },
  {
    "id": 104,
    "shikenId": 2,
    "no": 14,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "少額短期保険に関する次の記述の空欄（ア）～（エ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"d0010892-fdce-48f1-92bf-e38a12d03b91\" src='/img/2_14_1776848348873515.png'>",
    "question2": "",
    "choice1": "（ア）３００万円 （イ）１年 （ウ）２年 （エ）ならない",
    "choice2": "（ア）５００万円 （イ）１年 （ウ）１年 （エ）なる",
    "choice3": "（ア）３００万円 （イ）２年 （ウ）１年 （エ）ならない",
    "choice4": "（ア）５００万円 （イ）２年 （ウ）２年 （エ）なる",
    "choice5": 2401,
    "categoryName": "リスク",
    "rontenName": "少額短期保険",
    "important": ""
  },
  {
    "id": 105,
    "shikenId": 2,
    "no": 15,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,1,1,2",
    "score": "1,1,1,1",
    "question1": "加瀬さん（４５歳）は、下記＜資料＞の自動車保険に加入している。下記＜資料＞に基づく次の（ア）～（エ）の記述のうち、適切なものには○、不適切なものには×を選択しなさい。なお、＜資料＞に記載のない特約については考慮しないものとする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"24a92368-cf6b-4bbc-80ba-0f0d996941f8\" src='/img/2_15_1776848349409270.png'>",
    "question2": "",
    "choice1": "加瀬さんの友人（５０歳）が被保険自動車を運転中、他人にケガをさせ法律上の損害賠償責任を負った場合、補償の対象となる。",
    "choice2": "加瀬さんが被保険自動車を運転中、飛び石により窓ガラスが破損し、車両保険金のみが支払われた場合、当該事故はノンフリート等級別料率制度における「１等級ダウン事故」に該当する。",
    "choice3": "加瀬さんが被保険自動車を運転中、他人が運転する自動車と衝突し、加瀬さんがケガをした場合、過失割合にかかわらず治療費用の補償を受けることができる。",
    "choice4": "加瀬さんが所有する原動機付自転車を加瀬さんの妻（４０歳）が運転中、他人にケガをさせ法律上の損害賠償責任を負った場合、補償の対象とならない。",
    "choice5": 2401,
    "categoryName": "リスク",
    "rontenName": "自動車保険",
    "important": ""
  },
  {
    "id": 106,
    "shikenId": 2,
    "no": 16,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "羽田涼介さんが本年中に支払った終身保険と終身医療保険の保険料は下記＜資料＞のとおりである。<br>涼介さんの本年分の所得税の計算における生命保険料控除額として、正しいものはどれか。なお、下記＜資料＞の保険について、これまでに契約内容の変更はないものとする。また、本年分の生命保険料控除額が最も多くなるように計算すること。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"15ef7df2-604a-48f9-a289-484043a1b069\" src='/img/2_16_1776848351088306.png'>",
    "question2": "",
    "choice1": "７８,７８０円",
    "choice2": "８３,７８０円",
    "choice3": "８８,７８０円",
    "choice4": "９３,７８０円",
    "choice5": 2401,
    "categoryName": "リスク",
    "rontenName": "生命保険料控除額",
    "important": ""
  },
  {
    "id": 107,
    "shikenId": 2,
    "no": 17,
    "answerType": 9,
    "groupId": 0,
    "answer": 41100,
    "score": 2,
    "question1": "西川さんは地震保険の加入を検討している。下記＜資料＞に基づく西川さんの自宅に係る年間の地震保険料を計算しなさい。なお、西川さんの自宅は埼玉県にあるロ構造の一戸建てで、火災保険の保険金額は２,０００万円であり、地震保険の保険金額は、火災保険の保険金額に基づく契約可能な最大額とする。また、地震保険料の割引制度は考慮せず、解答に当たっては、解答欄に記載された単位に従うこと。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"e804f80f-ac7d-428d-a506-9d92311d78d2\" src='/img/2_17_1776848356794076.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2505,
    "categoryName": "リスク",
    "rontenName": "地震保険料",
    "important": ""
  },
  {
    "id": 108,
    "shikenId": 2,
    "no": 18,
    "answerType": 9,
    "groupId": 0,
    "answer": 540,
    "score": 2,
    "question1": "会社員の小田さんは、本年１２月末で３５年４ヵ月勤め続けてきた株式会社ＹＺを退職し、退職一時金３,０００万円を受け取った。この退職一時金に係る退職所得の金額はいくらになるか。なお、小田さんは、勤務先の役員であったことはなく、退職は障害者になったことに基因するものではない。また、解答に当たっては、解答欄に記載されている単位に従うこと。",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2301,
    "categoryName": "タックス",
    "rontenName": "退職所得の金額",
    "important": ""
  },
  {
    "id": 109,
    "shikenId": 2,
    "no": 19,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "公的年金等に係る所得税の取扱いに関する次の記述のうち、最も不適切なものはどれか。",
    "question2": "",
    "choice1": "小規模企業共済の共済金や確定拠出年金の老齢給付金は、年金形式で受け取る場合、公的年金等に係る雑所得の収入金額となる。",
    "choice2": "公的年金等に係る雑所得の金額の計算は、「公的年金等の収入金額－公的年金等控除額」により計算するが、公的年金等控除額は、受給者の年齢が７０歳以上か７０歳未満かにより、控除額が異なる。",
    "choice3": "公的年金等以外の総合課税となる雑所得の金額に、赤字が生じた場合、その赤字の金額と公的年金等に係る雑所得の金額を通算し、雑所得の金額を計算することができる。",
    "choice4": "公的年金等の収入金額が４００万円以下であり、かつ、その公的年金等の全部が源泉徴収の対象となる場合において、公的年金等に係る雑所得以外の所得金額の合計が２０万円以下であるときは、確定申告は不要である。",
    "choice5": 2301,
    "categoryName": "タックス",
    "rontenName": "公的年金等に係る所得税の取り扱い",
    "important": ""
  },
  {
    "id": 110,
    "shikenId": 2,
    "no": 20,
    "answerType": 9,
    "groupId": 1,
    "answer": "55,65,10",
    "score": "1,1,1",
    "question1": "所得税の青色申告特別控除制度に関する次の記述の空欄（ア）～（ウ）に入る適切な数値を解答欄に入力しなさい。<img data-asset-scope=\"data_check\" data-asset-id=\"ba851457-3cfc-4193-937f-d4af568cd39b\" src='/img/2_20_1776848359773729.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": 2301,
    "categoryName": "タックス",
    "rontenName": "青色申告特別控除制度",
    "important": ""
  },
  {
    "id": 111,
    "shikenId": 2,
    "no": 21,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 2,
    "question1": "会社員の山岸さんの年分の所得等が下記＜資料＞のとおりである場合、山岸さんが本年分の所得税の確定申告を行う際に、給与所得と損益通算できる損失に関する次の記述のうち、最も適切なものはどれか。なお、▲が付された所得金額は、その所得に損失が発生していることを意味する。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"ea5723cb-3e49-45ca-a6e6-9f279002ceb4\" src='/img/2_21_1776848360691959.png'>",
    "question2": "",
    "choice1": "不動産所得▲１００万円と損益通算できる。",
    "choice2": "副業の雑所得▲１０万円と損益通算できる。",
    "choice3": "上場株式の譲渡所得▲１５０万円と損益通算できる。",
    "choice4": "損益通算できる損失はない。",
    "choice5": 2301,
    "categoryName": "タックス",
    "rontenName": "損益通算できる損失",
    "important": ""
  },
  {
    "id": 112,
    "shikenId": 2,
    "no": 22,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,1,2,2",
    "score": "1,1,1,1",
    "question1": "大久保家が契約している保険の保険金等が支払われた場合の課税に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択しなさい。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"0bdfe265-c62d-46cb-ad01-bc2e6a9fcef1\" src='/img/2_22_1776848361387635.png'>",
    "question2": "",
    "choice1": "和雄さんが余命６ヵ月以内と診断され、定期保険Ａからリビング・ニーズ特約の生前給付金を受け取った後、和雄さんが死亡した場合、相続開始時点における残額は、相続税の課税対象となる。",
    "choice2": "和雄さんが死亡したことにより、留美子さんが受け取る定期保険Ａの死亡保険金は、相続税の課税対象となる。",
    "choice3": "自宅が火災で全焼となり、和雄さんが受け取る火災保険Ｂの損害保険金は、所得税（一時所得）の課税対象となる。",
    "choice4": "留美子さんが、がんに罹患して陽子線治療を受けたことによって、留美子さんが受け取る医療保険Ｃからの先進医療給付金は、所得税（一時所得）の課税対象となる。",
    "choice5": 2301,
    "categoryName": "タックス",
    "rontenName": "保険金等に対する課税",
    "important": ""
  },
  {
    "id": 113,
    "shikenId": 2,
    "no": 23,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "下記の相続事例（本年７月３０日相続開始）における相続税の課税価格の合計額として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"3d5a52f2-44b2-4dc7-ab8a-eb1e88d5ca13\" src='/img/2_23_1776848362319553.png'>",
    "question2": "",
    "choice1": "５,３００万円",
    "choice2": "５,５００万円",
    "choice3": "６,８００万円",
    "choice4": "８,５００万円",
    "choice5": 2409,
    "categoryName": "相続",
    "rontenName": "相続税の課税価格の合計額",
    "important": ""
  },
  {
    "id": 114,
    "shikenId": 2,
    "no": 24,
    "answerType": 8,
    "groupId": 1,
    "answer": "4,3,2,8",
    "score": "1,1,1,1",
    "question1": "木内さんは、父の相続開始後の手続き等について、ＦＰで税理士でもある高倉さんに質問をした。<br>下記の空欄（ア）～（エ）にあてはまる適切な語句を語群の中から選びなさい。なお、同じ番号を何度選んでもよいものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"eef0e45e-d808-4f35-9d8d-fc955fccab3c\" src='/img/2_24_1776848363307935.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2409,
    "categoryName": "相続",
    "rontenName": "相続開始後の手続き等",
    "important": ""
  },
  {
    "id": 115,
    "shikenId": 2,
    "no": 25,
    "answerType": 8,
    "groupId": 1,
    "answer": "5,9,2",
    "score": "1,1,1",
    "question1": "下記＜親族関係図＞の場合において、民法の規定に基づく法定相続分および遺留分に関する次の記述の空欄（ア）～（ウ）にあてはまる適切な語句または数値を語群の中から選びなさい。なお、同じ番号を何度選んでもよいものとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"8b4b3d58-82e2-4ada-aae0-057f92c31e79\" src='/img/2_25_1776848364499476.png'><br>［各相続人の法定相続分および遺留分］<br>・被相続人の弟の法定相続分は（ ア ）である。<br>・被相続人の甥の法定相続分は（ イ ）である。<br>・被相続人の配偶者の遺留分は（ ウ ）である。<br><img data-image-id=\"I2\" / data-asset-scope=\"content_extraction\" data-asset-id=\"5084649e-bce7-48a1-85db-2145169c7557\" src='/img/2_25_1776848364981697.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8|9",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2409,
    "categoryName": "相続",
    "rontenName": "法定相続分および遺留分",
    "important": ""
  },
  {
    "id": 116,
    "shikenId": 2,
    "no": 26,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "下記＜資料＞の宅地（貸家建付地）に係る路線価方式による相続税評価額の計算式として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"fe7b7bc2-7207-4185-8a75-044edf728413\" src='/img/2_26_1776848365370948.png'>",
    "question2": "",
    "choice1": "３５０,０００円×１.００×３００㎡",
    "choice2": "３５０,０００円×１.００×３００㎡×７０％",
    "choice3": "３５０,０００円×１.００×３００㎡×（１－７０％）",
    "choice4": "３５０,０００円×１.００×３００㎡×（１－７０％×３０％×１００％）",
    "choice5": 2409,
    "categoryName": "相続",
    "rontenName": "貸家建付地の相続税評価額",
    "important": ""
  },
  {
    "id": 117,
    "shikenId": 2,
    "no": 27,
    "answerType": 9,
    "groupId": 0,
    "answer": 54,
    "score": 2,
    "question1": "二木さん（３６歳）が、当年中に贈与を受けた財産の価額と贈与者が以下のとおりである場合の二木さんの当年分の贈与税額を計算しなさい。なお、記載のない事項については一切考慮しないものとする。<br>また、解答に当たっては、解答欄に記載されている単位に従うこと。<br>・二木さんの父からの贈与：現金５００万円<br>・二木さんの母からの贈与：現金 ３０万円<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"3e778a45-8705-45a8-a207-4800bdde772b\" src='/img/2_27_1776848366108438.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2505,
    "categoryName": "相続",
    "rontenName": "贈与税額の計算",
    "important": ""
  },
  {
    "id": 118,
    "shikenId": 2,
    "no": 28,
    "answerType": 9,
    "groupId": 0,
    "answer": 396,
    "score": 2,
    "question1": "下記は、福岡家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）にあてはまる数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用すること。また、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"ab84392d-b6e0-4e45-ba22-818d292c7139\" src='/img/2_28_1776848367048012.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2309,
    "categoryName": "ライフ",
    "rontenName": "CF表",
    "important": ""
  },
  {
    "id": 119,
    "shikenId": 2,
    "no": 29,
    "answerType": 9,
    "groupId": 0,
    "answer": 728,
    "score": 2,
    "question1": "下記は、中村家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）にあてはまる数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用すること。また、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"85ea8228-f87b-412c-af59-5706a8cb11a7\" src='/img/2_29_1776848368103037.png'><br>※年齢および金融資産残高は各年１２月３１日現在のものとする。<br>※給与収入は可処分所得で記載している。<br>※記載されている数値は正しいものとする。また、問題作成の都合上、一部を空欄としている。",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2505,
    "categoryName": "ライフ",
    "rontenName": "CF表",
    "important": ""
  },
  {
    "id": 120,
    "shikenId": 2,
    "no": 30,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "パーソナルファイナンスにおいては、ローンや消費生活に関する知識が必要である。クレジットカードの利用等に関する次の記述のうち、最も適切なものはどれか。",
    "question2": "",
    "choice1": "リボルビング払いの残高スライド方式は、支払残高があらかじめ決められた額を超えるごとに毎月の返済額を減額する支払方法である。",
    "choice2": "カードローンとクレジットカードのキャッシング機能を比較した場合、一般的にクレジットカードのキャッシング機能の方が金利は低い。",
    "choice3": "カードローンの金利に適用される利息制限法では、借入元本の額が１０万円未満、１０万円以上１００万円未満、１００万円以上の場合で、それぞれ金利の上限が異なる。",
    "choice4": "クレジットカードのフリーローンは、一般的に事業資金として使うことが認められている。",
    "choice5": 2409,
    "categoryName": "ライフ",
    "rontenName": "クレジットカードの利用",
    "important": ""
  },
  {
    "id": 121,
    "shikenId": 2,
    "no": 31,
    "answerType": 9,
    "groupId": 0,
    "answer": 4525000,
    "score": 2,
    "question1": "皆川さんは、住宅のリフォーム費用として、１０年後に５００万円を準備したいと考えている。年利 １.０％で１０年間複利運用する場合、現在いくらの資金があればよいか、下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"cb844387-68d7-43bd-963e-9c82bc128c55\" src='/img/2_31_1776848368964365.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2305,
    "categoryName": "ライフ",
    "rontenName": "6つの係数",
    "important": ""
  },
  {
    "id": 122,
    "shikenId": 2,
    "no": 32,
    "answerType": 9,
    "groupId": 0,
    "answer": 975000,
    "score": 2,
    "question1": "山根さんは、退職金の２,５００万円を今後３０年間、年利１.０％で複利運用しながら毎年１回、年末に均等に生活資金として取り崩していきたいと考えている。毎年取り崩すことができる最大金額はいくらになるか、下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"cb844387-68d7-43bd-963e-9c82bc128c55\" src='/img/2_32_1776848369668004.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2305,
    "categoryName": "ライフ",
    "rontenName": "6つの係数",
    "important": ""
  },
  {
    "id": 123,
    "shikenId": 2,
    "no": 33,
    "answerType": 9,
    "groupId": 0,
    "answer": 930000,
    "score": 2,
    "question1": "安藤さんは、子どもの留学資金として、１５年後に１,５００万円を準備したいと考えている。年利 １.０％で複利運用しながら毎年年末に一定額を積み立てる場合、毎年いくらずつ積み立てればよいか、下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"cb844387-68d7-43bd-963e-9c82bc128c55\" src='/img/2_33_1776848370489227.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2305,
    "categoryName": "ライフ",
    "rontenName": "6つの係数",
    "important": ""
  },
  {
    "id": 124,
    "shikenId": 2,
    "no": 34,
    "answerType": 9,
    "groupId": 0,
    "answer": 14020,
    "score": 2,
    "question1": "安藤家（雅之さんと裕子さん）の現時点の資産および負債が下記＜資料＞のとおりである場合、＜資料＞に基づく安藤家のバランスシートの空欄（ア）にあてはまる数値を計算しなさい。なお、記載のない事項については一切考慮しないものとする。<br><br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"8250319a-6cc8-467c-811a-fb0dc4f643f6\" src='/img/2_34_1776848371252020.png'><br><br><img data-image-id=\"I2\"  data-asset-scope=\"content_extraction\" data-asset-id=\"54c3d701-a857-4349-8218-63d05bec2ea0\" src='/img/2_34_1776848371996835.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": 2405,
    "categoryName": "ライフ",
    "rontenName": "バランスシート",
    "important": ""
  },
  {
    "id": 125,
    "shikenId": 2,
    "no": 35,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 3,
    "question1": "大久保和雄さんは、現在居住している自宅の住宅ローンの繰上げ返済を検討しており、ＦＰの岡さんに質問をした。和雄さんが住宅ローンを１２０回返済後に、１００万円以内で期間短縮型の繰上げ返済をする場合、この繰上げ返済により短縮される返済期間として、正しいものはどれか。なお、計算に当たっては、下記＜資料＞を使用し、繰上げ返済額は１００万円を超えない範囲での最大額とすること。また、繰上げ返済に伴う手数料等は考慮しないものとする。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"9477e168-1f11-447a-8d34-761daee358f2\" src='/img/2_35_1776848372809028.png'>",
    "question2": "",
    "choice1": "１年８ヵ月",
    "choice2": "１年７ヵ月",
    "choice3": "１年６ヵ月",
    "choice4": "１０ヵ月",
    "choice5": 2301,
    "categoryName": "ライフ",
    "rontenName": "繰上げ返済により短縮される返済期間",
    "important": ""
  },
  {
    "id": 126,
    "shikenId": 2,
    "no": 36,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 2,
    "question1": "安藤裕子さん（５４歳）は、老齢年金の繰上げ受給を検討しており、ＦＰの飯田さんに質問をした。<br>裕子さんの老齢基礎年金の繰上げ受給に関する次の記述のうち、最も不適切なものはどれか。",
    "question2": "",
    "choice1": "「老齢基礎年金の繰上げ請求を行った場合の年金額は、０.４％に繰上げ請求月から６５歳に達する月の前月までの月数を乗じた率に基づき減額されます。」",
    "choice2": "「老齢厚生年金の繰上げ請求を行うことができる人が老齢基礎年金の繰上げ請求をする場合、老齢厚生年金も同時に繰上げ請求しなければなりません。」",
    "choice3": "「老齢基礎年金と併せて付加年金を受給できる人が老齢基礎年金の繰上げ請求をした場合、付加年金も減額されて繰上げ支給されます。」",
    "choice4": "「２０歳から６０歳になるまでの間に保険料を納めていなかった期間がある人については、老齢基礎年金の繰上げ請求をした後であっても、国民年金に任意加入することができます。」",
    "choice5": 2405,
    "categoryName": "ライフ",
    "rontenName": "老齢年金の繰上げ受給",
    "important": ""
  },
  {
    "id": 127,
    "shikenId": 2,
    "no": 37,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "井上和義さんの家族構成等は下記＜資料＞のとおりである。和義さんが在職中に３８歳で死亡した場合、和義さんの死亡時点において妻の知代さんが受け取ることができる遺族給付の組み合わせとして、最も適切なものはどれか。なお、和義さんは、大学卒業後の２２歳から死亡時まで継続して厚生年金保険の被保険者であったものとする。また、家族に障害者に該当する者はなく、記載以外の遺族給付の受給要件はすべて満たしているものとする。<br><img data-image-id=\"I1\" / data-asset-scope=\"content_extraction\" data-asset-id=\"db16f403-2c14-4c9f-b362-07f06463514b\" src='/img/2_37_1776848373968432.png' style='width:500px'>",
    "question2": "",
    "choice1": "遺族基礎年金＋中高齢寡婦加算",
    "choice2": "遺族厚生年金＋中高齢寡婦加算",
    "choice3": "遺族基礎年金＋遺族厚生年金",
    "choice4": "遺族基礎年金＋遺族厚生年金＋中高齢寡婦加算",
    "choice5": 2505,
    "categoryName": "ライフ",
    "rontenName": "遺族給付",
    "important": ""
  },
  {
    "id": 128,
    "shikenId": 2,
    "no": 38,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,1,1,1",
    "score": "1,1,1,1",
    "question1": "安藤枝里子さん（３２歳）は、民間企業に勤務する会社員であり、現在妊娠中である。枝里子さんは、出産のために仕事を休んだ場合に支給される出産手当金や、産前産後休業中の社会保険料の取扱いについて、ＦＰの岡さんに質問をした。出産手当金および産前産後休業中の社会保険料に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択しなさい。なお、枝里子さんは、全国健康保険協会管掌健康保険（協会けんぽ）の被保険者であり、かつ厚生年金の被保険者であるものとする。<img data-asset-scope=\"data_check\" data-asset-id=\"fc84c7fa-a708-4a92-850b-3ecebce7f283\" src='/img/2_38_1776848374455114.png'>",
    "question2": "",
    "choice1": "空欄（ ａ ）にあてはまる語句は「４２日」である。",
    "choice2": "空欄（ ｂ ）にあてはまる語句は「３分の２」である。",
    "choice3": "空欄（ ｃ ）にあてはまる語句は「本人負担分および事業主負担分」である。",
    "choice4": "空欄（ ｄ ）にあてはまる語句は「保険料を納めた期間」である。",
    "choice5": 2301,
    "categoryName": "ライフ",
    "rontenName": "産前産後期間の社会保険",
    "important": ""
  },
  {
    "id": 129,
    "shikenId": 2,
    "no": 39,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,2,1,2",
    "score": "1,1,1,1",
    "question1": "安藤和雄さんは、労働者災害補償保険（以下「労災保険」という）について、ＦＰの岡さんに質問をした。労災保険の概要に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択しなさい。",
    "question2": "",
    "choice1": "労災保険は、在宅勤務をする労働者を給付対象としない。",
    "choice2": "労災保険における保険料率は、業種にかかわらず一律である。",
    "choice3": "労災保険の保険料は、その全額を事業主が負担する。",
    "choice4": "労働者が業務上の災害により労災指定病院等において療養を受けた場合は、その費用の１割を労働者が負担し、残る部分が療養補償給付となる。",
    "choice5": 2301,
    "categoryName": "ライフ",
    "rontenName": "労働者災害補償保険",
    "important": ""
  },
  {
    "id": 130,
    "shikenId": 2,
    "no": 40,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "雅之さんの妹の洋子さんは、本年２月中に病気（私傷病）療養のため休業した日がある。ＦＰの飯田さんが下記＜資料＞に基づいて計算した洋子さんに支給される傷病手当金の額として、正しいものはどれか。なお、洋子さんは全国健康保険協会管掌健康保険（協会けんぽ）の被保険者であるものとする。また、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"677ebc5f-10c3-4215-9de4-e29d77d0ea83\" src='/img/2_40_1776848375366909.png'>",
    "question2": "",
    "choice1": "１７,５６０円",
    "choice2": "２６,３４０円",
    "choice3": "４３,９００円",
    "choice4": "７０,２４０円",
    "choice5": 2405,
    "categoryName": "ライフ",
    "rontenName": "傷病手当金",
    "important": ""
  },
  {
    "id": 1000,
    "shikenId": 9,
    "no": 1,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "ファイナンシャル・プランナー（以下「ＦＰ」という）の顧客に対する行為に関する次の記述のうち、職業倫理や関連法規に照らし、最も不適切なものはどれか。",
    "choice1": "投資信託について顧客から相談を受けたＦＰのＡさんは、投資信託には元本保証および利回り保証のないことを説明した。",
    "choice2": "社会保険労務士の資格を有しないＦＰのＢさんは、顧客から公的年金の老齢給付の繰下げ支給について相談を受け、顧客の「ねんきん定期便」に記載されている年金見込額を基に、繰り下げた場合の年金額を試算した。",
    "choice3": "顧客からアパートの建設について相談を受けたＦＰのＣさんは、デベロッパーに事業計画策定のための資料として、顧客から預かっていた確定申告書（控）を顧客の同意を得ずにコピーして渡した。",
    "choice4": "税理士の資格を有しないＦＰのＤさんは、顧客から医療費控除やふるさと納税について相談を受け、制度の概要や確定申告の手続きについて説明した。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "FPの職業倫理と関連法規",
    "important": ""
  },
  {
    "id": 1001,
    "shikenId": 9,
    "no": 2,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "雇用保険に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "２つの事業所に雇用される６５歳以上の労働者で、１つの事業所における１週間の所定労働時間がそれぞれ５時間以上２０時間未満であり、かつ、２つの事業所における１週間の所定労働時間の合計が２０時間以上である者は、所定の要件を満たせば、申出により、雇用保険の高年齢被保険者となることができる。",
    "choice2": "雇用保険の適用事業所に雇用される労働者であって、所定の要件を満たす者は、日本国籍の有無にかかわらず、雇用保険の被保険者となる。",
    "choice3": "雇用保険の保険料は、失業等給付・育児休業給付に係る保険料および雇用保険二事業に係る保険料のすべてを事業主と労働者が折半して負担する。",
    "choice4": "基本手当の受給期間中に、妊娠、出産、育児、病気等により、引き続き３０日以上職業に就くことができない場合、所定の期間内の申出により、最長４年まで受給期間を延長することができる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "雇用保険",
    "important": ""
  },
  {
    "id": 1002,
    "shikenId": 9,
    "no": 3,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "労働者災害補償保険に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "派遣労働者が派遣先で業務上負傷した場合、派遣元事業が労働者災害補償保険の適用事業とされる。",
    "choice2": "労働者が業務上の負傷または疾病による療養のため労働することができず賃金を受けられない場合、賃金を受けられない日の第４日目から休業補償給付が支給される。",
    "choice3": "労働者が業務上死亡した場合、葬祭を行う者に葬祭料が支給される。",
    "choice4": "労働者が業務上の負傷または疾病が治癒したときに障害が残り、その障害の程度が所定の障害等級に該当するときは、障害補償年金または障害補償一時金のいずれかを選択して受給することができる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "労災保険",
    "important": ""
  },
  {
    "id": 1003,
    "shikenId": 9,
    "no": 4,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "公的年金に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "産前産後休業、育児休業を取得している厚生年金保険の被保険者の厚生年金保険料は、所定の手続きにより、被保険者負担分のみが免除される。",
    "choice2": "厚生年金保険の適用事業所に常時使用される者のうち、６５歳以上の者は、厚生年金保険の被保険者とならない。",
    "choice3": "国民年金の保険料免除期間に係る保険料のうち、追納することができる保険料は、追納に係る厚生労働大臣の承認を受けた日の属する月前５年以内の期間に係るものに限られる。",
    "choice4": "日本国籍を有するが日本国内に住所を有しない２０歳以上６５歳未満の者は、国民年金の第２号被保険者および第３号被保険者に該当しない場合、原則として、国民年金の任意加入被保険者となることができる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的年金の諸制度",
    "important": ""
  },
  {
    "id": 1004,
    "shikenId": 9,
    "no": 5,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "老齢基礎年金の繰下げ支給に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "老齢基礎年金の受給権を有する６６歳０ヵ月以上の者は、当該老齢基礎年金の繰下げ支給の申出をすることができる。",
    "choice2": "付加年金を受給できる者が老齢基礎年金の繰下げ支給の申出をした場合、付加年金の額は繰下げによって増額されない。",
    "choice3": "１９５２年（昭和２７年）４月２日以降生まれの者の老齢基礎年金の繰下げ支給による年金の増額率は、繰り下げた月数に０．７％を乗じて得た率で、最大４２％となる。",
    "choice4": "老齢厚生年金の受給権を有する者が老齢基礎年金の支給開始年齢を繰下げる場合は、同時に老齢厚生年金の支給開始年齢も繰下げなければならない。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老齢基礎年金の繰下げ支給",
    "important": ""
  },
  {
    "id": 1005,
    "shikenId": 9,
    "no": 6,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "公的年金の併給調整等に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "老齢厚生年金と障害基礎年金の受給権を有している者は、６５歳以降、老齢厚生年金と障害基礎年金を同時に受給することができる。",
    "choice2": "遺族厚生年金と老齢厚生年金の受給権を有している者は、６５歳以降、その者の選択によりいずれか一方の年金が支給され、他方の年金は支給停止となる。",
    "choice3": "遺族厚生年金と障害基礎年金の受給権を有している者は、６５歳以降、遺族厚生年金と障害基礎年金を同時に受給することができる。",
    "choice4": "障害厚生年金と労働者災害補償保険法に基づく障害補償年金が、同一の事由により支給される場合、障害厚生年金は全額支給され、障害補償年金は所定の調整率により減額される。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的年金の併給調整",
    "important": ""
  },
  {
    "id": 1006,
    "shikenId": 9,
    "no": 7,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "公的年金制度の障害給付に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "障害厚生年金の額を計算する際に、その計算の基礎となる被保険者期間の月数が３００月に満たない場合、３００月として計算する。",
    "choice2": "障害基礎年金の受給権者が、所定の要件を満たす配偶者を有する場合、その受給権者に支給される障害基礎年金には、配偶者に係る加算額が加算される。",
    "choice3": "国民年金の被保険者ではない２０歳未満の期間に初診日および障害認定日があり、２０歳に達した日において障害等級１級または２級に該当する程度の障害の状態にある者に対しては、その者の前年の所得の額にかかわらず、障害基礎年金が支給される。",
    "choice4": "障害手当金の支給を受けようとする者が、同一の傷病により労働者災害補償保険の障害補償給付の支給を受ける場合、障害手当金と障害補償給付の支給を同時に受けることができる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的年金の障害給付",
    "important": ""
  },
  {
    "id": 1007,
    "shikenId": 9,
    "no": 8,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "公的年金等に係る税金に関する次の記述のうち、最も不適切なものはどれか。<br>なお、記載のない事項については考慮しないものとする。",
    "choice1": "老齢基礎年金および老齢厚生年金は、その年中に受け取る当該年金の収入金額から公的年金等控除額を控除した金額が雑所得として所得税の課税対象となる。",
    "choice2": "老齢基礎年金および老齢厚生年金の受給者が死亡した場合、その者に支給されるべき年金のうち、支給されていなかった未支給年金は、その年金を受け取った遺族の一時所得として所得税の課税対象となる。",
    "choice3": "国民年金の保険料および国民年金基金の掛金は、いずれも社会保険料控除として所得税の所得控除の対象となる。",
    "choice4": "確定拠出年金の老齢給付金、小規模企業共済の加入者が事業を廃止した際に受け取る共済金のうち、年金形式で受給する場合は一時所得として所得税の課税対象となる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的年金の税務",
    "important": ""
  },
  {
    "id": 1008,
    "shikenId": 9,
    "no": 9,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "日本学生支援機構の貸与型奨学金および日本政策金融公庫の教育一般貸付（以下「国の教育ローン」という）に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "貸与型奨学金の一つである第一種奨学金の貸与を受けられるのは、国内の大学等に在学する特に優れた学生等であって、経済的理由により著しく修学に困難がある者とされている。",
    "choice2": "国の教育ローンの融資金利は固定金利であり、返済期間は、２０年以内とされている。",
    "choice3": "国の教育ローンを利用するためには、世帯年収（所得）が申込人の世帯で扶養している子の人数に応じて定められた額以下でなければならない。",
    "choice4": "国の教育ローンの資金使途は、受験にかかった費用（受験料、受験時の交通費・宿泊費など）と学校納付金（入学金、授業料、施設設備費など）に限定されている。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "教育資金",
    "important": ""
  },
  {
    "id": 1009,
    "shikenId": 9,
    "no": 10,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "クレジットカード会社（貸金業者）が発行するクレジットカードの一般的な利用に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "クレジットカードは、約款上、クレジットカード会社が所有権を有しており、クレジットカード券面上に印字された会員本人以外が使用することはできない。",
    "choice2": "クレジットカードで無担保借入（キャッシング）をする行為は、貸金業法上、総量規制の対象となるが、クレジットカードで商品を購入（ショッピング）する行為は、総量規制の対象外である。",
    "choice3": "クレジットカードで商品を購入（ショッピング）した場合の支払方法の１つである定額リボルビング払い方式は、カード利用時に代金の支払回数を決め、利用代金をその回数で分割して支払う方法である。",
    "choice4": "ＩＣチップを埋め込んであるクレジットカードを専用の端末機のある加盟店で利用する場合、署名に代えて暗証番号を入力することで決済することができる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "クレジットカード",
    "important": ""
  },
  {
    "id": 1010,
    "shikenId": 9,
    "no": 11,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "少額短期保険に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "少額短期保険業者と締結した保険契約は保険法の適用対象となるが、少額短期保険業者は保険業法の適用対象とならない。",
    "choice2": "少額短期保険の保険期間は、損害保険では２年、生命保険および傷害疾病保険では１年が上限である。",
    "choice3": "少額短期保険は、低発生率保険を適用している少額短期保険業者が引き受ける保険契約を除き、今後、新規または更新後に、被保険者１人につき加入できる保険金額の合計額は１, ５００万円が上限である。",
    "choice4": "破綻した少額短期保険業者と締結していた保険契約は、生命保険契約者保護機構または損害保険契約者保護機構による保護の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "少額短期保険",
    "important": ""
  },
  {
    "id": 1011,
    "shikenId": 9,
    "no": 12,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "低解約返戻金型終身保険は、他の契約条件が同じで低解約返戻金型ではない終身保険と比較して、保険料払込期間中および保険料払込終了後の解約返戻金が低く抑えられており、割安な保険料が設定されている。",
    "choice2": "養老保険は、被保険者に高度障害保険金が支払われた場合、保険期間満了時に満期保険金から高度障害保険金相当額が控除された金額が支払われる。",
    "choice3": "収入保障保険の死亡保険金を一時金で受け取る場合、年金形式で受け取る場合の受取総額よりも多くなる。",
    "choice4": "定期保険特約付終身保険（更新型）では、定期保険特約を同額の保険金額で自動更新すると、更新後の保険料は、通常、更新前よりも高くなる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険の商品性",
    "important": ""
  },
  {
    "id": 1012,
    "shikenId": 9,
    "no": 13,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "生命保険料控除に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "終身保険の保険料の払込みがないために自動振替貸付となった場合、それによって立て替えられた金額は、生命保険料控除の対象とならない。",
    "choice2": "２０１１年１２月３１日以前に締結した医療保険契約を２０１２年１月１日以後に更新した場合、更新後の保険料は介護医療保険料控除の対象となる。",
    "choice3": "２０１２年１月１日以後に締結した生命保険契約に付加された傷害特約および災害割増特約の保険料は、一般の生命保険料控除の対象となる。",
    "choice4": "外貨建て終身保険は、円貨建ての終身保険と異なり、支払った保険料が生命保険料控除の対象とならない。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険料控除",
    "important": ""
  },
  {
    "id": 1013,
    "shikenId": 9,
    "no": 14,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "契約者（＝保険料負担者）を法人、被保険者を役員とする生命保険に係る保険料等の経理処理に関する次の記述のうち、最も適切なものはどれか。なお、いずれの保険契約も新たに締結し、他に加入している保険契約はなく、保険料は年払いであるものとする。",
    "choice1": "被保険者が役員および従業員全員、死亡保険金受取人が被保険者の遺族、満期保険金受取人が被保険者である養老保険の支払保険料は、その全額を資産に計上する。",
    "choice2": "被保険者が特定の役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を損金の額に算入することができる。",
    "choice3": "給付金受取人が法人で、解約返戻金相当額のない短期払いの医療保険の支払保険料は、その事業年度に支払った保険料の額が被保険者１人当たり３０万円以下の場合、その支払った日の属する事業年度の損金の額に算入することができる。",
    "choice4": "死亡保険金受取人が法人で、最高解約返戻率が６５％である定期保険（保険期間２０年　被保険者１人当たり年換算保険料相当額３０万円超）の支払保険料は、保険期間の前半４割相当期間においては、その６０％相当額を資産に計上し、残額を損金の額に算入することができる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "法人契約の生命保険の経理処理",
    "important": ""
  },
  {
    "id": 1014,
    "shikenId": 9,
    "no": 15,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "損害保険による損害賠償等に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "失火の責任に関する法律によれば、失火により他人に損害を与えた場合、失火者に重大な過失がなかったときは、民法第７０９条（不法行為による損害賠償）の規定が適用される。",
    "choice2": "政府の自動車損害賠償保障事業および自動車損害賠償責任保険は、人身事故および物損事故による損害が対象となる。",
    "choice3": "施設所有（管理）者賠償責任保険では、被保険者が営む飲食店の店舗の床が清掃時の水で濡れていたことによって滑って転倒した来店客がケガをしたことについて、法律上の損害賠償責任を負った場合、補償の対象となる。",
    "choice4": "自動車保険の対人賠償保険では、被保険者が被保険自動車の運転中に起こした事故が原因で、兄弟姉妹にケガを負わせたことにより法律上の損害賠償責任を負った場合、補償の対象とならない。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "損害保険と法律",
    "important": ""
  },
  {
    "id": 1015,
    "shikenId": 9,
    "no": 16,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "地震保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "地震保険は、原則として火災保険に自動付帯となっているが、契約者が地震保険を付帯しないことの意思表示をした場合は、付帯しないことができる。",
    "choice2": "地震保険には、「建築年割引」「免震建築物割引」「耐震等級割引」「耐震診断割引」の４種類の保険料割引制度があり、重複して適用を受けることができる。",
    "choice3": "地震保険の保険料は、保険の対象となる居住用建物の構造と所在地によって異なる。",
    "choice4": "地震保険では、地震による津波によって建物が破損し、一定の損害を被った場合、補償の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "地震保険",
    "important": ""
  },
  {
    "id": 1016,
    "shikenId": 9,
    "no": 17,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "自動車保険のノンフリート等級別料率制度では、人身傷害保険の保険金が支払われる場合、３等級ダウン事故となる。",
    "choice2": "自動車を運転中に交通事故で被保険者が重傷を負った場合、その損害のうち被保険者自身の過失割合に相当する部分を差し引いたものが人身傷害補償保険の補償の対象となる。",
    "choice3": "車両保険を契約した場合、他に特約を付帯していなくても地震・噴火およびそれらに起因する津波による車両の損害は補償の対象となる。",
    "choice4": "運転免許失効中の被保険者が自動車を運転中に交通事故で他人を死傷させてしまった場合、その損害は対人賠償保険の補償の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "自動車保険",
    "important": ""
  },
  {
    "id": 1017,
    "shikenId": 9,
    "no": 18,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "個人が契約者（＝保険料負担者）となる損害保険の課税関係に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "自動車の運転中の交通事故により契約者が入院したことで家族傷害保険から受け取る保険金は、非課税となる。",
    "choice2": "契約者が年金払積立傷害保険から毎年受け取る給付金（年金）は、一時所得として課税対象となる。",
    "choice3": "配偶者が不慮の事故で死亡したことにより契約者が家族傷害保険から受け取る死亡保険金は、相続税の課税対象となる。",
    "choice4": "個人事業主が一部を事業の用に供している自宅を保険の対象として契約した火災保険の保険料は、事業所得の金額の計算上、事業の用に供している部分も必要経費に算入することができない。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "損害保険の税務",
    "important": ""
  },
  {
    "id": 1018,
    "shikenId": 9,
    "no": 19,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "第三分野の保険や特約の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "所得補償保険では、ケガや病気によって就業不能となった場合であっても、所定の医療機関に入院しなければ、補償の対象とならない。",
    "choice2": "がん保険の入院給付金は、１回の入院での支払限度日数や保険期間を通じて累計した支払限度日数が定められている。",
    "choice3": "医療保険では、退院後に入院給付金を受け取り、その退院日の翌日から１８０日以内に前回と同一の疾病により再入院した場合、１回の入院での支払日数は前回の入院での支払日数と合算される。",
    "choice4": "先進医療特約では、契約時点において厚生労働大臣により定められていた先進医療が給付の対象となり、契約後に定められた先進医療は、給付の対象とならない。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "第三分野の保険",
    "important": ""
  },
  {
    "id": 1019,
    "shikenId": 9,
    "no": 20,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "法人に対する生命保険等を活用した福利厚生に係るアドバイスに関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "「従業員の死亡時に支給する弔慰金や死亡退職金の原資を準備したい」という顧客に対して、団体信用生命保険の活用をアドバイスした。",
    "choice2": "「休業補償規程に基づいて従業員に支給する休業の補償に係る給付の原資を準備したい」という顧客に対して、団体就業不能保障保険の活用をアドバイスした。",
    "choice3": "「従業員の死亡時に支給する死亡退職金や定年退職時に支給する退職金の原資を準備したい」という顧客に対して、養老保険の活用をアドバイスした。",
    "choice4": "「従業員の自助努力による財産形成を支援したい」という顧客に対して、勤労者財産形成貯蓄積立保険（一般財形）の活用をアドバイスした。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険を活用したリスク管理",
    "important": ""
  },
  {
    "id": 1020,
    "shikenId": 9,
    "no": 21,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "経済指標のうち、国内総生産（ＧＤＰ）および日本銀行の全国企業短期経済観測調査（日銀短観）に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "ＧＤＰは、国内で一定期間内に生産された財やサービスの付加価値の合計であり、海外で得た所得は含まれず、支出側の構成項目のうち、最も大きな構成比を占めるのは、民間最終消費支出である。",
    "choice2": "ＧＤＰには名目値と実質値があり、物価が持続的に低下する状態（デフレーション）にあるときは、一般に名目値が実質値を下回る。",
    "choice3": "日銀短観で公表される「業況判断ＤＩ」は、回答時点の業況とその３カ月後の業況予測について、「良い」と回答した企業の社数構成比から「悪い」と回答した企業の社数構成比を差し引いて算出される。",
    "choice4": "日銀短観の調査対象企業は、全国の資本金1,000 万円以上の民間企業（金融機関等を除く）の中から抽出され、調査は年４回実施され、その結果は、３月、６月、９月、１２月に公表される。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "経済指標",
    "important": ""
  },
  {
    "id": 1021,
    "shikenId": 9,
    "no": 22,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "銀行等の金融機関で取り扱う預金の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "期日指定定期預金は、据置期間経過後から最長預入期日までの間で、預金者が指定した日を満期日とすることができる。",
    "choice2": "貯蓄預金は、クレジットカード利用代金などの自動振替口座や、給与や年金などの自動受取口座として利用することができる。",
    "choice3": "スーパー定期預金は、預入期間が３年以上の場合、単利型と半年複利型があるが、半年複利型を利用することができるのは個人に限られる。",
    "choice4": "デリバティブを組み込んだ仕組預金には、金融機関の判断によって満期日が繰り上がったり、延長される商品がある。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "預金の一般的な商品性",
    "important": ""
  },
  {
    "id": 1022,
    "shikenId": 9,
    "no": 23,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "株式投資信託の一般的な運用手法等に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "個別銘柄の調査・分析に基づいて投資価値のある銘柄を選択し、その積上げによってポートフォリオを構築する運用手法は、トップダウン・アプローチと呼ばれる。",
    "choice2": "割高な銘柄の買建てと割安な銘柄の売建てをそれぞれ同程度の金額で行い、市場全体の変動に左右されない収益の確保を目指す手法を、マーケット・ニュートラル運用という。",
    "choice3": "企業の将来の売上高や利益の成長性が市場平均よりも高いと見込まれる銘柄を組み入れて運用するグロース運用は、ＰＥＲやＰＢＲが低い銘柄中心のポートフォリオとなる傾向がある。",
    "choice4": "「ブル型」「ベア型」と呼ばれる特殊型の投資信託のうち、「ベア型」は、ベンチマークが下落すると基準価額が上昇するように設計されている。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "投資信託",
    "important": ""
  },
  {
    "id": 1023,
    "shikenId": 9,
    "no": 24,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "債券投資のリスクに関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "債券の発行体の所在する国や地域における政治・経済状況の変化等により、債券価格が大きく変動したり、債券の元本や利子の支払不能等が生じたりするリスクを、一般に、カントリーリスクという。",
    "choice2": "債券の価格変動リスクは、表面利率などの他の条件が同一であれば、一般に、残存期間が長いほど高くなる。",
    "choice3": "債券の信用格付けにおいて、Ｂ（シングルビー）格相当以上の格付けが付された債券は、一般に、投資適格債と呼ばれ、信用リスクが低い債券とされる。",
    "choice4": "外貨建て債券の為替変動リスクを回避または軽減する方法の一つとして、当該債券の購入時に、その償還日にあわせて為替予約を行う為替ヘッジが考えられる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "債券投資",
    "important": ""
  },
  {
    "id": 1024,
    "shikenId": 9,
    "no": 25,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "東京証券取引所の市場区分や株価指数に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "日経平均株価は、プライム市場に上場している銘柄のうち、時価総額上位２２５銘柄を対象として算出される株価指標である。",
    "choice2": "プライム市場における上場維持基準は、株主数や流通株式数等において、スタンダード市場およびグロース市場よりも高い数値が設定されている。",
    "choice3": "東証株価指数（ＴＯＰＩＸ）は、プライム、スタンダード、グロース市場の全銘柄を対象として算出される。",
    "choice4": "ＪＰＸ日経インデックス４００は、プライム市場に上場する普通株式のうち、ＲＯＥや営業利益等の指標等により選定された４００銘柄を対象として算出される。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株式市場のしくみ",
    "important": ""
  },
  {
    "id": 1025,
    "shikenId": 9,
    "no": 26,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "個人（居住者）が国内の金融機関等を通じて行う外貨建て金融商品の取引等に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "国外の証券取引所に上場している外国株式を国内店頭取引により売買するためには、あらかじめ外国証券取引口座を開設する必要がある。",
    "choice2": "為替予約を締結していない外貨定期預金を満期時に円貨で払い戻した結果生じた為替差益は、一時所得として所得税の課税対象となる。",
    "choice3": "国内の証券取引所に上場している外国株式を国内委託取引により売買した場合の受渡日は、国内株式と同様に、売買の約定日から起算して４営業日目となる。",
    "choice4": "外貨預金の払戻し時において、預金者が外貨を円貨に換える場合に適用される為替レートは、預入金融機関が提示する対顧客直物電信売相場（ＴＴＳ）である。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "外貨建て金融商品",
    "important": ""
  },
  {
    "id": 1026,
    "shikenId": 9,
    "no": 27,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "金融派生商品の取引の一般的な仕組みや特徴等に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "オプション取引において、コール・オプションは「原資産を売る権利」、プット・オプションは「原資産を買う権利」であり、いずれも買い手は売り手に対してオプション料を支払う。",
    "choice2": "原資産を保有している投資家は、その先物取引で売りヘッジを行うことで、取引を行った時点以降の原資産価格の下落によって生じる評価損を先物取引の利益で相殺または軽減することができる。",
    "choice3": "金融派生商品を利用する場合、現物取引を行った場合と同等の投資効果を得るには、現物取引よりも多額の資金を投入する必要がある。",
    "choice4": "クーポンスワップは、異なる通貨間で将来の金利および元本を交換する通貨スワップである。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "金融派生商品",
    "important": ""
  },
  {
    "id": 1027,
    "shikenId": 9,
    "no": 28,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "ＮＩＳＡの成長投資枠およびつみたて投資枠に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "ＮＩＳＡのつみたて投資枠と成長投資枠は、同時に利用することはできない。",
    "choice2": "ＮＩＳＡの年間の非課税投資枠はつみたて投資枠は４０万円、成長投資枠は１２０万円である。",
    "choice3": "ＮＩＳＡを通じて購入した公募株式投資信託等に譲渡損失が生じた場合、その損失の金額は、特定口座や一般口座で生じた上場株式等に係る譲渡益の金額と損益の通算をすることができる。",
    "choice4": "ＮＩＳＡのつみたて投資枠を通じて購入することができる金融商品は、所定の要件を満たす公募株式投資信託やＥＴＦ（上場投資信託）であり、長期の積立・分散投資に適した一定の商品性を有するものに限られる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "NISA",
    "important": ""
  },
  {
    "id": 1028,
    "shikenId": 9,
    "no": 29,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "下記<資料>に基づくファンドAとファンドBの過去5 年間の運用パフォーマンスの比較評価に関する次の記述の空欄（ア）、（イ）にあてはまる組み合わせとして、最も適切なものはどれか。<br><img style='width:600px' data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"e01b857b-9e23-497c-90e6-36cb95068f56\" src='/img/9_29_1778645242200809.png'>",
    "choice1": "（ア）２．０　　（イ）ファンドＡ",
    "choice2": "（ア）２．０　　（イ）ファンドＢ",
    "choice3": "（ア）２．５　　（イ）ファンドＡ",
    "choice4": "（ア）２．５　　（イ）ファンドＢ",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "シャープレシオの計算",
    "important": ""
  },
  {
    "id": 1029,
    "shikenId": 9,
    "no": 30,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "金融サービス提供法、消費者契約法および金融商品取引法に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "金融サービス提供法では、金融商品販売業者等は重要事項の説明義務違反によって生じた顧客の損害を賠償する責任を負うとされ、当該顧客は説明義務違反を立証すれば、その説明義務違反と損害発生との因果関係を立証する必要はない。",
    "choice2": "金融サービス提供法が規定する金融商品の販売において、金融サービス提供法と消費者契約法の両方の規定を適用することができる場合は、金融サービス提供法が優先して適用される。",
    "choice3": "消費者契約法では、事業者の一定の行為により、消費者が誤認または困惑した場合、消費者は、消費者契約の申込みまたは承諾の意思表示を取り消すことができるとされている。",
    "choice4": "金融商品取引法等によれば、原則として、株式の信用取引を行う際の委託保証金の額は３０万円以上で、かつ、株式の約定金額に１００分の３０を乗じた金額以上でなければならないとされている。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "金融関連法規",
    "important": ""
  },
  {
    "id": 1030,
    "shikenId": 9,
    "no": 31,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "わが国の税制に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "所得税は、国や地方公共団体の会計年度と同様、毎年４月１日から翌年３月３１日までの期間を単位として課される。",
    "choice2": "所得税、相続税、贈与税、法人税は、納税者が自ら納付すべき税額を確定させ、申告・納付する申告納税方式を採用している。",
    "choice3": "税金を負担する者と税金を納める者が異なる税金を間接税といい、固定資産税や消費税は間接税に該当する。",
    "choice4": "相続税は国税に該当し、登録免許税は地方税に該当する。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "わが国の税制",
    "important": ""
  },
  {
    "id": 1031,
    "shikenId": 9,
    "no": 32,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "次のうち、所得税における非課税所得に該当しないものはどれか。",
    "choice1": "健康保険の傷病手当金",
    "choice2": "障害基礎年金",
    "choice3": "ふるさと納税の返礼品",
    "choice4": "雇用保険の基本手当や高年齢雇用継続基本給付金",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "非課税所得",
    "important": ""
  },
  {
    "id": 1032,
    "shikenId": 9,
    "no": 33,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "所得税の損益通算に関する記述のうち、最も適切なものはどれか。",
    "choice1": "不動産所得の金額の計算上生じた損失の金額は、上場株式等に係る譲渡所得の金額と損益通算することができる。",
    "choice2": "公的年金等以外の雑所得の金額の計算上生じた損失の金額は、不動産所得の金額と損益通算することができる。",
    "choice3": "総合課税の対象となる事業所得の金額の計算上生じた損失の金額は、公的年金等に係る雑所得の金額と損益通算することができる。",
    "choice4": "一時所得の金額の計算上生じた損失の金額は、給与所得の金額と損益通算することができる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "損益通算",
    "important": ""
  },
  {
    "id": 1033,
    "shikenId": 9,
    "no": 34,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "所得税における医療費控除に関する次の記述のうち、最も不適切なものはどれか。なお、「特定一般用医薬品等購入費を支払った場合の医療費控除の特例」は考慮しないものとする",
    "choice1": "納税者の合計所得金額が１，０００万円を超える場合、医療費控除の適用を受けることはできない。",
    "choice2": "納税者本人の電車やバスによる通院費は医療費控除の対象となるが、マイカーのガソリン代や病院の駐車場代は医療費控除の対象とならない。",
    "choice3": "医療費控除の対象となる医療費の金額は、原則としてその年中に実際に支払った金額が対象となり、年末の時点で未払いの金額はその年分の医療費控除の対象とならない。",
    "choice4": "健康診断により重大な疾病が発見され、かつ、当該診断に引き続きその疾病の治療をした場合の健康診断の費用は、医療費控除の対象となる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "医療費控除",
    "important": ""
  },
  {
    "id": 1034,
    "shikenId": 9,
    "no": 35,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "所得税における住宅借入金等特別控除（以下「住宅ローン控除」という）に関する次の記述のうち、最も適切なものはどれか。なお、本年１０月中に住宅ローンを利用して住宅を取得し、同月中にその住宅を居住の用に供したものとする。",
    "choice1": "取得した住宅が認定住宅等以外の一般の中古住宅である場合、住宅ローン控除の控除額は住宅ローンの年末残高３,０００万円までにつき控除率０.７％で計算され、控除期間は最長で１３年となる。",
    "choice2": "取得した住宅が店舗併用住宅である場合、その床面積の２分の１以上に相当する部分がもっぱら居住の用に供されなければ、住宅ローン控除の適用を受けることができない。",
    "choice3": "住宅ローン控除は、納税者が給与所得者である場合、所定の書類を勤務先に提出することにより、住宅を取得し、居住の用に供した年分から年末調整により適用を受けることができる。",
    "choice4": "住宅ローン控除の適用を受けていた者が、転勤等のやむを得ない事由により転居したため、取得した住宅を居住の用に供しなくなった場合、翌年以降に再び当該住宅をその者の居住の用に供したとしても、再入居した年以降、住宅ローン控除の適用を受けることはできない。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "住宅ローン控除",
    "important": ""
  },
  {
    "id": 1035,
    "shikenId": 9,
    "no": 36,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "次のうち、青色申告者のみが適用を受けることができる所得税の青色申告の特典として、最も不適切なものはどれか。",
    "choice1": "納税者と生計を一にする親族（１５歳未満である者を除く）でもっぱらその納税者の営む事業に従事する者に対して支払った所定の給与の全額必要経費算入",
    "choice2": "純損失の繰戻還付",
    "choice3": "雑損失の繰越控除",
    "choice4": "棚卸資産の評価における低価法の選択",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "青色申告",
    "important": ""
  },
  {
    "id": 1036,
    "shikenId": 9,
    "no": 37,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "法人税の仕組み等に関する次の記述のうち、最も適切なものはどれか。なお、法人はいずれも内国法人（普通法人）であるものとする。",
    "choice1": "期末資本金の額等が１億円以下の一定の中小法人に対する法人税の税率は、所得金額のうち年１，０００万円以下の部分については軽減税率が適用される。",
    "choice2": "新たに設立された法人が、その設立事業年度から青色申告の適用を受けるためには、設立の日以後２ヵ月経過した日と当該事業年度終了の日のいずれか早い日の前日までに、「青色申告承認申請書」を納税地の所轄税務署長に提出しなければならない。",
    "choice3": "法人は、その本店の所在地または当該代表者の住所地のいずれかから法人税の納税地を任意に選択することができる。",
    "choice4": "法人税における事業年度とは、法令または定款等により定められた１年以内の会計期間がある場合にはその期間をいう。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "法人税の仕組み",
    "important": ""
  },
  {
    "id": 1037,
    "shikenId": 9,
    "no": 38,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "消費税に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "個人事業者における特定期間とは、その年の前年１月１日から６月３０日までの期間をいう。",
    "choice2": "簡易課税制度の適用を受けることができる事業者は、消費税の課税期間に係る基準期間における課税売上高が５，０００万円以下の事業者である。",
    "choice3": "簡易課税制度の適用を受けようとする事業者は、原則として、その適用を受けようとする課税期間の開始の日の前日までに、「消費税簡易課税制度選択届出書」を納税地の所轄税務署長に提出しなければならない。",
    "choice4": "消費税の課税事業者である法人は、原則として、消費税の確定申告書を各課税期間の末日の翌日から１カ月以内に、納税地の所轄税務署長に提出しなければならない。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "消費税",
    "important": ""
  },
  {
    "id": 1038,
    "shikenId": 9,
    "no": 39,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "役員が所有する土地を無償で会社に譲渡した場合、その適正な時価相当額が会社の受贈益として益金の額に算入される。",
    "choice2": "会社が所有する土地を適正な時価よりも低い価額で役員に譲渡した場合、その適正な時価と譲渡価額との差額が役員の給与所得の収入金額に算入される。",
    "choice3": "役員が会社の所有する社宅に無償で居住している場合、通常の賃貸料相当額が役員の給与所得の収入金額に算入される。",
    "choice4": "役員が会社に無利息で金銭の貸付けを行った場合、原則として、通常収受すべき利息に相当する金額が役員の雑所得の収入金額に算入される。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "会社と役員間の取引に係る税金",
    "important": ""
  },
  {
    "id": 1039,
    "shikenId": 9,
    "no": 40,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "決算書の見方や一般的な特徴に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "貸借対照表の、純資産の部の合計額は、資産の部および負債の部の合計額と一致する。",
    "choice2": "貸借対照表の固定負債は、返済期限が決算日の翌日から起算して3 年以内に到来しない借入金等の負債の金額を表示している。",
    "choice3": "損益計算書の経常利益の額は、営業利益の額に営業外損益の額を加算・減算した額である。",
    "choice4": "損益計算書の営業利益の額は、売上高の額から売上原価の額を差し引いた額である。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "決算書",
    "important": ""
  },
  {
    "id": 1040,
    "shikenId": 9,
    "no": 41,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "不動産の登記に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "不動産の登記記録は、当該不動産の所有者の住所地である市町村および特別区の役所や役場に備えられている。",
    "choice2": "不動産の登記事項証明書の交付を請求することができるのは、当該不動産に利害関係を有する者に限られる。",
    "choice3": "不動産の売買契約を締結した当事者は、当該契約締結後１ヵ月以内に、所有権移転の登記をすることが義務付けられている。",
    "choice4": "区分建物に係る登記記録において、床面積は、壁その他の区画の内側線で囲まれた部分の水平投影面積（内法面積）により算出される。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の登記",
    "important": ""
  },
  {
    "id": 1041,
    "shikenId": 9,
    "no": 42,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "不動産の売買契約に係る民法の規定に関する次の記述のうち、最も不適切なものはどれか。なお、特約については考慮しないものとする。",
    "choice1": "未成年者が法定代理人の同意を得ずに、不動産の売買契約を締結した場合であっても、原則として、法定代理人は当該売買契約を取り消すことができない。",
    "choice2": "不動産が共有されている場合に、各共有者が、自己が有している持分を共有者以外の者に売却するときは、他の共有者の同意を得る必要はない。",
    "choice3": "売買契約締結後、買主の責めに帰することができない事由により、当該契約の目的物の引渡債務の全部が履行不能となった場合、買主は履行の催告をすることなく、直ちに契約の解除をすることができる。",
    "choice4": "同一の不動産について二重に売買契約が締結された場合、譲受人相互間においては、売買契約の締結の先後にかかわらず、原則として、所有権移転登記を先にした者が、当該不動産の所有権の取得を他方に対抗することができる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の売買契約（民法）",
    "important": ""
  },
  {
    "id": 1042,
    "shikenId": 9,
    "no": 43,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "借地借家法に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、同法第２２条から第２４条の定期借地権等以外の借地権を普通借地権という。",
    "choice1": "普通借地権の設定契約において、期間の定めがない場合には、存続期間は３０年となる。",
    "choice2": "普通借地権の存続期間が満了した場合、契約の更新がないときは、借地権者は、借地権設定者に対して、建物その他借地権者が権原により土地に附属させた物を時価で買い取るべきことを請求することができる。",
    "choice3": "事業用定期借地権等においては、建物の用途は事業用に限定されているため、法人が従業員向けの社宅として利用する建物の所有を目的として設定することができる。",
    "choice4": "建物の譲渡により建物譲渡特約付借地権が消滅した場合において、当該建物を使用する賃借人が借地権設定者に対して建物の継続使用を請求したときには、賃借人と借地権設定者との間で存続期間の定めのない建物の賃貸借がされたものとみなされる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "借地権",
    "important": ""
  },
  {
    "id": 1043,
    "shikenId": 9,
    "no": 44,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "借地借家法に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、同法第３８条による定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。また、記載のない事項については考慮しないものとする。",
    "choice1": "普通借家契約において存続期間を６ヵ月と定めた場合、その存続期間は１年とみなされる。",
    "choice2": "普通借家契約および定期借家契約において、賃借人は、原則として、その建物の賃借権の登記がなくても、引渡しを受けていれば、その後その建物について物権を取得した者に賃借権を対抗することができる。",
    "choice3": "普通借家契約および定期借家契約において、賃借人に造作買取請求権を放棄させる旨の特約は有効となる。",
    "choice4": "定期借家契約において、経済事情の変動があっても賃料を増減額しないこととする特約をした場合、その特約は有効である。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "借家権",
    "important": ""
  },
  {
    "id": 1044,
    "shikenId": 9,
    "no": 45,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "市街化調整区域は、すでに市街地を形成している区域およびおおむね１０年以内に優先的かつ計画的に市街化を図るべき区域とされている。",
    "choice2": "市街化区域については用途地域を定め、市街化調整区域については原則として用途地域を定めないものとされている。",
    "choice3": "都市計画区域内において、用途地域が定められている区域については、防火地域または準防火地域のいずれかを定めなければならない。",
    "choice4": "市街化区域における開発行為は、その規模にかかわらず、都道府県知事等の許可が必要である。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "都市計画法",
    "important": ""
  },
  {
    "id": 1045,
    "shikenId": 9,
    "no": 46,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "建築物の敷地は、原則として、建築基準法に規定する道路に、２ｍ以上接していなければならない。",
    "choice2": "防火地域内に耐火建築物を建築する場合、建蔽率の制限について緩和措置を受けられる。",
    "choice3": "建築物の敷地が異なる２つの用途地域にわたる場合、その建築物の全部について、敷地の過半の属する用途地域の建築物の用途に関する規定が適用される。",
    "choice4": "建築基準法第４２条第２項の道路に面している敷地のうち、道路と道路境界線とみなされる線までの間の敷地部分（セットバック部分）は、建蔽率および容積率を算定する際の敷地面積に算入することができる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "建築基準法",
    "important": ""
  },
  {
    "id": 1046,
    "shikenId": 9,
    "no": 47,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "不動産の取得に係る税金に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "不動産取得税は、贈与により取得した場合には課税されるが、相続により不動産を取得した場合には課税されない。",
    "choice2": "所定の要件を満たす戸建て住宅（認定長期優良住宅を除く）を新築した場合、不動産取得税の課税標準の算定に当たっては、１戸につき最高１, ５００万円を価格から控除することができる。",
    "choice3": "不動産に抵当権設定登記をする際の登録免許税の課税標準は、当該不動産の固定資産税評価額である。",
    "choice4": "所有権移転登記に係る登録免許税の税率は、登記原因が贈与による場合の方が相続による場合よりも低い。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の取得に係る税金",
    "important": ""
  },
  {
    "id": 1047,
    "shikenId": 9,
    "no": 48,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "個人が土地を譲渡した場合の譲渡所得に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "譲渡所得の金額の計算上、取得費が不明な場合には、譲渡収入金額の１０％相当額を取得費とすることができる。",
    "choice2": "譲渡所得のうち、土地を譲渡した日の属する年の１月１日における所有期間が１０年以下のものについては短期譲渡所得に区分される。",
    "choice3": "譲渡するために直接要した仲介手数料は、譲渡所得の金額の計算上、譲渡費用に含まれる。",
    "choice4": "土地の譲渡に係る譲渡所得の金額は、当該土地の所有期間の長短にかかわらず、他の所得の金額と合算して税額が計算される。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "土地に係る譲渡所得",
    "important": ""
  },
  {
    "id": 1048,
    "shikenId": 9,
    "no": 49,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "居住用財産を譲渡した場合の３,０００万円の特別控除（以下、３,０００万円特別控除）と居住用財産を譲渡した場合の長期譲渡所得の課税の特例（以下、軽減税率の特例）、特定居住用財産の買換えの場合の長期譲渡所得の課税の特例に関する次の記述のうち、最も適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。",
    "choice1": "３, ０００万円特別控除と軽減税率の特例は、居住の用に供さなくなった日の属する年の翌年１２月３１日までに譲渡することが要件とされる。",
    "choice2": "軽減税率の特例の適用を受けた場合、課税長期譲渡所得のうち、１億円以下の部分の税率が軽減される。",
    "choice3": "特定居住用財産の買換えの場合の長期譲渡所得の課税の特例の適用を受ける場合、３, ０００万円特別控除および軽減税率の特例は重複して適用することはできない。",
    "choice4": "軽減税率の特例は譲渡する年の１月１日時点の所有期間が２０年を超えていることが要件とされる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "居住用財産の譲渡の特例",
    "important": ""
  },
  {
    "id": 1049,
    "shikenId": 9,
    "no": 50,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "不動産の投資判断の手法等に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "ＩＲＲ（内部収益率）とは、投資によって得られる将来のキャッシュフローの現在価値と投資額が等しくなる割引率をいう。",
    "choice2": "ＤＣＦ法は、連続する複数の期間に発生する純収益および復帰価格を、その発生時期に応じて現在価値に割り引き、それぞれを合計して対象不動産の収益価格を求める手法である。",
    "choice3": "ＮＯＩ利回り（純利回り）は、対象不動産から得られる年間の総収入を総投資額で除して算出される利回りであり、不動産の収益性を測る指標である。",
    "choice4": "レバレッジ効果とは、投資の収益率が借入金の金利を上回っている場合に、借入金を利用することにより自己資金に対する利回りが上昇する効果をいう。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の投資分析",
    "important": ""
  },
  {
    "id": 1050,
    "shikenId": 9,
    "no": 51,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "民法上の贈与に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "書面によらない贈与は、その履行の終わった部分を除き、各当事者が解除をすることができる。",
    "choice2": "死因贈与では、民法の遺贈に関する規定が準用され、贈与者の一方的な意思表示により成立し、贈与者の死亡によってその効力を生じる。",
    "choice3": "定期贈与は、贈与者または受贈者の死亡によって、その効力を失う。",
    "choice4": "負担付贈与では、受贈者がその負担である義務を履行しない場合において、贈与者が相当の期間を定めてその履行の催告をし、その期間内に履行がない場合、原則として、贈与者は、当該贈与の解除をすることができる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与",
    "important": ""
  },
  {
    "id": 1051,
    "shikenId": 9,
    "no": 52,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "親族等に係る民法の規定に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "親族の範囲は、３親等内の血族、配偶者、６親等内の姻族である。",
    "choice2": "特別養子縁組が成立した場合、原則として養子と実方の父母との親族関係は終了する。",
    "choice3": "相続開始時における胎児は、すでに生まれたものとみなされ、死産の場合を除き、相続権が認められる。",
    "choice4": "直系血族および兄弟姉妹は、互いに扶養をする義務があるが、家庭裁判所は、特別の事情があるときは、３親等内の親族間においても扶養の義務を負わせることができる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "親族等（民法）",
    "important": ""
  },
  {
    "id": 1052,
    "shikenId": 9,
    "no": 53,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "贈与税の申告と納付に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "贈与税の配偶者控除の適用を受けることにより納付すべき贈与税額が算出されない場合であっても、当該控除の適用を受けるためには、贈与税の申告書を提出する必要がある。",
    "choice2": "贈与税の申告書の提出期間は、原則として、贈与を受けた年の翌年２月１日から３月１５日までである。",
    "choice3": "贈与税の納付は、金銭による一括納付が原則であるが、所定の要件を満たせば物納が認められる。",
    "choice4": "贈与税を延納するには、納付すべき贈与税額が１０万円を超えていなければならない。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与税の申告と納付",
    "important": ""
  },
  {
    "id": 1053,
    "shikenId": 9,
    "no": 54,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "相続人が負担した次の費用等のうち、相続税の課税価格の計算上、相続財産の価額から債務控除をすることができるものはどれか。なお、相続人は債務控除の適用要件を満たしているものとする。",
    "choice1": "被相続人が生前に購入した墓碑の購入代金で、相続開始時点で未払いのものは、相続税の課税価格の計算上、相続財産の価額から債務控除することができる。",
    "choice2": "被相続人が所有していた不動産に係る固定資産税のうち、相続開始時点で納税義務は生じているが、納付期限が到来していない未払いのものは、相続税の課税価格の計算上、相続財産の価額から債務控除することができる。",
    "choice3": "被相続人に係る初七日および四十九日の法要に要した費用のうち、社会通念上相当と認められるものは、相続税の課税価格の計算上、相続財産の価額から債務控除することができる。",
    "choice4": "被相続人の相続に係る相続税の申告書を作成するために、相続人が支払った税理士報酬は、相続税の課税価格の計算上、相続財産の価額から債務控除することができる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "債務控除",
    "important": ""
  },
  {
    "id": 1054,
    "shikenId": 9,
    "no": 55,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "遺産分割に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "遺産の分割について、共同相続人間で協議が調わないときや協議をすることができないときは、各共同相続人は、家庭裁判所に調停または審判を申し立てることができる。",
    "choice2": "相続財産である不動産を、共同相続人間で分割するために売却して換価した場合、その所得は、所得税において非課税所得とされる。",
    "choice3": "適法に成立した遺産分割協議については、共同相続人全員の合意があったとしても、解除することは認められない。",
    "choice4": "被相続人は、遺言によって、相続開始のときから１０年間を超えない期間を定めて、遺産の分割を禁ずることができる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "遺産分割",
    "important": ""
  },
  {
    "id": 1055,
    "shikenId": 9,
    "no": 56,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "相続税の計算に関する次の記述のうち、最も不適切なものはどれか。なお、本問において、相続の放棄をした者はいないものとする。",
    "choice1": "遺産に係る基礎控除額の計算上、法定相続人の数に含めることができる養子（特別養子、代襲相続人である孫等の実子とみなされる者を除く）の数は、実子がいる場合、２人に制限される。",
    "choice2": "遺産に係る基礎控除額の計算上、法定相続人の数は、相続の放棄があっても、その放棄がなかったものとする。",
    "choice3": "相続税の２割加算の対象となるのは、兄弟姉妹や代襲相続人でない孫養子等であり、代襲相続人である孫は２割加算の対象とならない。",
    "choice4": "法定相続人が被相続人の配偶者のみである場合、「配偶者に対する相続税額の軽減」の適用を受けた配偶者については、相続により取得した遺産額の多寡にかかわらず、納付すべき相続税額が生じない。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の計算",
    "important": ""
  },
  {
    "id": 1056,
    "shikenId": 9,
    "no": 57,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "相続税における宅地の評価に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "倍率方式とは、宅地の固定資産税評価額に市町村長が一定の地域ごとに定めた倍率を乗じて計算した金額によって評価する方式である。",
    "choice2": "正面と側方に路線がある宅地（角地）を路線価方式によって評価する場合、原則として、それぞれの路線価に奥行価格補正率を乗じた価額を比較し、低い方の路線価が正面路線価となる。",
    "choice3": "宅地の評価方法には、路線価方式と倍率方式とがあり、いずれの方式を採用するかは、納税者が任意に選択することができる。",
    "choice4": "路線価図において、路線に「３００C 」と記載されている場合、３００はその路線に面する標準的な宅地１㎡当たりの価額が３００千円であることを示し、Ｃはその路線に面する宅地の借地権割合が７０％であることを示す。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "宅地の評価",
    "important": ""
  },
  {
    "id": 1057,
    "shikenId": 9,
    "no": 58,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "金融資産の相続税評価に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "普通預金の価額は、課税時期現在の既経過利子の額が少額なものに限り、課税時期現在の預入高によって評価する。",
    "choice2": "外貨預金の邦貨換算は、原則として、取引金融機関が公表するその外貨預金の預入時における最終の対顧客直物電信買相場（ＴＴＢ）またはこれに準ずる相場による。",
    "choice3": "金融商品取引所に上場されている利付公社債の価額は、原則として、課税時期の最終価格と課税時期において利払い期が到来していない利息のうち源泉所得税相当額控除後の既経過利息の額との合計額によって評価する。",
    "choice4": "相続開始時において、保険事故がまだ発生していない生命保険契約（解約返戻金等のないものを除く）に関する権利の価額は、原則として、相続開始時においてその契約を解約するとした場合に支払われることとなる解約返戻金の額によって評価する。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "金融資産の評価",
    "important": ""
  },
  {
    "id": 1058,
    "shikenId": 9,
    "no": 59,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "小規模宅地等についての相続税の課税価格の計算の特例（以下「本特例」という）に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢において、相続人が相続により取得した宅地は、相続開始直前において被相続人の事業の用に供されていなかったものとし、他に必要とされる要件等はすべて満たしているものとする。",
    "choice1": "相続開始直前において被相続人の居住の用に供されていた宅地を相続により取得した被相続人の配偶者は、相続税の申告期限までに当該宅地を売却した場合であっても、本特例の適用を受けることができる。",
    "choice2": "相続開始直前において被相続人の居住の用に供されていた宅地を相続により取得した被相続人の子が、当該宅地上の被相続人の居住の用に供されていた一棟の建物に相続開始前から相続税の申告期限まで引き続き居住し、かつ、当該宅地を相続開始時から相続税の申告期限まで所有していた場合、本特例の適用を受けることができる。",
    "choice3": "相続開始直前において被相続人および被相続人の配偶者の居住の用に供されていた宅地を相続により取得した被相続人の子が、当該宅地を相続開始後に初めて自己の居住の用に供し、相続税の申告期限まで所有していた場合、本特例の適用を受けることができる。",
    "choice4": "相続開始直前において被相続人と生計を一にする被相続人の母の居住の用に供されていた宅地を相続により取得した被相続人の配偶者は、本特例の適用を受けることができる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "小規模宅地等の特例",
    "important": ""
  },
  {
    "id": 1059,
    "shikenId": 9,
    "no": 60,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "中小企業における経営の承継の円滑化に関する法律による「遺留分に関する民法の特例」（以下、「本特例」という）に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "会社事業後継者が本特例の適用を受けるためには、遺留分を有する旧代表者の推定相続人および会社事業後継者全員の書面による合意が必要である。",
    "choice2": "本特例の適用を受けることにより、会社事業後継者が旧代表者から贈与により取得した自社株式について、その価額を、遺留分を算定するための財産の価額に算入しないことができる。",
    "choice3": "本特例の適用を受けることにより、会社事業後継者が旧代表者から贈与により取得した自社株式について、遺留分を算定するための財産の価額に算入すべき価額を、本特例の適用に係る合意をした時点の価額とすることができる。",
    "choice4": "本特例の対象となる会社事業後継者は、旧代表者の親族に限られる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "事業承継対策",
    "important": ""
  },
  {
    "id": 1060,
    "shikenId": 13,
    "no": 1,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "ファイナンシャル・プランナー（以下「ＦＰ」という）の顧客に対する行為に関する次の記述のうち、職業倫理や関連法規に照らし、最も不適切なものはどれか。",
    "choice1": "顧客から公正証書遺言の作成時に証人になることを要請されたＦＰが、証人の欠格事由に該当しないことを確認した上で、証人になった。",
    "choice2": "司法書士資格や弁護士資格を有しないＦＰが、顧客からの要請により、有償で当該顧客の任意後見受任者となった。",
    "choice3": "司法書士の資格を有しないＦＰが、住宅ローンを完済した顧客から、抵当権の抹消登記について相談を受け、申請書を作成して、登記手続きを代行した。",
    "choice4": "生命保険募集人や損害保険募集人でないＦＰが、生命保険の必要保障額を試算したり、生命保険や損害保険の商品の保障（補償）内容についてアドバイスをした。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "関連法規とコンプライアンス",
    "important": ""
  },
  {
    "id": 1061,
    "shikenId": 13,
    "no": 2,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "ライフプランニングにおいて活用される各種係数に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "一定の利率で複利運用しながら一定期間後の元利合計額を試算する場合、現在保有する資金の額に乗じる係数は、終価係数である。",
    "choice2": "一定の利率で複利運用しながら一定期間後に目標とする額を得るために必要な毎年の積立額を試算する場合、目標とする額に乗じる係数は、減債基金係数である。",
    "choice3": "一定の利率で複利運用しながら一定期間、毎年一定金額を積み立てた場合の一定期間後の元利合計額を試算する場合、毎年の積立額に乗じる係数は、年金終価係数である。",
    "choice4": "一定の利率で複利運用しながら一定期間、毎年一定金額を受け取るために必要な元本を試算する場合、毎年受け取りたい金額に乗じる係数は、資本回収係数である。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "各種係数",
    "important": ""
  },
  {
    "id": 1062,
    "shikenId": 13,
    "no": 3,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "公的医療保険に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "全国健康保険協会管掌健康保険（協会けんぽ）の一般保険料率は全国一律であるが、介護保険料率は都道府県ごと保険料率が異なる。",
    "choice2": "健康保険の適用事業所に常時使用される７５歳未満の者は、原則として、全国健康保険協会管掌健康保険（協会けんぽ）または組合管掌健康保険に加入することになる。",
    "choice3": "健康保険の任意継続被保険者となるためには、健康保険の被保険者資格を喪失した日の前日まで継続して２年以上の被保険者期間が必要である。",
    "choice4": "個人事業主などが被保険者となる国民健康保険は、国が保険者として運営している。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的医療保険",
    "important": ""
  },
  {
    "id": 1063,
    "shikenId": 13,
    "no": 4,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "国民年金の保険料に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "第１号被保険者で障害基礎年金を受給している者は、原則として、所定の届出により、保険料の納付が免除される。",
    "choice2": "学生を除く５０歳未満の第１号被保険者は、本人および配偶者の前年の所得（１月から６月までの月分の保険料については前々年の所得）がそれぞれ一定金額以下の場合、所定の申請により、保険料納付猶予制度の適用を受けることができる。",
    "choice3": "第１号被保険者である大学生は、本人の所得金額の多寡にかかわらず、所定の申請により、学生納付特例制度の適用を受けることができる。",
    "choice4": "第１号被保険者が出産する場合、所定の届出により、出産予定月の前月から４カ月間（多胎妊娠の場合は出産予定月の３カ月前から６カ月間）、保険料の納付が免除される。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "国民年金の保険料",
    "important": ""
  },
  {
    "id": 1064,
    "shikenId": 13,
    "no": 5,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "老齢厚生年金に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "６５歳以上の厚生年金保険の被保険者に支給される老齢厚生年金は、在職老齢年金の仕組みにより、その受給権者の総報酬月額相当額と基本月額との合計額が６５万円（本年度価額）を超えた場合、超える部分の２分の１が支給停止となる。",
    "choice2": "厚生年金保険適用事業所に勤めていても、７０歳以降は厚生年金保険の被保険者とはならないため、７０歳以降は在職老齢年金の仕組みは適用されない。",
    "choice3": "老齢厚生年金の加給年金は、その受給権者に、所定の要件を満たす配偶者または子があり、原則として、厚生年金保険の被保険者期間が２５年以上あることが支給要件とされる。",
    "choice4": "２０２２年４月１日以降に６０歳に到達する者の老齢厚生年金の繰上げ支給による減額率は、繰り上げた月数に０．５％を乗じて得た率で最大３０％となる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老齢厚生年金",
    "important": ""
  },
  {
    "id": 1065,
    "shikenId": 13,
    "no": 6,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "公的年金の遺族給付に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "遺族基礎年金を受給することができる遺族は、国民年金の被保険者等の死亡当時その者によって生計を維持し、かつ、所定の要件を満たす「子のある妻」または「子」である。",
    "choice2": "国民年金の第１号被保険者としての保険料納付済期間が３６月以上ある者が、老齢基礎年金または障害基礎年金の支給を受けないまま死亡し、遺族基礎年金の支給を受けられる遺族がいない場合、死亡した者と生計を同じくしていた一定の遺族に死亡一時金が支給される。",
    "choice3": "厚生年金保険の被保険者である夫が死亡し、子のない３０歳未満の妻が遺族厚生年金の受給権を取得した場合、その妻に対する遺族厚生年金の支給期間は、最長で１０年間である。",
    "choice4": "遺族厚生年金の年金額は、原則として、死亡した者の厚生年金保険の被保険者記録を基に計算された老齢厚生年金の報酬比例部分の３分の２相当額である。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的年金の遺族給付",
    "important": ""
  },
  {
    "id": 1066,
    "shikenId": 13,
    "no": 7,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "確定拠出年金に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "個人型年金に加入できるのは、国内に居住する国民年金の被保険者に限られる。",
    "choice2": "個人型年金の加入者が国民年金の第３号被保険者である場合、掛金の拠出限度額は年額２７６, ０００円である。",
    "choice3": "企業型年金において、加入者が掛金を拠出することができることを規約で定める場合、加入者掛金の額は、その加入者に係る事業主掛金の額を超える額とすることができない。",
    "choice4": "一時金で受け取る老齢給付金は、一時所得として所得税の課税対象となる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "確定拠出年金",
    "important": ""
  },
  {
    "id": 1067,
    "shikenId": 13,
    "no": 8,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "住宅金融支援機構と金融機関が締結した住宅ローンであるフラット３５（買取型）に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "フラット３５の融資額は、住宅の建設費または購入価額以内で、最高1億２，０００円である。",
    "choice2": "フラット３５を利用するためには、一戸建て住宅を購入する場合、専有面積が５０㎡以上でなければならない。",
    "choice3": "フラット３５を利用するためには、対象となる住宅について、住宅金融支援機構が第1 位の抵当権者となる。",
    "choice4": "フラット３５を利用している者が行う一部繰上げ返済について、インターネットを通じて申し込む場合には、返済金額１００万円から可能である。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "フラット35",
    "important": ""
  },
  {
    "id": 1068,
    "shikenId": 13,
    "no": 9,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "変動金利型の住宅ローンを返済しているAさんの返済方法の見直し等に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "Aさんが別の金融機関の住宅ローンに借り換える場合、元利均等返済を選択するほうが、他の条件が同じ元金均等返済と比べて、総返済額は少なくなる。",
    "choice2": "Aさんが住宅ローンの借換えに際して、現在借入れをしている金融機関の抵当権を抹消し、借換先の金融機関の抵当権を新たに設定する場合には、登録免許税等の諸費用が必要ない。",
    "choice3": "住宅金融支援機構と民間金融機関が提携して提供する「フラット３５」は、すべての商品が住宅取得時における利用に限定されているため、A さんは住宅ローンの借換先として選択することができない。",
    "choice4": "Aさんが全期間固定金利型の住宅ローンに借り換えた場合、仮に返済期間中に市中金利が上昇しても、金利の上昇分に相当する額の返済負担が増加するリスクは避けられる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "住宅ローンの返済方法の見直し",
    "important": ""
  },
  {
    "id": 1069,
    "shikenId": 13,
    "no": 10,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "中小企業による金融機関からの資金調達に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "当座貸越は、借入れについての内容や条件等を記載した金銭消費貸借契約証書によって資金を調達する方法である。",
    "choice2": "信用保証協会保証付融資（マル保融資）の対象となる企業には、業種に応じた資本金または常時使用する従業員数の要件はない。",
    "choice3": "ＡＢＬ（動産・債権担保融資）は、企業が保有する売掛債権等の債権や在庫・機械設備等の動産を担保として資金を調達する方法である。",
    "choice4": "インパクトローンは、米ドル等の外貨によって資金を調達する方法であり、その資金使途は限定されている。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "中小企業の資金調達",
    "important": ""
  },
  {
    "id": 1070,
    "shikenId": 13,
    "no": 11,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "保険法に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "保険法では、保険契約者と被保険者が異なる死亡保険契約は、その加入に当たって、被保険者の同意が必要とされる。",
    "choice2": "保険法では、告知義務に関して、同法の規定より保険契約者、被保険者にとって不利な内容である約款の定めは、適用除外となる一部の保険契約を除き、無効となる旨が定められている。",
    "choice3": "保険法は、保険契約と同等の内容を有する共済契約についても適用対象となる。",
    "choice4": "保険法では、保険金等の支払時期に関する規定が設けられており、同法の施行日後に締結された保険契約に限って適用される。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "保険法",
    "important": ""
  },
  {
    "id": 1071,
    "shikenId": 13,
    "no": 12,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "死亡保障を目的とする生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
    "choice1": "逓減定期保険は、保険期間の経過に伴い所定の割合で保険金額および保険料が逓減する。",
    "choice2": "終身保険の保険料は、被保険者の年齢、死亡保険金額、保険料払込期間など契約内容が同一の場合、一般に、被保険者が女性である方が男性であるよりも高い。",
    "choice3": "特定疾病保障定期保険は、被保険者がガン、急性心筋梗塞、脳卒中以外で死亡した場合には、死亡保険金は支払われない。",
    "choice4": "変額保険（終身型）は、一般に、契約時に定めた死亡保険金額（基本保険金額）が保証されている。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "死亡保障目的の生命保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 1072,
    "shikenId": 13,
    "no": 13,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "生命保険の保険料等の一般的な仕組みに関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "収支相等の原則は、保険会社が受け取る保険料等の総額が、保険会社が支払う保険金等の総額と等しくなるように保険料を算定することをいう。",
    "choice2": "生命保険の保険料は、将来の保険金等の支払いの財源となる純保険料と、保険会社が保険契約を維持・管理していくために必要な経費等の財源となる付加保険料で構成される。",
    "choice3": "終身保険の予定利率を低く設定した場合、新規契約の保険料は安くなる。",
    "choice4": "終身保険において、保険会社が設定した予定死亡率よりも、実際の死亡率が低かった場合、死差益が生じる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険の保険料の仕組み",
    "important": ""
  },
  {
    "id": 1073,
    "shikenId": 13,
    "no": 14,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "生命保険の税金に関する次の記述のうち、最も適切なものはどれか。なお、いずれも契約者（＝保険料負担者）および保険金・給付金等の受取人は個人であるものとする。",
    "choice1": "一時払終身保険を保険期間の初日から３年８カ月で解約して契約者が受け取った解約返戻金は、一時所得として総合課税の対象となる。",
    "choice2": "契約者と被保険者が同一人である終身保険において、被保険者がリビング・ニーズ特約に基づいて受け取った特約保険金は、一時所得として課税の対象となる。",
    "choice3": "契約者と被保険者が同一人である医療保険において、被保険者が疾病の治療により入院したことで受け取った入院給付金は、一時所得として課税の対象となる。",
    "choice4": "契約者と被保険者が同一人である養老保険において、被保険者の相続人ではない者が受け取った死亡保険金は、贈与税の課税対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "個人の生命保険の税金",
    "important": ""
  },
  {
    "id": 1074,
    "shikenId": 13,
    "no": 15,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "法人を契約者（＝保険料負担者）とする生命保険に係る保険料の経理処理に関する次の記述のうち、最も適切なものはどれか。なお、いずれも保険料は年払いで、いずれの保険契約も新たに締結したものとする。",
    "choice1": "被保険者が役員のみ、死亡保険金受取人が被保険者の遺族、満期保険金受取人が法人である養老保険の支払保険料は、その２分の１相当額を資産に計上し、残額を福利厚生費として損金の額に算入することができる。",
    "choice2": "被保険者が役員、死亡保険金受取人が法人で、最高解約返戻率が８０％である定期保険（保険期間１０年）の支払保険料は、保険期間の前半４割相当期間においては、その４０％相当額を資産に計上し、残額を損金の額に算入することができる。",
    "choice3": "被保険者が役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を資産に計上する。",
    "choice4": "被保険者が役員、給付金受取人が法人である解約返戻金のない医療保険の支払保険料は、資産に計上する。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "法人契約の生命保険の経理処理",
    "important": ""
  },
  {
    "id": 1075,
    "shikenId": 13,
    "no": 16,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "傷害保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "家族傷害保険の被保険者は、被保険者本人、配偶者、被保険者本人または配偶者と生計を共にする同居の親族および別居の未婚の子であり、その続柄は事故発生時におけるものによる。",
    "choice2": "普通傷害保険では、日本国外における業務中の事故によるケガは補償の対象とならない。",
    "choice3": "国内旅行傷害保険では、国内旅行中にかかった細菌性食中毒は補償の対象とならない。",
    "choice4": "海外旅行傷害保険では、日本を出国してから帰国するまでの間の事故によって被った損害を補償の対象としており、国内移動中の事故によるケガは補償の対象とならない。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "傷害保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 1076,
    "shikenId": 13,
    "no": 17,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "損害保険を活用した家庭のリスク管理に関する次の記述のうち、最も不適切なものはどれか。なお、契約者（＝保険料負担者）は個人とする。",
    "choice1": "病気やケガにより仕事にまったく従事できなくなるリスクに備えて、所得補償保険に加入した。",
    "choice2": "自宅を新築したため、地震により自宅が損壊するリスクに備えて、火災保険に地震保険を付帯して加入した。",
    "choice3": "自動車を運転中に、他人に接触してケガをさせて法律上の損害賠償責任を負うリスクに備えて、個人賠償責任保険に加入した。",
    "choice4": "同居している小学生の子が、学校生活でケガをするリスクに備えて、家族傷害保険に加入した。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "損害保険を利用した家庭のリスク管理",
    "important": ""
  },
  {
    "id": 1077,
    "shikenId": 13,
    "no": 18,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "地震保険料控除に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "地震保険料控除の控除限度額は、所得税では４０，０００円、住民税では２８，０００円である。",
    "choice2": "地震保険の保険期間が１年を超える長期契約で、地震保険料を一括で支払った場合、その全額が支払った年分の地震保険料控除の対象となる。",
    "choice3": "店舗併用住宅の所有者が、当該家屋を保険の対象とする火災保険に地震保険を付帯して契約した場合、当該家屋全体の９０％以上を居住の用に供しているときは、支払った地震保険料の全額を居住用として地震保険料控除を計算できる。",
    "choice4": "居住用家屋を保険の対象とする地震保険の保険料は、その家屋の所有者と契約者（＝保険料負担者）が同一人である場合に限り、地震保険料控除の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "地震保険料控除",
    "important": ""
  },
  {
    "id": 1078,
    "shikenId": 13,
    "no": 19,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "契約者（＝保険料負担者）を法人とする損害保険に係る経理処理に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "法人が所有する建物について長期の火災保険に加入し、保険料を一括で支払った場合、支払った保険料のうち当該事業年度に係る部分については損金の額に算入することができる。",
    "choice2": "業務中の事故で従業員が死亡し、普通傷害保険の死亡保険金が保険会社から従業員の遺族へ直接支払われた場合、法人は死亡保険金の一部を死亡退職金として損金の額に算入することができる。",
    "choice3": "法人が所有する業務用自動車が交通事故で全損となり、受け取った自動車保険の車両保険の保険金で同一事業年度内に代替となる車両を取得した場合、所定の要件に基づき圧縮記帳が認められる。",
    "choice4": "積立普通傷害保険の満期返戻金と契約者配当金を法人が受け取った場合、いずれも全額を益金の額に算入し、それまで資産計上していた積立保険料の累計額を取り崩して損金の額に算入することができる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "法人契約の損害保険の経理処理",
    "important": ""
  },
  {
    "id": 1079,
    "shikenId": 13,
    "no": 20,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "第三分野の保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "特定疾病保障保険は、ガンに罹患して特定疾病保険金が支払われた後も契約が存続し、ガンが再発した場合には、１度目の再発に限り特定疾病保険金が支払われる。",
    "choice2": "所得補償保険では、勤務している企業が倒産したことによって失業した場合、保険金が支払われる。",
    "choice3": "ガン保険は、契約日から２カ月経過以降に被保険者がガンと診断された場合、診断給付金が支払われる。",
    "choice4": "医療保険（更新型）は、所定の年齢の範囲内であれば、保険期間中に入院給付金を受け取ったとしても、契約を更新することができる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "第三分野の保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 1080,
    "shikenId": 13,
    "no": 21,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "内閣府が公表する景気動向指数に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "景気動向指数の遅行系列に採用されているものには、消費者物価指数、新規求人数等がある。",
    "choice2": "景気動向指数に採用されている指数は、先行指数が１１系列、一致指数が１０系列、遅行指数が９系列の合計３０系列となっている。",
    "choice3": "景気動向指数の先行系列に採用されているものには、新設住宅着工床面積、完全失業率等がある。",
    "choice4": "景気動向指数の一致系列に採用されているものには、有効求人倍率（除学卒）、法人税収入等がある。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "景気動向指数",
    "important": ""
  },
  {
    "id": 1081,
    "shikenId": 13,
    "no": 22,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "銀行等の金融機関で取り扱う預金等の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "大口定期預金は、最低預入金額が1 億円に設定された固定金利型の定期預金である。",
    "choice2": "当座預金は、公共料金などの自動振替口座として利用することはできるが、株式の配当金の自動受取口座として利用することはできない。",
    "choice3": "スーパー定期預金は、市場金利の動向等に応じて、各金融機関が預金金利を設定する。",
    "choice4": "ゆうちょ銀行の預入限度額は、通常貯金と定期性貯金（財形貯金各種を除く）を合わせて１, ３００万円である。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "預金等の一般的な商品性",
    "important": ""
  },
  {
    "id": 1082,
    "shikenId": 13,
    "no": 23,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "投資信託の費用に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "購入時手数料がかからない投資信託のことを、一般に、ノーロードファンドという。",
    "choice2": "運用管理費用（信託報酬）は、一般に、インデックス型（パッシブ型）投資信託よりもアクティブ型投資信託の方が高い傾向がある。",
    "choice3": "投資信託の会計監査に必要な費用（監査報酬）や組入有価証券に係る委託手数料は、信託財産から支出され、投資家の負担となる。",
    "choice4": "信託財産留保額は、解約する投資家と長期に投資信託を保有する投資家との間の公平性を確保するための費用とされ、すべての投資信託に設定されている。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "投資信託の費用",
    "important": ""
  },
  {
    "id": 1083,
    "shikenId": 13,
    "no": 24,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "上場投資信託（ＥＴＦ）に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "ＥＴＦの分配金を受け取るためには、ＥＴＦの決算日（権利確定日）において所有者になっている必要がある。",
    "choice2": "ＥＴＦを市場で売買する際に支払う委託手数料は、証券会社により異なる。",
    "choice3": "証券取引所を通じて行うＥＴＦの売買取引では、現物取引のほか、信用取引も行うことができる。",
    "choice4": "ＥＴＦを証券取引所の立会時間中に売買する場合、成行注文はできるが、指値注文はできない。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "上場投資信託（ETF）",
    "important": ""
  },
  {
    "id": 1084,
    "shikenId": 13,
    "no": 25,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "固定利付債券の利回り（単利・年率）に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、手数料、経過利子、税金等については考慮しないものとし、計算結果は表示単位の小数点以下第３位を四捨五入するものとする。<br><br>表面利率が１．５０％、償還までの残存期間が５年の固定利付債券を、額面１００円当たり１０２円で購入した投資家が、購入から３年後に額面１００円当たり１０３円で売却した場合の所有期間利回りは（ ア ）であり、償還期限まで５年保有した場合の最終利回りは（ イ ）である。",
    "choice1": "（ア）１．８０％　　（イ）１．０８％",
    "choice2": "（ア）１．８０％　　（イ）１．８６％",
    "choice3": "（ア）１．８３％　　（イ）１．０８％",
    "choice4": "（ア）１．８３％　　（イ）１．８６％",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "債券の利回り",
    "important": ""
  },
  {
    "id": 1085,
    "shikenId": 13,
    "no": 26,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "株式指標の一般的な特徴に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "ＰＥＲ（倍）は、「株価÷１株当たり経常利益」の算式により計算され、業種および事業内容が同一である場合、数値が高いほど割高と考えられる。",
    "choice2": "ＰＢＲ（倍）は、「株価÷１株当たり総資産」の算式により計算され、これが１倍を下回ると、理論上、株価は解散価値を下回っていることを示す。",
    "choice3": "ＲＯＥ（％）は、「当期純利益÷自己資本×１００」により求められ、数値が高いほど、会社が自己資本を効率的に活用して利益を上げていると評価できる。",
    "choice4": "配当利回り（％）は、「配当金総額÷純資産×１００」の算式により計算され、この値が高いほど投資価値が高いと考えられる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株式指標",
    "important": ""
  },
  {
    "id": 1086,
    "shikenId": 13,
    "no": 27,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "金融派生商品に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "先物取引には、証拠金を預けることによって、それよりも多額の取引ができるという現物取引にはない特徴があり、これをレバレッジ効果という。",
    "choice2": "ヘッジ取引には、将来の価格上昇リスク等を回避または軽減する売りヘッジと将来の価格下落リスク等を回避または軽減する買いヘッジがある。",
    "choice3": "現物と反対のポジションの先物を保有することなどにより、価格変動リスク等を回避または軽減することを狙う取引を、ヘッジ取引という。",
    "choice4": "先物の将来の価格を予想してポジションを取り、予想どおりの方向に変動したときに、反対売買を行って利益を確定する取引を、スペキュレーション取引という。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "金融派生商品",
    "important": ""
  },
  {
    "id": 1087,
    "shikenId": 13,
    "no": 28,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "上場株式の譲渡および配当（一定の大口株主等が受けるものを除く）および特定公社債の譲渡および利子に係る税金に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "上場株式等の配当金について、申告分離課税を選択して確定申告をした場合、配当控除の適用を受けることができる。",
    "choice2": "上場株式等の譲渡損失を翌年以降に繰り越すには、特定口座の源泉徴収選択口座を選択している場合でも、確定申告が必要となる。",
    "choice3": "上場株式等の譲渡損失は、特定公社債の利子等に係る利子所得と損益通算することができる。",
    "choice4": "特定公社債の譲渡所得等および利子所得は、申告分離課税の対象となる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "上場株式等の税金",
    "important": ""
  },
  {
    "id": 1088,
    "shikenId": 13,
    "no": 29,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "ポートフォリオ理論に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "ポートフォリオの期待収益率は、組み入れた各資産の期待収益率を組入比率で加重平均した値となる。",
    "choice2": "株式のポートフォリオにおいて、組入銘柄数を増やすことにより、システマティック・リスクを低減することができる。",
    "choice3": "ポートフォリオのリスクは、組み入れた各資産のリスクを組入比率で加重平均した値よりも大きくなる。",
    "choice4": "異なる２資産からなるポートフォリオにおいて、２資産間の相関係数が１である場合、ポートフォリオを組成することによる分散投資の効果（リスクの低減効果）は最大となる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "ポートフォリオ理論",
    "important": ""
  },
  {
    "id": 1089,
    "shikenId": 13,
    "no": 30,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "わが国における個人による金融商品取引に係るセーフティネットに関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "国内銀行に預け入れられている円預金のうち、財形貯蓄や確定拠出年金制度で運用されている預金も、預金保険制度による保護の対象となる。",
    "choice2": "国内銀行に預け入れた外貨預金は預金保険制度による保護の対象となるが、外国銀行の在日支店に預け入れた外貨預金は預金保険制度による保護の対象とならない。",
    "choice3": "国内銀行に預け入れた決済用預金は、その金額の多寡にかかわらず、全額が預金保険制度による保護の対象となる。",
    "choice4": "証券会社が破綻し、分別管理が適切に行われていなかったために、一般顧客の資産の一部または全部が返還されない事態が生じた場合、日本投資者保護基金により、補償対象債権に係る顧客資産について一般顧客１人当たり１,０００万円を上限として補償される。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "セーフティネット",
    "important": ""
  },
  {
    "id": 1090,
    "shikenId": 13,
    "no": 31,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "所得税の原則的な仕組みに関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "所得税では、課税対象となる所得を８種類に区分して、それぞれの所得の種類ごとに定められた計算方法により所得の金額を計算する。",
    "choice2": "非居住者は国内源泉所得についてのみ所得税の納税義務がある。",
    "choice3": "所得税は、納税者が申告をした後に、税務署長が所得や納付すべき税額を決定する賦課課税方式を採用している。",
    "choice4": "課税総所得金額に対する所得税額は、課税総所得金額の多寡にかかわらず、一律の税率により計算する。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の原則的な仕組み",
    "important": ""
  },
  {
    "id": 1091,
    "shikenId": 13,
    "no": 32,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "所得税における各種所得の算式に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "給与所得の金額は、「（給与等の収入金額－給与所得控除額）×１／２」の算式により計算される。",
    "choice2": "一時所得の金額は、「（一時所得に係る総収入金額－その収入を得るために支出した金額の合計額－特別控除額）×１／２」の算式により計算される。",
    "choice3": "公的年金等に係る雑所得の金額は、「（公的年金等の雑所得に係る総収入金額－公的年金等控除額）×１／２」の算式により計算される。",
    "choice4": "退職所得の金額（特定役員退職手当等および短期退職手当等を除く）は、「（退職手当等の収入金額－退職所得控除額）×１／２」の算式により計算される。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "各種所得の算式",
    "important": ""
  },
  {
    "id": 1092,
    "shikenId": 13,
    "no": 33,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "所得税における各種所得に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "会社員が勤務先から無利息で金銭を借り入れたことによる経済的利益は、利子所得に該当する。",
    "choice2": "貸付けが事業的規模で行われているアパート経営の賃貸収入に係る所得は、事業所得に該当する。",
    "choice3": "賃貸していた土地および建物を売却したことによる所得は、不動産所得に該当する。",
    "choice4": "専業主婦が金地金を売却したことによる所得は、譲渡所得に該当する。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "各種所得",
    "important": ""
  },
  {
    "id": 1093,
    "shikenId": 13,
    "no": 34,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "Ａさんの本年分の所得の金額が下記のとおりであった場合の所得税における総所得金額として、最も適切なものはどれか。なお、▲が付された所得の金額は、その所得に損失が発生していることを意味するものとする。<br><img  style='width:600px' data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"134b174e-9851-4cc8-aef4-0102b3093631\" src='/img/13_34_1778645405213316.png'>",
    "choice1": "４３０万円",
    "choice2": "５０５万円",
    "choice3": "５３０万円",
    "choice4": "５５０万円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "損益通算と総所得金額の計算",
    "important": ""
  },
  {
    "id": 1094,
    "shikenId": 13,
    "no": 35,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "基礎控除は、納税者本人の合計所得金額を問わず、誰でも４８万円を控除することができる。",
    "choice2": "配偶者控除および配偶者特別控除は、納税者本人の合計所得金額が１，０００万円を超える場合、控除することができない。",
    "choice3": "扶養控除の対象となる控除対象扶養親族のうち、同居老親等とは納税者またはその配偶者の直系尊属で同居している６５歳以上の老人扶養親族をいう。",
    "choice4": "控除対象扶養親族のうち、その年の１２月３１日現在の年齢が１６歳以上１９歳未満の者に係る扶養控除の控除額は６３万円である。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得控除",
    "important": ""
  },
  {
    "id": 1095,
    "shikenId": 13,
    "no": 36,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "新たに本年中に新築住宅（省エネ基準適合住宅、ＺＥＨ水準省エネ住宅、認定住宅）を取得・入居した場合の所得税における住宅借入金等特別控除（以下、「住宅ローン控除」という）に関する次の記述のうち、最も適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。",
    "choice1": "住宅ローン控除を受けようとする年の合計所得金額は３，０００万円以下でなければならない。",
    "choice2": "住宅ローン控除の控除額は、住宅ローン等の年末残高の合計額（限度額あり）に控除率１％を乗じて求められる。",
    "choice3": "住宅ローン控除の適用を受ける場合、居住の用に供した年分以後、最長１０年間、各年分の所得税額から控除することができる。",
    "choice4": "住宅ローン控除の適用を受けるためには、その対象となる家屋を取得等した日から６カ月以内に自己の居住の用に供さなければならない。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "住宅借入金等特別控除",
    "important": ""
  },
  {
    "id": 1096,
    "shikenId": 13,
    "no": 37,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "所得税の申告に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "確定申告を要する者は、原則として、所得が生じた年の翌年２月１６日から３月１５日までの間に納税地の所轄税務署長に対して確定申告書を提出しなければならない。",
    "choice2": "給与所得者が、医療費控除の適用を受けるために、所得税の還付を受けようとする場合、納税地の所轄税務署長に確定申告書を提出しなければならない。",
    "choice3": "1 年間の給与収入の金額が２，０００万円を超える給与所得者は、勤務先における年末調整の対象とならない。",
    "choice4": "確定申告書を提出した納税者が、計算の誤りによって所得税を過大に申告していたことに気づいた場合、原則として、法定申告期限から３年以内に限り、更正の請求をすることができる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の申告",
    "important": ""
  },
  {
    "id": 1097,
    "shikenId": 13,
    "no": 38,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "法人税の仕組みに関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "法人税額は、各事業年度の確定した決算に基づく当期純利益の額に税率を乗じて算出される。",
    "choice2": "法人は、法人税の納税地に異動があった場合、原則として、異動前の納税地の所轄税務署長にその旨を届け出なければならない。",
    "choice3": "法人税の確定申告書は、原則として、各事業年度終了の日の翌日から２カ月以内に、納税地の所轄税務署長に提出しなければならない。",
    "choice4": "法人税の納税地は、原則として、その本店または主たる事務所の所在地である。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "法人税の仕組み",
    "important": ""
  },
  {
    "id": 1098,
    "shikenId": 13,
    "no": 39,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "法人税の損金に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "法人が納付した法人住民税の本税は、その全額を損金の額に算入することができない。",
    "choice2": "会社が役員に支給した退職金は、不相当に高額な部分を除き、支給する金額が確定した事業年度に損金に算入することができる。",
    "choice3": "法人が支払う固定資産税、都市計画税、印紙税、事業所税は、損金に算入することができる。",
    "choice4": "法人が減価償却費として損金経理した金額のうち、償却限度額を超える部分の金額は、その事業年度の損金の額に算入することができる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "法人税",
    "important": ""
  },
  {
    "id": 1099,
    "shikenId": 13,
    "no": 40,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "消費税に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "簡易課税制度の適用を受けた事業者は、課税売上高に従業員数に応じて定められたみなし仕入率を乗じて仕入に係る消費税額を計算する。",
    "choice2": "消費税の課税事業者が行う株式や公社債など有価証券の譲渡は、消費税の課税取引に該当する。",
    "choice3": "「消費税課税事業者選択届出書」を提出して消費税の課税事業者となった法人は、事業を廃止した場合を除き、原則として２年間は消費税の免税事業者となることができない。",
    "choice4": "消費税の課税事業者である個人事業者は、原則として、消費税の確定申告書をその年の翌年３月１５日までに納税地の所轄税務署長に提出しなければならない。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "消費税",
    "important": ""
  },
  {
    "id": 1100,
    "shikenId": 13,
    "no": 41,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "土地の価格に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "都道府県地価調査の基準地の標準価格は、毎年７月１日を価格判定の基準としている。",
    "choice2": "相続税路線価は、地価公示の公示価格の８０％を価格水準の目安として設定されている。",
    "choice3": "評価替えの基準年度における固定資産税評価額は、前年の公示価格の６０％を価格水準の基準として決定されている。",
    "choice4": "固定資産課税台帳に登録する土地の価格は、市町村長が決定する。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "土地の価格",
    "important": ""
  },
  {
    "id": 1101,
    "shikenId": 13,
    "no": 42,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "宅地建物取引業法に関する次の記述のうち、最も不適切なものはどれか。なお、買主は宅地建物取引業者ではないものとする。",
    "choice1": "宅地建物取引業者は、自ら売主となる宅地・建物の売買契約を締結したときは、当該買主に、遅滞なく、宅地建物取引士をして、宅地建物取引業法第３５条に規定する重要事項を記載した書面を交付して説明をさせなければならない。",
    "choice2": "宅地建物取引業者は、自ら売主となる宅地・建物の売買契約の締結に際して、売買代金の２割を超える額の手付を受領することができない。",
    "choice3": "宅地建物取引業者が、宅地・建物の貸借の媒介を行う場合に、貸主・借主の双方から受け取ることのできる報酬の合計額の上限は、賃料の１カ月分に消費税を加えた金額に相当する額である。",
    "choice4": "専任媒介契約の有効期間は、３カ月を超えることができず、これより長い期間を定めたときは、３カ月とされ、３カ月を超える部分が無効とされる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "宅地建物取引業法",
    "important": ""
  },
  {
    "id": 1102,
    "shikenId": 13,
    "no": 43,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "不動産の売買契約における民法上の留意点に関する次の記述のうち、最も適切なものはどれか。なお、記載のない特約については考慮しないものとする。",
    "choice1": "売買の目的物である建物が、その売買契約の締結から当該建物の引渡しまでの間に、地震によって全壊した場合であっても、買主は、売主に対する建物代金の支払いを拒むことができない。",
    "choice2": "買主が売主に解約手付を交付した場合、買主が契約の履行に着手するまでは、売主は、受領した手付金を買主に現実に提供することにより、契約を解除することができる。",
    "choice3": "土地の売買契約において、その土地の登記記録の面積と実測面積とが相違していても、その面積の差に基づく売買代金の増減精算は行わないという旨の特約は有効である。",
    "choice4": "民法上、売主が種類または品質に関して契約内容に適合しない建物を買主に引き渡した場合、買主は不適合を知ったときから２年以内に売主に対してその旨を通知しなければ、不適合を理由とする追完請求、代金減額請求、損害賠償請求、契約の解除はできない。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の売買契約における民法上の留意点",
    "important": ""
  },
  {
    "id": 1103,
    "shikenId": 13,
    "no": 44,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "民法および借地借家法に関する次の記述のうち、最も不適切なものはどれか。<br>なお、本問においては、同法第38 条による定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。",
    "choice1": "賃借人は、建物の引渡しを受けた後にこれに生じた損傷であっても、通常の使用および収益によって生じた建物の損耗および経年変化については、賃貸借終了時、原状に復する義務を負わない。",
    "choice2": "期間の定めがある普通借家契約において、賃借人は、正当の事由があると認められるときでなければ、賃貸人に対して更新しない旨の通知をすることができない。",
    "choice3": "定期借家契約は、公正証書以外の書面（電磁的記録を含む）によって、締結することができる。",
    "choice4": "定期借家契約では、賃貸借期間が１年以上の場合、賃貸人は、原則として、期間満了の１年前から６カ月前までの間に賃借人に対して期間満了により契約が終了する旨の通知をしなければ、その終了を賃借人に対抗することができない。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "民法と借地借家法",
    "important": ""
  },
  {
    "id": 1104,
    "shikenId": 13,
    "no": 45,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "市街化調整区域内において、農業を営む者の居住の用に供する建築物の建築を目的として行う開発行為は、都道府県知事の許可が必要である。",
    "choice2": "開発許可を受けた開発区域内の土地においては、開発行為に関する工事完了の公告があるまでの間は、原則として、建築物を建築することができない。",
    "choice3": "土地の区画形質の変更は、建築物の建築や特定工作物の建設の用に供することを目的としていない場合であっても、開発行為に該当する。",
    "choice4": "土地区画整理事業、市街地再開発事業の施行として行う開発行為は、都道府県知事等の許可が必要である。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "都市計画法",
    "important": ""
  },
  {
    "id": 1105,
    "shikenId": 13,
    "no": 46,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "第一種低層住居専用地域、第二種低層住居専用地域、田園住居地域の建築物の高さは、原則として１０ｍまたは１２ｍを超えてはならない。",
    "choice2": "全ての用途地域で適用される斜線制限は、隣地斜線制限である。",
    "choice3": "北側斜線制限は、第一種低層住居専用地域内の建築物は適用されるが、商業地域内の建築物には適用されない。",
    "choice4": "日影規制（日影による中高層の建築物の高さの制限）は、原則として、工業専用地域、工業地域、商業地域では適用されない。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "建築基準法",
    "important": ""
  },
  {
    "id": 1106,
    "shikenId": 13,
    "no": 47,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "区分所有者であっても希望すれば管理組合を任意に脱退できる。",
    "choice2": "区分所有建物のうち、構造上の独立性と利用上の独立性を備えた建物の部分は、区分所有権の目的となる専有部分であり、規約によって共用部分とすることはできない。",
    "choice3": "建替え決議を除く集会の招集の通知は、規約で別段の定めをしない限り、開催日の少なくとも１週間前までに会議の目的たる事項を示して各区分所有者に発しなければならない。",
    "choice4": "規約を変更するためには、集会に出席した区分所有者および議決権の各５分の４以上の多数による集会の決議が必要となる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "区分所有法",
    "important": ""
  },
  {
    "id": 1107,
    "shikenId": 13,
    "no": 48,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "不動産に係る固定資産税および都市計画税に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "土地および家屋に係る固定資産税の税率は１.４％と定められており、各市町村は条例によってこれと異なる税率を定めることができない。",
    "choice2": "都市計画税は、都市計画区域のうち、原則として市街化調整区域内に所在する土地または家屋の所有者に対して課される。",
    "choice3": "地方税法において、固定資産税における小規模住宅用地（住宅用地で住宅１戸当たり２００㎡以下の部分）の課税標準については、課税標準となるべき価格の３分の１の額とする特例がある。",
    "choice4": "固定資産税および都市計画税は、毎年１月１日における所有者に課税されるため、年の途中に売買等により所有者が変わっても、納税義務者は変わらない。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "固定資産税および都市計画税",
    "important": ""
  },
  {
    "id": 1108,
    "shikenId": 13,
    "no": 49,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "居住用財産を譲渡した場合の３,０００万円の特別控除（以下「３,０００万円特別控除」という）および居住用財産を譲渡した場合の長期譲渡所得の課税の特例（以下「軽減税率の特例」という）に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "３,０００万円特別控除と軽減税率の特例は、要件を満たせば、重複して適用を受けることができる。",
    "choice2": "３,０００万円特別控除および軽減税率の特例は、いずれも譲渡した居住用財産の所有期間が、譲渡した日の属する年の１月１日において１０年を超えていなければ、適用を受けることはできない。",
    "choice3": "３,０００万円特別控除と軽減税率の特例は、配偶者や子に譲渡した場合には適用を受けることができない。",
    "choice4": "軽減税率の特例では、課税長期譲渡所得金額のうち６, ０００万円以下の部分の金額について軽減税率が適用される。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "居住用財産の譲渡の特例",
    "important": ""
  },
  {
    "id": 1109,
    "shikenId": 13,
    "no": 50,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "不動産の投資判断手法等に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "NPV 法（正味現在価値法）による投資判断においては、投資額よりも対象不動産から得られる収益の現在価値の合計額のほうが下回っている場合、その投資は有利であると判定することができる。",
    "choice2": "IRR法（内部収益率法）による投資判断においては、対象不動産の内部収益率のほうが投資家の期待収益率を下回っている場合、その投資は有利であると判定することができる。",
    "choice3": "DCF 法は、対象不動産の一期間の純収益を還元利回りで還元して対象不動産の収益価格を求める手法である。",
    "choice4": "DSCR（借入金償還余裕率）の数値が１.０を上回っている場合は、対象不動産から得られる収益だけで借入金を返済することができる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の投資判断手法",
    "important": ""
  },
  {
    "id": 1110,
    "shikenId": 13,
    "no": 51,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "贈与税の配偶者控除（以下「本控除」という）に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "本控除は、贈与を受けた時点で、婚姻期間が１０年以上である配偶者から受けた贈与でなければ、適用を受けることができない。",
    "choice2": "本控除の適用を受けた場合、贈与税額の計算上、贈与税の課税価格から基礎控除額１１０万円のほかに最高２，０００万円を控除することができる。",
    "choice3": "本控除の適用を受けた後に、同一の配偶者から贈与を受けても、再び本控除の適用を受けることはできない。",
    "choice4": "本控除の適用を受けた翌年に贈与者の相続が開始した場合、本控除の適用を受けた財産のうち、その控除額に相当する金額は、相続税の課税価格に加算されない。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与税の配偶者控除",
    "important": ""
  },
  {
    "id": 1111,
    "shikenId": 13,
    "no": 52,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "贈与税の課税財産に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "契約者（＝保険料負担者）が母、被保険者が父、保険金受取人が子である生命保険契約において、父の死亡により子が受け取った死亡保険金は、子が母から贈与されたものとして贈与税の課税対象となる。",
    "choice2": "離婚による財産分与として取得した財産は、その価額が婚姻中の夫婦の協力によって得た財産の額等を考慮しても、なお過大であると認められる部分は、贈与税の課税対象となる。",
    "choice3": "父が、その所有する土地の名義を無償で子の名義に変更した場合には、原則として、子が父からその土地を贈与により取得したものとして、贈与税の課税対象となる。",
    "choice4": "子が、父の所有する土地を使用貸借によって借り受け、その土地に自己資金で建物を建築して自己の居住の用に供する場合には、子が父から借地権相当額を贈与により取得したものとして、贈与税の課税対象となる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与税の課税財産",
    "important": ""
  },
  {
    "id": 1112,
    "shikenId": 13,
    "no": 53,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "民法に規定する相続に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "被相続人と婚姻の届出をしていないが、被相続人と生計を一にしており内縁関係にあった者は、被相続人の配偶者とみなされて相続人となる。",
    "choice2": "被相続人の兄と妹が相続人である場合において、当該兄が被相続人の相続開始以前に死亡していたときは、その死亡した兄の子が代襲して相続人となる。",
    "choice3": "相続の放棄をする場合は、相続の開始があったことを知った時から原則として３カ月以内に、共同相続人全員で家庭裁判所に申述しなければならない。",
    "choice4": "相続の単純承認をした相続人は、被相続人の財産のうち、預金や不動産などの積極財産のみを相続する。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "民法に規定する相続",
    "important": ""
  },
  {
    "id": 1113,
    "shikenId": 13,
    "no": 54,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "民法上の遺言に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "遺言は、未成年者であっても、満１５歳以上の者で、かつ、遺言をする時にその能力があれば、法定代理人の同意を得ることなく単独ですることができる。",
    "choice2": "自筆証書によって遺言をするには、遺言者が全文、日付および氏名を自書し、これに押印することが必要となるが、財産目録については自筆でなくてもよい。",
    "choice3": "公正証書遺言を作成した遺言者が、自筆証書遺言も作成し、それぞれの内容が異なる場合、その異なる部分について作成日付の新しい遺言の内容が効力を有する。",
    "choice4": "公正証書によって遺言をするには証人２人以上の立会いが必要であり、推定相続人はその証人になることができる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "遺言",
    "important": ""
  },
  {
    "id": 1114,
    "shikenId": 13,
    "no": 55,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "相続税の非課税財産に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "被相続人の死亡によって相続人に支給される弔慰金は、被相続人の死亡が業務外の死亡である場合、被相続人の死亡当時における普通給与の３年分に相当する金額まで相続税の課税対象とならない。",
    "choice2": "被相続人の死亡によって被相続人に支給されるべきであった死亡退職金で、被相続人の死亡後３年以内に支給が確定したものを相続人が取得した場合は、死亡退職金の非課税金額の規定の適用を受けることができる。",
    "choice3": "死亡保険金の非課税限度額は「５００万円×法定相続人の数」であり、相続を放棄した者がいた場合でも、相続の放棄がなかったものとして計算する。",
    "choice4": "死亡保険金および死亡退職金の非課税金額の規定は、相続人が受け取る場合にのみ適用され、相続を放棄した者が受け取る場合には適用されない。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の非課税財産",
    "important": ""
  },
  {
    "id": 1115,
    "shikenId": 13,
    "no": 56,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "相続税の申告と納付に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "配偶者の税額軽減の適用を受けた結果、相続税額がゼロとなる場合、相続税の申告は不要となる。",
    "choice2": "相続税の金銭一括納付、延納が困難である場合、物納することができ、国債、不動産、上場株式等は物納順位の第１位である。",
    "choice3": "期限内申告書に係る相続税の納付は、原則として、相続人がその相続の開始があったことを知った日の翌日から４カ月以内にしなければならない。",
    "choice4": "相続税は金銭により一時に納付することが原則であるが、それが困難な場合には、納税義務者は、任意に延納または物納を選択することができる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の申告と納付",
    "important": ""
  },
  {
    "id": 1116,
    "shikenId": 13,
    "no": 57,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "宅地の財産評価に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "普通借地権が設定されている宅地（貸宅地）の価額は、「自用地評価額×（1 －借地権割合）」により評価する。",
    "choice2": "貸家建付地は、「自用地評価額×（１－借家権割合×賃貸割合）」により評価する。",
    "choice3": "普通借地契約により借り受けた宅地に、建物を建築して、第三者に適正な賃料で貸し付けている場合の貸家建付借地権の評価額は、「自用地評価額×借地権割合×（1 －借地権割合×借家権割合×賃貸割合）」により評価する。",
    "choice4": "路線価方式によって正面と側方に路線がある宅地（角地）を評価する場合、それぞれの路線価に奥行価格補正率を乗じた価額を比較して、低いほうの路線価が正面路線価となる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "宅地の評価",
    "important": ""
  },
  {
    "id": 1117,
    "shikenId": 13,
    "no": 58,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "小規模宅地等についての相続税の課税価格の計算の特例（以下「本特例」）に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢に記載されている内容以外の要件はすべて満たしているものとする。",
    "choice1": "被相続人が居住の用に供していた宅地等を配偶者が取得した場合、４００㎡まで８０％の減額の対象となる。",
    "choice2": "被相続人が事業の用に供していた宅地等を、事業を引き継いだ親族が、相続税の申告期限まで宅地等を所有し続け、事業を継続している場合、３３０㎡まで８０％の減額の対象となる。",
    "choice3": "被相続人が貸付事業の用に供していた宅地等を、貸付事業を引き継いだ親族が、相続税の申告期限まで宅地等を所有し続け、貸付事業を継続している場合、２００㎡まで５０％の減額の対象となる。",
    "choice4": "特定居住用宅地等と貸付事業用宅地等について本特例を適用する場合、それぞれの適用対象面積の限度まで適用できる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "小規模宅地等の特例",
    "important": ""
  },
  {
    "id": 1118,
    "shikenId": 13,
    "no": 59,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "相続税の納税資金対策に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "相続により土地を取得した者が相続税を延納する場合、担保として不適格でなければ、当該土地を延納の担保として提供することができる。",
    "choice2": "延納の許可を受けた相続税額について、延納を継続することが困難となった場合であっても、延納から物納へ変更することはできない。",
    "choice3": "「小規模宅地等についての相続税の課税価格の計算の特例」の適用を受けた宅地等を物納する場合の収納価額は、特例適用前の価額である。",
    "choice4": "経営者が死亡したときの相続税の負担を軽減するため、経営者が保有する自社株式の大半を経営に関与しない第三者に生前に移転しておくことが望ましいといえる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の納税資金対策",
    "important": ""
  },
  {
    "id": 1119,
    "shikenId": 13,
    "no": 60,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "同族株主等が取得する取引相場のない株式の評価に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "会社規模が大会社である会社の株式を同族株主等が取得する場合、原則として、類似業種比準方式と純資産価額方式の併用方式によって評価する。",
    "choice2": "会社規模が小会社である会社の株式を同族株主等が取得する場合、純資産価額方式によって評価し、類似業種比準方式と純資産価額方式の併用方式によって評価することはできない。",
    "choice3": "会社規模が中会社である会社の株式を同族株主等が取得する場合、類似業種比準方式または純資産価額方式のいずれかによって評価する。",
    "choice4": "同族株主のいる会社において、同族株主以外の株主が取得した株式の価額は、その会社規模にかかわらず、原則として、配当還元方式によって評価する。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "取引相場のない株式の評価",
    "important": ""
  },
  {
    "id": 1120,
    "shikenId": 17,
    "no": 1,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "ライフプランニングにおける各種係数を用いた必要額の算出に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、算出に当たっては下記＜資料＞の係数を乗算で使用し、手数料や税金等については考慮しないものとする。<br><br>Aさんが60 歳から65 歳になるまでの5 年間、年率2％で複利運用しながら、毎年300 万円を受け取る場合、60 歳時点の元金として（　ア　）が必要となる。<br>Bさんが45 歳から毎年一定額を積み立てながら年率2％で複利運用し、15 年後の60 歳時に1,500 万円を準備する場合、毎年の積立金額は（　イ　）となる。<br><br><img  style='width:600px' data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"c0fc27d3-d499-47b8-81be-67605db661ba\" src='/img/17_1_1778645538138204.png'>",
    "choice1": "（ア）１４，１４０，５００円　　　（イ）８６７，０００円",
    "choice2": "（ア）１４，１４０，５００円　　　（イ）１，１６７，０００円",
    "choice3": "（ア）１５，６１２，０００円　　　（イ）８６７，０００円",
    "choice4": "（ア）１５，６１２，０００円　　　（イ）１，１６７，０００円",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "ライフプランニングにおける各種係数",
    "important": ""
  },
  {
    "id": 1121,
    "shikenId": 17,
    "no": 2,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "公的医療保険に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "健康保険の被保険者の甥や姪が被扶養者になるためには、被保険者と同一世帯に属していることが必要である。",
    "choice2": "健康保険の被保険者資格を喪失した者は、資格喪失日の前日までの被保険者期間が継続して１年以上あるなどの所定の要件を満たせば、最長で２年間、健康保険の任意継続被保険者となることができる。",
    "choice3": "後期高齢者医療制度の被保険者が保険医療機関等の窓口で支払う一部負担金（自己負担額）の割合は、原則として、当該被保険者が現役並み所得者である場合は３割、それ以外の者は１割とされる。",
    "choice4": "健康保険や国民健康保険の被保険者が７０歳に達したときは、その被保険者資格を喪失し、後期高齢者医療制度の被保険者となる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的医療保険",
    "important": ""
  },
  {
    "id": 1122,
    "shikenId": 17,
    "no": 3,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "労働者災害補償保険（以下「労災保険」という）に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "労災保険の適用を受ける労働者には、雇用形態がアルバイトやパートタイマーである者は含まれない。",
    "choice2": "業務上の負傷または疾病は治癒したものの、身体に一定の障害が残った場合、その障害の程度が労災保険法に規定する障害等級に該当する場合、障害補償給付が受けられる。",
    "choice3": "労災保険の保険料を計算する際に用いる保険料率は、適用事業所の事業の種類による差異はない。",
    "choice4": "労災保険の特別加入制度において、適用事業所の事業主は、その営む事業において使用する労働者数の多寡にかかわらず、労災保険の対象となる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "労働者災害補償保険",
    "important": ""
  },
  {
    "id": 1123,
    "shikenId": 17,
    "no": 4,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "雇用保険の失業等給付に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "自己都合による離退職などの一般の受給資格者に支給される基本手当の所定給付日数は、被保険者期間が２０年以上の場合、１８０日である。",
    "choice2": "雇用保険の一般被保険者が失業した場合、基本手当を受給するためには、原則として、離職の日以前２年間に被保険者期間が通算して１２ヵ月以上あること等の要件を満たす必要がある。",
    "choice3": "雇用保険に係る保険料のうち、失業等給付に係る保険料は、被保険者の賃金総額に事業の種類に応じた雇用保険率を乗じて得た額となり、事業主がその全額を負担する。",
    "choice4": "高年齢雇用継続基本給付金の支給を受けるためには、一定の一般被保険者に対して支給対象月に支払われた賃金の額が、原則として６０歳到達時の賃金月額の８５％未満になっていることが必要である。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "雇用保険の失業給付等",
    "important": ""
  },
  {
    "id": 1124,
    "shikenId": 17,
    "no": 5,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "公的年金の老齢給付に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "国民年金の保険料納付済期間が１０年以上あり、厚生年金保険の被保険者期間を有する者は、原則として、６５歳から老齢基礎年金および老齢厚生年金を受給することができる。",
    "choice2": "老齢厚生年金の加給年金額対象者である配偶者が、厚生年金保険の被保険者期間が２０年以上であるときは、当該配偶者に係る加給年金額は支給停止となる。",
    "choice3": "老齢厚生年金の繰下げ支給を申し出る場合、老齢基礎年金の繰下げ支給と同時に申し出なければならない。",
    "choice4": "付加年金の受給権者が老齢基礎年金の繰下げ支給の申出をした場合、付加年金の額についても繰下げによって増額される。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的年金の老齢給付",
    "important": ""
  },
  {
    "id": 1125,
    "shikenId": 17,
    "no": 6,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "確定拠出年金に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "個人型年金の加入者が６０歳から老齢給付金を受給するためには、通算加入者等期間が１０年以上なければならない。",
    "choice2": "個人型年金は、いずれの運営管理機関であっても口座管理手数料や運用できる金融商品は同一である。",
    "choice3": "老齢給付金を年金で受け取った場合、当該給付金は雑所得として所得税の課税対象となるが、雑所得の金額の計算上、公的年金等控除額を控除することはできない。",
    "choice4": "個人型年金に加入できるのは、国内に居住する国民年金の被保険者に限られる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "確定拠出年金",
    "important": ""
  },
  {
    "id": 1126,
    "shikenId": 17,
    "no": 7,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "中小企業退職金共済、小規模企業共済および国民年金基金に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "小売業を主たる事業として営む個人事業主が、小規模企業共済に加入するためには、常時使用する従業員数が５人以下でなければならない。",
    "choice2": "中小企業退職金共済の掛金は、原則として、事業主と従業員が折半して負担する。",
    "choice3": "国民年金基金の掛金は、加入員が確定拠出年金の個人型年金に加入している場合、個人型年金加入者掛金と合わせて月額６８, ０００円が上限となる。",
    "choice4": "国内に住所を有する６０歳以上６５歳未満の国民年金の任意加入被保険者や、日本国籍を有する者で、日本国内に住所を有しない２０歳以上６５歳未満の国民年金の任意加入被保険者は、国民年金基金に加入することができる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老後の資金準備に利用できる制度",
    "important": ""
  },
  {
    "id": 1127,
    "shikenId": 17,
    "no": 8,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "リタイアメントプランニング等に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "一般に、金融機関のリバースモーゲージには、利用者が死亡し、担保物件の売却代金による借入金返済後に残る債務について、利用者の相続人がその返済義務を負う「ノンリコース型」と、返済義務を負わない「リコース型」がある。",
    "choice2": "将来、本人の判断能力が不十分になった場合に備えて、あらかじめ自らが選任した者と任意後見契約を締結する場合、必ず公正証書によって締結しなければならない。",
    "choice3": "２０２５年４月以降、すべての企業に対して６５歳までの雇用確保が義務づけられ、それまでは定年年齢を６５歳未満に定めている事業主は、６５歳までの雇用確保のため「定年の引上げ」「継続雇用制度の導入」「定年の定めの廃止」のいずれかの措置を講じなければならない。",
    "choice4": "高齢者の居住の安定確保に関する法律に定める「サービス付き高齢者向け住宅」の入居者は、「状況把握サービス」や「生活相談サービス」を受けることができる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "リタイアメントプランニング",
    "important": ""
  },
  {
    "id": 1128,
    "shikenId": 17,
    "no": 9,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "決算書に基づく経営分析指標に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "当座比率は、「当座資産÷流動負債×１００（％）」の算式によって求めることができ、一般に、この数値が高い方が望ましいとされる。",
    "choice2": "損益分岐点売上高は、「固定費÷限界利益率」の算式によって求めることができる。",
    "choice3": "自己資本比率（株主資本比率）は、「自己資本÷総資産×１００（％）」の算式によって求めることができ、一般に、この数値が高い方が財務の健全性が高いと判断される。",
    "choice4": "固定比率は、固定負債に対する固定資産の割合を示したものであり、一般に、この数値が高い方が財務の健全性が高いと判断される。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "決算書に基づく経営分析指標",
    "important": ""
  },
  {
    "id": 1129,
    "shikenId": 17,
    "no": 10,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "キャッシュレス決済の一般的な特徴等に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "交通系や流通系の電子マネーやプリペイドカードは、カードやスマートフォンに事前にチャージしておき、商品やサービスの購入時にチャージ額から支払う決済手段であるが、チャージ方法はクレジットカードによる電子決済に限られる。",
    "choice2": "デビットカードは、商品やサービスの購入時に使用すると代金が原則として翌月に銀行口座から引き落とされる決済手段であり、残高不足になってもあらかじめ設定された一定額までは後払いで使用することができる。",
    "choice3": "スマートフォン決済のうち、二次元コードやバーコードを利用するコード決済は、支払いアプリをスマートフォンにインストールして銀行口座やクレジットカード等の情報を登録したうえで、店舗または自身のスマートフォン上の二次元コードやバーコードを認証して支払う決済手段である。",
    "choice4": "クレジットカードで商品やサービスを購入した場合の返済方法の一つである分割払いは、利用代金の支払回数を決め、その回数で代金を分割して支払う方法であり、５回以上の分割払いでは手数料が発生する。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "キャッシュレス決済の一般的な特徴",
    "important": ""
  },
  {
    "id": 1130,
    "shikenId": 17,
    "no": 11,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "生命保険の保険料等の仕組みに関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "責任準備金は、保険会社が、将来の保険金や給付金の支払財源として保険数理に基づいて算定し、積み立てておく準備金である。",
    "choice2": "保険会社が実際に要した事業費が、保険料を算定する際に見込んでいた事業費よりも多かった場合、費差益が生じる。",
    "choice3": "収支相等の原則は、保険会社が受け取る保険料等の総額が、保険会社が支払う保険金等の総額と等しくなるように保険料を算定する原則のことをいう。",
    "choice4": "終身保険について、保険料の算定に用いられる予定利率が引き下げられた場合、新規契約の保険料は高くなる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険の保険料等の仕組み",
    "important": ""
  },
  {
    "id": 1131,
    "shikenId": 17,
    "no": 12,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "個人年金保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "保証期間付終身年金の保険料は、他の契約条件が同一であれば、被保険者が男性のほうが女性よりも高くなる。",
    "choice2": "変額個人年金保険では、保険会社の特別勘定による保険料の運用成果によって、将来受け取る年金額等が変動するが、死亡給付金については基本保険金額が最低保証されている。",
    "choice3": "外貨建て個人年金保険では、円換算支払特約を付加することで、当該保険契約の締結後から年金や解約返戻金、死亡給付金を受け取るまでの為替リスクを回避することができる。",
    "choice4": "確定年金では、年金受取開始日前に被保険者（＝年金受取人）が死亡した場合、死亡給付金受取人が契約時に定められた年金受取総額と同額の死亡給付金を受け取ることができる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "個人年金保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 1132,
    "shikenId": 17,
    "no": 13,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "総合福祉団体定期保険および団体定期保険（Ｂグループ保険）の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、いずれも契約者は企業であるものとする。",
    "choice1": "総合福祉団体定期保険のヒューマン・ヴァリュー特約は、従業員の死亡等による企業の経済的損失に備えるものであり、その特約死亡保険金の受取人は、従業員の遺族ではなく企業となる。",
    "choice2": "総合福祉団体定期保険の契約締結に際しては、加入予定者の被保険者になることについての同意および保険約款に基づく告知が必要である。",
    "choice3": "団体定期保険（Ｂグループ保険）の死亡保険金額は、企業の退職金規程等で定められた死亡退職金の金額の範囲内で設定しなければならない。",
    "choice4": "団体定期保険（Ｂグループ保険）は、従業員等が任意で加入し、その従業員等が保険料も負担する。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "総合福祉団体定期保険と団体定期保険",
    "important": ""
  },
  {
    "id": 1133,
    "shikenId": 17,
    "no": 14,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "個人年金保険の税金に関する次の記述のうち、最も適切なものはどれか。なお、いずれも契約者（＝保険料負担者）は個人であるものとする。",
    "choice1": "契約者と年金受取人が同一である個人年金保険の場合、毎年受け取る年金は雑所得として、公的年金等控除の対象となる。",
    "choice2": "契約者と年金受取人が異なる場合、年金受取人は年金支払開始時に年金受給権を取得したものとみなされ、年金受給権が贈与税の課税対象となる。",
    "choice3": "契約者と被保険者が異なる個人年金保険において、年金支払開始前に被保険者が死亡して契約者が受け取った死亡給付金は、相続税の課税対象となる。",
    "choice4": "一時払終身年金保険を契約から５年以内に解約したことにより契約者が受け取る解約返戻金は、源泉分離課税の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "個人年金保険の税金",
    "important": ""
  },
  {
    "id": 1134,
    "shikenId": 17,
    "no": 15,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "住宅用建物および住宅用建物に収容している家財を対象とする火災保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
    "choice1": "家財を保険の対象として契約した場合、同一敷地内の車庫に駐車している自動車が火災により受けた損害は補償の対象となる。",
    "choice2": "火災保険の保険料は、対象となる住宅用建物の構造により、Ｍ構造、Ｔ構造、Ｈ構造の３つに区分されて算定され、保険料は、Ｍ構造が最も安く、次いでＴ構造、Ｈ構造が最も高い。",
    "choice3": "家財を保険の対象として契約した場合、開放していた窓から雨が吹き込み、家財が濡れた損害は補償の対象となる。",
    "choice4": "住宅用建物を保険の対象として契約した場合、時間の経過により建物の壁に発生したカビによる損害は補償の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "火災保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 1135,
    "shikenId": 17,
    "no": 16,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "傷害保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
    "choice1": "普通傷害保険では、細菌性食中毒は補償の対象となる。",
    "choice2": "家族傷害保険の被保険者は、被保険者本人および契約時の配偶者、本人または配偶者と生計を一にする同居の親族および別居の未婚の子となる。",
    "choice3": "交通事故傷害保険では、道路通行中または交通乗用具に搭乗中の交通事故および交通乗用具の火災によるケガを補償の対象としており、エレベーターやエスカレーターも交通乗用具に含まれる。",
    "choice4": "海外旅行傷害保険、国内旅行傷害保険では、旅行中の地震によるケガは補償の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "傷害保険の一般的な商品性",
    "important": ""
  },
  {
    "id": 1136,
    "shikenId": 17,
    "no": 17,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "個人を契約者（＝保険料負担者）とする損害保険の税金に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "新たに損害保険会社と契約した自らを被保険者とする所得補償保険や医療保険の保険料は、介護医療保険料控除の対象とならない。",
    "choice2": "新たに住宅用建物および家財を保険の対象とする火災保険に地震保険を付帯して加入した場合、火災保険および地震保険に係る保険料はともに地震保険料控除の対象となる。",
    "choice3": "契約者と被保険者が同一人である自動車保険の人身傷害（補償）保険において、被保険者が自動車事故で死亡した場合、その遺族が受け取った死亡保険金は、過失割合にかかわらず、その全額が非課税となる。",
    "choice4": "契約者の配偶者が不慮の事故で死亡したことにより、契約者が受け取った家族傷害保険の死亡保険金は、一時所得として課税の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "個人契約の損害保険の税金",
    "important": ""
  },
  {
    "id": 1137,
    "shikenId": 17,
    "no": 18,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "法人を契約者（＝保険料負担者）とする損害保険の保険料や保険金の経理処理に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "法人が所有する自動車で従業員が業務中に起こした対人事故により、その相手方に保険会社から自動車保険の対人賠償保険金が直接支払われた場合、法人は当該保険金に関して経理処理する必要はない。",
    "choice2": "すべての役員・従業員を被保険者とする労働災害総合保険を契約した場合、支払った保険料の全額を損金の額に算入することができる。",
    "choice3": "すべての役員・従業員を被保険者とする積立普通傷害保険を契約した場合、支払った保険料の全額を損金の額に算入することができる。",
    "choice4": "法人が所有する倉庫建物が火災で焼失し、受け取った火災保険の保険金で同一事業年度内に代替の倉庫建物を取得した場合、所定の要件に基づき圧縮記帳が認められる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "法人契約の損害保険の経理処理",
    "important": ""
  },
  {
    "id": 1138,
    "shikenId": 17,
    "no": 19,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "生命保険を利用した家庭のリスク管理に係る一般的なアドバイスに関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "「自分の老後の生活資金を準備するために生命保険に加入したい」という相談に対して、個人年金保険への加入を提案した。",
    "choice2": "「自分が死亡した後の子どもが社会人になるまでの生活資金を準備するために生命保険に加入したい」という相談に対して、収入保障保険への加入を提案した。",
    "choice3": "「子どもが生まれたので、教育資金を準備するために生命保険に加入したい」という相談に対して、こども保険（学資保険）への加入を提案した。",
    "choice4": "「病気やケガで入院した場合の医療費の負担が不安なので生命保険に加入したい」という相談に対して、定期保険への加入を提案した。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険を利用した家庭のリスク管理",
    "important": ""
  },
  {
    "id": 1139,
    "shikenId": 17,
    "no": 20,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "事業活動に係る各種損害保険に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "飲食店を営む事業者が、食中毒による休業により売上が減少する場合に備えて、生産物賠償責任保険（PL 保険）を契約した。",
    "choice2": "外部からの不正アクセスにより、顧客の個人情報が外部に漏えいした場合に、被保険者が法律上の損害賠償責任を負うことによって被る損害やそれらに対応する費用を補償する保険として、サイバー保険と個人情報漏えい保険を契約した。",
    "choice3": "製造業を営む事業者が、業務中の事故により従業員がケガをする場合に備えて、労働者災害補償保険（政府労災保険）の上乗せ補償を目的として労働災害総合保険を契約した。",
    "choice4": "ボウリング場を経営する事業者が、施設の管理不備により、来場者がケガをして法律上の損害賠償責任を負うリスクに備えて、施設所有（管理）者賠償責任保険を契約した。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "事業活動に係る各種損害保険",
    "important": ""
  },
  {
    "id": 1140,
    "shikenId": 17,
    "no": 21,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "日本円・米ドル間の為替相場の変動要因等に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "米国の物価が日本と比較して相対的に上昇することは、一般に、円安米ドル高要因となる。",
    "choice2": "購買力平価説によれば、米国と日本に同じ財があり、その財を米国では２米ドル、日本では２５０円で買える場合、為替レートは１米ドル＝１２５円が妥当と考える。",
    "choice3": "米国の景気が日本と比較して相対的に景気がよく、日本円が売られて、米ドルが買われる動きが多くなることは、一般に、円安ドル高の要因となる。",
    "choice4": "米国が政策金利を引き上げ、日本との金利差が拡大することは、一般に、円安米ドル高要因となる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "為替相場の変動要因",
    "important": ""
  },
  {
    "id": 1141,
    "shikenId": 17,
    "no": 22,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "わが国における上場投資信託（ETF）および上場不動産投資信託（J-REIT）の特徴に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "ＥＴＦは、非上場の投資信託と異なり、運用管理費用（信託報酬）は発生しない。",
    "choice2": "証券取引所を通じて行うＥＴＦの売買取引では、現物取引のほか、信用取引も行うことができる。",
    "choice3": "Ｊ－ＲＥＩＴは、一般に、信託財産の解約ができるオープン・エンド型の投資信託として設定されている。",
    "choice4": "Ｊ－ＲＥＩＴの分配金は、所得税の配当控除の対象となる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "ETF、J-REITの特徴",
    "important": ""
  },
  {
    "id": 1142,
    "shikenId": 17,
    "no": 23,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "固定利付債券の利回り（単利・年率）と市場金利の変動との関係に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、手数料、経過利子、税金等については考慮しないものとする。<br><br>償還年限が１０年、表面利率が０. ５％の固定利付債券（以下「債券Ａ」という）が額面１００円当たり１００円で新規に発行された。発行から４年後に中央銀行の金融政策により市場金利が上昇した場合、この時点で債券Ａを購入した場合の最終利回りは０．５％よりも（ ア ）。<br>また、債券Ａを新規発行時に購入し、発行から４年後に売却する場合の所有期間利回りは０. ５％よりも（ イ ）。",
    "choice1": "（ア）高くなる　　（イ）高くなる",
    "choice2": "（ア）高くなる　　（イ）低くなる",
    "choice3": "（ア）低くなる　　（イ）高くなる",
    "choice4": "（ア）低くなる　　（イ）低くなる",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "債券の利回りと市場金利の変動との関係",
    "important": ""
  },
  {
    "id": 1143,
    "shikenId": 17,
    "no": 24,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "株式の信用取引に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "制度信用取引の対象となる銘柄は、証券取引所の規則等に基づいて選定されたものに限られる。",
    "choice2": "一般信用取引の建株を制度信用取引の建株に変更することはできないが、制度信用取引の建株を一般信用取引の建株に変更することはできる。",
    "choice3": "一般信用取引では、投資家が証券会社から貸付けを受けた金銭や株式を３ヵ月以内に返済しなければならない。",
    "choice4": "信用取引で売建てした場合、反対売買により決済する差金決済の方法でしか決済できない。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株式の信用取引",
    "important": ""
  },
  {
    "id": 1144,
    "shikenId": 17,
    "no": 25,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "下記＜Ａ社のデータ＞に基づき算出されるＡ社株式の投資指標に関する次の記述のうち、最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"6912cc3a-741e-4fa3-8a2a-68be869975d9\" src='/img/17_25_1778645538727617.png'>",
    "choice1": "ＰＥＲ（株価収益率）は、２０. ０倍である。",
    "choice2": "ＰＢＲ（株価純資産倍率）は、５．０倍である。",
    "choice3": "ＲＯＥ（自己資本利益率）は、２５. ０％である。",
    "choice4": "配当利回りは、３. ０％である。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株式の投資指標の計算",
    "important": ""
  },
  {
    "id": 1145,
    "shikenId": 17,
    "no": 26,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "株価チャート分析に関する次の記述の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><br>株価チャート分析は、過去の株価や出来高などの推移を図示し、将来の株価の動向を予測する手法であり、（ ア ）分析の一つとされている。<br>下図は、株価の始値、高値、安値、終値を図示する「ローソク足」であり、（ イ ）よりも（ ウ ）の方が高い場合は陽線、（ イ ）よりも（ ウ ）の方が安い場合は陰線となる。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"9dd38456-bbad-4bc5-bf8e-db05eca4e347\" src='/img/17_26_1778645539147059.png'>",
    "choice1": "（ア）ファンダメンタルズ （イ）始値 （ウ）終値",
    "choice2": "（ア）テクニカル （イ）始値 （ウ）終値",
    "choice3": "（ア）ファンダメンタルズ （イ）終値 （ウ）始値",
    "choice4": "（ア）テクニカル （イ）終値 （ウ）始値",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株価チャート分析",
    "important": ""
  },
  {
    "id": 1146,
    "shikenId": 17,
    "no": 27,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "オプション取引に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "コール・オプション、プット・オプションの売り手は、買い手に対してプレミアム（オプション料）を支払う。",
    "choice2": "満期までの残存期間が長い方が短い場合に比べて、プレミアム（オプション料）は低くなる。",
    "choice3": "原資産価格が上昇していく場合、コール・オプションのプレミアム（オプション料）は高くなり、プット・オプションのプレミアム（オプション料）は低くなる。",
    "choice4": "オプション取引において、買い手の損失は限定されないが、売り手の損失はオプション料に限定される。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "オプション取引",
    "important": ""
  },
  {
    "id": 1147,
    "shikenId": 17,
    "no": 28,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "アセットアロケーションに関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "アセットアロケーションとは、投資資金を複数の資産クラス（株式、債券および不動産等）に配分することである。",
    "choice2": "現代ポートフォリオ理論の一般的な考え方によれば、運用成果に与える影響は、資産クラスの配分よりも、個別銘柄の選択や売買のタイミング等の方が大きいとされる。",
    "choice3": "運用期間を通して、定められた各資産クラスの投資金額の配分比率を維持する方法の一つとして、値上がりした資産クラスを売却し、値下がりした資産クラスを購入するリバランスという方法がある。",
    "choice4": "各資産クラスの投資金額ではなくリスク量が同等になるように配分比率を調整するリスクパリティ運用（戦略）においては、特定の資産クラスのボラティリティが上昇した場合、当該資産を売却する。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "アセットアロケーション",
    "important": ""
  },
  {
    "id": 1148,
    "shikenId": 17,
    "no": 29,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "ＮＩＳＡのつみたて投資枠に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "ＮＩＳＡのつみたて投資枠を利用できるのは１月１日現在２０歳以上である居住者等に限られる。",
    "choice2": "ＮＩＳＡのつみたて投資枠の対象商品は、所定の要件を満たす、長期の積立・分散投資に適した一定の公募株式投資信託、ＥＴＦ、Ｊ―ＲＥＩＴ等に限られる。",
    "choice3": "ＮＩＳＡのつみたて投資枠は非課税期間に制限がない。",
    "choice4": "ＮＩＳＡのつみたて投資枠の年間投資上限額は２４０万円である。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "NISAつみたて投資枠",
    "important": ""
  },
  {
    "id": 1149,
    "shikenId": 17,
    "no": 30,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "金融商品の取引に係る各種法令に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "外国為替証拠金取引は、金融サービス提供法における金融商品の販売に該当する取引であるが、ゴルフ会員権や金は金融サービス提供法の重要事項説明の対象外である。",
    "choice2": "金融商品取引法では、金融商品取引契約を締結しようとする金融商品取引業者等は、あらかじめ顧客（特定投資家を除く）に契約締結前交付書面を交付しなければならないとされているが、顧客から交付を要しない旨の意思表示があった場合には、金融商品取引業者等に対する書面交付義務は免除される。",
    "choice3": "犯罪収益移転防止法では、金融機関等の特定事業者が顧客と特定業務に係る取引を行った場合、特定事業者は、原則として、直ちに当該取引に関する記録を作成し、当該取引の行われた日から７年間保存しなければならないとされている。",
    "choice4": "大阪取引所における金、白金などのコモディティを対象とした市場デリバティブ取引は、金融商品取引法の適用対象となる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "金融商品の取引に係る各種法令",
    "important": ""
  },
  {
    "id": 1150,
    "shikenId": 17,
    "no": 31,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "所得税における各種所得に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "退職所得の金額（特定役員退職手当等､短期退職手当等に係るものを除く）は、「退職手当等の収入金額－退職所得控除額」の算式により計算される。",
    "choice2": "給与所得の金額は、原則として「給与等の収入金額－給与所得控除額」の算式により計算され、給与所得控除額は最低４８万円が保証され、収入金額が８５０万円を超える場合は１９５万円となる。",
    "choice3": "一時所得の金額は、「（一時所得に係る総収入金額－その収入を得るために支出した金額の合計額－特別控除額）×１／２」の算式により計算される。",
    "choice4": "不動産所得の金額は、原則として「不動産所得に係る総収入金額－必要経費」の算式により計算される。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税における各種所得",
    "important": ""
  },
  {
    "id": 1151,
    "shikenId": 17,
    "no": 32,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "所得税における損益通算に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "金地金を譲渡したことによる譲渡所得の損失は、他の各種所得の金額と損益通算することができる。",
    "choice2": "賃貸アパート（国内）の土地および建物を譲渡したことによる譲渡所得の損失の金額は、給与所得の金額と損益通算することができる。",
    "choice3": "青色申告の承認を受けていない納税者の事業所得の金額の計算上生じた損失の金額は、他の各種所得の金額と損益通算することができない。",
    "choice4": "別荘を譲渡したことによる譲渡所得の金額の計算上生じた損失の金額は、他の各種所得の金額と損益通算することができない。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "損益通算",
    "important": ""
  },
  {
    "id": 1152,
    "shikenId": 17,
    "no": 33,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "所得税における所得控除に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "控除対象扶養親族のうち、その年の１２月３１日時点の年齢が１９歳以上２３歳未満の者を特定扶養親族といい、その者に係る扶養控除の額は５８万円である。",
    "choice2": "納税者が加入している健康保険の被扶養者となっていて内縁関係にあると認められる者は、配偶者控除の対象とならない。",
    "choice3": "配偶者控除および配偶者特別控除の控除額は、控除を受ける納税者本人の合計所得金額に応じて異なる。",
    "choice4": "年の途中で死亡した者が、その死亡の時において控除対象扶養親族に該当している場合には、納税者は扶養控除の適用を受けることができる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得控除",
    "important": ""
  },
  {
    "id": 1153,
    "shikenId": 17,
    "no": 34,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。<br>なお、選択肢記載以外の要件は満たしているものとする。",
    "choice1": "納税者が生命保険の保険料を支払った場合、支払った保険料の多寡にかかわらず、その年中に支払った全額を生命保険料控除として控除することができる。",
    "choice2": "納税者が医療費を支払った場合、支払った医療費の多寡にかかわらず、その年中に支払った全額を、医療費控除として控除することができる。",
    "choice3": "納税者が本人の確定拠出年金の個人型年金の掛金を支払った場合、支払った掛金の多寡にかかわらず、その年中に支払った全額を社会保険料控除として控除することができる。",
    "choice4": "納税者が自己、生計を一にする配偶者、親族に係る社会保険料を支払った場合、支払った社会保険料の多寡にかかわらず、その年中に支払った全額を、社会保険料控除として控除することができる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得控除",
    "important": ""
  },
  {
    "id": 1154,
    "shikenId": 17,
    "no": 35,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "次のうち、所得税の確定申告を要する者はどれか。なお、いずれも適切に源泉徴収等がされ、年末調整すべきものは年末調整が済んでいるものとする。",
    "choice1": "給与として１ヵ所から年額１, ８００万円の支払いを受けた給与所得者",
    "choice2": "退職一時金として２, ０００万円の支払いを受け、その支払いを受ける時までに「退職所得の受給に関する申告書」を提出している者",
    "choice3": "同族会社である法人１ヵ所から給与として年額１, ０００万円の支払いを受け、かつ、その法人から不動産賃貸料として年額１２万円の支払いを受けたその法人の役員",
    "choice4": "老齢基礎年金および老齢厚生年金を合計で年額３００万円受給し、かつ、原稿料に係る雑所得が年額１８万円ある者",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の確定申告を要する者",
    "important": ""
  },
  {
    "id": 1155,
    "shikenId": 17,
    "no": 36,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "所得税の青色申告に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "青色申告の適用を受けることができる者は、不動産所得、事業所得、雑所得を生ずべき業務を行う者で、納税地の所轄税務署長の承認を受けた者である。",
    "choice2": "青色申告者は、原則として７年間（一部５年間）、住所地もしくは居所地または事業所等に総勘定元帳その他の一定の帳簿を保存しなければならない。",
    "choice3": "前年からすでに業務を行っている者が、本年分から新たに青色申告の適用を受けようとする場合、その承認を受けようとする年の３月３１日までに「青色申告承認申請書」を納税地の所轄税務署長に提出しなければならない。",
    "choice4": "青色申告を取りやめようとする者は、その年の３月１５日までに「青色申告の取りやめ届出書」を納税地の所轄税務署長に提出しなければならない。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の青色申告",
    "important": ""
  },
  {
    "id": 1156,
    "shikenId": 17,
    "no": 37,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "法人税の損金に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "役員退職給与を損金の額に算入するためには、事前に所定の時期に確定額を支給する旨の定めの内容を税務署長に届け出なければならない。",
    "choice2": "会社が役員に対して定期同額給与を支給した場合、不相当に高額な部分の金額など一定のものを除き、その会社の所得金額の計算上損金の額に算入される。",
    "choice3": "国または地方公共団体に対して支払った寄附金の額（確定申告書に明細を記載した書類を添付している）は、損金の額に算入することができる。",
    "choice4": "法人が納付した法人税の本税の額は、損金の額に算入することができない。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "法人税の損金",
    "important": ""
  },
  {
    "id": 1157,
    "shikenId": 17,
    "no": 38,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "法人税に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "過去に行った法人税の確定申告について、計算の誤りにより、納付した税額が過大であったことが判明した場合、原則として、法定申告期限から５年以内に限り、更正の請求をすることができる。",
    "choice2": "法人税の確定申告書は、原則として、各事業年度終了の日の翌日から2カ月以内に、納税地の所轄税務署長に提出しなければならない。",
    "choice3": "１人当たり５，０００円以下の得意先等との飲食費であることを条件に、必要とされる書類等を保存していれば、税法上の交際費等に該当せず、その全額を損金の額に算入することができる。",
    "choice4": "期末資本金の額等が１億円以下の一定の中小法人が支出した交際費は、年８００万円までの金額または飲食費の５０％のいずれか多い金額までを損金に算入することができる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "法人税に関する記述",
    "important": ""
  },
  {
    "id": 1158,
    "shikenId": 17,
    "no": 39,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "消費税の適格請求書等保存方式（インボイス制度）に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "適格請求書発行事業者の登録を受けようとする事業者は、適格請求書発行事業者の登録申請書を、納税地の所轄税務署長に提出しなければならない。",
    "choice2": "適格請求書発行事業者の登録番号は、適格請求書に必要とされる記載事項の一つである。",
    "choice3": "適格請求書として必要とされる事項が記載された書類は、納品書や領収書等の名称で発行されたものであっても適格請求書に該当する。",
    "choice4": "適格請求書には、必ず適格請求書発行事業者の本店または主たる事務所の所在地を記載しなければならない。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "消費税の適格請求書等保存方式",
    "important": ""
  },
  {
    "id": 1159,
    "shikenId": 17,
    "no": 40,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "決算書に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "損益計算書において、経常利益の額は、営業利益の額に特別利益・特別損失を加算・減算した額である。",
    "choice2": "貸借対照表における無形固定資産は、物理的な形態を持たない特許権や商標権等の資産の金額を表している。",
    "choice3": "キャッシュフロー計算書において、保有していた固定資産を売却した場合には、その売却額を投資活動によるキャッシュフローの区分記載する。",
    "choice4": "間接法による営業活動によるキャッシュフローにおいて、キャッシュの変動を伴わない減価償却費は、税引前当期純利益の金額に加算する。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "決算書に関する記述",
    "important": ""
  },
  {
    "id": 1160,
    "shikenId": 17,
    "no": 41,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "不動産の登記や調査に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "不動産の登記記録において、土地の所有者とその土地上の建物の所有者が異なる場合は、その土地の登記記録に借地権設定の登記がなくても、借地権が設定されていることがある。",
    "choice2": "不動産登記には公信力がないため、登記記録を確認し、その登記記録の内容が真実であると信じて取引した場合、その登記記録の内容が真実と異なっていても法的な保護を受けることができない。",
    "choice3": "登記の目的が抵当権の設定である場合、不動産の登記記録の権利部甲区に、債権額や抵当権者の氏名または名称などが記載される。",
    "choice4": "公図は登記所に備え付けられており、対象とする土地の位置関係等を確認する資料として有用である。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の登記や調査",
    "important": ""
  },
  {
    "id": 1161,
    "shikenId": 17,
    "no": 42,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "不動産鑑定評価基準における不動産の価格を求める鑑定評価の手法に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "不動産の価格を求める鑑定評価の基本的な手法は、原価法、収益還元法および取引事例比較法に大別される。",
    "choice2": "最有効使用の原則は、不動産の効用が最高度に発揮される可能性に最も富む使用を前提として把握される価格を標準として不動産の価格が形成されるとする原則である。",
    "choice3": "収益還元法は、実際に賃貸の用に供されていない自用の不動産の価格を求める際には適用することができない。",
    "choice4": "取引事例比較法は、多数の取引事例を収集して、適切な事例を選択し、これらの取引価格に事情補正および時点修正ならびに地域要因の比較および個別的要因の比較を行って求められた価格を比較考量して、対象不動産の価格を求める手法である。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の鑑定評価の手法",
    "important": ""
  },
  {
    "id": 1162,
    "shikenId": 17,
    "no": 43,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "不動産の売買契約に係る民法の規定に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
    "choice1": "売買契約において、売主、買主の双方の責めに帰することができない事由により、売主が売買の目的物を引き渡すことができなくなった場合、買主は売買代金の支払を拒むことができる。",
    "choice2": "買主が売主に解約手付を交付した場合、買主が代金を支払った後であっても、売主は、自らが契約の履行に着手するまでは、受領した手付の倍額を買主に現実に提供して契約を解除することができる。",
    "choice3": "共有名義となっている建物について、自己が有している持分を第三者に譲渡するときは、他の共有者全員の同意を得なければならない。",
    "choice4": "不動産について二重に売買契約が締結された場合、当該複数の買主間においては、原則として、売買契約を先に締結した者が当該不動産の所有権を取得する。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の売買契約に係る民法の規定",
    "important": ""
  },
  {
    "id": 1163,
    "shikenId": 17,
    "no": 44,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、同法第２２条の借地権を一般定期借地権といい、同法第２２条から第２４条の定期借地権等以外の借地権を普通借地権という。",
    "choice1": "普通借地権の存続期間は３０年とされているが、当事者が契約でこれより短い期間を定めたときは、その期間とする。",
    "choice2": "普通借地権の当初の存続期間が満了する場合、借地上に建物が存在しなくても、借地権者が借地権設定者に契約の更新を請求したときは、従前の契約と同一の条件（期間を除く）で契約を更新したものとみなされる。",
    "choice3": "一般定期借地権において、契約の更新および建物の築造による存続期間の延長がなく、建物等の買取りの請求をしないこととする旨を定める特約は、公正証書によってしなければならない。",
    "choice4": "一般定期借地権は、居住用および事業用の建物の所有を目的として、５０年以上の存続期間を定めて設定することができる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "借地借家法（借地権）",
    "important": ""
  },
  {
    "id": 1164,
    "shikenId": 17,
    "no": 45,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "建築物の敷地が異なる建蔽率の地域にわたる場合、その敷地の全部について、敷地の過半の属する地域の建蔽率が適用される。",
    "choice2": "工業地域および工業専用地域内には、原則として、住宅を建てることはできない。",
    "choice3": "建築物の敷地が接する前面道路の幅員が１２ｍ未満である場合、容積率の上限は、指定容積率と前面道路の幅員に一定の数値を乗じて求めた容積率のいずれか高い方が適用される。",
    "choice4": "道路斜線制限は、すべての用途地域および用途地域の指定がない区域で適用される。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "建築基準法",
    "important": ""
  },
  {
    "id": 1165,
    "shikenId": 17,
    "no": 46,
    "answerType": 1,
    "groupId": 0,
    "answer": 1,
    "score": 1,
    "question1": "",
    "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "集会において、区分所有者および議決権の各４分の３以上の多数により、建替えの決議をすることができる。",
    "choice2": "区分所有法が定める場合を除いて、専有部分と共用部分を分離処分することはできず、規約で定める場合を除き、専有部分と敷地利用権（数人で有する所有権その他の権利である場合）は分離処分できない。",
    "choice3": "区分所有者以外の専有部分の占有者は、建物またはその敷地もしくは附属施設の使用方法について、区分所有者が規約または集会の決議に基づいて負う義務と同一の義務を負う。",
    "choice4": "共用部分に対する区分所有者の共有持分は、規約に別段の定めがない限り、各共有者の専有部分の床面積の割合による。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "区分所有等に関する法律",
    "important": ""
  },
  {
    "id": 1166,
    "shikenId": 17,
    "no": 47,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "不動産の取得に係る税金に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "贈与により取得した不動産について相続時精算課税制度の適用を受けた場合、相続により取得したものとみなされるため不動産取得税は課されない。",
    "choice2": "売買によって不動産を取得した場合の、不動産取得税の課税標準は、原則として、その取引価格とされる。",
    "choice3": "登録免許税は、贈与により建物を取得した場合には課税されるが、相続により建物を取得した場合には課税されない。",
    "choice4": "不動産取得税は、所有権移転登記の有無にかかわらず、契約内容等から総合的に判断して現実に所有権を取得したと認められる場合に、当該不動産の取得者に対して課される。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の取得に係る税金",
    "important": ""
  },
  {
    "id": 1167,
    "shikenId": 17,
    "no": 48,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "不動産に係る固定資産税および都市計画税に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "所定の要件を満たす新築住宅に係る固定資産税は、１戸当たり１２０㎡以下の床面積に相当する部分の税額について、一定期間にわたり６分の１に軽減される特例がある。",
    "choice2": "住宅用地に係る固定資産税の課税標準については、住宅用地で住宅１戸当たり３００㎡以下の部分について課税標準となるべき価格の６分の１の額とする特例がある。",
    "choice3": "土地または家屋に係る固定資産税の課税標準となる価格は、原則として毎年度、評価替えが行われる。",
    "choice4": "都市計画税の税率は各地方自治体の条例で定められるが、１００分の０. ３を超えることはできない。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "固定資産税および都市計画税",
    "important": ""
  },
  {
    "id": 1168,
    "shikenId": 17,
    "no": 49,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "個人が土地を譲渡した場合の譲渡所得に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "土地の譲渡が長期譲渡所得に区分される場合、課税長期譲渡所得金額に対し、原則として、所得税（復興特別所得税を含む）１５. ３１５%、住民税５％の税率により課税される。",
    "choice2": "相続により土地を取得して相続税を課された者が、その土地を当該相続の開始があった日の翌日から相続税の申告期限の翌日以後３年を経過する日までに譲渡した場合、譲渡所得の金額の計算上、その者が負担した相続税額のうち、その土地に対応する部分の金額を取得費に加算することができる。",
    "choice3": "他者から購入した土地の取得の日は、原則としてその土地の引渡しを受けた日であるが、当該売買契約の効力が発生した日とすることもできる。",
    "choice4": "相続により取得した土地を譲渡した場合、その土地の所有期間を判定する際の取得の日は、相続人が当該相続を登記原因として所有権移転登記をした日である。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "譲渡所得",
    "important": ""
  },
  {
    "id": 1169,
    "shikenId": 17,
    "no": 50,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "土地の有効活用の手法の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "建設協力金方式は、入居予定のテナントから建設資金の全部または一部を借り受けて、テナントの仕様に合わせた建物を建設するため、用途の汎用性は低い。",
    "choice2": "等価交換方式は、土地所有者は建物の建築資金を負担する必要はないが、土地の所有権の一部を手放すことにより、当該土地上に建設された建物の全部を取得することができる。",
    "choice3": "定期借地権方式では、土地所有者は土地を一定期間貸し付けることにより地代収入を得ることができ、当該土地上に建設する建物の資金調達をする必要がない。",
    "choice4": "事業受託方式は、土地の有効活用の企画、建設会社の選定および当該土地上に建設された建物の管理・運営をデベロッパーに任せ、建設資金の調達や返済は土地所有者が行う。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "土地の有効活用の手法",
    "important": ""
  },
  {
    "id": 1170,
    "shikenId": 17,
    "no": 51,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "贈与に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "民法上、贈与は、当事者の一方がある財産を無償で相手方に与える意思表示をすることにより効力が生じ、相手方が受諾する必要はない。",
    "choice2": "定期贈与契約は、贈与者または受贈者の一方が死亡すると、その権利・義務が相続人に承継される。",
    "choice3": "負担付贈与については、贈与者は、その負担の限度において、売買契約の売主と同様の担保責任を負う。",
    "choice4": "死因贈与によって取得した財産は、贈与税の課税対象となる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与に関する記述",
    "important": ""
  },
  {
    "id": 1171,
    "shikenId": 17,
    "no": 52,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "贈与税の計算に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "祖父と父のそれぞれから同一の年において財産の贈与を受け、いずれの贈与についても暦年課税の適用を受けた場合の贈与税額の計算においては、贈与税の課税価格から基礎控除額として最高２２０万円を控除することができる。",
    "choice2": "贈与税額の計算において、贈与税の配偶者控除の適用を受ける場合は、贈与税の課税価格から基礎控除額を控除することができない。",
    "choice3": "相続時精算課税適用者が、２０２４年1 月1 日以後に特定贈与者から贈与により財産を取得した場合、贈与税額の計算上、基礎控除額が控除される。",
    "choice4": "相続時精算課税制度を選択した場合、特定贈与者からの贈与により取得した財産に係る贈与税額の計算上、贈与税の税率は、贈与税の課税価格に応じた超過累進税率である。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与税の計算",
    "important": ""
  },
  {
    "id": 1172,
    "shikenId": 17,
    "no": 53,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "贈与税の非課税財産に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "個人から受ける社交上必要と認められる香典・見舞金等の金品で、贈与者と受贈者との関係等に照らして社会通念上相当と認められるものは、贈与税の課税対象とならない。",
    "choice2": "個人が法人からの贈与により取得した財産は、贈与税の課税対象とならない。",
    "choice3": "相続により財産を取得した者が、その相続開始の年に被相続人から贈与により取得した財産は、原則として相続税の課税対象となり、贈与税の課税対象とならない。",
    "choice4": "扶養義務者から生活費として受け取った金銭を、投資目的の株式の運用に充てたとき、その金銭は、贈与税の課税対象とならない。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与税の非課税財産",
    "important": ""
  },
  {
    "id": 1173,
    "shikenId": 17,
    "no": 54,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "民法上の法定相続分に関する次の記述のうち、最も適切なものはどれか。",
    "choice1": "普通養子の法定相続分は、実子の法定相続分の２分の１である。",
    "choice2": "被相続人と父母の一方のみを同じくする兄弟姉妹の法定相続分は、父母の双方を同じくする兄弟姉妹の法定相続分の２分の１である。",
    "choice3": "相続人が被相続人の配偶者と母の合計２人である場合、配偶者および母の法定相続分は、それぞれ２分の１である。",
    "choice4": "代襲相続人が１人である場合、その代襲相続人の法定相続分は、被代襲者が受けるべきであった法定相続分の２分の１である。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "民法上の法定相続分",
    "important": ""
  },
  {
    "id": 1174,
    "shikenId": 17,
    "no": 55,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "民法上の遺言および遺留分に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "相続人が自宅にある自筆証書遺言を発見し、家庭裁判所の検認を受ける前に開封した場合であっても、開封したことをもって、その遺言書が直ちに無効となるわけではない。",
    "choice2": "被相続人は、遺言で、遺産分割の方法を定めることを第三者に委託することができる。",
    "choice3": "被相続人の相続人が兄弟姉妹であった場合に、兄弟姉妹には遺留分は認められない。",
    "choice4": "遺留分権利者は、相続の開始があったことを知った時から３ヵ月以内に限り、家庭裁判所の許可を受けて遺留分の放棄をすることができる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "遺言および遺留分",
    "important": ""
  },
  {
    "id": 1175,
    "shikenId": 17,
    "no": 56,
    "answerType": 1,
    "groupId": 0,
    "answer": 3,
    "score": 1,
    "question1": "",
    "question2": "相続人が負担した次の費用等のうち、相続税の課税価格の計算上、相続財産の価額から債務控除することができるものはどれか。なお、債務控除を受けるために必要とされる他の要件はすべて満たしているものとする。",
    "choice1": "被相続人が生前に購入した墓碑の購入代金で、相続開始時点で未払いのもの",
    "choice2": "被相続人に係る初七日および四十九日の法要に要した費用のうち、社会通念上相当と認められるもの",
    "choice3": "被相続人が所有していた不動産に係る固定資産税のうち、相続開始時点で納税義務は生じているが、納付期限が到来していない未払いの金額",
    "choice4": "被相続人が団体信用生命保険に加入して金融機関から借り入れていた住宅ローンで、相続開始直前にローン残高があるもの",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "債務控除",
    "important": ""
  },
  {
    "id": 1176,
    "shikenId": 17,
    "no": 57,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "相続税における家屋等の評価に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "自用家屋の価額は、「その家屋の固定資産税評価額×１.０」の算式により計算した金額により評価する。",
    "choice2": "貸家の価額は、「自用家屋としての評価額×（１－借家権割合×借地権割合×賃貸割合）」の算式により計算した金額により評価する。",
    "choice3": "借家権は、この権利が権利金等の名称をもって取引される慣行のない地域においては、評価しない。",
    "choice4": "家屋と一体となっている設備の価額は、その家屋の価額に含めて評価する。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "家屋等の評価",
    "important": ""
  },
  {
    "id": 1177,
    "shikenId": 17,
    "no": 58,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "相続税額の計算における宅地の評価に関する次の記述のうち、最も適切なものはどれか。なお、評価の対象となる宅地は、借地権の取引慣行のある地域にあるものとする。また、宅地の上に存する権利は、定期借地権および一時使用目的の借地権等を除くものとする。",
    "choice1": "賃借している宅地の上に家屋を建てて、これを賃貸している場合、賃借している宅地の上に存する権利は、転貸借地権として評価する。",
    "choice2": "賃借している宅地の上に家屋を建てて、これを自宅として使用している場合、賃借している者の宅地の上に存する権利は、借地権として評価する。",
    "choice3": "自己が所有する土地を青空駐車場として第三者に賃貸する場合、土地所有者の権利は貸宅地として評価する。",
    "choice4": "親から子が土地を使用貸借により借り受けて、子がアパートを建築し、第三者に賃貸する場合、親の土地の権利は貸宅地として評価する。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "宅地の評価",
    "important": ""
  },
  {
    "id": 1178,
    "shikenId": 17,
    "no": 59,
    "answerType": 1,
    "groupId": 0,
    "answer": 2,
    "score": 1,
    "question1": "",
    "question2": "直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税の特例（以下「本特例」）に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢記載の条件以外はすべて満たしているものとする。",
    "choice1": "本特例は、受贈者の父母や祖父母からの贈与は対象となるが、受贈者の配偶者の父母や祖父母からの贈与は対象とならない。",
    "choice2": "本特例は、贈与年の１月１日時点で１８歳以上であり、贈与を受ける前年の合計所得金額が２，０００万円以下である者が適用を受けることができる。",
    "choice3": "新築した家屋が店舗併用住宅で、その家屋の登記簿上の床面積の２分の１以上が居住の用に供される場合、本特例の適用を受けることができる。",
    "choice4": "住宅取得等資金の贈与者が死亡した場合、その相続人が贈与を受けた住宅取得等資金のうち、本特例の適用を受けて贈与税が非課税とされた部分は、相続税の課税価格に加算されない。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "住宅取得等資金の贈与税非課税",
    "important": ""
  },
  {
    "id": 1179,
    "shikenId": 17,
    "no": 60,
    "answerType": 1,
    "groupId": 0,
    "answer": 4,
    "score": 1,
    "question1": "",
    "question2": "非上場企業の事業承継対策等に関する次の記述のうち、最も不適切なものはどれか。",
    "choice1": "「非上場株式等についての贈与税の納税猶予及び免除の特例」の適用を受ける場合であっても、相続時精算課税制度の適用を受けることができる。",
    "choice2": "経営者が保有している自社株式を後継者（役員）に取得させる場合、あらかじめ後継者の役員報酬を増加させるなどの対策を講じることで、後継者の自社株式取得資金の負担を減らすことができる。",
    "choice3": "「遺留分に関する民法の特例」の適用を受けることにより、会社事業後継者が旧代表者から贈与により取得した自社株式について、その価額を、遺留分を算定するための財産の価額に算入しないことができる。",
    "choice4": "「遺留分に関する民法の特例」の適用を受けるための会社事業後継者は、旧代表者の親族に限られる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "事業承継対策",
    "important": ""
  },
  {
    "id": 1200,
    "shikenId": 10,
    "no": 1,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,1,2,1",
    "score": "1,1,1,1",
    "question1": "ファイナンシャル・プランナー（以下「ＦＰ」という）が、ファイナンシャル・プランニング業務を行う上では、関連法規等を順守することが重要である。ＦＰの行為に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択しなさい。",
    "question2": "",
    "choice1": "司法書士資格を有していないＦＰが、顧客から依頼され、顧客の任意後見人となる契約を締結した。",
    "choice2": "生命保険募集人・生命保険仲立人、金融サービス仲介業の登録をしていないＦＰが、生命保険契約を検討している顧客のライフプランに基づき、有償で必要保障額を具体的に試算した。",
    "choice3": "社会保険労務士資格を有していないＦＰが、顧客である個人事業主が受け取る雇用関係助成金申請の書類を作成して手続きの代行を行い、報酬を受け取った。",
    "choice4": "税理士資格を有していないＦＰが、節税対策を検討している顧客に対し、有料の相談業務において、仮定の事例に基づく一般的な解説を行った。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "職業倫理と関連法規",
    "important": "A"
  },
  {
    "id": 1201,
    "shikenId": 10,
    "no": 2,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 2,
    "question1": "「消費者契約法」に関する次の記述のうち、最も不適切なものはどれか。",
    "question2": "",
    "choice1": "消費者が、商品を買わずに帰りたいと言っても帰らせてもらえずに困惑して商品購入の契約をした場合、購入場所が事業者の店舗であるときであっても、当該契約は取り消すことができる。",
    "choice2": "「販売した商品は、いかなる理由があっても、後から返品・キャンセルはできません」とした契約条項は無効である。",
    "choice3": "消費者の判断力が著しく低下し、過大な不安を抱いている状況に付け込んで、事業者の不当性の高い行為により、消費者が困惑した状況で契約を締結した場合、当該契約は取り消すことができる。",
    "choice4": "消費者契約法における「消費者」とは、個人（事業としてまたは事業のために契約の当事者となる場合におけるものを除く）に加えて、法人も含まれる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "消費者契約法",
    "important": "B"
  },
  {
    "id": 1202,
    "shikenId": 10,
    "no": 3,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "吉田さんは、保有している投資信託（ＸＹファンド）の収益分配金を受け取った（下記＜資料＞参照）。この収益分配金に関する次の記述のうち、正しいものはどれか。なお、復興特別所得税は考慮しないこととする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"f99973e7-b3bd-4d04-8b54-54bc33aba11f\" src='/img/10_3_1778738875620731.png'>",
    "question2": "",
    "choice1": "収益分配金から源泉徴収される所得税および住民税の合計額は１万口当たり２００円であり、分配後の吉田さんの個別元本は１万口当たり９, ５００円である。",
    "choice2": "収益分配金から源泉徴収される所得税および住民税の合計額は１万口当たり１００円であり、分配後の吉田さんの個別元本は１万口当たり９, ５００円である。",
    "choice3": "収益分配金から源泉徴収される所得税および住民税の合計額は１万口当たり２００円であり、分配後の吉田さんの個別元本は１万口当たり１０, ０００円である。",
    "choice4": "収益分配金から源泉徴収される所得税および住民税の合計額は１万口当たり１００円であり、分配後の吉田さんの個別元本は１万口当たり１０, ０００円である。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "収益分配金の計算",
    "important": "A"
  },
  {
    "id": 1203,
    "shikenId": 10,
    "no": 4,
    "answerType": 9,
    "groupId": 0,
    "answer": "0.735",
    "score": 2,
    "question1": "下記＜資料＞の債券を満期まで保有した場合の最終利回り（単利・年率）を計算しなさい。なお、手数料や税金等については考慮しないものとし、計算結果については小数点以下第４位を切り捨てること。また、解答に当たっては記載されている単位（％）に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"f42cef6f-d4e5-4ae5-b5b3-42a10f44f4f7\" src='/img/10_4_1778738876070584.png'>",
    "question2": "",
    "choice1": "％",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "債券の利回り計算",
    "important": "A"
  },
  {
    "id": 1204,
    "shikenId": 10,
    "no": 5,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "下記＜資料＞に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"329716a3-e3cd-45be-ae74-995f8469dcc8\" src='/img/10_5_1778738876413412.png'>",
    "question2": "",
    "choice1": "（ア）ＰＡ　　 （イ）ＰＡ",
    "choice2": "（ア）ＰＡ　　 （イ）ＰＢ",
    "choice3": "（ア）ＰＢ　　 （イ）ＰＡ",
    "choice4": "（ア）ＰＢ　　 （イ）ＰＢ",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株式の投資指標",
    "important": "A"
  },
  {
    "id": 1205,
    "shikenId": 10,
    "no": 6,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "下記＜資料＞は、外貨定期預金の契約締結前交付書面の一部である。この契約締結前交付書面に関する次の記述の空欄（ア）～（エ）にあてはまる語句として、最も適切なものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"621a4355-714d-4461-a590-1ab2ea81e87a\" src='/img/10_6_1778738876960138.png'>",
    "question2": "",
    "choice1": "空欄（ア）にあてはまる語句は「源泉」である。",
    "choice2": "空欄（イ）に当てはまる語句は「譲渡」である。",
    "choice3": "空欄（ウ）に当てはまる語句は「１，４９０，０００円」である。",
    "choice4": "空欄（エ）に当てはまる語句は「対象」である。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "外貨預金",
    "important": "A"
  },
  {
    "id": 1206,
    "shikenId": 10,
    "no": 7,
    "answerType": 9,
    "groupId": 1,
    "answer": "950,170",
    "score": "1,1",
    "question1": "下記＜資料＞は、本年４月２３日時点の渡辺さん夫婦（竜二さんと真紀子さん）のＸＹ銀行（日本国内に本店のある普通銀行）における金融資産（時価）の一覧表である。この時点においてＸＹ銀行が破綻した場合に、預金保険制度によって保護される金融資産の金額に関する次の記述の空欄（ア）、（イ）にあてはまる数値を答えなさい。<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"d3ec8733-63a0-4d6e-b249-27bf5b56c689\" src='/img/10_7_1778738877681362.png'><br>※竜二さんおよび真紀子さんはともに、ＸＹ銀行からの借入れはない。<br>※普通預金は決済用預金ではない。<br>※預金の利息については考慮しない。<br>※ＸＹ銀行は過去１年以内に他行との合併等は行っていないこととする。<br><br><div style=\"border: 1px solid #000; padding:1em;\">・ 竜二さんの金融資産のうち、預金保険制度によって保護される金額は（ ア ）万円である。<br>・ 真紀子さんの金融資産のうち、預金保険制度によって保護される金額は（ イ ）万円である。</div>",
    "question2": "",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "預金保険制度",
    "important": "B"
  },
  {
    "id": 1207,
    "shikenId": 10,
    "no": 8,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,2,1,1",
    "score": "1,1,1,1",
    "question1": "下記＜資料＞は伊沢さんが購入を検討している物件の登記事項証明書の一部である。この登記事項証明書に関する次の（ア）～（エ）の記述について、正しいものには○、誤っているものには×を選択しなさい。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"50557598-f8f3-44ad-be79-0760f96074ea\" src='/img/10_8_1778738878112718.png'>",
    "question2": "",
    "choice1": "市役所等で手数料を納付すれば、誰でも登記事項証明書の交付を請求することができる。",
    "choice2": "所有権保存など所有権に関する事項が記載されている欄（ Ａ ）は、権利部の乙区である。",
    "choice3": "平成〇年にＡＢ銀行の抵当権設定が行われ、ＡＢ銀行の抵当権設定当初の債権額は３, ５００万円であることが分かる。",
    "choice4": "上記＜資料＞を確認する限り、本物件には現在、抵当権の設定はないことが分かる。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "登記",
    "important": "B"
  },
  {
    "id": 1208,
    "shikenId": 10,
    "no": 9,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "建築基準法に従い、下記＜資料＞の土地に耐火建築物を建てる場合、建築面積の最高限度（ア）と延べ面積の最高限度（イ）の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない条件については一切考慮しないこと。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"4d4a4150-9d3f-4e65-b809-a552aaad09f1\" src='/img/10_9_1778738878909086.png'>",
    "question2": "",
    "choice1": "（ア）１８０㎡　（イ）９００㎡",
    "choice2": "（ア）１８０㎡　（イ）８４０㎡",
    "choice3": "（ア）２１０㎡　（イ）８４０㎡",
    "choice4": "（ア）２１０㎡　（イ）９００㎡",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "建築面積と延べ面積の最高限度",
    "important": "A"
  },
  {
    "id": 1209,
    "shikenId": 10,
    "no": 10,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "芝沼さんは、保有しているマンションを賃貸している。下記＜資料＞に基づいて計算した本年の所得税に係る不動産所得の金額として、正しいものはどれか。<br>なお、＜資料＞以外の収入および支出等はないものとし、青色申告特別控除は考慮しないこととする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"29882898-d774-461e-8a1b-0e228e9a2bd3\" src='/img/10_10_1778738879446433.png'>",
    "question2": "",
    "choice1": "３万円",
    "choice2": "７３万円",
    "choice3": "９３万円",
    "choice4": "１３３万円",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産所得の計算",
    "important": "B"
  },
  {
    "id": 1210,
    "shikenId": 10,
    "no": 11,
    "answerType": 8,
    "groupId": 1,
    "answer": "2,4,7",
    "score": "1,1,1",
    "question1": "鴇田さんは、所有しているアパートを賃貸するに当たり、ＦＰの岸さんから借家契約の説明を受けた。借地借家法に基づく借家契約に関する下表の空欄（ア）～（ウ）に入る最も適切な語句を語群の中から選び、その番号を選択しなさい。<br>なお、同じ語句を何度選んでもよいこととする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"5ce4f709-f18d-4492-93ce-9035a3081db2\" src='/img/10_11_1778738880021485.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"6bed843f-f00b-446a-9184-395e6db901aa\" src='/img/10_11_1778738880573654.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "借家契約",
    "important": "B"
  },
  {
    "id": 1211,
    "shikenId": 10,
    "no": 12,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "太田さんは、自身の居住用財産である土地・建物の譲渡を予定しており、ＦＰで税理士でもある加藤さんに居住用財産を譲渡した場合の３，０００万円特別控除の特例（以下「本特例」という）について質問をした。＜資料＞に基づく次の記述のうち、最も不適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"0385a6c8-27e0-433e-9b88-67acfa3f36c7\" src='/img/10_12_1778738880962380.png'>",
    "question2": "",
    "choice1": "「本年中に譲渡する場合、太田さんの本年の合計所得金額が２，０００万円を超えるときは、本特例の適用を受けることはできません。」",
    "choice2": "「譲渡先が太田さんの子であるときは、本特例の適用を受けることはできません。」",
    "choice3": "「２０２６年６月１０日に太田さんが家族とともに居住の用に供さなくなった場合、その日から２０２９年１２月３１日までに譲渡しなければ、本特例の適用を受けることはできません。」",
    "choice4": "「２０２６年中に譲渡する場合、太田さんが２０２４年に本特例の適用を受けていたときは、本特例の適用を受けることはできません。」",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "3,000万円特別控除の特例",
    "important": "C"
  },
  {
    "id": 1212,
    "shikenId": 10,
    "no": 13,
    "answerType": 9,
    "groupId": 1,
    "answer": "180,10,110",
    "score": "2,2,2",
    "question1": "後藤さん（５４歳）が保険契約者（保険料負担者）および被保険者として加入している生命保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）～（ウ）にあてはまる数値を答えなさい。なお、保険契約は有効に継続しているものとし、後藤さんはこれまでに＜資料＞の保険から、保険金・給付金を一度も受け取っていないものとする。また、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"94639106-0760-4e64-9d92-c75695bfbc45\" src='/img/10_13_1778738881366292.png'><br><img data-image-id=\"I2\" data-asset-scope=\"data_check\" data-asset-id=\"4300fd4a-f095-45b6-a180-4012d336be8f\" src='/img/10_13_1778738882074862.png'><br><div style=\"border:1px solid #000; padding:1em;\">・ 後藤さんが現時点で、初めてがん（乳がん・悪性新生物）と診断されて２０日間入院し、その間に約款所定の手術（給付倍率４０倍）１回受けた場合、保険会社から支払われる保険金・給付金の合計は、（　ア　）万円である。<br>・ 後藤さんが現時点で、糖尿病で１４日間入院し（手術は受けていない）、退院日の翌日から約款所定の期間内に１０日間通院した場合、保険会社から支払われる保険金・給付金の合計は、（　イ　）万円である。<br>・ 後藤さんが現時点で、交通事故で死亡（入院・手術なし）した場合、保険会社から支払われる保険金・給付金の合計は、（　ウ　）万円である。</div>",
    "question2": "",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険証書の読み取り",
    "important": "A"
  },
  {
    "id": 1213,
    "shikenId": 10,
    "no": 14,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "下記の生命保険契約について、保険金・給付金の課税に関する次の記述のうち、最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"fe05bfdb-939f-4543-a552-ec7cf3fc7bf7\" src='/img/10_14_1778738882760521.png'>",
    "question2": "",
    "choice1": "夫が死亡し、契約Ａについて妻が取得する死亡保険金に係る年金受給権は、相続税の課税対象となる。",
    "choice2": "夫が死亡し、契約Ａから妻が２年目以降に受け取る死亡給付金のうち課税部分は、所得税（一時所得）の課税対象となる。",
    "choice3": "妻がガンと診断されたために、契約Ｂから妻が受け取ったガン診断給付金は所得税（一時所得）の課税対象となる。",
    "choice4": "妻が死亡し、契約Ｂから夫が受け取る死亡給付金は贈与税の課税対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険の税務",
    "important": "B"
  },
  {
    "id": 1214,
    "shikenId": 10,
    "no": 15,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,2,2,1",
    "score": "1,1,1,1",
    "question1": "大下秀男さんが契約している火災保険および地震保険（下記＜資料＞参照）に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択しなさい。なお、保険契約の内容は適正（超過保険や一部保険に該当しない）であり、かつ有効に継続しているものとする。また、＜資料＞に記載のない特約等については考慮しないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"ce49944b-07dd-4096-a332-2940eb549793\" src='/img/10_15_1778738883170771.png'>",
    "question2": "",
    "choice1": "住宅の屋根が台風の強風により損壊し、１００万円の損害を被った場合、補償の対象になる。",
    "choice2": "住宅内に保管していた時価２０万円のダイヤモンドの指輪が盗難にあった場合、補償の対象とならない。",
    "choice3": "洪水が原因で建物と家財が全損となった場合、合計２, ６００万円の保険金が支払われる。",
    "choice4": "大下さんがベランダから誤って物を落とし、歩道を通行中の他人にケガを負わせた場合の損害賠償責任について補償の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "火災保険証書の読み取り",
    "important": "B"
  },
  {
    "id": 1215,
    "shikenId": 10,
    "no": 16,
    "answerType": 8,
    "groupId": 1,
    "answer": "3,7,8,13",
    "score": "1,1,1,1",
    "question1": "リビング・ニーズ特約に関する下記＜資料＞の空欄（ア）～（エ）に入る適切な語句を語群の中から選び、その番号を選択しなさい。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"25589dac-3d52-4d6a-b303-c38b73964cc4\" src='/img/10_16_1778738884099408.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"4eb5772d-d6b9-4495-9788-a4e47fec7eb5\" src='/img/10_16_1778738884726887.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8|9|10|11|12|13|14",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "リビング・ニーズ特約",
    "important": "B"
  },
  {
    "id": 1216,
    "shikenId": 10,
    "no": 17,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "宮井さんは、生命保険の解約返戻金について、ＦＰの清田さんに質問をした。<br>清田さんが、生命保険の解約返戻金相当額について説明する際に使用した下記の＜イメージ図＞のうち、一般的な養老保険の解約返戻金相当額の推移に係る図として、最も適切なものはどれか。<br>＜イメージ図＞",
    "question2": "",
    "choice1": "<img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"f882a3b0-5309-4355-a624-2f645a28b9b9\" src='/img/10_17_1778738885145903.png'>",
    "choice2": "<img data-image-id=\"I2\" data-asset-scope=\"data_check\" data-asset-id=\"87c598b8-8c3b-4e6f-8d8b-eba8c9e015b3\" src='/img/10_17_1778738885522892.png'>",
    "choice3": "<img data-image-id=\"I3\" data-asset-scope=\"data_check\" data-asset-id=\"174a3661-2682-4889-a4c9-bdd20720fa8a\" src='/img/10_17_1778738885963098.png'>",
    "choice4": "<img data-image-id=\"I4\" data-asset-scope=\"data_check\" data-asset-id=\"7afc2a11-8166-4b2b-9b80-c522cc6ad3d2\" src='/img/10_17_1778738886272702.png'>",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険の性質",
    "important": "B"
  },
  {
    "id": 1217,
    "shikenId": 10,
    "no": 18,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,2,1",
    "score": "1,1,1",
    "question1": "雑所得に関する次の（ア）～（ウ）の記述について、適切なものには〇、不適切なものには×を選択しなさい。",
    "question2": "",
    "choice1": "小規模企業共済の共済金や確定拠出年金の老齢給付金は、年金形式で受け取る場合、公的年金等に係る雑所得の収入金額となる。",
    "choice2": "公的年金等に係る雑所得の金額の計算は、「公的年金等の収入金額－公的年金等控除額」により計算するが、公的年金等控除額は、受給者の年齢が70 歳以上か70 歳未満かにより、控除額が異なる。",
    "choice3": "年金等の収入金額が400 万円以下であり、かつ、その公的年金等の全部が源泉徴収の対象となる場合において、公的年金等に係る雑所得以外の所得金額の合計が20 万円以下であるときは、確定申告は不要である。",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "雑所得",
    "important": "B"
  },
  {
    "id": 1218,
    "shikenId": 10,
    "no": 19,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "個人事業主の新城さんは、本年２月に建物を購入したが、営業開始が遅延し、同年４月１０日から事業の用に供している。新城さんの本年分の所得税における事業所得の計算上、必要経費に算入すべき減価償却費の金額として、正しいものはどれか。なお、建物は、事業にのみ使用しており、その取得価額は９，０００万円、法定耐用年数は５０年である。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"82e9c19c-3d62-40df-823f-4645a9a721e0\" src='/img/10_19_1778738886700506.png'>",
    "question2": "",
    "choice1": "１，２００，０００円",
    "choice2": "１，３５０，０００円",
    "choice3": "１，６５０，０００円",
    "choice4": "２，７００，０００円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "減価償却費",
    "important": "B"
  },
  {
    "id": 1219,
    "shikenId": 10,
    "no": 20,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 2,
    "question1": "会社員の小岩さんの本年分の所得等が下記＜資料＞のとおりである場合、小岩さんが本年分の所得税の確定申告をする際における総所得金額として、最も適切なものはどれか。なお、▲が付された所得の金額は、その所得に損失が発生していることを意味するものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"df095484-bbc0-4f72-af7b-af2e7074963a\" src='/img/10_20_1778738887059114.png'>",
    "question2": "",
    "choice1": "４１０万円",
    "choice2": "４３０万円",
    "choice3": "４５０万円",
    "choice4": "４９０万円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "損益通算",
    "important": "A"
  },
  {
    "id": 1220,
    "shikenId": 10,
    "no": 21,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "内田さんは、加入していた下記＜資料＞の養老保険が当年９月に満期を迎えたため、満期保険金を一括で受け取った。内田さんの当年分の所得税において、総所得金額に算入すべき一時所得の金額として、正しいものはどれか。なお、内田さんには、この満期保険金以外に一時所得の対象となるものはないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"1b2c7be1-345d-4e1b-ae76-b23e01398a09\" src='/img/10_21_1778738887651545.png'>",
    "question2": "",
    "choice1": "１５万円",
    "choice2": "３０万円",
    "choice3": "４０万円",
    "choice4": "８０万円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "総所得金額に算入される一時所得",
    "important": "A"
  },
  {
    "id": 1221,
    "shikenId": 10,
    "no": 22,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "星野さんは、本年12 月に勤務先を退職する予定である。星野さんが受け取る退職一時金（下記＜資料＞参照）から源泉徴収された所得税額として、正しいものはどれか。なお、星野さんは、退職に際して「退職所得の受給に関する申告書」を適正に提出している。また、復興特別所得税は考慮しないこと。<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"3ddb71da-0aaf-413f-885f-092d28c964b2\" src='/img/10_22_1778738888003393.png'><br><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"e0bad6a4-af05-4ae7-a847-6097bc6d630f\" src='/img/10_22_1778738888588338.png'>",
    "question2": "",
    "choice1": "８５，０００円",
    "choice2": "２５２，５００円",
    "choice3": "５１２，５００円",
    "choice4": "５８２，５００円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "退職所得に係る所得税の算出",
    "important": "B"
  },
  {
    "id": 1222,
    "shikenId": 10,
    "no": 23,
    "answerType": 8,
    "groupId": 1,
    "answer": "8,3,5",
    "score": "1,1,1",
    "question1": "下記の＜親族関係図&gt; において、民法の規定に基づく法定相続分に関する次の記述の空欄（ア）～（ウ）に入る適切な語句または数値を語群の中から選び、その番号を選択しなさい。なお、同じ語句または数値を何度選んでもよいこととする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"8234ad7b-4a24-4945-b2e7-127aa54a17e9\" src='/img/10_23_1778738889192242.png'><br>［相続人の法定相続分および遺留分］<br>・被相続人の配偶者の法定相続分は（　ア　）である。<br>・被相続人の母の法定相続分は（　イ　）である。<br>・被相続人の母の遺留分は（　ウ　）である。<br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"594c1b2c-75b1-4370-b307-8d1839f3205b\" src='/img/10_23_1778738889675999.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8|9|10",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "法定相続分と遺留分",
    "important": "A"
  },
  {
    "id": 1223,
    "shikenId": 10,
    "no": 24,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "下記の相続事例（本年４月２６日相続開始）における相続税の課税価格の合計額として正しいものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"b0df2fbc-9931-4a40-b77d-19c89cb47303\" src='/img/10_24_1778738890004582.png'>",
    "question2": "",
    "choice1": "０円",
    "choice2": "２,３００万円",
    "choice3": "２,７００万円",
    "choice4": "３,３００万円",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の課税価格の計算",
    "important": "A"
  },
  {
    "id": 1224,
    "shikenId": 10,
    "no": 25,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "杉田さん（５８歳）は、本年１１月に夫から居住用不動産（財産評価額２，８００万円）の贈与を受けた。杉田さんが贈与税の配偶者控除の適用を受けた場合の本年分の贈与税額として、正しいものはどれか。<br>なお、本年においては、このほかに杉田さんが受けた贈与はないものとする。また、納付すべき贈与税額が最も少なくなるように計算すること。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"d0a52412-f47e-4f6d-961a-83f88ee2d0c4\" src='/img/10_25_1778738890883420.png'>",
    "question2": "",
    "choice1": "１９万円",
    "choice2": "１１７万円",
    "choice3": "１５１万円",
    "choice4": "１９５万円",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与税の配偶者控除",
    "important": "A"
  },
  {
    "id": 1225,
    "shikenId": 10,
    "no": 26,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,2,2,1",
    "score": "1,1,1,1",
    "question1": "福本さんは、自宅（敷地および建物）、店舗（敷地および建物）、貸駐車場（敷地）を所有している。<br>下記＜資料＞をもとに福本さんに相続が発生した場合、相続税の計算における小規模宅地等についての相続税の課税価格の計算の特例に関する次の記述（ア）～（エ）について適切なものには○、不適切なものには×を選択しなさい。なお、資料に記述がない要件はすべて満たしているものとして、一切考慮しないこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"1d8cb742-504a-4182-914b-88217e6d5127\" src='/img/10_26_1778738891697668.png'>",
    "question2": "",
    "choice1": "福本さんの自宅敷地は、最大で３００㎡まで８０％の減額の適用を受けられる。",
    "choice2": "福本さんの店舗敷地は、最大で５００㎡まで８０％の減額の適用を受けられる。",
    "choice3": "福本さんの貸駐車場は、最大で２００㎡まで５０％の減額の適用を受けられる。",
    "choice4": "福本さんの自宅敷地と店舗敷地については、面積調整をせずに、それぞれ限度面積まで適用を受けられる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "小規模宅地等の特例",
    "important": "B"
  },
  {
    "id": 1226,
    "shikenId": 10,
    "no": 27,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 2,
    "question1": "下記＜資料＞の宅地（貸家建付地）に係る路線価方式による相続税評価額の計算式として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"3634ec5e-9914-4bab-bffa-57d595045495\" src='/img/10_27_1778738892368476.png'>",
    "question2": "",
    "choice1": "１８０，０００円×１．００×２８６㎡×（１－６０％）",
    "choice2": "１８０，０００円×１．００×２８６㎡×（１－６０％×３０％×１００％）",
    "choice3": "１８０，０００円×１．００×２８６㎡×（１－７０％）",
    "choice4": "１８０，０００円×１．００×２８６㎡×（１－７０％×３０％×１００％）",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "宅地の評価",
    "important": "B"
  },
  {
    "id": 1227,
    "shikenId": 10,
    "no": 28,
    "answerType": 9,
    "groupId": 0,
    "answer": 702,
    "score": 2,
    "question1": "松原さんの過去のある年の給与明細等が以下＜資料＞のとおりである場合、松原さんの可処分所得の金額を計算しなさい。なお、ある年における松原さんの収入は給与収入のみである。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"99ec7959-e8cc-4de5-98e2-dfd0f8ee63c1\" src='/img/10_28_1778738892884887.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "可処分所得の計算",
    "important": "A"
  },
  {
    "id": 1228,
    "shikenId": 10,
    "no": 29,
    "answerType": 9,
    "groupId": 0,
    "answer": 502,
    "score": 2,
    "question1": "松原家のキャッシュフロー表の空欄（ア）に入る数値を計算しなさい。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"30fa93bb-f505-4ba9-af34-78270c9ac515\" src='/img/10_29_1778738893382181.png'><br>※年齢および金融資産残高は各年１２月３１日現在のものとする。<br>※記載されている数値は正しいものとする。<br>※問題作成の都合上、一部空欄にしてある。",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "キャッシュフロー表",
    "important": "A"
  },
  {
    "id": 1229,
    "shikenId": 10,
    "no": 30,
    "answerType": 9,
    "groupId": 0,
    "answer": 190,
    "score": 2,
    "question1": "松原家の両親が考えている進学プランは下記のとおりである。下記＜条件＞および＜資料＞のデータに基づいて、松原家のキャッシュフロー表の空欄（イ）に入る教育費の予測数値を計算しなさい。なお、計算過程においては端数処理をせずに計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"6703082c-5d48-49e7-acf4-e6200185824a\" src='/img/10_30_1778738894136150.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"e2984a98-094f-49d7-8413-4129e245f0ce\" src='/img/10_30_1778738894805358.png'><br><img data-image-id=\"I3\" data-asset-scope=\"content_extraction\" data-asset-id=\"a6288a5c-169d-4cf5-b6b0-16bcb355931a\" src='/img/10_30_1778738895241632.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "キャッシュフロー表",
    "important": "A"
  },
  {
    "id": 1230,
    "shikenId": 10,
    "no": 31,
    "answerType": 9,
    "groupId": 0,
    "answer": 9060000,
    "score": 2,
    "question1": "大和田さんは、有料老人ホームへの入居を検討しており、そのための資金として、５年後に１，０００万円を準備したいと考えている。５年間、年利２．０％で複利運用する場合、現在いくらの資金があればよいか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"af559f0e-7bd5-4527-8832-6c226ef7575c\" src='/img/10_31_1778738896051666.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "係数計算",
    "important": "A"
  },
  {
    "id": 1231,
    "shikenId": 10,
    "no": 32,
    "answerType": 9,
    "groupId": 0,
    "answer": 455000,
    "score": 2,
    "question1": "鈴木さんは、独立開業の準備資金として、１０年後に５００万円を準備しようと考えている。年利２．０％で複利運用しながら毎年年末に一定額を積み立てる場合、毎年いくらずつ積み立てればよいか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"c256e086-4e32-4eb2-9197-573dc18afef8\" src='/img/10_32_1778738896807387.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "係数計算",
    "important": "A"
  },
  {
    "id": 1232,
    "shikenId": 10,
    "no": 33,
    "answerType": 9,
    "groupId": 0,
    "answer": 6917200,
    "score": 2,
    "question1": "長門さんは、住宅の購入資金準備として新たに積立を開始する予定である。毎年年末に４０万円を積み立てるものとし、１５年間、年利２．０％で複利運用しながら積み立てた場合、１５年後の合計額はいくらになるか。なお、計算には下記の＜係数早見表＞を使用し、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"da82dec4-49db-4376-b6ca-1285ff5d8c26\" src='/img/10_33_1778738897583314.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "係数計算",
    "important": "A"
  },
  {
    "id": 1233,
    "shikenId": 10,
    "no": 34,
    "answerType": 9,
    "groupId": 0,
    "answer": 9660,
    "score": 2,
    "question1": "ＦＰの谷本さんは、現時点における星野家（和弘さんと康子さん）のバランスシート分析を行うこととした。下表の空欄（ア）に入る数値を計算しなさい。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"f2e6eafc-819c-4136-ab63-254594497ae7\" src='/img/10_34_1778738898295971.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"8442c238-a858-4679-9468-27931eb12ca2\" src='/img/10_34_1778738899170628.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "個人バランスシート",
    "important": "A"
  },
  {
    "id": 1234,
    "shikenId": 10,
    "no": 35,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "宮井麻紀さんは、夫の誠司さんが死亡した場合の公的年金の遺族給付について、ＦＰの清田さんに相談をした。仮に誠司さんが、本年９月に４７歳で在職中に死亡した場合に、誠司さんの死亡時点において麻紀さんが受け取ることができる公的年金の遺族給付の額として、正しいものはどれか。なお、遺族給付の計算に当たっては、下記＜資料＞の金額を使用することとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"994f5b45-25e8-4b5d-bf3c-c8f7b07ede69\" src='/img/10_35_1778738899926041.png'>",
    "question2": "",
    "choice1": "１，０９１，１００円",
    "choice2": "１，３８７，３００円",
    "choice3": "１，６３１，１００円",
    "choice4": "１，８７４，９００円",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "遺族給付",
    "important": "C"
  },
  {
    "id": 1235,
    "shikenId": 10,
    "no": 36,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "宮井さん（４７歳）の健康保険料等に関する次の記述のうち、最も適切なものはどれか。なお、宮井さんは全国健康保険協会管掌健康保険（協会けんぽ）の被保険者である。また、健康保険料の計算に当たり、下記＜資料＞に基づくこと。<br><br>［宮井さんに関するデータ］<br>毎月の給与：基本給４２０，０００円、通勤手当１２，０００円<br>賞与　　　：１回につき１，０００，０００円（年２回支給）<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"8c644964-b8d0-4cbf-b190-f84c9b372b05\" src='/img/10_36_1778738900667948.png'><br><br>［健康保険の保険料率］<br>介護保険第２号被保険者に該当しない場合：９．９１％（労使合計）<br>介護保険第２号被保険者に該当する場合　：１１．５０％（労使合計）",
    "question2": "",
    "choice1": "宮井さんが負担した健康保険料は、全額が社会保険料控除の対象となる。",
    "choice2": "協会けんぽの一般保険料率は、全国一律である。",
    "choice3": "毎月の給与に係る健康保険料のうち、宮井さんの負担分は２３，５７５円である。",
    "choice4": "賞与に係る健康保険料については、全額を会社が負担する。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "健康保険",
    "important": "B"
  },
  {
    "id": 1236,
    "shikenId": 10,
    "no": 37,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 3,
    "question1": "宮井誠司さんの弟の泰典さん（３０歳）は、よりよい職を求め、大学卒業後８年間勤務していたＴＦ社を本年５月に自己都合退職した。求職活動中は雇用保険から基本手当を受給する予定であり、基本手当の受給手続きについてＦＰの清田さんに質問をした。清田さんが雇用保険の基本手当について説明する際に使用した下表の空欄（ア）～（エ）に当てはまる適切な語句の組み合わせとして、正しいものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"2ecdda44-7a75-48d1-8027-5f6894135323\" src='/img/10_37_1778738900984933.png'>",
    "question2": "",
    "choice1": "（ア）　６カ月　（イ）３カ月　（ウ）２週間　（エ）１年間",
    "choice2": "（ア）１２カ月　（イ）３カ月　（ウ）２週間　（エ）２年間",
    "choice3": "（ア）　６カ月　（イ）１カ月　（ウ）４週間　（エ）２年間",
    "choice4": "（ア）１２カ月　（イ）１カ月　（ウ）４週間　（エ）１年間",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "雇用保険の基本手当",
    "important": "B"
  },
  {
    "id": 1237,
    "shikenId": 10,
    "no": 38,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "労働者災害補償保険（以下「労災保険」という）に関する次の記述のうち、最も適切なものはどれか。",
    "question2": "",
    "choice1": "労災保険が適用される労働者には、アルバイトおよびパートタイマーは含まれるが、在宅勤務労働者は含まれない。",
    "choice2": "労災保険の給付には、脳血管疾患や心臓疾患の発症の予防等を目的とする二次健康診断等給付がある。",
    "choice3": "休業補償給付は、労働者が業務上の負傷または疾病による療養のため、労働することができず、賃金を受けない日の１日目から支給される。",
    "choice4": "労働者が業務上の災害により、労災指定病院等において療養を受けた場合、その費用の１割を労働者が負担し、残る部分が療養補償給付とされる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "労災保険",
    "important": "C"
  },
  {
    "id": 1238,
    "shikenId": 10,
    "no": 39,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,1,2,2",
    "score": "1,1,1,1",
    "question1": "星野さんは、自分の老齢年金の受け取り方法について考えており、ＦＰの谷本さんに質問をした。星野さんの老齢年金の繰上げ受給および繰下げ受給に関する次の（ア）～（エ）の記述のうち、適切なものには〇、不適切なものには×を選択しなさい。",
    "question2": "",
    "choice1": "老齢基礎年金と老齢厚生年金の繰上げ請求は、異なる時期に別々に行うことができない。",
    "choice2": "老齢基礎年金と老齢厚生年金の繰下げ申出は、異なる時期に別々に行うことができる。",
    "choice3": "老齢厚生年金の支給の繰下げによる年金額の増額率は、最大で３０％となる。",
    "choice4": "老齢基礎年金とあわせて付加年金が受給できる場合であっても、付加年金は繰上げ受給により減額されることはなく、繰下げ受給により増額されることもない。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老齢年金の繰上げ支給と繰下げ支給",
    "important": "A"
  },
  {
    "id": 1239,
    "shikenId": 10,
    "no": 40,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "高橋さんは、自分や家族に介護が必要となった場合に備えて、公的介護保険制度について、ＦＰの駒田さんに質問をした。公的介護保険に関する次の説明の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><div style=\"border: solid 1px #000;padding: 1em;\">「介護保険の給付を受けるためには、市町村（特別区を含む）から要介護・要支援認定を受ける必要があります。主治医の意見書等も踏まえ、市町村（特別区を含む）に設置されている介護認定審査会により、自立（非該当）、要支援、要介護のいずれかに認定されることとなり、自立以外に認定された場合は、要支援、要介護を合わせ全（　ア　）のランク付けがなされます。なお、在宅サービスなど実際に介護保険の給付を受ける際の利用者負担の割合は、一定以上の所得がある者を除き、原則として（　イ　）となっており、認定された要介護度のランクに応じた支給限度額を上回るサービス費用については、全額自己負担となります。<br>初めて要介護の認定を受ける場合、要介護認定の有効期間は原則6か月となります。要介護認定を更新する場合、原則として、有効期間の最終日の（　ウ　）前から最終日までに、市町村（特別区を含む）に更新の手続きを行う必要があります。」</div>",
    "question2": "",
    "choice1": "（ア）７段階　　（イ）１割　　（ウ）　６０日",
    "choice2": "（ア）９段階　　（イ）１割　　（ウ）　３か月",
    "choice3": "（ア）９段階　　（イ）３割　　（ウ）　６０日",
    "choice4": "（ア）７段階　　（イ）３割　　（ウ）　３か月",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的介護保険",
    "important": "B"
  },
  {
    "id": 1239,
    "shikenId": 11,
    "no": 1,
    "answerType": 6,
    "groupId": 0,
    "answer": "ロ,ヘ,チ,ル",
    "score": "1,2,1,1",
    "question1": "<img src='/img/setsu_1239.png'/><br><img src='/img/setsu_1239_2.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、Ａさんが本年度現時点で死亡した場合に妻Ｂさんが受給することができる公的年金制度からの遺族給付および遺族年金生活者支援給付金について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>Ⅰ　 「Ａさんが現時点において死亡した場合、妻Ｂさんに対して遺族基礎年金および遺族厚生年金が支給されます。遺族基礎年金を受けられる遺族の範囲は、死亡した被保険者によって生計を維持されていた『子のある配偶者』または『子』です。『子』とは、（　①　）歳到達年度の末日までの間にあるか、□□□歳未満で障害等級１級または２級に該当する障害の状態にあり、かつ、現に婚姻していない子を指します。Ａさんの死亡直後に妻Ｂさんが受給することができる遺族基礎年金の額は（　②　）円（本年度価額）です。また、妻Ｂさんが遺族基礎年金を受給し、前年の所得が一定額以下である場合、妻Ｂさんは、遺族年金生活者支援給付金を受給することができ、その年額は（　③　）円（本年度価額）となります」<br>Ⅱ　 「遺族厚生年金の額は、Ａさんの厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の□分の□相当額になります。ただし、その計算の基礎となる被保険者期間の月数が（　④　）に満たない場合、（　④　）とみなして年金額が計算されます」<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"bad544e4-ec18-4ebb-9176-2576c5269bce\" src='/img/11_1_1778739917443909.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル|ヲ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "遺族基礎年金および遺族年金生活者支援給付金",
    "important": "B"
  },
  {
    "id": 1240,
    "shikenId": 11,
    "no": 2,
    "answerType": 4,
    "groupId": 0,
    "answer": 491772,
    "score": 2,
    "question1": "<img src='/img/setsu_1239.png'/><br><img src='/img/setsu_1239_2.png'/>",
    "question2": "Ａさんが本年度現時点で死亡した場合、《設例》の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づき、妻Ｂさんが受給することができる遺族厚生年金の額を求めなさい（計算過程の記載は不要）。なお、年金額は本年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"7f95eff3-64e2-432b-923d-63b84c667b4e\" src='/img/11_2_1778739917945539.png'>",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "遺族厚生年金",
    "important": "B"
  },
  {
    "id": 1241,
    "shikenId": 11,
    "no": 3,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1239.png'/><br><img src='/img/setsu_1239_2.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、公的介護保険（以下、「介護保険」という）の保険給付等について説明した。Ｍさんが説明した次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「Ａさんが現時点で介護保険の保険給付を受けた場合、 原則として、自己負担割合は実際にかかった費用（食費、居住費等を除く）の３割です」",
    "choice2": "「介護保険の第2 号被保険者に係る介護保険料は、市町村（特別区を含む）から送付される納付書により納付することになります」",
    "choice3": "「Aさんが介護保険の保険給付を受けるためには、都道府県から、要介護認定または要支援認定を受ける必要があります」",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "障害給付・介護保険",
    "important": "B"
  },
  {
    "id": 1242,
    "shikenId": 11,
    "no": 4,
    "answerType": 4,
    "groupId": 0,
    "answer": "5.50,4.29",
    "score": "2,2",
    "question1": "<img src='/img/setsu_1242.png'/>",
    "question2": "《設例》の＜Ｘ社株式の関連情報＞および＜Ｘ社の財務データ＞に基づいて算出される次の①、②を求めなさい（計算過程の記載は不要）。〈答〉は、％表示の小数点以下第３位を四捨五入し、小数点以下第２位までを解答すること。<br><br>①　51 期におけるROE（自己資本は50 期と51 期の平均を用いる）<br>②　51 期における配当利回り",
    "choice1": "％",
    "choice2": "％",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株式投資指標",
    "important": "A"
  },
  {
    "id": 1243,
    "shikenId": 11,
    "no": 5,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1242.png'/>",
    "question2": "ファイナンシャル・プランナーのＭさんは、Ａさんに対して、Ｘ社株式を購入する際の留意点等について説明した。Ｍさんが説明した次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「配当を受け取るためには、権利確定日に株主として株主名簿に記載される必要があります。次の決算期末の配当を受け取るためには、権利確定日の３営業日前である９月25 日（木）までに買付けを行ってください」",
    "choice2": "「51 期におけるＸ社株式のPBR は1.0 倍を下回っていますが、PBR の１倍割れだけをもって、割安と判断するのは注意が必要です。PER 等の他の投資指標も併せて比較・検討するなど、多角的な視点が望まれます」",
    "choice3": "「Ａさんが特定口座（源泉徴収あり）においてＸ社株式を株価1,400 円で200株購入し、同年中に株価2,000 円で全株売却した場合、その他の取引や手数料等を考慮しない場合、売買益12 万円に対して20.315％相当額が源泉徴収されます」",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株式購入時の留意点",
    "important": "A"
  },
  {
    "id": 1244,
    "shikenId": 11,
    "no": 6,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1242.png'/>",
    "question2": "ファイナンシャル・プランナーのＭさんは、Ａさんに対して、NISAの成長投資枠およびつみたて投資枠について説明した。Ｍさんが説明した次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「つみたて投資枠に受け入れることができる商品は、積立・分散投資に適した一定の公募株式投資信託や上場投資信託（ETF）、上場株式とされています。そのため、X 社株式はつみたて投資枠に受け入れることができます」",
    "choice2": "「成長投資枠とつみたて投資枠は同時に利用することはできません」",
    "choice3": "「NISAの年間非課税投資額は、成長投資枠は120 万円、つみたて投資枠は240 万円です」",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "NISA",
    "important": "A"
  },
  {
    "id": 1245,
    "shikenId": 11,
    "no": 7,
    "answerType": 4,
    "groupId": 0,
    "answer": "50,745",
    "score": "2,2",
    "question1": "<img src='/img/setsu_1245.png'/><br><img src='/img/setsu_1245_2.png'/>",
    "question2": "Ａさんの本年分の所得金額について、次の①、②を求めなさい（計算過程の記載は不要）。なお、総所得金額の計算上、Ａさんが所得金額調整控除の適用対象者に該当している場合、所得金額調整控除額を控除すること。また、答は万円単位とすること。<br><br>①　総所得金額に算入される一時所得の金額<br>②　総所得金額<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"ad6139af-7bc5-4773-935f-261ff0bb35de\" src='/img/11_7_1778739918534732.png'>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "総所得金額の計算",
    "important": "A"
  },
  {
    "id": 1246,
    "shikenId": 11,
    "no": 8,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1245.png'/><br><img src='/img/setsu_1245_2.png'/>",
    "question2": "Ａさんの本年分の所得税の所得控除等に関する次の記述①～③について、適切なものには〇、不適切なものには×を選択しなさい。",
    "choice1": "「Ａさんが適用を受けることができる配偶者控除の額は48 万円です」",
    "choice2": "「Ａさんが適用を受けることができる長男Ｃさんに係る扶養控除の額は、38万円です」",
    "choice3": "「父Ｅさんは公的年金の収入が150 万円あるため、Ａさんは父Ｅさんに係る扶養控除の適用を受けることができません」",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "扶養控除",
    "important": "A"
  },
  {
    "id": 1247,
    "shikenId": 11,
    "no": 9,
    "answerType": 6,
    "groupId": 0,
    "answer": "ヌ,イ,ホ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1245.png'/><br><img src='/img/setsu_1245_2.png'/>",
    "question2": "所得税における医療費控除に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の＜数値群＞の中から選び、その記号を答えなさい。<br><br>「通常の医療費控除は、その年分の総所得金額等の合計額が200 万円以上である場合、その年中に自己または自己と生計を一にする配偶者等のために支払った医療費の総額から保険金等で補填される金額を控除した金額が100,000 円を超えるときは、その超える部分の金額（最高で（　①　）円）を総所得金額等から控除することができます。<br>また、通常の医療費控除との選択適用となるセルフメディケーション税制（医療費控除の特例）は、定期健康診断や予防接種などの一定の取組を行っている者が自己または自己と生計を一にする配偶者等のために特定一般用医薬品等購入費を支払った場合、その年中に支払った特定一般用医薬品等購入費の総額から保険金などで補填される金額を控除した金額が（　②　）円を超えるときは、その超える部分の金額（最高（　③　）円）を総所得金額等から控除することができます」<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"1b9491fd-c12d-4c70-bda7-3f0a97885ac1\" src='/img/11_9_1778739919012463.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "医療費控除",
    "important": "B"
  },
  {
    "id": 1248,
    "shikenId": 11,
    "no": 10,
    "answerType": 4,
    "groupId": 0,
    "answer": "210,840",
    "score": "2,2",
    "question1": "<img src='/img/setsu_1248.png'/>",
    "question2": "甲土地上に耐火建築物を建築する場合における次の①、②を求めなさい（計算過程の記載は不要）。<br><br>①　建蔽率の上限となる建築面積<br>②　容積率の上限となる延べ面積",
    "choice1": "㎡",
    "choice2": "㎡",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "建蔽率と容積率の計算",
    "important": "A"
  },
  {
    "id": 1249,
    "shikenId": 11,
    "no": 11,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1248.png'/>",
    "question2": "Ｘ社が提案する事業用定期借地権方式に関する次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「事業用定期借地権等は、存続期間が10 年以上30 年未満の事業用借地権と30 年以上50 年未満の事業用定期借地権に区別されます。事業用定期借地権等の設定契約は、公正証書等の書面（電磁的記録を含む）でしなければなりません」",
    "choice2": "「Ａさんが、所有する宅地をＸ社に事業用定期借地権方式により貸し付ける場合、宅地建物取引業の免許が必要となります」",
    "choice3": "「X 社が甲土地に書店チェーンの店舗を建設した場合、相続税額の計算上、甲土地は貸宅地として評価されます」",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "事業用定期借地権方式",
    "important": "B"
  },
  {
    "id": 1250,
    "shikenId": 11,
    "no": 12,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1248.png'/>",
    "question2": "被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例（以下、「本特例」という）に関する次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「本特例の適用を受けた場合の特別控除の額は最高3,000 万円です。本特例と相続財産を譲渡した場合の取得費の特例（相続税の取得費加算の特例）は併用できます」",
    "choice2": "「本特例の適用を受けるための要件の１つとして、1981（昭和56）年５月31日以前に建築された家屋であることが挙げられます。実家の建物を取り壊して、甲土地を更地にした場合、本特例の適用を受けることはできませんので、本特例の適用を検討しているのであれば、建物は現況の空き家のままにしておいてください」",
    "choice3": "「本特例の適用要件の１つとして譲渡対価の額が１億円以下であることがあげられます」",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "空き家に係る譲渡所得の特例",
    "important": "C"
  },
  {
    "id": 1251,
    "shikenId": 11,
    "no": 13,
    "answerType": 6,
    "groupId": 0,
    "answer": "ハ,ヘ,ト",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1251.png'/><br><img src='/img/setsu_1251_2.png'/>",
    "question2": "Ａさんの相続・事業承継等に関する以下の文章の空欄①～③に入る最も適切な語句を、下記の＜語句群＞の中から選び、その記号を答えなさい。<br><br>Ⅰ　 「自筆証書遺言は（　①　）における保管制度を利用した場合、相続開始後、家庭裁判所における遺言書の検認が不要となります」<br>Ⅱ　 「遺言により、自宅および現預金等を妻Ｂさん、Ｘ社関連の資産を長男Ｃさんに相続させた場合、長女Ｄさんの遺留分を侵害する恐れがあります。仮に、遺留分を算定するための財産の価額が２億5,000 万円であるとした場合、長女Ｄさんの遺留分の金額は（　②　）万円となります」<br>Ⅲ　 「孫Ｅさんは相続税額の２割加算の対象に（　③　）」<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"d9ace0d5-68da-40f8-b2a1-1518c38a2bc4\" src='/img/11_13_1778739919342730.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続に関する記述",
    "important": "A"
  },
  {
    "id": 1252,
    "shikenId": 11,
    "no": 14,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1251.png'/><br><img src='/img/setsu_1251_2.png'/>",
    "question2": "相続に関する以下の文章①～③について、適切なものには〇、不適切なものには×を選択しなさい。",
    "choice1": "「仮に長男Ｃさんが、Ａさんの相続開始前に、Ａさんから相続時精算課税制度の適用を受けた贈与財産を贈与されていた場合、その贈与財産の贈与時の価額が相続税の課税価格に加算されます」",
    "choice2": "「Ａさんが、本年分の所得税について確定申告書を提出しなければならない場合に該当する時、相続人は原則として、相続の開始があったことを知った日の翌日から３カ月以内に準確定申告書を提出しなければなりません」",
    "choice3": "「仮に、妻Ｂさんが自宅の敷地および建物を相続により取得し、相続税の申告期限までに自宅の敷地を売却した場合、当該敷地は、特定居住用宅地等として『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けることができません」",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続に関する各手続き",
    "important": "A"
  },
  {
    "id": 1253,
    "shikenId": 11,
    "no": 15,
    "answerType": 4,
    "groupId": 0,
    "answer": "10000,4800,815,3970",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_1251.png'/><br><img src='/img/setsu_1251_2.png'/>",
    "question2": "相続人等は《設例》の記載のとおり、Ａさんの財産を取得した。Ａさんの相続に係る相続税の総額を計算した下記の表の空欄①～④に入る数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"b9390b53-9727-4a48-a586-de8eea0b1659\" src='/img/11_15_1778739919687201.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"6274a1ff-1bb2-4b73-9277-31b3d3049346\" src='/img/11_15_1778739920319024.png'>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "万円",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の計算",
    "important": "A"
  },
  {
    "id": 1254,
    "shikenId": 12,
    "no": 1,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1254.png'/><br><img src='/img/setsu_1254_2.png'/>",
    "question2": "はじめに、Ｍさんは、Ａさん夫妻に対して、公的年金制度からの老齢給付について説明した。Ｍさんが説明した次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「原則として、会社員歴を有する1961 年４月２日以降生まれの男性、1966年４月２日以降生まれの女性には特別支給の老齢厚生年金は支給されず、65歳から老齢基礎年金および老齢厚生年金を受給することになります」",
    "choice2": "「Ａさんおよび妻Ｂさんが希望すれば、66 歳以後、老齢基礎年金および老齢厚生年金の繰下げ支給の申出をすることができます。仮に、Ａさんが68歳０カ月で老齢基礎年金の繰下げ支給の申出をした場合、年金の増額率は18.0％となります」",
    "choice3": "「Ａさんおよび妻Ｂさんが希望すれば、老齢基礎年金および老齢厚生年金の繰上げ支給の申出をすることができ、減額率は１カ月につき0.4％となります。老齢基礎年金および老齢厚生年金の繰上げ支給の申出は同時にしなければならず、一生涯減額された年金額を受け取ることになります」",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的年金の諸制度",
    "important": "A"
  },
  {
    "id": 1255,
    "shikenId": 12,
    "no": 2,
    "answerType": 6,
    "groupId": 0,
    "answer": "ロ,ホ,チ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1254.png'/><br><img src='/img/setsu_1254_2.png'/>",
    "question2": "次に、Mさんは、Aさんに対して、公的保険について説明した。Mさんが説明した次の文章の空欄①～③に入る最も適切な語句または数値を、下記の＜語句群＞の中から選び、その記号を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>Ⅰ． 「仮に、A さんがX 社に引き続き勤務し、業務外の事由による負傷または疾病の療養のために労務に服することができず、連続して□□□日間休業し、かつ、（　①　）日目以降の休業した日について事業主から賃金の支払いがなかった場合、所定の手続きにより、（　①　）日目以降の休業した日について、傷病手当金が支給されます」<br>Ⅱ． 「傷病手当金の支給額は、休業1 日につき、原則として、傷病手当金の支給を始める日の属する月以前の直近の継続した12カ月間の各月の標準報酬月額を平均した額の30 分の1に相当する額の（　②　）となり、その支給を開始した日から通算（　③　）を限度として支給されます」<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"13db5f6e-2161-4145-9680-a93df4d25be6\" src='/img/12_2_1778742253211861.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的医療保険",
    "important": "B"
  },
  {
    "id": 1256,
    "shikenId": 12,
    "no": 3,
    "answerType": 4,
    "groupId": 0,
    "answer": "796109,1270815",
    "score": "2,2",
    "question1": "<img src='/img/setsu_1254.png'/><br><img src='/img/setsu_1254_2.png'/>",
    "question2": "最後に、Ｍさんは、Ａさんに対して、Ａさんが65 歳以後に受給することができる公的年金制度からの老齢給付について説明した。《設例》の＜Ａさん夫妻に関する資料＞および下記の＜資料＞に基づき、次の①、②を求めなさい（計算過程の記載は不要）。なお、年金額は本年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。<br><br>①　 原則として、Ａさんが65 歳から受給することができる老齢基礎年金の年金額<br>②　 原則として、Ａさんが65 歳から受給することができる老齢厚生年金の年金額<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"efaf8754-9610-4d03-af17-a7e5537946b6\" src='/img/12_3_1778742253658060.png'>",
    "choice1": "円",
    "choice2": "円",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老齢基礎年金および老齢厚生年金の計算",
    "important": "A"
  },
  {
    "id": 1257,
    "shikenId": 12,
    "no": 4,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1257.png'/><br><img src='/img/setsu_1257_2.png'/>",
    "question2": "はじめに、Ｍさんは、Ａさんに対して、Ａさんや妻Ｂさんの保障の見直し方法と障害年金について説明した。Ｍさんが説明した次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「妻Ｂさんに会社員としての給与収入があるため、妻Ｂさんが専業主婦である場合に比べて、Ａさんが死亡した場合の必要保障額が少なくなりますが、妻Ｂさんが病気やケガ等で就業不能となった場合や離職した場合などの生活への影響が大きくなります。夫婦で行ってきた家事や育児等を外部の代行業者等の利用を踏まえると、Ａさんの生命保険だけでなく、妻Ｂさんの保障内容も検討する必要があると考えられます」",
    "choice2": "「仮にAさんが厚生年金の被保険者期間中に初診日のある傷病によって重度の障害状態となり、障害認定日において、障害等級1 級～3 級のいずれかに該当し、保険料納付要件を満たしている場合、障害基礎年金を請求することができます」",
    "choice3": "「仮にA さんが業務上の理由により、障害厚生年金と労働者補償保険法に基づく障害補償年金が支給される場合、障害厚生年金は全額支給され、障害補償年金は所定の調整率により減額されます」",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（個人）",
    "rontenName": "保障の見直し方法と障害年金",
    "important": "B"
  },
  {
    "id": 1258,
    "shikenId": 12,
    "no": 5,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1,2",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_1257.png'/><br><img src='/img/setsu_1257_2.png'/>",
    "question2": "次に、Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の保障内容や税務、見直しの注意点等について説明した。Ｍさんが説明した次の記述①～④について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「現在加入している生命保険を契約転換することができます。転換後契約の保険料は転換前契約の加入時の年齢により算出されるため、新規に加入する場合と比較して、保険料負担を抑えられます」",
    "choice2": "「生命保険の契約の際、傷病歴や現在の健康状態など、事実を正しく告知しましょう。告知受領権は生命保険募集人が有しており、募集人に対して口頭で告知すれば、正しく告知したことになります」",
    "choice3": "「先進医療特約では、療養を受けた時点において厚生労働大臣により先進医療に該当した治療が先進医療給付金の対象となります」",
    "choice4": "「Ａさんが所定の就業不能状態となり、就業不能給付金を請求できない特別な事情がある場合には、指定代理請求人である妻ＢさんがＡさんに代わって請求することができます。妻Ｂさんが代理請求した場合、就業不能給付金は一時所得として扱われます」",
    "choice5": "",
    "categoryName": "リスク（個人）",
    "rontenName": "生命保険に関する記述",
    "important": "A"
  },
  {
    "id": 1259,
    "shikenId": 12,
    "no": 6,
    "answerType": 6,
    "groupId": 0,
    "answer": "ロ,ニ,リ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1257.png'/><br><img src='/img/setsu_1257_2.png'/>",
    "question2": "最後に、Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の課税関係について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ　 「支払保険料のうち、終身保険特約および定期保険特約に係る保険料は一般の生命保険料控除の対象となり、就業不能サポート特約、入院特約および先進医療特約に係る保険料は介護医療保険料控除の対象となります。それぞれの控除の適用限度額は、所得税で40,000 円、住民税で（　①　）円です。また、一般の生命保険料控除、介護医療保険料控除および個人年金保険料控除を合わせた合計適用限度額は、所得税で120,000 円、住民税で（　②　）円となります」<br>Ⅱ　 「提案の生命保険にはリビング・ニーズ特約が付加されているため、Ａさんが余命６カ月以内と判断された場合、所定の範囲内で、死亡保険金の一部または全部を生前に受け取ることができます。Ａさんが受け取る特約保険金は、（　③　）となります」<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"65c15f0e-e7d7-4cac-b8a2-c02b71f966b2\" src='/img/12_6_1778742254618749.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（個人）",
    "rontenName": "生命保険の税務",
    "important": "A"
  },
  {
    "id": 1260,
    "shikenId": 12,
    "no": 7,
    "answerType": 4,
    "groupId": 0,
    "answer": "1500,1750",
    "score": "1,2",
    "question1": "<img src='/img/setsu_1260.png'/><br><img src='/img/setsu_1260_2.png'/>",
    "question2": "仮に、Ｘ社がAさんに役員退職金5,000 万円を支給した場合、Ａさんが受け取る役員退職金について、次の①、②を求めなさい。《答》は万円単位とすること。なお、Ａさんの役員在任期間（勤続年数）を29 年６カ月とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。<br><br>①　退職所得控除額<br>②　退職所得の金額",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（法人）",
    "rontenName": "退職所得の計算",
    "important": "A"
  },
  {
    "id": 1261,
    "shikenId": 12,
    "no": 8,
    "answerType": 6,
    "groupId": 0,
    "answer": "チ,ホ,ヌ,ニ",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_1260.png'/><br><img src='/img/setsu_1260_2.png'/>",
    "question2": "《設例》の＜資料１＞の生命保険を現時点で解約した場合のＸ社の経理処理（仕訳）について、 下記の＜条件＞を基に、空欄①～④に入る最も適切な語句または数値を、下記の＜語句群＞の中から選び、その記号を答えなさい。<br>＜条件＞<br>・Ｘ社が解約時までに支払った保険料の総額は6,000 万円である。<br>・解約返戻金の金額は5,460 万円である。<br>・配当等、上記以外の条件は考慮しないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"2c702040-428e-4229-a09e-8be378c45eee\" src='/img/12_8_1778742254921614.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"0396580c-c437-49d3-8d49-3971e7b45606\" src='/img/12_8_1778742255306800.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル|ヲ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（法人）",
    "rontenName": "法人契約の生命保険の経理処理",
    "important": "B"
  },
  {
    "id": 1262,
    "shikenId": 12,
    "no": 9,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,1,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1260.png'/><br><img src='/img/setsu_1260_2.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、《設例》の＜資料２＞の終身保険について説明した。Ｍさんが説明した次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「当該生命保険の支払保険料は、その全額を資産に計上します。仮に、保険料払込期間満了時にＡさんが死亡した場合、Ｘ社は、それまで資産計上していた保険料積立金4,180 万円を取り崩し、死亡保険金5,000 万円との差額820 万円を雑収入として経理処理します」",
    "choice2": "「Ａさんが勇退する際に、契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義変更することで、当該保険契約を役員退職金の一部または全部として支給することができます。Ａさん個人の保険として継続することにより、納税資金の確保や死亡保険金の非課税金額の規定の適用など、相続対策として活用することができます」",
    "choice3": "「Ｘ社が保険期間中に資金を必要とした場合、契約者貸付制度を利用することにより、当該生命保険を解約することなく、資金を調達することができます。Ｘ社が契約者貸付金を受け取った場合、当該保険契約は継続しているため、経理処理は必要ありません」",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（法人）",
    "rontenName": "法人契約の終身保険の特徴",
    "important": "B"
  },
  {
    "id": 1263,
    "shikenId": 12,
    "no": 10,
    "answerType": 4,
    "groupId": 0,
    "answer": "6340000,69500,312500",
    "score": "1,1,2",
    "question1": "<img src='/img/setsu_1263.png'/><br><img src='/img/setsu_1263_2.png'/>",
    "question2": "Ａさんの本年分の所得税の算出税額を計算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I3\" data-asset-scope=\"data_check\" data-asset-id=\"d585a1c7-1e0b-4830-b7e1-1cb06e0e0024\" src='/img/12_10_1778742255611435.png'>",
    "choice1": "円",
    "choice2": "円",
    "choice3": "円",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税額の算出",
    "important": "A"
  },
  {
    "id": 1264,
    "shikenId": 12,
    "no": 11,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1263.png'/><br><img src='/img/setsu_1263_2.png'/>",
    "question2": "Ａさんの本年分の所得税の所得控除等に関する次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「Ａさんが適用を受けることができる配偶者控除の額は48 万円です」",
    "choice2": "「Ａさんが適用を受けることができる長男Ｃさんに係る扶養控除の額は、38万円です」",
    "choice3": "「父Ｄさんは公的年金の収入が150 万円あるため、Ａさんは父Ｄさんに係る扶養控除の適用を受けることができません」",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得控除",
    "important": "A"
  },
  {
    "id": 1265,
    "shikenId": 12,
    "no": 12,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1263.png'/><br><img src='/img/setsu_1263_2.png'/>",
    "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「Ａさんが受け取った一時払変額個人年金保険の解約返戻金は、契約から10年以内の解約のため、金融類似商品に該当し、源泉分離課税の対象となります」",
    "choice2": "「Ａさんの場合、一時所得の金額が20 万円を超えるため、所得税の確定申告をしなければなりません」",
    "choice3": "「所得税の確定申告書を提出する方法として、確定申告書を税務署に持参または送付して提出する方法のほかに、e-Tax を利用する方法があります」",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の申告等",
    "important": "B"
  },
  {
    "id": 1266,
    "shikenId": 12,
    "no": 13,
    "answerType": 6,
    "groupId": 0,
    "answer": "ロ,ヘ,チ,ニ",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_1266.png'/><br><img src='/img/setsu_1266_2.png'/>",
    "question2": "父Ｄさんの相続等に関する以下の文章の空欄①～④に入る最も適切な数値を、下記の＜数値群＞の中から選び、その記号を答えなさい。<br><br>Ⅰ　 「賃貸アパートを経営していた父Ｄさんが本年分の所得税について確定申告書を提出しなければならない場合に該当するとき、相続人は、原則として、相続の開始があったことを知った日の翌日から（　①　）カ月以内に準確定申告書を提出しなければなりません」<br><br>Ⅱ　 「弟Ｂさんが受け取る死亡保険金（3,000 万円）のうち、相続税の課税価格に算入される金額は、（　②　）万円となります」<br><br>Ⅲ　 「自宅（実家）の敷地および建物をＡさんおよび弟Ｂさんが取得し、『被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例』の適用を受けた場合、譲渡所得の金額の計算上、それぞれ最高（　③　）万円の特別控除の適用を受けることができます」<br><br>Ⅳ　 「相続税の申告書の提出期限は、原則として、相続の開始があったことを知った日の翌日から（　④　）カ月以内です。申告書の提出先は、父Ｄさんの死亡時の住所地を所轄する税務署長になります」<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"f435947e-a908-4d94-a88e-2e096e6c82fd\" src='/img/12_13_1778742256481809.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続に関する記述",
    "important": "A"
  },
  {
    "id": 1267,
    "shikenId": 12,
    "no": 14,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1266.png'/><br><img src='/img/setsu_1266_2.png'/>",
    "question2": "「小規模宅地等についての相続税の課税価格の計算の特例」（以下、「小規模宅地等の特例」という）および「被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例」（以下、空き家の譲渡の特例という）に関する次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「Ａさんが実家の建物を取り壊して敷地のみを譲渡した場合、空き家の譲渡の特例の適用を受けることができなくなります。空き家の譲渡の特例の適用を受けることを検討している場合、建物は現況の空き家のままにしておいてください」",
    "choice2": "「自宅（実家）の敷地と賃貸アパートの敷地について、小規模宅地等の特例の適用を受けようとする場合、適用対象面積の調整はせず、それぞれの宅地等の適用対象の限度面積まで適用を受けることができます」",
    "choice3": "「空き家の譲渡の特例と『相続財産に係る譲渡所得の課税の特例（相続税の取得費加算の特例）』 は、重複して適用を受けることができます」",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "小規模宅地等の特例と空き家に係る譲渡所得の特例",
    "important": "B"
  },
  {
    "id": 1268,
    "shikenId": 12,
    "no": 15,
    "answerType": 4,
    "groupId": 0,
    "answer": "4800,310,930",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_1266.png'/><br><img src='/img/setsu_1266_2.png'/>",
    "question2": "父Ｄさんの相続における相続税の総額を試算した下記の表の空欄①～③に入る数値を求めなさい。なお、相続税の課税価格の合計額は１億2,000 万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"93add87e-dbb7-4fde-bb47-13136c4db906\" src='/img/12_15_1778742256901100.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"6d3bbdf8-c8a5-446c-b9f0-7c1072d18151\" src='/img/12_15_1778742257359664.png'>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の計算",
    "important": "A"
  },
  {
    "id": 22000,
    "shikenId": 14,
    "no": 1,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,1,2",
    "score": "1,1,1",
    "question1": "ファイナンシャル・プランナーは、執筆や講演などの依頼を受ける場合があり、著作権についての理解が必要である。著作権法に基づく著作権の保護に関する次の（ア）～（ウ）の記述について、適切なものには○、不適切なものには×を選択してください。",
    "question2": "",
    "choice1": "新聞記事をコピーし、投資希望者向け講演会の資料として配布する場合は、当該新聞社の許諾が必要である。",
    "choice2": "著作内容に、政府が集計、公表した統計資料を転載する場合、原則として担当省庁の許諾は不要である。",
    "choice3": "公表されている他人の著作物を自分の著作物に引用する場合、内容的に引用部分が「主」、自ら作成する部分が「従」であるような主従関係がなければならない。",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "著作権法",
    "important": "C"
  },
  {
    "id": 22001,
    "shikenId": 14,
    "no": 2,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "個人情報の保護に関する法律（以下、「個人情報保護法」という）に関する次の記述のうち、最も不適切なものはどれか。",
    "question2": "",
    "choice1": "個人番号（マイナンバー）、基礎年金番号、健康保険の被保険者証の記号番号のいずれも、個人情報として取り扱う必要がある。",
    "choice2": "個人事業主であるファイナンシャル・プランナーが、事業の用に供する目的で５名分の顧客名簿を作成している場合、個人情報保護法の適用対象とならない。",
    "choice3": "個人情報取扱事業者が、本人との契約書を通じて、契約者本人の個人情報を取得する場合、原則として、契約締結前に本人に対し、その利用目的を明示する必要がある。",
    "choice4": "個人情報取扱事業者が、税務署の職員による税務調査に応じ、個人情報を提出する場合は、第三者提供に関する本人の同意は不要である。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "個人情報保護法",
    "important": "C"
  },
  {
    "id": 22002,
    "shikenId": 14,
    "no": 3,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "根本さんは、本年7月に購入し、特定口座（源泉徴収選択口座）で保有している国内公募追加型株式投資信託WS ファンドの売却を検討している。下記＜資料＞に基づき、WS ファンドを一部解約した場合の譲渡所得の金額として、正しいものはどれか。なお、計算過程に当たっては、円未満の端数が生じた場合には、円未満の端数を切り捨てること。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"47445ba6-2119-450e-9d01-bf6ce182a1d4\" src='/img/14_3_1779255956058145.png'>",
    "question2": "",
    "choice1": "９４，７７７円",
    "choice2": "９５，９１１円",
    "choice3": "９６，１６９円",
    "choice4": "１０３，０００円",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "投資信託の譲渡所得の計算",
    "important": "C"
  },
  {
    "id": 22003,
    "shikenId": 14,
    "no": 4,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,2,1,2",
    "score": "1,1,1,1",
    "question1": "下記は、ＮＩＳＡ（少額投資非課税制度）の成長投資枠およびつみたて投資枠について概要の一部をまとめた表である。下表に関する次の（ア）～（エ）の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img data-image-id=\"I1\"  data-asset-scope=\"content_extraction\" data-asset-id=\"fd5d91fb-ff01-4353-a446-6d6f2fa6cb0e\" src='/img/14_4_1779255956491332.png'><br>※問題作成の都合上、一部を空欄にしている",
    "question2": "",
    "choice1": "空欄（ａ）にあてはまる数値は、「２０」である。",
    "choice2": "空欄（ｂ）にあてはまる数値は、「３００」である。",
    "choice3": "空欄（ｃ）にあてはまる数値は、「１２０」である。",
    "choice4": "空欄（ｃ）にあてはまる数値は、「１，５００」である。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "NISA",
    "important": "B"
  },
  {
    "id": 22004,
    "shikenId": 14,
    "no": 5,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "個人向け国債に関する下表の空欄（ア）～（エ）にあてはまる語句または数値に関する次の記述のうち、最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"bbf42f1a-7f26-438c-9012-7ab54f31e171\" src='/img/14_5_1779255956886073.png'>",
    "question2": "",
    "choice1": "空欄（ア）にあてはまる語句は、「変動」である。",
    "choice2": "空欄（イ）にあてはまる語句は、「１年」である。",
    "choice3": "空欄（ウ）にあてはまる語句は、「０.０５」である。",
    "choice4": "空欄（エ）にあてはまる語句は、「３カ月」である。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "個人向け国債",
    "important": "B"
  },
  {
    "id": 22005,
    "shikenId": 14,
    "no": 6,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "下記＜資料＞の外貨定期預金を満期まで保有した場合における外貨ベースの元利合計額を円転した金額として正しいものはどれか。なお、計算結果（円転した金額）について円未満の端数が生じる場合は切り捨てること。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"f52d007d-63bb-41b1-860f-7dc88af7b4eb\" src='/img/14_6_1779255957292577.png'><br>注１： 利息の計算に際しては、預入期間は日割りではなく月割りで計算すること。<br>注２：為替差益・為替差損に関する税金は考慮しないこと。<br>注３： 利息に対しては、米ドル建ての利息額の２０％（復興特別所得税は考慮しない）相当額が所得税・住民税として源泉徴収されるものとすること。",
    "question2": "",
    "choice1": "１，５８６，３２０円",
    "choice2": "１，５８７，９００円",
    "choice3": "１，５９５，８００円",
    "choice4": "１，６０６，４００円",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "外貨預金の計算",
    "important": "B"
  },
  {
    "id": 22006,
    "shikenId": 14,
    "no": 7,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "安藤さんは、投資信託への投資を検討するに当たり、ＦＰの細川さんから候補である３ファンドの過去３年間の運用パフォーマンスについて説明を受けた。<br>ＦＰの細川さんが下記＜資料＞に基づいて説明した内容の空欄（ア）～（ウ）にあてはまる語句および数値の組み合わせとして、最も適切なものはどれか。<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"7a50f31f-bdcc-42ea-86d7-b964dc3d3515\" src='/img/14_7_1779255957614833.png'><br><br><img data-image-id=\"I2\" data-asset-scope=\"data_check\" data-asset-id=\"38562eaa-bf40-4b1a-ad06-e3488953be6d\" src='/img/14_7_1779255957898294.png'>",
    "question2": "",
    "choice1": "（ア）０．９６　　　（イ）ＲＺファンド　　　（ウ）ＲＹファンド",
    "choice2": "（ア）１．６０　　　（イ）ＲＺファンド　　　（ウ）ＲＸファンド",
    "choice3": "（ア）０．９６　　　（イ）ＲＸファンド　　　（ウ）ＲＺファンド",
    "choice4": "（ア）１．６０　　　（イ）ＲＹファンド　　　（ウ）ＲＺファンド",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "シャープレシオ",
    "important": "C"
  },
  {
    "id": 22007,
    "shikenId": 14,
    "no": 8,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "谷村さんは、自らが居住している自宅の土地および建物の売却を検討している。売却に係る状況が下記＜資料＞のとおりである場合、所得税における課税長期譲渡所得金額として、正しいものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"8fd70c8e-c7b2-4ab8-a470-be1fecba3edf\" src='/img/14_8_1779255958116251.png'>",
    "question2": "",
    "choice1": "１，５００万円",
    "choice2": "２，１００万円",
    "choice3": "２，４００万円",
    "choice4": "２，７００万円",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産の譲渡所得の計算",
    "important": "A"
  },
  {
    "id": 22008,
    "shikenId": 14,
    "no": 9,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "不動産取得税に関する次の記述の空欄（ア）～（ウ）に入る語句の組み合わせとして、正しいものはどれか。<br><div style=\"border:solid 1px #333; padding:0.5em\">・ 不動産取得税は、原則として不動産の所有権を取得した者に対して、その不動産が所在する（　ア　）が課税するものであるが、（　イ　）や法人の合併等を原因とする取得の場合は非課税となる。<br>・ 一定の条件を満たした新築住宅（認定長期優良住宅ではない）を取得した場合、不動産取得税の課税標準から１戸当たり最大（　ウ　）を控除することができる。</div>",
    "question2": "",
    "choice1": "（ア）国　　　　　（イ）相続　　（ウ）１，０００万円",
    "choice2": "（ア）国　　　　　（イ）贈与　　（ウ）１，２００万円",
    "choice3": "（ア）都道府県　　（イ）相続　　（ウ）１，２００万円",
    "choice4": "（ア）都道府県　　（イ）贈与　　（ウ）１，０００万円",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産取得税",
    "important": "B"
  },
  {
    "id": 22009,
    "shikenId": 14,
    "no": 10,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "下記＜資料＞は、三浦さんが購入を検討している中古タワーマンションのインターネット上の広告（抜粋）である。この広告の内容等に関する次の記述のうち、最も不適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"fb2909c4-4361-4fa6-b911-f7fb9d7d5cda\" src='/img/14_10_1779255958364950.png'>",
    "question2": "",
    "choice1": "この広告の物件を購入した場合、購入前になされた集会の決議について、三浦さんにその効力は及ばない。",
    "choice2": "この広告の物件の専有面積は壁芯面積で記載されているが、これは登記簿上の内法面積より大きい。",
    "choice3": "この広告の物件を購入する場合、現在の区分所有者が管理費を滞納していれば、新たに区分所有者となる者にも滞納分の管理費の支払義務が生じる。",
    "choice4": "この物件を購入する場合、通常、宅地建物取引業者に媒介業務に係る報酬（仲介手数料）を支払う。",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産広告の見方",
    "important": "B"
  },
  {
    "id": 22010,
    "shikenId": 14,
    "no": 11,
    "answerType": 9,
    "groupId": 1,
    "answer": "4.56,3.72",
    "score": "2,2",
    "question1": "下記＜資料＞は、大浜さんが購入を検討している投資用マンションの概要である。この物件の表面利回り（年利）と実質利回り（年利）を計算しなさい。なお、＜資料＞に記載のない事項については一切考慮しないこととし、計算結果については小数点以下第３位を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"1cab894c-d6d4-4f77-8e75-650acc05f611\" src='/img/14_11_1779255958885840.png'><br>・表面利回り（年利）は（　ア　）％となる。<br>・実質利回り（年利）は（　イ　）％となる。",
    "question2": "",
    "choice1": "%",
    "choice2": "%",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "投資利回りの計算",
    "important": "B"
  },
  {
    "id": 22011,
    "shikenId": 14,
    "no": 12,
    "answerType": 9,
    "groupId": 0,
    "answer": 208,
    "score": 2,
    "question1": "建築基準法に従い、下記＜資料＞の土地に建物を建てる場合の建築面積の最高限度を計算しなさい。なお、記載のない事項については一切考慮しないものとする。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"31716e13-a7d0-4aa3-9164-e45a3b2a81ae\" src='/img/14_12_1779255959324637.png'>",
    "question2": "",
    "choice1": "㎡",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "建築面積の計算",
    "important": "B"
  },
  {
    "id": 22012,
    "shikenId": 14,
    "no": 13,
    "answerType": 9,
    "groupId": 1,
    "answer": "370,2330,2",
    "score": "2,2,2",
    "question1": "羽鳥秀一さん（４５歳）が加入の提案を受けた生命保険の保障内容は下記＜資料＞のとおりである。この生命保険に加入した場合、次の記述の空欄（ア）～（ウ）にあてはまる数値を計算しなさい。なお、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"35cb3be6-88ba-4b7f-8d3b-e17e2468c4f7\" src='/img/14_13_1779255959633274.png'><br><img data-image-id=\"I2\" data-asset-scope=\"data_check\" data-asset-id=\"64b021ac-cf23-496b-b37e-7315dc2a3d3c\" src='/img/14_13_1779255960065802.png'><br><br>・ 羽鳥さんが初めてがん（悪性新生物）と診断され、治療のため３０日間継続して入院し、その入院中に公的医療保険制度の対象となる所定の手術を１回受けた場合、保険会社から支払われる保険金・給付金の合計は（　ア　）万円である。<br>・ 羽鳥さんが交通事故で即死した場合、保険会社から支払われる保険金・給付金の合計は（　イ　）万円である。<br>・ 羽鳥さんがケガで公的医療保険制度の対象となる所定の手術を入院せずに１回受けた場合、保険会社から支払われる保険金・給付金の合計は（　ウ　）万円である。",
    "question2": "",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険の証券分析",
    "important": "A"
  },
  {
    "id": 22013,
    "shikenId": 14,
    "no": 14,
    "answerType": 9,
    "groupId": 0,
    "answer": 140,
    "score": 2,
    "question1": "広瀬さんは、心疾患および事故により合計３回入院をした。下記＜資料＞に基づき、広瀬さんが契約している医療保険の入院給付金の日数に関する次の記述の空欄（ア）に入る数値を計算しなさい。なお、広瀬さんは、入院Ａについてはこの医療保険から所定の入院給付金を受け取っているが、それ以外にこの医療保険から一度も給付金を受け取っていないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"dd2597af-9786-4b79-a84f-d25cfa5e2b33\" src='/img/14_14_1779255960738480.png'>",
    "question2": "",
    "choice1": "日分",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "医療保険の入院給付金",
    "important": "C"
  },
  {
    "id": 22014,
    "shikenId": 14,
    "no": 15,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,2,1,2",
    "score": "1,1,1,1",
    "question1": "真鍋国春さんが契約している保険（下記＜資料＞参照）の契約に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択してください。なお、保険契約は、有効に成立しており、記載のない事項については一切考慮しないこととする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"7634c8ff-b201-4cb3-9bc2-38fd7cbd75c5\" src='/img/14_15_1779255961157929.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"43e93db2-9fd9-49b0-bdf7-25b51098c4a3\" src='/img/14_15_1779255961780017.png'>",
    "question2": "",
    "choice1": "特定疾病保障保険Ａおよび介護保障定期保険Ｂにリビング・ニーズ特約を中途付加する場合、特約保険料はかからない。",
    "choice2": "国春さんが、初めてがん（悪性新生物）と診断確定され、その後に死亡した場合、特定疾病保障保険Ａから特定疾病保険金と死亡保険金の両方を受け取ることができる。",
    "choice3": "国春さんが、常時寝たきり状態で、ベッド周辺の歩行、入浴および大小便の排泄後の拭き取り始末が自分ではできず、他人の介護を要する状態が１８０日以上継続した場合、介護保障定期保険Ｂから介護保険金を受け取ることができる。",
    "choice4": "国春さんが、公的介護保険制度の要介護１に認定された場合、介護保障定期保険Ｂから介護保険金を受け取ることができる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険の証券分析",
    "important": "C"
  },
  {
    "id": 22015,
    "shikenId": 14,
    "no": 16,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,1,2,1",
    "score": "1,1,1,1",
    "question1": "持田孝夫さんが契約している個人年金保険（下記＜資料＞参照）に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択してください。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"4876da13-63ac-42c1-88f8-adf06695db37\" src='/img/14_16_1779255962266384.png'>",
    "question2": "",
    "choice1": "孝夫さんが毎年受け取る年金は、一時所得として所得税の課税対象となる。",
    "choice2": "孝夫さんが死亡し、幸恵さんが受け取る死亡給付金は、相続税の課税対象となる。",
    "choice3": "孝夫さんが契約日から５年経過後に解約して受け取った解約返戻金は、雑所得として所得税の課税対象となる。",
    "choice4": "孝夫さんが毎年支払う保険料は、所得税における個人年金保険料控除の対象となる。",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "個人年金保険",
    "important": "B"
  },
  {
    "id": 22016,
    "shikenId": 14,
    "no": 17,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "井上貴弘さんは、契約中の収入保障保険Ａの保障額について、ＦＰの小椋さんに質問をした。小椋さんが説明の際に使用した下記＜イメージ図＞を基に、本年１０月１日に貴弘さんが死亡した場合に支払われる年金総額として正しいものはどれか。なお、年金は毎月受け取るものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"4c5587ef-9c88-4db1-801d-7e4c85bcb2a1\" src='/img/14_17_1779255962718119.png'>",
    "question2": "",
    "choice1": "４，８００万円",
    "choice2": "３，８４０万円",
    "choice3": "３，３６０万円",
    "choice4": "４８０万円",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "収入保障保険の計算",
    "important": "B"
  },
  {
    "id": 22017,
    "shikenId": 14,
    "no": 18,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "野村さん（７０歳）の本年分の収入等は下記のとおりである。野村さんの本年分の所得税における総所得金額として、正しいものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"66dada9f-e85e-46ae-80c8-75aba1679aaf\" src='/img/14_18_1779255963028276.png'>",
    "question2": "",
    "choice1": "１６０万円",
    "choice2": "１９０万円",
    "choice3": "２１０万円",
    "choice4": "２１５万円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "総所得金額の計算",
    "important": "A"
  },
  {
    "id": 22018,
    "shikenId": 14,
    "no": 19,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 2,
    "question1": "個人でデザイン事務所を営む落合さんの本年分の所得等は下記＜資料＞のとおりである。落合さんの本年分の所得税において、事業所得と損益通算できる損失に関する次の記述のうち、最も適切なものはどれか。なお、▲が付された所得の金額は、その所得に損失が発生していることを意味するものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"cb0d8b24-dcdf-4422-8d39-dccc85629571\" src='/img/14_19_1779255963536827.png'>",
    "question2": "",
    "choice1": "不動産所得の損失（▲５０万円）、譲渡所得の損失（▲８０万円）と損益通算できる。",
    "choice2": "不動産所得の損失（▲２０万円）、一時所得の損失（▲６０万円）と損益通算できる。",
    "choice3": "不動産所得の損失（▲５０万円）とのみ損益通算できる。",
    "choice4": "不動産所得の損失（▲２０万円）とのみ損益通算できる。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "損益通算の判定",
    "important": "A"
  },
  {
    "id": 22019,
    "shikenId": 14,
    "no": 20,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "会社員の半沢さんは、妻と子ども２人の４人家族である。本年中における半沢さんの合計所得金額が１，１００万円、妻の合計所得金額が３０万円である場合、半沢さんの本年分の所得税における配偶者控除（ア）と扶養控除（イ）の金額の組み合わせとして、正しいものはどれか。なお、本年中において、半沢家は全員同居し、生計を一にしている。また、障害者・特別障害者に該当する者はいない。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"062b6d80-c1a4-49f8-bb34-0875f3632a96\" src='/img/14_20_1779255963968490.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"17337d84-3c51-4ec5-b829-afdc87814732\" src='/img/14_20_1779255964141550.png'>",
    "question2": "",
    "choice1": "（ア） ０円　　　　　（イ） ６３万円",
    "choice2": "（ア） ０円　　　　　（イ） １０１万円",
    "choice3": "（ア） ３８万円　　　（イ） ６３万円",
    "choice4": "（ア） ３８万円　　　（イ） １０１万円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "配偶者控除と扶養控除",
    "important": "B"
  },
  {
    "id": 22020,
    "shikenId": 14,
    "no": 21,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,1,2",
    "score": "1,1,1",
    "question1": "会社員の高橋昌彦さん（給与収入：年額６００万円）は、会社員の妻の珠恵さん（給与収入：年額５００万円）と小学生の長女と３人暮らしである。高橋さん夫婦が本年中に昌彦さんと珠恵さんの共有名義で新築住宅を購入し、同年中に居住を開始した場合の住宅借入金等特別控除（以下、「住宅ローン控除」という）に関する次の（ア）～（ウ）の記述について、適切なものには○、不適切なものには×を選択してください。なお、高橋さん夫婦は、住宅ローン控除の適用を受けるための要件をすべて満たしているものとし、給与収入以外の収入はないものとする。",
    "question2": "",
    "choice1": "所得税の住宅ローン控除の適用を受ける場合は、毎年確定申告をする必要がある。",
    "choice2": "高橋昌彦さんが転勤により単身赴任をする場合、珠恵さんと長女が住み続ける等、所定の要件を満たせば、単身赴任中も住宅ローン控除の適用を受け続けることができる。",
    "choice3": "本年分の住宅ローン控除可能額が所得税から控除しきれない場合は、翌年度の住民税から控除することができるが、その場合、市区町村への住民税の申告が必要となる。",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "住宅借入金等特別控除",
    "important": "B"
  },
  {
    "id": 22021,
    "shikenId": 14,
    "no": 22,
    "answerType": 9,
    "groupId": 0,
    "answer": 2050,
    "score": 2,
    "question1": "井上さん夫婦は、本年１０月にマンションを購入する予定である。井上さん夫婦が＜資料＞のマンションを購入する場合の販売価格のうち、土地（敷地の共有持分）の価格を計算しなさい。なお、消費税の税率は１０％とし、計算結果について万円未満の端数が生じる場合は四捨五入すること。また、解答に当たっては、解答用紙に記載されている単位に従うこと。<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"eaaa7ee8-d23b-4f98-af39-e15874e88db7\" src='/img/14_22_1779255964401178.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "不動産取引の消費税の計算",
    "important": "B"
  },
  {
    "id": 22022,
    "shikenId": 14,
    "no": 23,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "下表の空欄（ア）～（エ）に当てはまる語句に関する次の記述のうち、最も不適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"9ce79dcf-589d-4433-a8be-fb7d5c11d941\" src='/img/14_23_1779255964535406.png'>",
    "question2": "",
    "choice1": "空欄（ア）にあてはまる語句は「３カ月」である。",
    "choice2": "空欄（イ）にあてはまる語句は「家庭裁判所」である。",
    "choice3": "空欄（ウ）にあてはまる語句は「６カ月」である。",
    "choice4": "空欄（エ）にあてはまる語句は「１０カ月」である。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続開始後の手続き",
    "important": "A"
  },
  {
    "id": 22023,
    "shikenId": 14,
    "no": 24,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "贈与税の配偶者控除（以下「本特例」という）に関する次の記述の空欄（ア）～（エ）に入る語句の組み合わせとして、正しいものはどれか。<br><br><div style=\"border:solid 1px #333; padding:0.5em\">・  本特例は、贈与日時点の婚姻期間が（　ア　）以上ある配偶者からの居住用不動産または居住用不動産を取得するための金銭の贈与が適用対象である。<br>・  本特例の適用を受けると、贈与を受けた財産の価格から、贈与税の基礎控除１１０万円（　イ　）、最高２，０００万円まで控除することができる。<br>・  本特例の適用を受けるためには、贈与を受けた年の（　ウ　）までに、贈与により取得した居住用不動産または贈与を受けた金銭で取得した居住用不動産に、贈与を受けた者が現実に住んでおり、その後も引き続き住む見込みでなければならない。<br>・  本特例の適用を受けた財産の贈与を受けた後、同一年内に贈与者の相続が開始した場合、特例の適用を受けた部分は相続財産に（　エ　）。</div>",
    "question2": "",
    "choice1": "（ア）２０年　（イ）とは別に　（ウ）翌年３月１５日 （エ）加算されない",
    "choice2": "（ア）２５年　（イ）とは別に　（ウ）翌年３月１５日 （エ）加算される",
    "choice3": "（ア）２０年　（イ）を含めて　（ウ）１２月３１日 （エ）加算される",
    "choice4": "（ア）２５年　（イ）を含めて　（ウ）１２月３１日 （エ）加算されない",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与税の配偶者控除",
    "important": "C"
  },
  {
    "id": 22024,
    "shikenId": 14,
    "no": 25,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "「小規模宅地等についての相続税の課税価格の計算の特例」に関する下表の空欄（ア）～（ウ）に当てはまる数値の組み合わせとして、正しいものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"12314088-cf9b-4bf8-bc05-c9280d305c65\" src='/img/14_25_1779255964865218.png'><br>※ 特定事業用宅地等と貸付事業用宅地等については、一定の場合に該当しない限り、相続開始前（　ウ　）年以内に新たに（貸付）事業の用に供された宅地等を除く。",
    "question2": "",
    "choice1": "（ア）８０　　　（イ）５０　　　（ウ）　１",
    "choice2": "（ア）８０　　　（イ）５０　　　（ウ）　３",
    "choice3": "（ア）５０　　　（イ）８０　　　（ウ）　３",
    "choice4": "（ア）５０　　　（イ）８０　　　（ウ）　１",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "小規模宅地等の特例",
    "important": "B"
  },
  {
    "id": 22025,
    "shikenId": 14,
    "no": 26,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,2,2,1",
    "score": "1,1,1,1",
    "question1": "服部さんは、FP の鈴木さんに遺言書の作成について相談をした。鈴木さんが行った次の（ア）～（エ）の説明について、適切なものには〇、不適切なものには×を選択してください。",
    "question2": "",
    "choice1": "「パソコンで自筆証書遺言書に添付する財産目録を作成する場合、当該目録の最初のページのみ署名および押印が必要です。」",
    "choice2": "「自筆証書遺言書保管制度では、自筆証書遺言の保管を申請する場合、疾病等で遺言者本人が遺言書保管所（法務局）へ出向くことが難しいときには、代理人による申請も認められています」",
    "choice3": "「自筆証書遺言書保管制度により遺言書保管所に保管されている自筆証書遺言書は、相続開始後に家庭裁判所の検認を受ける必要があります」",
    "choice4": "「公正証書による遺言をした人は、その遺言を自筆証書による遺言によって撤回することができます」",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "遺言",
    "important": "C"
  },
  {
    "id": 22026,
    "shikenId": 14,
    "no": 27,
    "answerType": 9,
    "groupId": 1,
    "answer": "3920,550",
    "score": "2,2",
    "question1": "下記の相続事例（本年６月１２日相続開始）における配偶者と長男の相続税の課税価格を求めなさい。なお、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"89cea3af-d4bb-4ff4-a501-37ce8c3acc87\" src='/img/14_27_1779255965227112.png'><br>・配偶者の相続税の課税価格は（　ア　）万円となる。<br>・長男の相続税の課税価格は（　イ　）万円となる。",
    "question2": "",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "各人の相続税課税価格",
    "important": "B"
  },
  {
    "id": 22027,
    "shikenId": 14,
    "no": 28,
    "answerType": 9,
    "groupId": 0,
    "answer": 624,
    "score": 2,
    "question1": "下記は、長尾家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）にあてはまる数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用すること。また、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"59911f6a-2151-42fd-ba0a-6285053acda2\" src='/img/14_28_1779255966046895.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "キャッシュフロー表",
    "important": "A"
  },
  {
    "id": 22028,
    "shikenId": 14,
    "no": 29,
    "answerType": 9,
    "groupId": 0,
    "answer": 817,
    "score": 2,
    "question1": "下記は、長尾家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）にあてはまる数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用すること。また、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"163619c2-4d39-4235-8287-374122872b96\" src='/img/14_29_1779255966644613.png'><br>※年齢および金融資産残高は各年１２月３１日現在のものとする。<br>※給与収入は可処分所得で記載している。<br>※記載されている数値は正しいものとする。<br>※問題作成の都合上、一部空欄にしてある。",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "キャッシュフロー表",
    "important": "A"
  },
  {
    "id": 22029,
    "shikenId": 14,
    "no": 30,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "長尾さんは、教育費の負担が心配になり、奨学金について調べることにした。<br>日本学生支援機構の奨学金に関する次の記述のうち、最も適切なものはどれか。",
    "question2": "",
    "choice1": "日本学生支援機構の貸与型奨学金には、利子が付く「第一種」と利子が付かない「第二種」がある。",
    "choice2": "日本学生支援機構の奨学金（貸与型）は、進学前に申し込む「予約採用」、進学後に申し込む「在学採用」、家計の急変等に対応する「緊急・応急採用」等がある。",
    "choice3": "日本学生支援機構の奨学金は、学生本人または保護者の名義の口座に振り込まれる。",
    "choice4": "日本学生支援機構の奨学金は、希望すれば進学前から受け取ることができる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "日本学生支援機構の奨学金",
    "important": "B"
  },
  {
    "id": 22030,
    "shikenId": 14,
    "no": 31,
    "answerType": 9,
    "groupId": 0,
    "answer": 9230000,
    "score": 2,
    "question1": "市岡さんは、独立開業の資金として、８年後に１，０００万円を準備したいと考えている。８年間、年利１．０％で複利運用する場合、現在いくらの資金があればよいか。下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"d40c855d-2ff1-41f7-a8fb-ed71f85746ad\" src='/img/14_31_1779255967158439.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "係数計算",
    "important": "A"
  },
  {
    "id": 22031,
    "shikenId": 14,
    "no": 32,
    "answerType": 9,
    "groupId": 0,
    "answer": 824000,
    "score": 2,
    "question1": "伊勢さんは、自宅のリフォーム費用４００万円を、リフォームローンを利用して返済しようと考えている。今後５年間、年利１．０％で毎年借入応当日に元利均等返済をする場合、毎年の返済額はいくらになるか。下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"85cbdeef-fd15-4c1e-b0ee-6e7a4c55f33a\" src='/img/14_32_1779255967578265.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "係数計算",
    "important": "A"
  },
  {
    "id": 22032,
    "shikenId": 14,
    "no": 33,
    "answerType": 9,
    "groupId": 0,
    "answer": 33034500,
    "score": 2,
    "question1": "村田さんは、老後の生活資金の一部として、毎年年末に１５０万円を受け取りたいと考えている。受取期間を２５年間とし、年利１．０％で複利運用をする場合、受取り開始時にいくらの資金があればよいか。下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"f1e66144-5951-42a5-a8da-31b1568e8c4a\" src='/img/14_33_1779255968120176.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "係数計算",
    "important": "A"
  },
  {
    "id": 22033,
    "shikenId": 14,
    "no": 34,
    "answerType": 9,
    "groupId": 0,
    "answer": 6540,
    "score": 2,
    "question1": "羽鳥家（孝治さんと千種さん）の現時点の資産および負債が下記＜資料＞のとおりである場合、＜資料＞に基づく羽鳥家のバランスシートの空欄（ア）にあてはまる数値を計算しなさい。なお、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"cb127e48-cdd4-4c7a-8f48-c1017a2be9b3\" src='/img/14_34_1779255968652769.png'><br>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "バランスシートの計算",
    "important": "A"
  },
  {
    "id": 22034,
    "shikenId": 14,
    "no": 35,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "井上孝弘さんは、住宅の購入を検討しており、住宅ローンの繰上げ返済についてＦＰの小椋さんに質問をした。小椋さんの説明の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><br>＜小椋さんの説明＞<br><div style=\"border:solid 1px #333; padding:0.5em\">「住宅ローンの一部繰上げ返済を行う場合の方法には、『期間短縮型』と『返済額軽減型』があります。このうち、利息軽減効果が大きいのは（　ア　）になります。いずれの方法についても、一部繰上げ返済をする場合の資金は（　イ　）の返済に充てられます。なお、フラット３５（買取型）を利用した場合、住宅金融支援機構のインターネットサービスである「住・My Note 」を利用して一部繰上げ返済を行う場合には、返済金額は（　ウ　）以上となっています。」</div>",
    "question2": "",
    "choice1": "（ア）期間短縮型　　　（イ）元金　　　　　（ウ）１０万円",
    "choice2": "（ア）期間短縮型　　　（イ）元金と利息　　（ウ）１００万円",
    "choice3": "（ア）返済額軽減型　　（イ）元金　　　　　（ウ）１００万円",
    "choice4": "（ア）返済額軽減型　　（イ）元金と利息　　（ウ）１０万円",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "住宅ローンの繰上げ返済",
    "important": "B"
  },
  {
    "id": 22035,
    "shikenId": 14,
    "no": 36,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "井上恵里菜さんは、仮に夫の貴弘さんが本年９月に４０歳で死亡した場合の公的年金の遺族給付について、ＦＰの小椋さんに質問をした。恵里菜さんが６５歳になるまで受給できる公的年金の遺族給付についての説明の空欄（ア）～（エ）に関する次の記述のうち、最も不適切なものはどれか。<br>なお、貴弘さんは、２０歳から大学卒業まで国民年金に加入し、大学卒業後の２２歳から死亡時まで継続して厚生年金保険に２２１月加入しているものとする。また、家族に障害者に該当する者はなく、記載以外の遺族給付の受給要件はすべて満たしているものとし、記載のない条件については一切考慮しないこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"1bbfdd02-4b6f-4f77-a456-6e1f125870a5\" src='/img/14_36_1779255969172040.png'><br><div style=\"border:solid 1px #333; padding:0.5em\">貴弘さんの死亡時、貴弘さんは厚生年金被保険者であり、（　ア　）到達年度末までの未婚の子がいるため、妻の恵里菜さんは、死亡直後は遺族基礎年金と遺族厚生年金を受け取ることができます。<br>遺族基礎年金を死亡した者の配偶者が受け取る場合、子が１人の場合は、基本額に１人分の子の加算額が加算されます。<br>遺族厚生年金は死亡時点で計算した報酬比例部分の年金額の（　イ　）となります。<br>ただし、貴弘さんは死亡時点で厚生年金保険の被保険者であり、厚生年金保険の被保険者期間は２２１月ですので、厚生年金被保険者期間が（　ウ　）月あるものとして計算されます。<br>なお、貴弘さん死亡後、恵里菜さんが４０歳に達し、かつ、遺族基礎年金の支給が終了した時点から６５歳に達するまで（　エ　）が加算されます。</div>",
    "question2": "",
    "choice1": "空欄（ア）にあてはまる語句は、「１８歳」である。",
    "choice2": "空欄（イ）にあてはまる語句は、「３分の２相当額」である。",
    "choice3": "空欄（ウ）にあてはまる語句は、「３００」である。",
    "choice4": "空欄（エ）にあてはまる語句は、「中高齢寡婦加算」である。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "遺族給付",
    "important": "A"
  },
  {
    "id": 22036,
    "shikenId": 14,
    "no": 37,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,2,2",
    "score": "1,1,1",
    "question1": "老齢年金の繰上げ受給または繰下げ受給をする場合に関する次の（ア）～（ウ）の記述について、適切なものは○、不適切なものは×を選択しなさい。なお、老齢基礎年金等の年金の受給要件は満たしているものとする。",
    "question2": "",
    "choice1": "老齢基礎年金と老齢厚生年金の繰上げ請求は、別々に行うことはできないため、同時に請求しなければならない。",
    "choice2": "老齢基礎年金と老齢厚生年金の繰下げ請求は、いずれも１カ月繰下げると０．５％の増額率で年金額が増額される。",
    "choice3": "加給年金額が加算される老齢厚生年金の繰下げの申出をした場合、加給年金額についても増額の対象となる。",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老齢年金の繰上げと繰下げ",
    "important": "B"
  },
  {
    "id": 22037,
    "shikenId": 14,
    "no": 38,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "羽鳥さんは、今後自分に介護が必要になった場合を考え、公的介護保険の介護サービスについて、ＦＰの玉田さんに質問をした。介護保険の給付に関する下表の空欄（ア）～（エ）に入る語句として適切なものはどれか。なお、問題の設定上、明らかにできない部分を（　＊　）としている。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"6e55b3d3-42a4-4305-bddf-50bca6b3e727\" src='/img/14_38_1779255969389444.png'>",
    "question2": "",
    "choice1": "（ア）にあてはまる語句は、「都道府県」である。",
    "choice2": "（イ）にあてはまる語句は、「６５歳」である。",
    "choice3": "（ウ）にあてはまる語句は、「原因を問わず」である。",
    "choice4": "（エ）にあてはまる語句は、「２割」である。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "介護保険",
    "important": "B"
  },
  {
    "id": 22038,
    "shikenId": 14,
    "no": 39,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "羽鳥さん（全国健康保険協会管掌健康保険に加入中）が、将来、会社を退職し、すぐに再就職しない場合に選択できる健康保険の任意継続被保険者について、ＦＰの玉田さんが説明を行った。任意継続被保険者に関する下表の空欄 （ア）～（ウ）に入る適切な語句の組み合わせとして最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"a7b9ec46-8c2f-4871-b825-fe893123802a\" src='/img/14_39_1779255969913694.png'>",
    "question2": "",
    "choice1": "（ア）２年　　　（イ）２年　　（ウ）１４日",
    "choice2": "（ア）２年　　　（イ）５年　　（ウ）２０日",
    "choice3": "（ア）２カ月　　（イ）２年　　（ウ）２０日",
    "choice4": "（ア）２カ月　　（イ）５年　　（ウ）１４日",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "任意継続被保険者",
    "important": "B"
  },
  {
    "id": 22039,
    "shikenId": 14,
    "no": 40,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,1,2",
    "score": "1,1,1",
    "question1": "後期高齢者医療制度に関する次の（ア）～（ウ）の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"d63bfffd-3f7c-4ecb-b81d-d6a84d5aba81\" src='/img/14_40_1779255970345088.png'>",
    "question2": "",
    "choice1": "空欄（ａ）にあてはまる語句は、「全国健康保険協会」である。",
    "choice2": "空欄（ｂ）にあてはまる語句は、「７５歳」である。",
    "choice3": "空欄（ｃ）にあてはまる語句は、「世帯」である。",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "後期高齢者医療制度",
    "important": "B"
  },
  {
    "id": 23000,
    "shikenId": 18,
    "no": 1,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,2,1,2",
    "score": "1,1,1,1",
    "question1": "ファイナンシャル・プランナー（以下「FP 」という）は、ファイナンシャル・プランニング業務を行ううえで関連業法等を順守することが重要である。FP の行為に関する次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を解答欄に記入しなさい。",
    "question2": "",
    "choice1": "社会保険労務士の登録を受けていないFPが、顧客に対して「ねんきんネット」の説明と「ねんきんネット」を使用した顧客の年金見込額の試算を行い、顧客から報酬を受け取った。",
    "choice2": "税理士の登録を受けていないFP が、自治体主催の無料相談会において、相談者からの依頼に基づき、無償で確定申告書の作成を代行した。",
    "choice3": "弁護士の登録を受けていないFP（遺言者や公証人と利害関係はない成年者）が、顧客から依頼されて公正証書遺言の証人となり、顧客から適正な報酬を受け取った。",
    "choice4": "投資助言・代理業の登録を受けていないFPが、顧客に対し有償で、特定企業の公表されている決算報告書を用いて、具体的な株式の投資時期等の判断や助言を行った。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "FP業務と関連法規",
    "important": "A"
  },
  {
    "id": 23001,
    "shikenId": 18,
    "no": 2,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,2,1,1",
    "score": "1,1,1,1",
    "question1": "「消費者契約法」に関する次の（ア）～（ウ）の記述について、適切なものには○、不適切なものには×を選択してください。",
    "question2": "",
    "choice1": "消費者契約法は、個人および法人を保護の対象としている。",
    "choice2": "消費者契約の申込み等に係る取消権は、原則として消費者が追認をすることができるときから１年間行わないとき、または契約の締結のときから１０年を経過したときは、時効によって消滅すると定められている。",
    "choice3": "事業者が、将来の受取額が不確実な金融商品の販売において、「確実に儲かる」と断言し、消費者がそれを信じて結んだ契約は、取り消すことができる。",
    "choice4": "「販売した商品は、いかなる理由があっても、後から返品・キャンセルはできません」とした契約条項は無効である。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "消費者契約法",
    "important": "B"
  },
  {
    "id": 23002,
    "shikenId": 18,
    "no": 3,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "下記＜資料＞は、瀬田さんが同一の特定口座内で本年中に行った東京証券取引所プライム市場上場会社であるＭＮ株式会社の株式（以下、「ＭＮ株式」という）の株式取引に係る明細である。瀬田さんのＭＮ株式の取引に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、正しいものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"bd3498db-85e1-4da9-a7c6-d6ce1b633368\" src='/img/18_3_1779256031477202.png'>",
    "question2": "",
    "choice1": "（ア）１２月２６日　　（イ）１，２５０円",
    "choice2": "（ア）１２月２６日　　（イ）１，３００円",
    "choice3": "（ア）１２月２７日　　（イ）１，２５０円",
    "choice4": "（ア）１２月２７日　　（イ）１，３００円",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株式の受渡し、取得価額の計算",
    "important": "B"
  },
  {
    "id": 23003,
    "shikenId": 18,
    "no": 4,
    "answerType": 9,
    "groupId": 0,
    "answer": 885024,
    "score": 2,
    "question1": "下記＜資料＞の外貨定期預金について、満期時の外貨ベースの元利合計額を円転した金額を計算しなさい。なお、計算結果（円転した金額）について円未満の端数が生じる場合は切り捨てること。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"fc5ce4e9-63f4-4c42-96af-a6f3e974af0d\" src='/img/18_4_1779256031774277.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "外貨預金の計算",
    "important": "B"
  },
  {
    "id": 23004,
    "shikenId": 18,
    "no": 5,
    "answerType": 8,
    "groupId": 1,
    "answer": "2,6,7,11",
    "score": "1,1,1,1",
    "question1": "財形貯蓄制度に関する下表の空欄（ア）～（エ）にあてはまる語句を語群の中から選択してください。なお、復興特別所得税は考慮せず、同じ数値を何度選んでもよいこととする。また、問題の設定上、明らかにできない部分を（　※　）としている。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"3b5357f0-6477-4e96-b47a-82e00c714d8d\" src='/img/18_5_1779256032038385.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"84faeedf-bc2c-4f3c-af66-21cee28dacd2\" src='/img/18_5_1779256032439751.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8|9|10|11",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "財形貯蓄",
    "important": "B"
  },
  {
    "id": 23005,
    "shikenId": 18,
    "no": 6,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "金投資に関する次の記述のうち、最も不適切なものはどれか。",
    "question2": "",
    "choice1": "金は、国際的には１トロイオンス当たりの米ドル建て価格で取引される。",
    "choice2": "個人が金地金を売却した場合の所得は、総合課税の譲渡所得として課税され、譲渡日時点の保有期間が５年超の場合は長期譲渡所得、５年以下の場合は短期譲渡所得となる。",
    "choice3": "金地金を売却して損失が発生した場合には他の所得と損益通算できる。",
    "choice4": "金価格の変動要因には、需給関係、金融動向、政治情勢などが挙げられ、円安（米ドル／円相場）は国内金価格上昇要因になる。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "金投資",
    "important": "B"
  },
  {
    "id": 23006,
    "shikenId": 18,
    "no": 7,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "経済統計等に関する下表の（ア）～（エ）にあてはまる語句に関する次の記述のうち、最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"f1e690e2-a47b-44ef-b130-4bf6e52ef40f\" src='/img/18_7_1779256032763985.png'>",
    "question2": "",
    "choice1": "空欄（ア）にあてはまる語句は、「財務省」である。",
    "choice2": "空欄（イ）にあてはまる語句は、「景気ウォッチャー調査」である。",
    "choice3": "空欄（ウ）にあてはまる語句は、「実質」である。",
    "choice4": "空欄（エ）にあてはまる語句は、「半期ごとに」である。",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "経済指標等に関する語句",
    "important": "C"
  },
  {
    "id": 23007,
    "shikenId": 18,
    "no": 8,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "建築基準法に従い、下記＜資料＞の甲土地に準耐火建築物を建てる場合の（ア）建築面積の最高限度、（イ）延べ面積の最高限度の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない条件については一切考慮しないこととする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"59fda85a-4ca6-4042-8cdd-1f39b769b67d\" src='/img/18_8_1779256033282925.png'>",
    "question2": "",
    "choice1": "（ア）３０４㎡　　（イ）７６０㎡",
    "choice2": "（ア）２６６㎡　　（イ）１，１４０㎡",
    "choice3": "（ア）３０４㎡　　（イ）１，１７０㎡",
    "choice4": "（ア）３２０㎡　　（イ）１，２００㎡",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "建築面積と延べ面積の計算",
    "important": "A"
  },
  {
    "id": 23008,
    "shikenId": 18,
    "no": 9,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "公的な土地評価に関する次の一覧表の空欄（ア）～（ウ）に入る適切な語句の組み合わせとして、正しいものはどれか。<img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"b61081c4-4c10-43d7-be76-057487d76057\" src='/img/18_9_1779256033700421.png'>※問題作成の都合上、一部を（＊＊）としている。",
    "question2": "",
    "choice1": "（ア）国土交通省　　　（イ）１月１日　　　（ウ）７割",
    "choice2": "（ア）内閣府　　　　　（イ）７月１日　　　（ウ）７割",
    "choice3": "（ア）国土交通省　　　（イ）７月１日　　　（ウ）６割",
    "choice4": "（ア）内閣府　　　　　（イ）１月１日　　　（ウ）６割",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "公的な土地評価",
    "important": "B"
  },
  {
    "id": 23009,
    "shikenId": 18,
    "no": 10,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 2,
    "question1": "固定資産税に関する次の記述の空欄（ア）～（エ）に入る語句の組み合わせとして、適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"e1ea424f-458b-468e-88c4-c99ffd1edc4e\" src='/img/18_10_1779256033916381.png'>",
    "question2": "",
    "choice1": "（ア）市町村（東京２３区は東京都） （イ）４月１日<br>（ウ）１２０㎡ （エ）３分の１",
    "choice2": "（ア）都道府県 （イ）１月１日 （ウ）１２０㎡ （エ）６分の１",
    "choice3": "（ア）都道府県 （イ）４月１日 （ウ）２００㎡ （エ）３分の１",
    "choice4": "（ア）市町村（東京２３区は東京都） （イ）１月１日<br>（ウ）２００㎡ （エ）６分の１",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "固定資産税",
    "important": "B"
  },
  {
    "id": 23010,
    "shikenId": 18,
    "no": 11,
    "answerType": 8,
    "groupId": 1,
    "answer": "2,6,9,10",
    "score": "1,1,1,1",
    "question1": "不動産取得税に関する次の記述の空欄（ア）～（エ）にあてはまる適切な語句を語群の中から選択してください。なお、同じ語句を何度選んでもよいこととする。<br><br><div style=\"border:solid 1px #333; padding:0.5em\">不動産取得税は、不動産の所有権を取得した者に対して、その不動産が所在する（　ア　）が課税するもので、課税標準は原則として（　イ　）である。<br>ただし、（　ウ　）を原因とする取得の場合、課税対象とならない。また、一定の条件を満たした新築住宅（認定長期優良住宅ではない）を取得した場合、課税標準から1戸当たり（　エ　）を控除することができる。</div><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"790a4d62-d2e8-4270-bd4f-5fa9233d0009\" src='/img/18_11_1779256034267450.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8|9|10|11|12",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "不動産取得税",
    "important": "C"
  },
  {
    "id": 23011,
    "shikenId": 18,
    "no": 12,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 2,
    "question1": "押田さんは、土地の有効活用をするに当たり、ＦＰの直井さんに、借地借家法に定める借地権について質問した。下記の記述の空欄（ア）～（ウ）に入る語句の組み合わせとして、適切なものはどれか。なお、「普通借地権」とは、借地借家法第２２条から第２４条の定期借地権等以外の借地権、「一般定期借地権」とは同法第２２条の借地権をいうものとする。<br><br><div style=\"border:solid 1px #333; padding:0.5em\">押田さん：「まず、普通借地権の設定契約について教えてください。」<br>直井さん： 「普通借地権の設定契約で、期間の定めがない場合の存続期間は（　ア　）ですが、契約でこれより長い期間を定めることができます。」<br>押田さん：「次に、一般定期借地権の存続期間について教えてください。」<br>直井さん： 「一般定期借地権の存続期間は（　イ　）以上です。契約を締結する際は、契約の更新がない旨などの特約を、（　ウ　）おこなわなければなりません。」</div>",
    "question2": "",
    "choice1": "（ア）１０年　　（イ）３０年　　（ウ）地方裁判所の許可を得て",
    "choice2": "（ア）１０年　　（イ）５０年　　（ウ）地方裁判所の許可を得て",
    "choice3": "（ア）３０年　　（イ）３０年　　（ウ）公正証書等の書面によって",
    "choice4": "（ア）３０年　　（イ）５０年　　（ウ）公正証書等の書面によって",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "借地権",
    "important": "C"
  },
  {
    "id": 23012,
    "shikenId": 18,
    "no": 13,
    "answerType": 9,
    "groupId": 1,
    "answer": "376,3205,8",
    "score": "1,1,1",
    "question1": "田中英俊さんが、保険契約者（保険料負担者）および被保険者として加入している生命保険（下記＜資料＞参照）の保障内容に関する次の空欄（ア）～（ウ）にあてはまる数値を計算しなさい。なお、保険契約は有効に継続し、かつ特約は自動更新しているものとし、英俊さんはこれまでに＜資料＞の保険から、保険金・給付金を一度も受け取っていないものとする。また、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"e9d74fa5-3723-4412-b04d-4c036cb0a3e3\" src='/img/18_13_1779256034577658.png'><br><img data-image-id=\"I2\" data-asset-scope=\"data_check\" data-asset-id=\"2b5e9f63-7bc9-4798-b592-ab409363c135\" src='/img/18_13_1779256035322655.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険の証券分析",
    "important": "A"
  },
  {
    "id": 23013,
    "shikenId": 18,
    "no": 14,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "高田泉さんが本年中に支払った生命保険の保険料は下記＜資料＞のとおりである。この場合の高田さんの本年分の所得税の計算における生命保険料控除の金額として、正しいものはどれか。<br>なお、下記＜資料＞の保険について、これまでに契約内容の変更はなく、高田さんに２３歳未満の扶養親族はいないものとする。また、本年分の生命保険料控除額が最も多くなるように計算すること。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"399d9c9d-7171-4447-8bdb-2574a73f19d2\" src='/img/18_14_1779256036073088.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"44a55e98-cfb2-4739-8d72-1510ad4ad01f\" src='/img/18_14_1779256036397344.png'><br><img data-image-id=\"I3\" data-asset-scope=\"content_extraction\" data-asset-id=\"f4b10590-052d-4ce4-a238-36ce161e5ed6\" src='/img/18_14_1779256036636968.png'><br>（注） 支払保険料とは、その年に支払った金額から、その年に受けた剰余金や割戻金を差し引いた残りの金額をいう。",
    "question2": "",
    "choice1": "７０，０００円",
    "choice2": "７５，０００円",
    "choice3": "８０，０００円",
    "choice4": "９０，０００円",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "生命保険料控除の計算",
    "important": "B"
  },
  {
    "id": 23014,
    "shikenId": 18,
    "no": 15,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,2,1,1",
    "score": "1,1,1,1",
    "question1": "栗林さん（５３歳）は、自身を記名被保険者として契約している自動車保険の契約更新案内（下記＜資料＞参照）について、ＦＰの広瀬さんにアドバイスを求めた。広瀬さんが述べた次の（ア）～（エ）の記述について、適切なものには○、不適切なものには×を選択してください。なお、＜資料＞に記載のない特約については考慮しないものとし、過去に自動車保険の対象となる事故はないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"3e828deb-317b-49a6-94bf-d9ab55d66488\" src='/img/18_15_1779256036875635.png'>",
    "question2": "",
    "choice1": "「前年同内容プランおよびおすすめプランＡでは、大雨による洪水で被保険自動車が水没した場合や盗難による損害を受けた場合の自動車の損害を補償しますが、単独事故による損害は補償されません」",
    "choice2": "「栗林さんの友人（３３歳）が被保険自動車を運転中に対人事故を起こした場合、おすすめプランＡおよびおすすめプランＢでは補償対象となりません」",
    "choice3": "「栗林さんが運転中に他車との接触事故でケガをした場合、おすすめプランＢは、過失割合にかかわらず治療費用等は補償対象となります」",
    "choice4": "「おすすめプランＢでは、栗林さんが所有する原動機付自転車を運転中に対物事故を起こした場合、補償の対象となります」",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "自動車保険の証券分析",
    "important": "B"
  },
  {
    "id": 23015,
    "shikenId": 18,
    "no": 16,
    "answerType": 9,
    "groupId": 0,
    "answer": 5760,
    "score": 2,
    "question1": "株式会社ＴＳの専務取締役の度会さんが任期満了で退職した場合、同社の役員退職慰労金規程に基づき受け取ることができる役員退職慰労金の金額を計算しなさい。なお、解答は以下の＜前提条件＞および＜資料＞に基づくものとし、記載のない事項については一切考慮しないものとする。<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"4cee309c-b4b8-4eb9-bae3-b505806c0e8a\" src='/img/18_16_1779256037506405.png'><br><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"6547f4a5-628a-46d1-8120-7261d46e77f7\" src='/img/18_16_1779256037812106.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "役員退職金の計算",
    "important": "C"
  },
  {
    "id": 23016,
    "shikenId": 18,
    "no": 17,
    "answerType": 9,
    "groupId": 0,
    "answer": 14850,
    "score": 2,
    "question1": "山本さんは、相次ぐ地震報道を受けて地震保険に関心を持った。下記＜資料＞を基に計算した山本さんの自宅に係る年間の地震保険料を計算しなさい。なお、山本さんの自宅は、東京都にあるイ構造のマンションで、火災保険の保険金額は１，２００万円であり、地震保険は火災保険の保険金額の５０％相当額で、本年９月に契約し、建築年割引１０％が適用されるものとする。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"3c6f6eec-5d9f-4c1d-8c7c-bd8b0e5303d9\" src='/img/18_17_1779256038294973.png'>",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク",
    "rontenName": "地震保険料の計算",
    "important": "B"
  },
  {
    "id": 23017,
    "shikenId": 18,
    "no": 18,
    "answerType": 9,
    "groupId": 0,
    "answer": 89,
    "score": 2,
    "question1": "大柳さん（６５歳）の本年分の収入等が下記のとおりである場合、大柳さんの本年分の所得税における総所得金額を計算しなさい。なお、青色申告特別控除１０万円の適用を受けるものとする。また、解答に当たっては、解答欄に記載されている単位に従うこと。<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"41b8efee-aa5c-4626-896a-86affb419cd4\" src='/img/18_18_1779256038519124.png'><br>※大柳さんは青色申告者であり、帳簿書類の備付け等の要件は満たしている。<br>アパート経営は、事業的規模には該当しない。<br><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"54919992-7d0e-4922-b1af-04e147b5bf89\" src='/img/18_18_1779256038855783.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "総所得金額の計算",
    "important": "A"
  },
  {
    "id": 23018,
    "shikenId": 18,
    "no": 19,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "会社員の保坂さんは、本年１２月に勤務先を退職する予定である。保坂さんの退職に係るデータが下記の＜資料＞のとおりである場合、保坂さんの退職一時金にかかる退職所得の金額として、正しいものはどれか。なお、保坂さんは、勤務先の役員であったことはなく、退職は障害者になったことに基因するものではない。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"d3c98541-78ba-41bb-932d-d7303a4fd2e8\" src='/img/18_19_1779256039163417.png'>",
    "question2": "",
    "choice1": "２３０万円",
    "choice2": "４１５万円",
    "choice3": "４５０万円",
    "choice4": "８３０万円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "退職所得の計算",
    "important": "A"
  },
  {
    "id": 23019,
    "shikenId": 18,
    "no": 20,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "香川さんの本年分の所得等に関して所得税の確定申告すべき金額として、最も適切なものは次のうちどれか。なお、給与所得については、年末調整により正しい所得税が源泉徴収されているものとし、他に申告すべき所得や、所得控除はないものとする。<br>＜香川さんの本年分の所得等資料＞<br>①給与所得：３００万円（給与所得控除後の金額）<br>②変額保険（終身型）の解約返戻金：５００万円<br>③外貨預金解約による為替差損：１５万円<br>注： 変額保険の契約者（保険料負担者）は、香川さん本人であり、払込保険料は４２０万円である。",
    "question2": "",
    "choice1": "確定申告は不要です。",
    "choice2": "確定申告が必要です。確定申告すべき金額は３１０万円です。",
    "choice3": "確定申告が必要です。確定申告すべき金額は３１５万円です。",
    "choice4": "確定申告が必要です。画定申告すべき金額は３３０万円です。",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "確定申告すべき金額の計算",
    "important": "C"
  },
  {
    "id": 23020,
    "shikenId": 18,
    "no": 21,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "会社員の下田晃大さんが、本年中に支払った医療費等が下記＜資料＞のとおりである場合、下田さんの本年の所得税の確定申告における医療費控除の金額として、正しいものはどれか。なお、下田さんの本年中の所得は、給与所得５００万円のみであるものとし、下田さんは妻および小学生の長女と生計を一にしている。また、セルフメディケーション税制（医療費控除の特例）については考慮せず、保険金および自治体の助成金等により補てんされる金額はないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"781cc4c0-70bd-4619-b15e-4b513a0a9e28\" src='/img/18_21_1779256039294417.png'>",
    "question2": "",
    "choice1": "４８０，０００円",
    "choice2": "５００，０００円",
    "choice3": "５８０，０００円",
    "choice4": "６８０，０００円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "医療費控除の計算",
    "important": "C"
  },
  {
    "id": 23021,
    "shikenId": 18,
    "no": 22,
    "answerType": 9,
    "groupId": 0,
    "answer": 1265,
    "score": 2,
    "question1": "＜資料＞の空欄（ア）にあてはまる滝上光男さんの本年分の事業所得の金額の数値を計算しなさい。なお、滝上さんは青色申告の承認を受けており、青色申告決算書（貸借対照表を含む）を添付し、国税電子申告・納税システム（ｅ－Ｔａｘ）を利用して電子申告を確定申告の期限内に行うものとする。解答は解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"f84b01c1-31bb-4043-b17a-9e3163caece6\" src='/img/18_22_1779256039606331.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "事業所得の計算",
    "important": "C"
  },
  {
    "id": 23022,
    "shikenId": 18,
    "no": 23,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,2,2,1",
    "score": "1,1,1,1",
    "question1": "下記＜親族関係図＞の場合において、民法の規定に基づく法定相続分および遺留分に関する次の（ア）～（ウ）の記述について、適切なものは○、不適切なものは×を選択しなさい。<img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"6f15ee94-9160-4604-806e-57bb171391a5\" src='/img/18_23_1779256039992389.png'><br>［各自の法定相続分と遺留分］<br>・被相続人の配偶者の法定相続分は（ａ）である。<br>・被相続人の甥の法定相続分は（ｂ）である。<br>・被相続人の弟の遺留分は（ｃ）である。<br>・被相続人の姪の遺留分は（ｄ）である。",
    "question2": "",
    "choice1": "空欄（ａ）にあてはまる数値は、「３／４」である。",
    "choice2": "空欄（ｂ）にあてはまる数値は、「１／12 」である。",
    "choice3": "空欄（ｃ）にあてはまる数値は、「１／16 」である。",
    "choice4": "空欄（ｄ）にあてはまる数値は、「０（ゼロ）」である。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "法定相続分と遺留分",
    "important": "A"
  },
  {
    "id": 23023,
    "shikenId": 18,
    "no": 24,
    "answerType": 7,
    "groupId": 1,
    "answer": "2,2,2,1",
    "score": "1,1,1,1",
    "question1": "相続税において相続財産から控除できる債務等に関する次の記述の（ア）～（エ）の記述のうち、適切なものには○、不適切なものには×を選択してください。",
    "question2": "",
    "choice1": "被相続人が生前に購入した墓地の購入未払い金は、相続財産から控除することができる。",
    "choice2": "被相続人に課される未払いの所得税、住民税、固定資産税等は、支払時期が到来しているものに限り、相続財産から控除することができる。",
    "choice3": "香典返しのためにかかった費用については、葬式費用として相続財産から控除することができる。",
    "choice4": "被相続人に係る未払い医療費は、相続財産から控除することができる。",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "債務控除",
    "important": "C"
  },
  {
    "id": 23024,
    "shikenId": 18,
    "no": 25,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "羽田さん（４０歳）は、父（６８歳）と祖母（９２歳）から下記＜資料＞の贈与を受けた。羽田さんの本年分（２０２６年分）の贈与税額として、最も適切なものはどれか。なお、父からの贈与については、１年前から相続時精算課税制度の適用を受けている。<br><br><div style=\"border:solid 1px #333; padding:0.5em\">＜資料＞<br>［２０２５年の贈与］<br>・父から贈与を受けた金銭の額　：２，３１０万円<br>［本年中の贈与］<br>・父から贈与を受けた金銭の額　：５００万円<br>・祖母から贈与を受けた金銭の額：５００万円<br>※ 1年前から本年までに上記以外の贈与はないものとする。<br>※ 上記の贈与は、住宅取得等資金や教育、結婚・子育てに係る資金の贈与ではない。</div><br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"270945e1-f072-4079-8c58-cea76f4d1831\" src='/img/18_25_1779256040188208.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"243c2ac5-1810-4809-88ef-a7a0fb724c2d\" src='/img/18_25_1779256040478440.png'>",
    "question2": "",
    "choice1": "５７．５万円",
    "choice2": "６６．５万円",
    "choice3": "７１．０万円",
    "choice4": "１１０．５万円",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与税の計算",
    "important": "A"
  },
  {
    "id": 23025,
    "shikenId": 18,
    "no": 26,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "下記＜資料＞の土地に係る路線価方式による普通借地権の相続税評価額の計算式として、正しいものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"5e28c966-11da-409a-b8e2-73287b8b4aa0\" src='/img/18_26_1779256040717081.png'>",
    "question2": "",
    "choice1": "２５０，０００円×０．９７×１０８㎡",
    "choice2": "２５０，０００円×０．９７×１０８㎡×（１－６０％）",
    "choice3": "２５０，０００円×０．９７×１０８㎡×６０％",
    "choice4": "２５０，０００円×０．９７×１０８㎡×（１－６０％×３０％×１００％）",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "宅地の評価",
    "important": "A"
  },
  {
    "id": 23026,
    "shikenId": 18,
    "no": 27,
    "answerType": 8,
    "groupId": 1,
    "answer": "1,3,6,7",
    "score": "1,1,1,1",
    "question1": "「直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税」についてまとめた下表の空欄（ア）～（エ）に入る適切な語句を語群の中から選択してください。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"65433783-6e49-4e42-bfa8-487473e46340\" src='/img/18_27_1779256040982117.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"0a6e46d3-710b-41f8-9ccc-1ee6e55598ab\" src='/img/18_27_1779256041332695.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "住宅取得等資金の贈与の特例",
    "important": "C"
  },
  {
    "id": 23027,
    "shikenId": 18,
    "no": 28,
    "answerType": 9,
    "groupId": 0,
    "answer": 258,
    "score": 2,
    "question1": "下記は、成田家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）に入る数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用すること。また、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"19302eb3-9747-4c72-9bc0-031a2e561510\" src='/img/18_28_1779256041481452.png'><br>※年齢および金融資産残高は各年１２月３１日現在のものとする。<br>※給与収入は可処分所得で記載している。<br>※ 記載されている数値は正しいものとする。また、問題作成の都合上、一部を空欄としている。",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "キャッシュフロー表",
    "important": "A"
  },
  {
    "id": 23028,
    "shikenId": 18,
    "no": 29,
    "answerType": 9,
    "groupId": 0,
    "answer": 748,
    "score": 2,
    "question1": "下記は、長谷川家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）にあてはまる数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用すること。また、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"6e971e75-2b79-41e7-be4f-d14afc3eedb3\" src='/img/18_29_1779256042070446.png'><br>※年齢および金融資産残高は各年12月31日現在のものとする。<br>※給与収入は可処分所得で記載している。<br>※ 記載されている数値は正しいものとする。また、問題作成の都合上、一部を空欄としている。",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "キャッシュフロー表",
    "important": "A"
  },
  {
    "id": 23029,
    "shikenId": 18,
    "no": 30,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "キャッシュフロー表を作成する上では、収入や支出などの変動率や金融資産の運用利回りの予測が重要である。運用利回り等の変動に影響を与える要因についての次の記述のうち、最も不適切なものはどれか。",
    "question2": "",
    "choice1": "消費者物価指数の算出では、消費税率を含めて計算される。",
    "choice2": "為替が円高になると、輸入物価を押し上げる要因となる。",
    "choice3": "変動金利型住宅ローンの適用金利は、短期プライムレートを基準にする金融機関が主流である。",
    "choice4": "新発１０年国債利回りは、国内長期金利の代表的な指標である。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "運用利回りに影響を与える要因",
    "important": "C"
  },
  {
    "id": 23030,
    "shikenId": 18,
    "no": 31,
    "answerType": 9,
    "groupId": 0,
    "answer": 10462000,
    "score": 2,
    "question1": "小川さんは、老後資金に備えるために、新たに積立てを開始する予定である。<br>毎年年末に１００万円を積み立てるものとし、１０年間、年利１．０％で複利運用しながら積み立てた場合、１０年後の合計額はいくらになるか、下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"396285a1-393f-40e0-a28e-aa5de2167a4f\" src='/img/18_31_1779256042754329.png'><br>※記載されている数値は正しいものとする。",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "係数計算",
    "important": "A"
  },
  {
    "id": 23031,
    "shikenId": 18,
    "no": 32,
    "answerType": 9,
    "groupId": 0,
    "answer": 21020000,
    "score": 2,
    "question1": "磯貝さんは相続により受け取った２，０００万円を運用しようと考えている。<br>これを５年間、年利１．０％で複利運用した場合、５年後の合計額はいくらになるか、下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"b65fec0d-2879-4e36-b20b-824277c7c615\" src='/img/18_32_1779256043323966.png'><br>※記載されている数値は正しいものとする。",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "係数計算",
    "important": "A"
  },
  {
    "id": 23032,
    "shikenId": 18,
    "no": 33,
    "answerType": 9,
    "groupId": 0,
    "answer": 1440000,
    "score": 2,
    "question1": "清水さんは、退職金として受け取った２，０００万円を老後の生活資金の一部として使用するつもりである。これを１５年間、年利１．０％で複利運用しながら毎年１回、年末に均等に取り崩すこととした場合、毎年年末に取り崩すことができる最大金額はいくらになるか、下記の係数早見表を乗算で使用し、計算しなさい。なお、税金は一切考慮しないものとし、解答に当たっては、解答欄に記載されている単位に従うこと。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"65ab488b-a4a0-409e-9cc9-a526278530ba\" src='/img/18_33_1779256043930523.png'><br>※記載されている数値は正しいものとする。",
    "question2": "",
    "choice1": "円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "係数計算",
    "important": "A"
  },
  {
    "id": 23033,
    "shikenId": 18,
    "no": 34,
    "answerType": 9,
    "groupId": 0,
    "answer": 3790,
    "score": 2,
    "question1": "ＦＰの寺岡さんは、本年現時点における滝上家（光男さんと彰子さん）のバランスシート分析を行うこととした。滝上家の現時点の資産および負債が下記＜資料＞のとおりである場合、＜資料＞に基づく滝上家のバランスシートの空欄（ア）にあてはまる数値を計算しなさい。なお、記載のない事項については一切考慮しないものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"96ace982-ccfe-4828-9019-0d5938b57319\" src='/img/18_34_1779256044396084.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"90979d8c-db1d-4b92-a498-f240e465f245\" src='/img/18_34_1779256044775243.png'><br><br><img data-image-id=\"I3\" data-asset-scope=\"content_extraction\" data-asset-id=\"bbcb47e7-23a3-4662-b9ff-96d786a1aa66\" src='/img/18_34_1779256045104476.png'>",
    "question2": "",
    "choice1": "万円",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "個人バランスシート",
    "important": "A"
  },
  {
    "id": 23034,
    "shikenId": 18,
    "no": 35,
    "answerType": 3,
    "groupId": 0,
    "answer": 4,
    "score": 2,
    "question1": "山本修司さんは、長男である隆司さん（１７歳）の進学を控えて奨学金や教育ローンに関心をもち、ＦＰの向さんに質問をした。<br>向さんが日本学生支援機構の奨学金（第一種・第二種）および日本政策金融公庫の教育一般貸付（国の教育ローン）について説明する際に使用した下表の空欄（ア）～（エ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"16f5ff8a-1696-4a15-8b69-d5cc9303a323\" src='/img/18_35_1779256045386065.png'>",
    "question2": "",
    "choice1": "(ア)学生・生徒の保護者　(イ)いつでも可能　(ウ)３００万円　(エ)年利２％",
    "choice2": "(ア)学生・生徒本人　(イ)決められた募集期間内　(ウ)３５０万円　(エ)年利２％",
    "choice3": "(ア)学生・生徒本人　(イ)決められた募集期間内　(ウ)３００万円　(エ)年利３％",
    "choice4": "(ア)学生・生徒の保護者　(イ)いつでも可能　(ウ)３５０万円　(エ)年利３％",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "奨学金と教育ローン",
    "important": "B"
  },
  {
    "id": 23035,
    "shikenId": 18,
    "no": 36,
    "answerType": 8,
    "groupId": 1,
    "answer": "4,9,12,6",
    "score": "1,1,1,1",
    "question1": "山本さんは、ｉＤｅＣｏ（個人型確定拠出年金）とＮＩＳＡのつみたて投資枠についてＦＰの向さんに質問をした。向さんがｉＤｅＣｏとＮＩＳＡのつみたて投資枠の概要を説明する際に使用した下表の空欄（ア）～（エ）に入る適切な数値または語句を語群の中から選び、その番号のみを解答欄に記入しなさい。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"f3b296a3-86c4-4a9b-820b-20ba48f36beb\" src='/img/18_36_1779256045850380.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"6a11d6bf-02a7-4db1-b83b-38803051e212\" src='/img/18_36_1779256046433605.png'>",
    "question2": "",
    "choice1": "1|2|3|4|5|6|7|8|9|10|11|12",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "iDeCoとNISAつみたて投資枠",
    "important": "B"
  },
  {
    "id": 23036,
    "shikenId": 18,
    "no": 37,
    "answerType": 7,
    "groupId": 1,
    "answer": "1,1,2",
    "score": "1,1,1",
    "question1": "山本さんは、現在居住している自宅の住宅ローンの見直しを検討しており、ＦＰの向さんに質問をした。住宅ローンの見直しに関する次の（ア）～（ウ）の記述について、適切なものには○、不適切なものには×を選択してください。",
    "question2": "",
    "choice1": "住宅ローンの繰上げ返済に充てられた金額は、全額が元本の返済に充当されるため、その元本に対応する部分の利息の支払いが軽減される。",
    "choice2": "借換えにおいては、抵当権の抹消や設定の費用、事務手数料等の諸費用が必要となるため、諸費用も含めて、借換え前後の支払額を比較することが重要である。",
    "choice3": "住宅ローンの条件変更では、返済期間を短くし、月々の返済額を増額すると、他の条件が同じであれば、変更前と比べて、住宅ローンの総返済額も増加する。",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "住宅ローンの見直し",
    "important": "C"
  },
  {
    "id": 23037,
    "shikenId": 18,
    "no": 38,
    "answerType": 3,
    "groupId": 0,
    "answer": 2,
    "score": 2,
    "question1": "個人事業主である滝上さんは、廃業後の生活の安定のために小規模企業共済に加入することを検討しており、ＦＰの寺岡さんに制度の概要について質問をした。小規模企業共済に関する次の記述のうち、最も適切なものはどれか。",
    "question2": "",
    "choice1": "加入できるのは、常時使用する従業員の数が１００人以下（卸売業、小売業等は２０人以下）の個人事業主（共同経営者を含む）や会社等の役員である。",
    "choice2": "小規模企業共済とｉＤｅＣｏ（個人型確定拠出年金）は同時に加入することができる。",
    "choice3": "掛金の月額は、１，０００円から６８，０００円までの範囲内（５００円単位）で自由に設定することができる。",
    "choice4": "掛金は、所得税における小規模企業共済等掛金控除として、支払った全額を所得税額から控除することができる。",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "小規模企業共済",
    "important": "C"
  },
  {
    "id": 23038,
    "shikenId": 18,
    "no": 39,
    "answerType": 3,
    "groupId": 0,
    "answer": 3,
    "score": 2,
    "question1": "滝上さんの公的年金の加入歴（見込みを含む）が下記＜資料＞のとおりである場合、滝上さんに６５歳から支給される老齢基礎年金（付加年金を含む）の額として、正しいものはどれか。なお、滝上さんは、60歳以降65歳まで保険料の納付を続ける見込みである。計算に当たっては、下記＜資料＞に基づくものとし、計算過程および老齢基礎年金の額について、円未満の端数が生じた場合には、円未満を四捨五入するものとする。<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"e7f7dc05-0a3d-4bdc-ac39-57fdef449a86\" src='/img/18_39_1779256046697346.png'>",
    "question2": "",
    "choice1": "７５４，４８３円",
    "choice2": "８０２，８８３円",
    "choice3": "８６０，３９６円",
    "choice4": "９０８，１９６円",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老齢基礎年金の計算",
    "important": "C"
  },
  {
    "id": 23039,
    "shikenId": 18,
    "no": 40,
    "answerType": 3,
    "groupId": 0,
    "answer": 1,
    "score": 2,
    "question1": "雇用保険の基本手当に関する次の１～３の記述について、最も適切なものを１つ選択しなさい。なお、問題作成の都合上、一部を「＊＊＊」にしてある。また、記載以外の雇用保険の基本手当の受給要件はすべて満たしているものとする。<br><br>・ 雇用保険の基本手当は、一般被保険者が失業した場合に、原則として、離職の日以前の＊＊＊に被保険者期間が通算して（ａ）以上あるときに支給される。<br>・ 基本手当日額は、原則として、離職の日の直前（ｂ）間に支払われた賃金総額（賞与等は除く）を＊＊＊で除した賃金日額に給付率を乗じた額であり、基本手当を受給できる期間は、原則として、（ｃ）から１年間である。",
    "question2": "",
    "choice1": "空欄（ａ）にあてはまる語句は、「１２ヵ月」である。",
    "choice2": "空欄（ｂ）にあてはまる語句は、「３ヵ月」である。",
    "choice3": "空欄（ｃ）にあてはまる語句は、「離職日が属する月の翌月1日」である。",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "雇用保険の基本手当",
    "important": "B"
  },
  {
    "id": 32000,
    "shikenId": 15,
    "no": 1,
    "answerType": 6,
    "groupId": 0,
    "answer": "ニ,イ,ヘ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_32000.png'/><br><img src='/img/setsu_32000_2.png'/>",
    "question2": "はじめに、Ｍさんは、Ａさんに対して、公的年金制度からの老齢給付について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>「報酬比例部分のみの特別支給の老齢厚生年金の支給開始年齢は、順次引き上げられており、（　①　）年４月２日以後生まれの男性からは支給がありません。Ａさんは、原則として、65歳から老齢基礎年金および老齢厚生年金を受給することになります。なお、Ａさんが希望すれば、60歳以上65歳未満の間に老齢基礎年金の繰上げ支給を請求することができます。仮に、Ａさんが63歳０カ月で老齢基礎年金の繰上げ支給を請求した場合の減額率は（　②　）％となります。Ａさんが老齢基礎年金の繰上げ支給の請求をする場合、同時に老齢厚生年金の繰上げ支給の請求を（　③　）」<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"080a39ff-0988-4255-9102-338f1fdc04f6\" src='/img/15_1_1779256587650354.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老齢給付",
    "important": "B"
  },
  {
    "id": 32001,
    "shikenId": 15,
    "no": 2,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_32000.png'/><br><img src='/img/setsu_32000_2.png'/>",
    "question2": "次に、Ｍさんは、Ａさんに対して、社会保険の取扱い等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
    "choice1": "「Ａさんが65歳でＸ社を退職し、厚生年金保険の被保険者でなくなった場合、妻Ｂさんは、国民年金の第３号被保険者から第１号被保険者への種別変更の届出を行い、65歳になるまでの間、国民年金の保険料を納付することになります」",
    "choice2": "「Ａさんが60歳でＸ社を定年退職し、雇用保険から基本手当を受給する場合、基本手当の所定給付日数は150日となります。基本手当の受給期間は、原則として、離職した日の翌日から１年間ですが、定年退職の場合は最長１年間の受給期間延長を申し出ることができます」",
    "choice3": "「Ａさんは、所定の手続を行うことにより、退職日の翌日から最長で２年間、全国健康保険協会管掌健康保険に任意継続被保険者として加入することができます。任意継続被保険者の保険料は、在職時とは異なり全額自己負担となります」",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "社会保険の取扱い等",
    "important": "B"
  },
  {
    "id": 32002,
    "shikenId": 15,
    "no": 3,
    "answerType": 4,
    "groupId": 0,
    "answer": "847300,1244473,380,1668553",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_32000.png'/><br><img src='/img/setsu_32000_2.png'/>",
    "question2": "Ａさんが、65歳でＸ社を退職した場合、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（本年度価額）を計算した次の＜計算の手順＞の空欄①～④に入る最も適切な数値を求めなさい。計算にあたっては、《設例》の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づくこと。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"7d16730b-6dcb-4676-84d9-3661cb6b0087\" src='/img/15_3_1779256588261750.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"bd223f8b-89b8-4ed2-9f0d-2182a7b74de2\" src='/img/15_3_1779256588873256.png'>",
    "choice1": "円",
    "choice2": "円",
    "choice3": "円",
    "choice4": "円",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老齢基礎年金および老齢厚生年金の計算",
    "important": "A"
  },
  {
    "id": 32003,
    "shikenId": 15,
    "no": 4,
    "answerType": 4,
    "groupId": 0,
    "answer": "20.00,4.00",
    "score": "2,2",
    "question1": "<img src='/img/setsu_32003.png'/>",
    "question2": "《設例》のデータに基づき算出される次の①、②を求めなさい（計算過程の記載は不要）。〈答〉は表示単位の小数点以下第3位を四捨五入し、小数点以下第2位までを解答すること。<br>①　W社のPER<br>②　X社のPBR",
    "choice1": "倍",
    "choice2": "倍",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株式投資指標の計算",
    "important": "A"
  },
  {
    "id": 32004,
    "shikenId": 15,
    "no": 5,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_32003.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、《設例》のデータに基づいて、株式の投資指標等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
    "choice1": "「ROE は、W 社株式のほうがX 社株式よりも高くなっています。一般に、ROE の数値が高いほうが経営の効率性が高いと判断されます」",
    "choice2": "「株主に対する利益還元の大きさに着目した指標として、配当性向があります。配当性向は、Ｘ社のほうがＷ社よりも高くなっています」",
    "choice3": "「一般に、自己資本比率が低いほど、経営の安全性が高いと考えられます。自己資本比率は、Ｗ社のほうがＸ社よりも高くなっています」",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "株式投資指標の計算",
    "important": "A"
  },
  {
    "id": 32005,
    "shikenId": 15,
    "no": 6,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_32003.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、インデックスファンド等を購入する際の留意点等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
    "choice1": "「運用管理費用（信託報酬）は、投資信託を保有する投資家が負担する費用です。一般に、インデックスファンド（パッシブ型の投資信託）は、アクティブ型投資信託よりも運用管理費用（信託報酬）が高い傾向があります」",
    "choice2": "「ドルコスト平均法は、価格が変動する商品を定期的に一定口数ずつ購入する方法で、定期的に一定額ずつ購入するよりも平均購入単価を引き下げる効果が期待できます」",
    "choice3": "「NISAの非課税保有限度額（総枠）は、1,800万円です。そのうち成長投資枠は1,200万円、つみたて投資枠は600万円とされており、これを超える金額の投資信託を購入し、保有することはできません」",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "運用管理費用、ドルコスト平均法、ＮＩＳＡ",
    "important": "C"
  },
  {
    "id": 32006,
    "shikenId": 15,
    "no": 7,
    "answerType": 6,
    "groupId": 0,
    "answer": "ホ,イ,ヘ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_32006.png'/><br><img src='/img/setsu_32006_2.png'/>",
    "question2": "2026年分の所得税における青色申告制度に関する以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　 「事業所得の金額の計算上、青色申告特別控除として最高（　①　）万円を控除することができます。（　①　）万円の青色申告特別控除の適用を受けるためには、事業所得に係る取引を正規の簿記の原則に従い記帳し、その記帳に基づいて作成した貸借対照表、損益計算書その他の計算明細書を添付した確定申告書を法定申告期限内に提出することに加えて、e-Tax による申告（電子申告）または一定の要件を満たす電子帳簿保存を行う必要があります。なお、確定申告書を法定申告期限後に提出した場合、青色申告特別控除額は最高（　②　）万円となります」<br><br>Ⅱ　 「青色申告者が受けられる税務上の特典として、青色申告特別控除のほかに、青色事業専従者給与の必要経費算入、純損失の（　③　）間の繰越控除、前年分の所得に対する税額から還付を受けられる純損失の繰戻還付、棚卸資産の評価について低価法を選択できることなどが挙げられます」<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"f8a2731c-0adb-48d6-a8b4-fef269841139\" src='/img/15_7_1779256589550181.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "青色申告",
    "important": "B"
  },
  {
    "id": 32007,
    "shikenId": 15,
    "no": 8,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_32006.png'/><br><img src='/img/setsu_32006_2.png'/>",
    "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
    "choice1": "「母Ｄさんの公的年金等に係る雑所得の金額は算出されません。Ａさんの所得控除において、母Ｄさんは同居老親等にあたります」",
    "choice2": "「Ａさんが受け取った一時払養老保険の満期保険金に係る差益は、源泉分離課税の対象となります」",
    "choice3": "「長男Cさんについて、A さんが適用を受けることができる扶養控除の控除額は、38万円となります」",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税総合",
    "important": "A"
  },
  {
    "id": 32008,
    "shikenId": 15,
    "no": 9,
    "answerType": 4,
    "groupId": 0,
    "answer": "4250000,0,580000,107500",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_32006.png'/><br><img src='/img/setsu_32006_2.png'/>",
    "question2": "Ａさんの本年分の所得税の算出税額を計算した下記の表の空欄①～④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"af0d96b3-6b1c-4845-8409-39fe71cc6f30\" src='/img/15_9_1779256589855461.png'>",
    "choice1": "円",
    "choice2": "円",
    "choice3": "円",
    "choice4": "円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の計算",
    "important": "A"
  },
  {
    "id": 32009,
    "shikenId": 15,
    "no": 10,
    "answerType": 4,
    "groupId": 0,
    "answer": "320,960",
    "score": "2,2",
    "question1": "<img src='/img/setsu_32009.png'/>",
    "question2": "甲土地上に準耐火建築物を建築する場合における次の①、②を求めなさい（計算過程の記載は不要）。<br><br>①　建蔽率の上限となる建築面積<br>②　容積率の上限となる延べ面積",
    "choice1": "㎡",
    "choice2": "㎡",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "建蔽率と容積率の計算",
    "important": "A"
  },
  {
    "id": 32010,
    "shikenId": 15,
    "no": 11,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_32009.png'/>",
    "question2": "Ｘ社が提案する事業方式による効果に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
    "choice1": "「Ａさんが金融機関から融資を受けて賃貸アパートを建築する場合、借入金による事業リスクを考慮する必要があります。ＤＳＣＲ（借入金償還余裕率）の値が1.0未満の場合、年間の賃料収入から必要経費を差し引いた金額の範囲内では年間の借入金の返済はできないことを示しています」",
    "choice2": "「Ｘ社と一括賃貸借契約（普通借家契約・マスターリース契約（特定賃貸借契約））を締結することで、賃料収入が保証されることは大きなメリットです。普通借家契約の場合、借地借家法の規定により、Ｘ社から賃料の減額請求をされることはありません」",
    "choice3": "「近年、サブリース業者に対する規制が強化されており、賃貸住宅の管理業務等の適正化に関する法律において、サブリース業者がマスターリース契約を締結しようとする際に誇大広告や不当な勧誘を行うことを禁止しており、Ａさんが賃貸マンションを建築し、Ｘ社がＡさんから建物を一括賃借する場合も当該規制の適用を受けます」",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "ＤＳＣＲ、賃貸借契約",
    "important": "B"
  },
  {
    "id": 32011,
    "shikenId": 15,
    "no": 12,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_32009.png'/>",
    "question2": "Ａさんが甲土地に賃貸アパートを建築した場合の課税に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
    "choice1": "「Ａさんが甲土地に賃貸アパートを建築した場合、甲土地に係る固定資産税の課税標準を、住宅１戸につき200㎡までの部分（小規模住宅用地）について課税標準となるべき価格の３分の１の額とする特例の適用を受けることができます」",
    "choice2": "「甲土地は、相続税額の計算上、貸家建付地として評価されます。甲土地の貸家建付地としての価額は、当該マンションの賃貸割合が高いほど、高く評価されます」",
    "choice3": "「対象地の面する道路に付された『300Ｄ』『200Ｄ』の数値は、１㎡当たりの価額を千円単位で表示した相続税路線価です。数値の後に表示されている『Ｄ』の記号（アルファベット）は、借地権割合が60％であることを示しています」",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "賃貸アパートの課税",
    "important": "A"
  },
  {
    "id": 32012,
    "shikenId": 15,
    "no": 13,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,1,2",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_32012.png'/>",
    "question2": "Ａさんの相続等に関する次の記述①～④について、適切なものには〇印を、不適切なものには×印を解答用紙に記入しなさい。",
    "choice1": "「Ｘ社関連の資産（Ｘ社株式、Ｘ社本社敷地・建物）の大半を長男Ｃさんに相続させた場合、妻Ｂさんおよび長女Ｄさんの遺留分を侵害するおそれがあります。仮に、遺留分算定の基礎となる財産が４億円の場合、長女Ｄさんの遺留分の金額は１億円となります」",
    "choice2": "「遺産分割をめぐる争いを防ぐために、遺言を作成することをお勧めします。公正証書遺言は、証人２人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人が作成します」",
    "choice3": "「契約者（＝保険料負担者）および被保険者をＡさん、死亡保険金受取人を長男Ｃさんとする終身保険（死亡保険金額1,500万円）に加入した場合、死亡保険金の非課税金額の規定の適用を最大限活用することができます」",
    "choice4": "「自宅の敷地および建物を妻Ｂさんが相続により取得し、申告期限までに自宅の敷地を売却した場合には、自宅の敷地を『特定居住用宅地等』として小規模宅地等についての相続税の課税価格の計算の特例の適用を受けることができなくなるので注意してください」",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続総合",
    "important": "C"
  },
  {
    "id": 32013,
    "shikenId": 15,
    "no": 14,
    "answerType": 6,
    "groupId": 0,
    "answer": "ロ,ヘ,ト",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_32012.png'/>",
    "question2": "Ｘ社株式に関する以下の文章の空欄①～③に入る最も適切な語句を、下記の〈語句群〉のイ～リのなかから選び、その記号を解答用紙に記入しなさい。<br><br>Ⅰ　 「類似業種比準価額は、類似業種の株価ならびに１株当たりの配当金額、（　①　）および簿価純資産価額の３つを比準要素として計算します。配当金額、（　①　）および簿価純資産価額が高い会社は株式の評価額が高くなります」<br>Ⅱ　 「長男ＣさんにＸ社株式を移転する方法として、『非上場株式等についての贈与税の納税猶予（特例措置）』の活用が考えられます。本特例措置の適用を受けた場合、贈与者の死亡時まで本特例措置の対象となる非上場株式等の贈与に係る贈与税額の（　②　）の納税が猶予され、本特例措置の対象となる株式は、発行済議決権株式の（　③　）となります」<br><img data-image-id=\"I1\"  data-asset-scope=\"data_check\" data-asset-id=\"ff8d9339-7f77-4d8c-b89e-be80bdde282d\" src='/img/15_14_1779256590482993.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "自社株",
    "important": "A"
  },
  {
    "id": 32014,
    "shikenId": 15,
    "no": 15,
    "answerType": 4,
    "groupId": 0,
    "answer": "4800,2090,9920",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_32012.png'/>",
    "question2": "現時点において、Ａさんに相続が開始した場合における相続税の総額を計算した下記の表の空欄①～③に入る数値を求めなさい。なお、相続税の課税価格の合計額は４億2,000万円とする。また、問題の性質上、明らかにできない部分は□□□で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"4b1445c4-0b8d-404f-b24c-ce1f030c7bdd\" src='/img/15_15_1779256590857647.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"04516446-511e-4bbc-b4b5-7e7edcedea25\" src='/img/15_15_1779256591143610.png'>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の計算",
    "important": "A"
  },
  {
    "id": 33000,
    "shikenId": 19,
    "no": 1,
    "answerType": 4,
    "groupId": 0,
    "answer": "794344,303867,157,304024",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_33000.png'/><br><img src='/img/setsu_33000_2.png'/>",
    "question2": "Ａさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（本年度価額）を計算した次の＜計算の手順＞の空欄①～④に入る最も適切な数値を答えなさい。計算にあたっては、《設例》の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づくこと。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"6ddf8814-1008-4eb8-a4e7-aa898098be1e\" src='/img/19_1_1779256674774650.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"a053be10-ede6-4dfd-8e21-7ef1d7d8558c\" src='/img/19_1_1779256675100242.png'>",
    "choice1": "円",
    "choice2": "円",
    "choice3": "円",
    "choice4": "円",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老齢基礎年金および老齢厚生年金の計算",
    "important": "A"
  },
  {
    "id": 33001,
    "shikenId": 19,
    "no": 2,
    "answerType": 6,
    "groupId": 0,
    "answer": "イ,ニ,チ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_33000.png'/><br><img src='/img/setsu_33000_2.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、国民年金の付加保険料および国民年金基金について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ　 「Ａさんは、所定の手続により、国民年金の定額保険料に加えて、国民年金の付加保険料を納付することができます。仮に、Ａさんが付加保険料を180月納付し、65歳から老齢基礎年金を受け取る場合、老齢基礎年金の額に付加年金として（　①　）円が上乗せされます」<br>Ⅱ　 「国民年金基金は、老齢基礎年金に上乗せする年金を支給する任意加入の年金制度です。掛金の額は、加入者が選択した給付の型や口数、加入時の年齢等で決まり、掛金の拠出限度額は月額（　②　）円となります。なお、国民年金基金に加入した場合は（　③　）を納付することはできません」<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"54be10bc-98be-4473-83cb-f64c9d68c9b6\" src='/img/19_2_1779256675590942.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "付加年金と国民年金基金",
    "important": "B"
  },
  {
    "id": 33002,
    "shikenId": 19,
    "no": 3,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_33000.png'/><br><img src='/img/setsu_33000_2.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、公的年金制度等の各種取扱いについて説明した。Ｍさんが説明した次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「Ａさんは、老齢基礎年金および老齢厚生年金の繰下げ支給の申出をすることができます。仮に、Ａさんが72歳０カ月で老齢基礎年金および老齢厚生年金の繰下げ支給の申出をした場合の増額率は33.6％となります」",
    "choice2": "「Ａさんのような個人事業主や会社等の役員が所定の要件を満たしていれば小規模企業共済に加入することができます。毎月の掛金は1,000円から７万円までの範囲内（500円刻み）で選択でき、その全額が税額控除の対象となります」",
    "choice3": "「Ａさんは、老後の年金収入を増やすために、確定拠出年金の個人型年金に加入することができます。ただし、Ａさんが確定拠出年金の個人型年金に加入した場合、小規模企業共済制度には加入することができません」",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的年金制度等",
    "important": "C"
  },
  {
    "id": 33003,
    "shikenId": 19,
    "no": 4,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_33003.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、Ｕ社債および米ドル建定期預金に係る留意点について説明した。Ｍさんが説明した次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「Ｕ社債の格付は、Ａ（シングルＡ）と評価されています。一般に、BBB（トリプルＢ）格相当以上の格付が付されていれば、投資適格債とされます」",
    "choice2": "「外貨預金の魅力は、円建ての預金と比べて相対的に金利が高いことにあります。《設例》の米ドル建定期預金の場合、Ａさんが満期時に受け取ることができる利息額（税引前）は、480米ドルになります」",
    "choice3": "「円建ての債券投資では、信用リスクや金利リスクに注意が必要です。一般に、市場金利が低下する局面では、債券価格は下落します」",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "債券と外貨預金に係る留意点",
    "important": "B"
  },
  {
    "id": 33004,
    "shikenId": 19,
    "no": 5,
    "answerType": 4,
    "groupId": 0,
    "answer": "1.47,8.14",
    "score": "2,2",
    "question1": "<img src='/img/setsu_33003.png'/>",
    "question2": "次の①、②を求めなさい（計算過程の記載は不要）。なお、計算にあたっては税金等を考慮せず、〈答〉は、％表示の小数点以下第３位を四捨五入し、小数点以下第２位までを解答すること。<br><br>①　 ＡさんがＵ社債を《設例》の条件で購入した場合の最終利回り（年率・単利）を求めなさい。<br>②　 Ａさんが《設例》の条件で円貨を米ドルに換えて米ドル建定期預金に40,000米ドルを預け入れ、満期を迎えた場合の円ベースでの運用利回り（単利による年換算）を求めなさい。なお、預入期間６カ月は0.5年として計算すること。",
    "choice1": "％",
    "choice2": "％",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "債券と外貨預金の利回りの計算",
    "important": "B"
  },
  {
    "id": 33005,
    "shikenId": 19,
    "no": 6,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,1,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_33003.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、Ｕ社債および米ドル建定期預金に係る課税関係について説明した。Ｍさんが説明した次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「Ｕ社債の利子は、利子の支払時において所得税および復興特別所得税と住民税の合計で20.315％相当額が源泉徴収等されます」",
    "choice2": "「為替予約のない米ドル建定期預金の満期による為替差益は、雑所得として総合課税の対象となります」",
    "choice3": "「Ｕ社債の譲渡益は、一時所得として総合課税の対象となりますので、上場株式の譲渡損失の金額と損益通算することはできません」",
    "choice4": "",
    "choice5": "",
    "categoryName": "金融",
    "rontenName": "債券と外貨預金に係る課税",
    "important": "C"
  },
  {
    "id": 33006,
    "shikenId": 19,
    "no": 7,
    "answerType": 6,
    "groupId": 0,
    "answer": "ハ,チ,ロ,ヌ",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_33006.png'/>",
    "question2": "住宅借入金等特別控除（以下、「本控除」という）に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈語句群〉のなかから選びなさい。<br><br>「住宅ローンを利用して新築住宅を取得し、本年中に居住した場合、所定の要件を満たせば、居住の用に供した年分以後、最大で（　①　）年間、本控除の適用を受けることができます。<br>なお、Aさんが新築マンションに入居した本年以後、合計所得金額が（　②　）万円を超える年があった場合、その年分については本控除の適用を受けることができません。<br>また、本控除の対象となる住宅借入金等は、契約において償還期間等が（　③　）年以上であることが要件とされているため、繰上げ返済を行い、住宅ローン返済期間が（　③　）年未満となった場合は、その年分以降について本控除の適用を受けることができなくなります。<br>本年の本控除の額は、原則として『住宅ローンの年末残高×（　④　）』で計算されます」<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"c46da724-0193-4138-8af6-83239baf4c0f\" src='/img/19_7_1779256675913095.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "住宅借入金等特別控除",
    "important": "C"
  },
  {
    "id": 33007,
    "shikenId": 19,
    "no": 8,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_33006.png'/>",
    "question2": "Ａさんが新築マンションを購入した場合の税金に関する次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。",
    "choice1": "「Ａさんは、本年分の所得税について、年末調整で住宅借入金等特別控除の適用を受けることができます」",
    "choice2": "「Ａさんが、父親から受けた500万円の資金援助について『直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税の特例』の適用を受けた場合、その贈与を受けた金額の全額について贈与税が課されません。ただし、この場合、住宅借入金等特別控除の適用を受けることができなくなります」",
    "choice3": "「Ａさん本年中の所得税から住宅借入金等特別控除の額を控除しきれない場合、住民税の確定申告をしなくても、その残額を、Ａさんの所得税の課税総所得金額等の額の５％（最高９万7,500円）を限度に、翌年度の住民税額から控除されます」",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "住宅借入金等特別控除等",
    "important": "C"
  },
  {
    "id": 33008,
    "shikenId": 19,
    "no": 9,
    "answerType": 4,
    "groupId": 0,
    "answer": "8900000,630000,208600",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_33006.png'/>",
    "question2": "Ａさんの本年分の所得税額を計算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、総所得金額の計算上、住宅借入金等特別控除の適用を受けるものとし、Ａさんが所得金額調整控除の適用対象者に該当している場合、所得金額調整控除額を控除すること。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"61c6625e-4246-4b74-8a2d-5bb267ff5231\" src='/img/19_9_1779256676363214.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"76965ab5-e744-4306-81a8-b40d3b2956a3\" src='/img/19_9_1779256676738169.png'>",
    "choice1": "円",
    "choice2": "円",
    "choice3": "円",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の計算",
    "important": "A"
  },
  {
    "id": 33009,
    "shikenId": 19,
    "no": 10,
    "answerType": 4,
    "groupId": 0,
    "answer": "1200,4800",
    "score": "2,2",
    "question1": "<img src='/img/setsu_33009.png'/>",
    "question2": "甲土地と乙土地を一体とした土地上に耐火建築物を建築する場合における次の①、②を答えなさい。〈答〉は㎡単位とすること。<br>①　建蔽率の上限となる建築面積<br>②　容積率の上限となる延べ面積",
    "choice1": "㎡",
    "choice2": "㎡",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "建蔽率と容積率の計算",
    "important": "A"
  },
  {
    "id": 33010,
    "shikenId": 19,
    "no": 11,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_33009.png'/>",
    "question2": "Aさんが、甲土地上に賃貸マンションを建築する場合の課税等に関する次の記述①～③について、適切なものには〇を、不適切なものには×を選択しなさい。",
    "choice1": "「Aさんが甲土地上に賃貸マンションを建築して経営するために実家の建物を取り壊した場合、その取壊しに係る費用は、不動産所得の金額の計算上、必要経費に算入することができません」",
    "choice2": "「NPV法による投資判断では、将来発生するキャッシュフローの現在価値の合計額と投資額を比較し、投資額のほうが大きい場合に、その投資は有利であると判断することができます。不動産投資においては、将来発生する収入や費用等について十分に検討したうえで投資判断をする必要があります」",
    "choice3": "「Aさんが甲土地上に賃貸マンションを建築した場合、A さんの相続に係る相続税額の計算上、甲土地は貸家建付地として評価されます。仮に、甲土地の自用地価額を6,000万円、借地権割合を60％、借家権割合を30％、賃貸割合を100％とした場合の相続税評価額は、4,920万円となります」",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "マンションを建築する場合の課税等",
    "important": "B"
  },
  {
    "id": 33011,
    "shikenId": 19,
    "no": 12,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,1,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_33009.png'/>",
    "question2": "土地の有効活用事業方式の一般的な特徴や固定資産税に関する次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「等価交換方式とは、マンション開発業者が建設資金を負担して、マンションを建設し、完成した区分所有建物と土地の共有持分をＡさんとＫ社がそれぞれの出資割合に応じて取得する手法です」",
    "choice2": "「Ａさんが所有する甲土地、乙土地に等価交換方式や建設協力金方式により建物を建築し、Ａさんが取得した建物を賃貸した後、Ａさんに相続が開始した場合、相続税額の計算上、建物は貸家、敷地は貸家建付地として評価されます」",
    "choice3": "「Ａさんが所有する甲土地、乙土地に賃貸マンションを建築した場合、甲土地、乙土地に係る固定資産税の課税標準は、住宅１戸につき200㎡までの部分（小規模住宅用地）について課税標準となるべき価格の３分の１の額とする特例の適用を受けることができます」",
    "choice4": "",
    "choice5": "",
    "categoryName": "不動産",
    "rontenName": "土地の有効活用方式と特徴と固定資産税",
    "important": "B"
  },
  {
    "id": 33012,
    "shikenId": 19,
    "no": 13,
    "answerType": 4,
    "groupId": 0,
    "answer": "41,2500,20,110",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_33012.png'/>",
    "question2": "生前贈与に関する以下の文章の空欄①～④に入る最も適切な数値を答えなさい。<br><br>Ⅰ　 「Aさんが生前贈与を実行するにあたり、長女C さんが暦年課税（各種非課税制度の適用はない）により、本年中にA さんから現金450万円の贈与を受けた場合、贈与税額は（　①　）万円となります」<br>Ⅱ　 「Aさんからの贈与について、長女C さんが暦年課税制度ではなく、相続時精算課税制度を選択した場合、累計で特別控除（　②　）万円までの贈与について贈与税は課されず、その額を超える部分については、一律（　③　）％の税率により贈与税が課されます。なお、2024年以降の相続時精算課税制度において、特別控除前に、暦年課税制度とは別枠で年間（　④　）万円を差し引くことができます」<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"d9c16aee-9785-4d9c-b1fa-d5d6f350025a\" src='/img/19_13_1779256677101731.png'>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "％",
    "choice4": "万円",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "生前贈与に関する記述",
    "important": "B"
  },
  {
    "id": 33013,
    "shikenId": 19,
    "no": 14,
    "answerType": 6,
    "groupId": 0,
    "answer": "リ,ロ,ヘ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_33012.png'/>",
    "question2": "Ａさんの相続等に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選択しなさい。<br><br>Ⅰ　 「Aさんの相続が現時点で開始した場合、A さんの相続における遺産に係る基礎控除額は（　①　）万円となります」<br>Ⅱ　 「生命保険に加入していないのであれば、契約者（＝保険料負担者）および被保険者をAさん、死亡保険金受取人を相続人とする終身保険に加入されることをお勧めします。終身保険に加入後、A さんの相続が開始した場合、相続人が受け取る死亡保険金は（　②　）万円を限度として、死亡保険金の非課税金額の規定の適用を受けることができます」<br>Ⅲ　 「妻Bさんが自宅の敷地および建物を相続した場合、小規模宅地等についての相続税の課税価格の計算の特例の適用を受けることができます。その場合、自宅の敷地（相続税評価額5,000万円）について、課税価格に算入すべき価額を（　③　）万円とすることができます」<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"82a08a93-5405-4594-8190-6dadc6035113\" src='/img/19_14_1779256677605888.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税に関する記述",
    "important": "A"
  },
  {
    "id": 33014,
    "shikenId": 19,
    "no": 15,
    "answerType": 4,
    "groupId": 0,
    "answer": "4200,1670,3340",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_33012.png'/>",
    "question2": "現時点において、Aさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を答えなさい。<br>なお、相続税の課税価格の合計額は2億円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"f652361b-8523-4c69-bde5-1a2a3a45886c\" src='/img/19_15_1779256677801078.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"bee0d53f-5402-4b06-b4d4-20f796e77e69\" src='/img/19_15_1779256678077607.png'>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の計算",
    "important": "A"
  },
  {
    "id": 42000,
    "shikenId": 16,
    "no": 1,
    "answerType": 6,
    "groupId": 0,
    "answer": "ロ,チ,ニ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_42000.png'/><br><img src='/img/setsu_42000_2.png'/>",
    "question2": "まず、Ｍさんは、Ａさんに対して、退職後の社会保険の各種取扱い等について説明した。Ｍさんが説明した以下の文章の空欄の①～③に入る適切な語句または数値を、下記の＜語句群＞のなかから選び、その記号を選択してください。<br><br>Ⅰ　 「Ａさんは、国民健康保険に加入する以外に、所定の手続により、退職日の翌日から最長で（　①　）、全国健康保険協会管掌健康保険に任意継続被保険者として加入することができます。そのためには資格喪失日から20日以内に手続きを行うことが必要です。なお、都道府県と市町村が保険者である国民健康保険は、健康保険とは異なり、（　②　）は任意給付となっています」<br>Ⅱ　 「Ａさんが厚生年金保険の被保険者でなくなった場合、妻Ｂさんは、国民年金の第３号被保険者から第（　③　）被保険者への種別変更の届出を行い、国民年金の保険料を納付することになります」<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"9e5aaf73-1193-4699-9948-5aaab374f0e8\" src='/img/16_1_1779256997594596.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "退職後の社会保険",
    "important": "B"
  },
  {
    "id": 42001,
    "shikenId": 16,
    "no": 2,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_42000.png'/><br><img src='/img/setsu_42000_2.png'/>",
    "question2": "次に、Ｍさんは、Ａさんに対して、確定拠出年金の個人型年金（以下、「個人型年金」という）について説明した。Ｍさんが説明した次の記述①～③について、適切なものには○印を、不適切なものには×印を選択してください。",
    "choice1": "「国民年金の第１号被保険者で国民年金の定額保険料を納付している者は、原則として、個人型年金に加入することができます。個人型年金は、通算加入者等期間が10年以上あれば、老齢給付金を最も早くて65歳から受給することができます」",
    "choice2": "「個人型年金では、銀行・証券会社等の運営管理機関が定める手数料を負担する必要がありますが、当該手数料の額は金融機関の別なく、一律です」",
    "choice3": "「個人型年金の掛金は、その全額が社会保険料控除の対象となり、総所得金額等から控除することができます」",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "個人型確定拠出年金",
    "important": "C"
  },
  {
    "id": 42002,
    "shikenId": 16,
    "no": 3,
    "answerType": 6,
    "groupId": 0,
    "answer": "ハ,イ,ト,ル",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_42000.png'/><br><img src='/img/setsu_42000_2.png'/>",
    "question2": "最後に、Ｍさんは、Ａさんに対して、老後の収入を増やすための各種制度について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な数値または語句を下記の＜語句群＞の中から選び、その記号を選択してください。<br><br><img data-asset-scope=\"data_check\" data-asset-id=\"a704bb3d-0b50-4869-8d45-8c54386dd9b0\" src='/img/16_3_1779256997900483.png'><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"04030d57-8b41-4669-b23d-cd90d3df4d4e\" src='/img/16_3_1779256998714907.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老後の収入を増やすための制度",
    "important": "B"
  },
  {
    "id": 42003,
    "shikenId": 16,
    "no": 4,
    "answerType": 6,
    "groupId": 0,
    "answer": "ホ,リ,ロ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_42003.png'/><br><img src='/img/setsu_42003_2.png'/>",
    "question2": "はじめに、Ｍさんは、Ａさんに対して、下記の＜前提＞においてＡさんが死亡した場合、妻Ｂさんが受給することができる公的年金制度からの遺族給付について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>＜前提＞<br>・妻Ｂさんは、遺族基礎年金および遺族厚生年金の受給権を取得する。<br>・妻Ｂさんおよび長女Ｃさん、二女Ｄさんおよび長男Ｅさんは、現在および将来においても、公的年金制度における障害等級に該当する障害の状態にないものとする。<br><br>「現時点において、Ａさんが死亡した場合、妻Ｂさんに対して遺族基礎年金および遺族厚生年金が支給されます。遺族基礎年金を受けられる遺族の範囲は、死亡した被保険者によって生計を維持されていた『子のある配偶者』または『子』です。『子』とは、原則として、18歳到達年度の末日までの間にあり、かつ、現に婚姻していない子等を指します。妻ＢさんがＡさんの死亡直後に受け取る遺族基礎年金の額は、（　①　）円（本年度価額）になります。<br>遺族厚生年金の額は、原則として、Ａさんの厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の（　②　）相当額になります。ただし、その計算の基礎となる被保険者期間の月数が（　③　）月に満たない場合、（　③　）月とみなして年金額が計算されます。<br>また、長男Ｅさんについて18歳到達年度の末日が終了し、妻Ｂさんの有する遺族基礎年金の受給権が消滅したときは、妻Ｂさんが65歳に達するまでの間、妻Ｂさんに支給される遺族厚生年金の額に中高齢寡婦加算が加算されます。<br>中高齢寡婦加算の額は、遺族基礎年金の額（子の加算額を除く）の（　②　）相当額になります」<br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"69b5d0e8-a554-4e6a-bf32-346531551a50\" src='/img/16_4_1779256999081754.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（個人）",
    "rontenName": "遺族給付",
    "important": "B"
  },
  {
    "id": 42004,
    "shikenId": 16,
    "no": 5,
    "answerType": 4,
    "groupId": 0,
    "answer": "7488,6000,7000",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_42003.png'/><br><img src='/img/setsu_42003_2.png'/>",
    "question2": "次に、Ｍさんは、Ａさんに対して、必要保障額およびＡさんが提案を受けた生命保険の死亡保障の額について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>「提案を受けた生命保険に加入する前に、現時点での必要保障額を算出し、準備すべき死亡保障の額を把握しましょう。下記の＜算式＞および＜条件＞を参考にすれば、Ａさんが現時点で死亡した場合の遺族に必要な生活資金等の総額は□□□万円となり、必要保障額は（　①　）万円となります。<br>仮に、提案を受けた生命保険に加入し、加入した年中にＡさんが死亡（不慮の事故や所定の感染症以外）した場合、妻Ｂさんに支払われる死亡保険金額は（　②　）万円となります。他方、加入した年中にＡさんが不慮の事故で180日以内に死亡した場合の死亡保険金額は（　③　）万円となります」<br><br><img data-image-id=\"I1\" data-asset-scope=\"data_check\" data-asset-id=\"6c691ee2-76e9-427a-94e5-5a22664ecbd6\" src='/img/16_5_1779256999415215.png'><br><br>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（個人）",
    "rontenName": "必要保障額と生命保険の保障内容の計算",
    "important": "A"
  },
  {
    "id": 42005,
    "shikenId": 16,
    "no": 6,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,2,1",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_42003.png'/><br><img src='/img/setsu_42003_2.png'/>",
    "question2": "最後に、Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の保障内容および課税関係について説明した。Ｍさんが説明した次の記述①～④について、適切なものには◯印を、不適切なものには×印を選択してください。",
    "choice1": "「先進医療の治療を受けた場合、その技術料に係る費用だけでなく診察料や投薬料等に係る費用も全てが自己負担となりますので、先進医療特約の付加をお勧めします」",
    "choice2": "「必要保障額は、通常、末子が生まれた時に最大となり、その後、子どもの成長とともに逓減していきます。Ａさんの今後のライフステージの変化に合わせて、保障内容を定期的に見直すことをお勧めします」",
    "choice3": "「当該生命保険の支払保険料のうち、終身保険特約、定期保険特約、逓減定期保険特約および傷害特約に係る保険料は一般の生命保険料控除の対象となり、入院特約および先進医療特約に係る保険料は介護医療保険料控除の対象となります」",
    "choice4": "「Ａさんが重い病気等で余命６カ月以内と判断された場合、リビング・ニーズ特約により所定の範囲内で死亡保険金の全部または一部を生前にＡさんが受け取ることができます」",
    "choice5": "",
    "categoryName": "リスク（個人）",
    "rontenName": "保障内容および課税関係",
    "important": "A"
  },
  {
    "id": 42006,
    "shikenId": 16,
    "no": 7,
    "answerType": 4,
    "groupId": 0,
    "answer": "1920,2540",
    "score": "1,1",
    "question1": "<img src='/img/setsu_42006.png'/>",
    "question2": "仮に、将来Ｘ社がＡさんに役員退職金7,000万円を支給した場合、Ａさんが受け取る役員退職金について、次の①、②を求めなさい（計算過程の記載は不要）。〈答〉は万円単位とすること。なお、Ａさんの役員在任期間（勤続年数）を35年３カ月とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。<br><br>①　退職所得控除額<br>②　退職所得の金額",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（法人）",
    "rontenName": "退職所得の計算",
    "important": "A"
  },
  {
    "id": 42007,
    "shikenId": 16,
    "no": 8,
    "answerType": 6,
    "groupId": 0,
    "answer": "ホ,ト,イ,ヘ",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_42006.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、＜資料＞の定期保険の支払保険料の経理処理について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選択してください。<br><br>「法人を契約者（＝保険料負担者）および死亡保険金受取人とし、役員等を被保険者とする保険期間が３年以上の定期保険で、最高解約返戻率が（　①　）％を超えるものの支払保険料の経理処理については、最高解約返戻率が『（　①　）％超（　②　）％以下』『（　②　）％超85％以下』『85％超』の３つの区分に応じて取り扱います。＜資料＞の定期保険の最高解約返戻率は『（　②　）％超85％以下』であるため、保険期間開始日から保険期間の（　③　）割相当期間を経過する日までは、当期分支払保険料の（　④　）％相当額を前払保険料として資産に計上し、残額は損金の額に算入します。（　③　）割に相当する期間経過後は、当期分支払保険料の全額を損金の額に算入するとともに、資産に計上した金額は、保険期間の7.5割相当期間経過後から保険期間終了日までにおいて均等に取り崩し、損金の額に算入します」<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"8363f4bb-688a-4538-8ba7-7d0795109b7f\" src='/img/16_8_1779257000228966.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（法人）",
    "rontenName": "生命保険の経理処理",
    "important": "A"
  },
  {
    "id": 42008,
    "shikenId": 16,
    "no": 9,
    "answerType": 6,
    "groupId": 0,
    "answer": "イ,ト,ニ,ヌ",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_42006.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、中小企業退職金共済制度（以下、「中退共」という）について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>「中退共は、中小企業の事業主が独立行政法人勤労者退職金共済機構と雇用者（従業員）を被共済者とする退職金共済契約を締結して、退職金を社外に積み立てる共済制度です。<br>掛金は、被共済者（従業員）１人につき、月額5,000円から（　①　）までの範囲から選択し、事業主が全額を負担します。なお、短時間労働者（パートタイマー等）は、特例として、月額2,000円から加入することができます。<br>中退共に新たに加入する事業主に対して、原則として、掛金月額の（　②　）（被共済者１人ごとに5,000円が上限）を加入後（　③　）から１年間、国が助成する制度があります。また、掛金月額が18,000円以下の被共済者（従業員）の掛金を増額した事業主に対して、増額分の３分の１を増額月から１年間、国が助成する制度もあります。<br>被共済者（従業員）が退職した場合、独立行政法人勤労者退職金共済機構から退職金が（　④　）支給されます。退職金は、退職時に一括して受け取る一時払いのほか、退職金が所定の金額以上であることなどの要件を満たした場合は、退職金の全部または一部を分割払いにすることもできます」<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"a86d5176-dd27-4e11-af8c-905b764389f3\" src='/img/16_9_1779257000394746.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（法人）",
    "rontenName": "中小企業退職金共済",
    "important": "B"
  },
  {
    "id": 42009,
    "shikenId": 16,
    "no": 10,
    "answerType": 6,
    "groupId": 0,
    "answer": "ハ,チ,ロ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_42009.png'/><br><img src='/img/setsu_42009_2.png'/>",
    "question2": "住宅借入金等特別控除（以下、「本控除」という）に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選択してください。<br><br>「Ａさんが、住宅ローンを利用して新築マンションを取得し、本年中に居住した場合、所定の要件を満たせば、居住の用に供した年分以後、最大で（　①　）年間、本控除の適用を受けられます。本控除の適用を受けるための要件には、『床面積の（　②　）以上を専ら自己の居住の用に供していること』『住宅の新築の日から６カ月以内に居住の用に供していること』『住宅ローンの償還期間が（　③　）年以上であること』などがあります」<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"300aebbe-c91c-4993-be16-b37f3f8f991f\" src='/img/16_10_1779257000589470.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "住宅借入金等特別控除",
    "important": "C"
  },
  {
    "id": 42010,
    "shikenId": 16,
    "no": 11,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,2,1,1",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_42009.png'/><br><img src='/img/setsu_42009_2.png'/>",
    "question2": "Ａさんの所得税および住宅取得資金に係る贈与税に関する次の記述①～④について、適切なものには○印を、不適切なものには×印を選択してください。",
    "choice1": "「Ａさんは白色申告者ですが、不動産所得の損失は損益通算することができます」",
    "choice2": "「Ａさんの株式の譲渡所得の損失は、給与所得と損益通算することができます」",
    "choice3": "「父親からの資金援助について、『直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税』の適用を受けた場合、贈与税は課されません」",
    "choice4": "「転勤等のやむを得ない事由によりＡさんが単身赴任で転居した場合、妻Ｂさん、長女Ｃさんおよび長男Ｄさんが引き続きマンションに居住する場合、単身赴任後も引き続き住宅借入金等特別控除の適用を受けることができます」",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "損益通算、住宅取得等資金の贈与税の非課税、住宅借入金等特別控除",
    "important": "B"
  },
  {
    "id": 42011,
    "shikenId": 16,
    "no": 12,
    "answerType": 4,
    "groupId": 0,
    "answer": "6700000,630000,207900",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_42009.png'/><br><img src='/img/setsu_42009_2.png'/>",
    "question2": "Ａさんの本年分の所得税額を計算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。①の計算上、Ａさんが所得金額調整控除の適用対象者に該当している場合、所得金額調整控除額を控除すること。<br>なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"643d7d12-5fe3-4ffa-a0e4-21cb9e4dae30\" src='/img/16_12_1779257000786798.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"52406b92-8f64-48c2-8c5a-e06a321de8c3\" src='/img/16_12_1779257001297004.png'>",
    "choice1": "円",
    "choice2": "円",
    "choice3": "円",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の計算",
    "important": "A"
  },
  {
    "id": 42012,
    "shikenId": 16,
    "no": 13,
    "answerType": 6,
    "groupId": 0,
    "answer": "イ,ヘ,チ,ホ",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_42012.png'/><br><img src='/img/setsu_42012_2.png'/>",
    "question2": "Ａさんの相続等に関する以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　 「Aさんが長女C さんに、X 社株式等の事業に関わる財産のすべてを相続させる旨の遺言を作成した場合、二女Dさんおよび三女E さんが遺留分の請求をする可能性があります。仮に、A さんの相続に係る遺留分を算定するための財産の価額を4億5,000万円とした場合、二女D さんの遺留分は（　①　）となります」<br>Ⅱ　 「Ｘ社株式の相続税評価額は、原則として類似業種比準方式により評価されます。類似業種比準価額は、類似業種の株価ならびに１株当たりの配当金額、１株当たりの利益金額、１株当たりの（　②　）価額の３つの比準要素を基に計算されます」<br>Ⅲ　 「Ａさんが生前贈与を実行するにあたっては、暦年課税による贈与を活用することもできます。仮に、長女Ｃさんが暦年課税（各種非課税制度の適用はない）により、本年中にＡさんから現金700万円の贈与を受けた場合、贈与税額は（　③　）万円となります」<br>Ⅳ　 「妻Bさんが『配偶者に対する相続税額の軽減』の適用を受けた場合、相続により取得した財産の金額が、配偶者の法定相続分相当額と1億6,000万円とのいずれか（　④　）金額までであれば、原則として、妻B さんが納付すべき相続税額は算出されません」<br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"23b06e3a-b933-41d3-98a9-89764a228900\" src='/img/16_13_1779257001821791.png'><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"651b6d9c-caba-4597-ade1-d31253fdcd10\" src='/img/16_13_1779257002269237.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "贈与税・財産評価等",
    "important": "B"
  },
  {
    "id": 42013,
    "shikenId": 16,
    "no": 14,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_42012.png'/><br><img src='/img/setsu_42012_2.png'/>",
    "question2": "Aさんの相続税等に関する以下の文章の①～③について適切なものには〇印を、不適切なものには×印を選択してください。",
    "choice1": "「二女Dさんと三女E さんに対する代償交付金を準備する方法として、契約者（＝保険料負担者）および被保険者をA さん、死亡保険金受取人を長女Cさんとする終身保険に加入する方法があります。ただし、死亡保険金は、原則として遺留分を算定するための財産に含まれるため、保険金額について十分に検討する必要があります」",
    "choice2": "「長女CさんにX 社株式を移転する方法として、相続時精算課税制度の活用が考えられます。相続時精算課税制度は、特定贈与者からの贈与のうち毎年110万円を除いた金額を累計して2,500万円までは贈与税が非課税になる制度です。2,500万円を超えた金額には暦年贈与の贈与税率により贈与税が課税されます」",
    "choice3": "「妻Bさんが相続により自宅建物および敷地を取得した場合、当該敷地は特定居住用宅地等として『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けることができます。仮に妻B さんが相続税の申告期限までに当該敷地を売却しても、適用を受けることが可能です」",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続等に関する記述",
    "important": "B"
  },
  {
    "id": 42014,
    "shikenId": 16,
    "no": 15,
    "answerType": 4,
    "groupId": 0,
    "answer": "5400,620,5080",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_42012.png'/><br><img src='/img/setsu_42012_2.png'/>",
    "question2": "現時点において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。<br>なお、相続税の課税価格の合計額は３億円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"fdeca0b3-2d92-4cc2-abcc-a6ffa6cf269a\" src='/img/16_15_1779257002717188.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"c8ddd11a-f083-42df-85e3-aea9d2621b94\" src='/img/16_15_1779257003213641.png'>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の計算",
    "important": "A"
  },
  {
    "id": 43000,
    "shikenId": 20,
    "no": 1,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_43000.png'/>",
    "question2": "はじめに、Ｍさんは、Ａさんに対して、公的介護保険（以下、「介護保険」という）について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
    "choice1": "「介護保険の保険給付を受けるためには、市町村（特別区を含む）から要介護認定または要支援認定を受ける必要があります。また、40歳以上60歳未満の医療保険加入者である介護保険の第２号被保険者は、特定疾病が原因で要介護状態または要支援状態となった場合に介護保険の保険給付を受けることができます」",
    "choice2": "「介護保険の第２号被保険者が保険給付を受けた場合の自己負担割合は、原則として実際にかかった費用（食費、居住費等を除く）の１割となりますが、一定金額以上の所得を有する第２号被保険者については、自己負担割合が２割または３割となります」",
    "choice3": "「介護保険の第２号被保険者に係る介護保険料は、国民健康保険の保険料と同時に徴収されます」",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "介護保険",
    "important": "B"
  },
  {
    "id": 43001,
    "shikenId": 20,
    "no": 2,
    "answerType": 6,
    "groupId": 0,
    "answer": "イ,ホ,ト",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_43000.png'/>",
    "question2": "次に、Ｍさんは、Ａさんに対してＡさんが受給することができる公的年金からの老齢給付および付加年金について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の語句群のなかから選び、その記号を選択してください。<br><br>ⅰ）　 老齢基礎年金の受給資格期間<br>「老齢基礎年金を受給するには受給資格期間が（　①　）年以上必要であり、受給資格期間を満たす場合、原則として、65歳から受給することができます」<br>ⅱ）　 付加年金<br>「Ａさんが付加保険料を240月納付する場合、65歳から受給することができる付加年金の額は（　②　）円となります」<br>ⅲ）　 任意加入<br>「Ａさんは学生納付特例期間について追納を行っていないため、60歳以降、任意加入することができます。60歳以降、任意加入する期間について、付加保険料を納付することが（　③　）」<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"324b296c-6bb2-4ed1-83c3-f49e8e9e9862\" src='/img/20_2_1779257144283596.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "公的年金からの老齢給付及び付加年金",
    "important": "A"
  },
  {
    "id": 43002,
    "shikenId": 20,
    "no": 3,
    "answerType": 6,
    "groupId": 0,
    "answer": "ト,イ,ル,チ",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_43000.png'/>",
    "question2": "さらに、Ｍさんは、Ａさんに対して、老後の収入を増やすための各種制度等について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>ⅰ）　 国民年金基金<br>「国民年金基金は、老齢基礎年金に上乗せする年金を支給する任意加入の年金制度です。国民年金基金への加入は口数制となっており、１口目は、保証期間のある終身年金Ａ型と保証期間のない終身年金Ｂ型の２種類のなかから選択します。国民年金基金に拠出する掛金については、月額（　①　）円が上限となります。なお、Ａさんのように国民年金の付加保険料を納付している者が国民年金基金に加入する場合には、付加保険料の納付をやめる手続が必要となります」<br><br>ⅱ）　 確定拠出年金の個人型年金（以下、「個人型年金」という）<br>「国民年金の第１号被保険者であるＡさんは、個人型年金に加入することができます。個人型年金の老齢給付金は、通算加入者等期間が（　②　）年以上ある場合に、60歳から受給することができます。個人型年金に加入するメリットとして、税制の優遇措置が挙げられます。加入者が拠出する掛金は、（　③　）控除の対象となります」<br><br>ⅲ）　 小規模企業共済制度<br>「小規模企業共済制度は、Ａさんのような個人事業主が廃業等した場合に必要となる資金を準備することができる共済制度です。毎月の掛金は、1,000円から（　④　）円の範囲内で、500円単位で選択することができます。共済金（死亡事由以外）の受取方法には『一括受取り』『分割受取り』『一括受取り・分割受取りの併用』があり、税法上、『一括受取り』の共済金（死亡事由以外）は退職所得として課税対象となります」<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"461cfc4a-a421-4d3f-a3e0-49f393e34bed\" src='/img/20_3_1779257144591838.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "ライフ",
    "rontenName": "老後の収入を増やすための制度",
    "important": "B"
  },
  {
    "id": 43003,
    "shikenId": 20,
    "no": 4,
    "answerType": 4,
    "groupId": 0,
    "answer": "460,2000,2600",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_43003.png'/><br><img src='/img/setsu_43003_2.png'/>",
    "question2": "はじめに、Ｍさんは、Ａさんに対して、必要保障額と現在加入している定期保険特約付終身保険の保障金額について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な数値を答えなさい。<br><br>「医療保障を充実させる前に、現時点での必要保障額を算出し、準備すべき死亡保障の額を把握しましょう。下記＜条件＞を参考にすれば、Ａさんが現時点で死亡した場合の必要保障額は（　①　）万円となります。<br>Ａさんが現時点で死亡（不慮の事故や所定の感染症以外）した場合、定期保険特約付終身保険から妻Ｂさんに支払われる死亡保険金額は（　②　）万円となります。他方、Ａさんが不慮の事故で180日以内に死亡した場合の死亡保険金額は（　③　）万円となります」<br><br>＜条件＞<br><div style=\"border:solid 1px #333; padding:0.5em\">１ ． 現在の毎月の日常生活費は30万円であり、Ａさん死亡後の妻Ｂさんの生活費は、現在の日常生活費の50％とする。<br>２ ．現時点の妻Ｂさんの年齢における平均余命は、32年とする。<br>３ ． Ａさんの死亡整理資金（葬儀費用等）・緊急予備資金は、300万円とする。<br>４ ．死亡退職金見込額とその他金融資産の合計額は、1,000万円とする。<br>５ ． Ａさん死亡後に妻Ｂさんが受け取る公的年金等の総額は、4,600万円とする。<br>６ ．現在加入している生命保険の死亡保険金額は考慮しなくてよい。</div>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（個人）",
    "rontenName": "必要保障額と加入保険の保障金額の計算",
    "important": "A"
  },
  {
    "id": 43004,
    "shikenId": 20,
    "no": 5,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,2,2",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_43003.png'/><br><img src='/img/setsu_43003_2.png'/>",
    "question2": "次に、Ｍさんは、Ａさんに対して、公的医療保険制度について説明した。Ｍさんが説明した次の記述①～④について、適切なものには〇印を、不適切なものには×印を選択してください。",
    "choice1": "「Ａさんが病気などで医師の診察を受けた場合、医療費の一部負担金の割合は、原則１割となります。ただし、高額療養費制度により、一医療機関の窓口で支払う同一月内の一部負担金を、所定の自己負担限度額までとすることができます」",
    "choice2": "「高額療養費制度における自己負担限度額は、年齢および所得状況等に応じて決められています。同じ所得金額であっても、70歳未満の者と70歳以上75歳未満の者とで自己負担限度額の計算の区分は異なります」",
    "choice3": "「Aさんが任意継続被保険者となった場合、妻B さんは被扶養者となることができないため、妻B さんは国民健康保険に加入する必要があります」",
    "choice4": "「任意継続被保険者となった場合は、原則として、在職中と同様の給付を受けられますが、高額療養費の支給は受けられません」",
    "choice5": "",
    "categoryName": "リスク（個人）",
    "rontenName": "公的医療保険制度",
    "important": "B"
  },
  {
    "id": 43005,
    "shikenId": 20,
    "no": 6,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,1,2",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_43003.png'/><br><img src='/img/setsu_43003_2.png'/>",
    "question2": "さらに、Ｍさんは、Ａさんに対して、Ａさんが現在加入している生命保険の見直しの方法やＡさんが提案を受けた終身医療保険の特徴等についてアドバイスした。Ｍさんがアドバイスした次の記述①～③について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「現在加入している定期保険特約付終身保険を見直す方法として、契約転換制度の活用があります。契約転換時の告知や医師の診査は不要であるため、健康状態にかかわらず、保障内容を見直すことができます」",
    "choice2": "「要介護状態となった場合、自宅の改修費用など多額の出費が必要となることがあります。公的介護保険の保険給付は主に訪問介護等の介護サービスなので、一定額を介護一時金で準備しておくことは検討に値します」",
    "choice3": "「厚生労働省の患者調査等の各種データでは、入院日数が年々長くなっており、退院後の通院時の療養に係る費用負担も増えていますので、入院中や退院後の通院に対する保障の充実を検討しましょう」",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（個人）",
    "rontenName": "生命保険の見直し等",
    "important": "B"
  },
  {
    "id": 43006,
    "shikenId": 20,
    "no": 7,
    "answerType": 4,
    "groupId": 0,
    "answer": "35,1850,2075",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_43006.png'/>",
    "question2": "仮に、Ａさんが役員在任期間（勤続年数）34年４カ月でＸ社を退任し、Ｘ社が役員退職金として6,000万円を支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額を計算した下記の計算式の空欄①～③に入る最も適切な数値を答えなさい。なお、Ａさんは、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"daaa56ee-f19a-4b41-b10d-9ac2a5d03551\" src='/img/20_7_1779257145066789.png'>",
    "choice1": "年",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（法人）",
    "rontenName": "退職所得の計算",
    "important": "A"
  },
  {
    "id": 43007,
    "shikenId": 20,
    "no": 8,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,1,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_43006.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、＜資料１＞の生命保険の特徴等について説明した。Ｍさんが説明した次の記述①～③について、適切なものには〇印を、不適切なものには×印を解答用紙に記入しなさい。",
    "choice1": "「福利厚生プランは、原則として、従業員全員を被保険者とする等の普遍的加入でなければなりませんので、制度導入後に入社した従業員について加入漏れがないように注意してください」",
    "choice2": "「福利厚生プランの保険料は、720万円のうち360万円は資産計上し、360万円は福利厚生費として損金の額に算入します」",
    "choice3": "「養老保険の死亡保険金が被保険者の遺族に支払われた場合、死亡保険金に係る経理処理は不要であり、Ｘ社は当該契約に係る資産計上額を取り崩し、その金額を雑損失として損金の額に算入します」",
    "choice4": "",
    "choice5": "",
    "categoryName": "リスク（法人）",
    "rontenName": "福利厚生プラン",
    "important": "C"
  },
  {
    "id": 43008,
    "shikenId": 20,
    "no": 9,
    "answerType": 5,
    "groupId": 0,
    "answer": "1,1,2,2",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_43006.png'/>",
    "question2": "Ｍさんは、Ａさんに対して、＜資料２＞の終身保険の特徴等について説明した。Ｍさんが説明した次の記述①～④について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「当該終身保険は、保険料払込期間における解約返戻金額が低解約返戻金型ではない通常の終身保険に比べて低く、その分保険料は通常の終身保険に比べて割安に設定されています」",
    "choice2": "「Ａさんが勇退する際に、契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義変更することで、当該保険契約を役員退職金の一部として支給することができます。個人の保険として継続することにより、納税資金の確保や死亡保険金の非課税金額の規定の適用など、相続対策として活用することができます」",
    "choice3": "「保険期間中にＸ社に緊急の資金需要が発生した場合、契約者貸付制度を利用することができます。当該制度により借り入れることができる金額は、その時点での既払込保険料相当額が限度となります」",
    "choice4": "「Ｘ社が高度障害保険金を受け取った場合、法人税法上、当該保険金については非課税所得となりますので、益金に計上する必要はありません」",
    "choice5": "",
    "categoryName": "リスク（法人）",
    "rontenName": "終身保険の特徴",
    "important": "A"
  },
  {
    "id": 43009,
    "shikenId": 20,
    "no": 10,
    "answerType": 6,
    "groupId": 0,
    "answer": "リ,ハ,ヘ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_43009.png'/><br><img src='/img/setsu_43009_2.png'/>",
    "question2": "所得税における青色申告制度に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の〈語句群〉のなかから選び、その記号を選択してください。<br><br>Ⅰ　 「事業所得に係る取引を正規の簿記の原則に従い記帳し、その記帳に基づいて作成した貸借対照表、損益計算書その他の計算明細書を添付した確定申告書をe-Tax を利用して法定申告期限内に提出することにより、事業所得の金額の計算上、青色申告特別控除として最高（　①　）万円を控除することができます。なお、青色申告者が備え付けるべき決算関係書類などの帳簿書類は、原則として（　②　）年間保存しなければなりません」<br>Ⅱ　 「青色申告者が受けられる税務上の特典として、青色申告特別控除のほかに、青色事業専従者給与の必要経費算入、純損失の３年間の繰越控除、純損失の繰戻還付、棚卸資産の評価について（　③　）を選択できることなどが挙げられます」<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"7be1b388-c4db-42aa-ade8-b70f3570b400\" src='/img/20_10_1779257145424397.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "青色申告制度",
    "important": "B"
  },
  {
    "id": 43010,
    "shikenId": 20,
    "no": 11,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_43009.png'/><br><img src='/img/setsu_43009_2.png'/>",
    "question2": "Ａさんの本年分の所得税の課税に関する次の記述①～③について、適切なものには〇印を、不適切なものには×印を選択してください。",
    "choice1": "「母Ｃさんの合計所得金額は62万円以下となりますので、Ａさんは母Ｃさんに係る扶養控除の適用を受けることができます。母Ｃさんに係る扶養控除の額は48万円となります」",
    "choice2": "「一時払養老保険の満期保険金に係る保険差益は、源泉分離課税の対象となりますので、確定申告をする必要はありません」",
    "choice3": "「Aさんが妻B さんの国民年金保険料を支払った場合、その支払った保険料は、A さんの社会保険料控除の対象となります」",
    "choice4": "",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の課税",
    "important": "A"
  },
  {
    "id": 43011,
    "shikenId": 20,
    "no": 12,
    "answerType": 4,
    "groupId": 0,
    "answer": "400000,200000,380000,142500",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_43009.png'/><br><img src='/img/setsu_43009_2.png'/>",
    "question2": "Ａさんの本年分の所得税の算出税額を計算した下記の表の空欄①～④に入る最も適切な数値を答えなさい。なお、予定納税や源泉徴収税等は考慮しないものとし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"30d9de94-af7c-4b4e-bac5-80ece8b5ff06\" src='/img/20_12_1779257145714231.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"1fa80120-1192-43b4-95d1-a76ee3ff508c\" src='/img/20_12_1779257146197879.png'>",
    "choice1": "円",
    "choice2": "円",
    "choice3": "円",
    "choice4": "円",
    "choice5": "",
    "categoryName": "タックス",
    "rontenName": "所得税の算出税額の計算",
    "important": "A"
  },
  {
    "id": 43012,
    "shikenId": 20,
    "no": 13,
    "answerType": 5,
    "groupId": 0,
    "answer": "2,2,1,1",
    "score": "1,1,1,1",
    "question1": "<img src='/img/setsu_43012.png'/>",
    "question2": "Ａさんの相続に関する次の記述①～④について、適切なものは〇を、不適切なものは×を選択しなさい。",
    "choice1": "「相続税の申告書の提出期限は、原則として、相続の開始があったことを知った日の翌日から４カ月以内です。申告書の提出先は、Ａさんの死亡時の住所地を所轄する税務署長になります」",
    "choice2": "「法務局（遺言書保管所）に保管されている自筆証書遺言は相続開始後、相続人が遅滞なく、家庭裁判所に提出して、その検認の請求をしなければなりません」",
    "choice3": "「相続人間で遺産分割に関する争いが起こり、相続税の申告期限までに遺産分割協議が成立しない場合の期限内の相続税の申告時において、未分割の財産に対しては『配偶者に対する相続税額の軽減』や『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けることができません」",
    "choice4": "「孫Ｆさん、孫Ｇさん、孫Ｈさんが相続または遺贈により財産を取得した場合、孫Ｇさんおよび孫ＨさんはＡさんの二女Ｅさんの代襲相続人ですので、相続税額の２割加算の対象となりませんが、孫Ｆさんは代襲相続人ではありませんので、２割加算の対象となります」",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続に関する記述",
    "important": "A"
  },
  {
    "id": 43013,
    "shikenId": 20,
    "no": 14,
    "answerType": 6,
    "groupId": 0,
    "answer": "チ,ホ,ハ",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_43012.png'/>",
    "question2": "Ａさんの相続に関する以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>ⅰ）　『遺留分』<br>「遺言により取得する財産がないとされた長女Ｄさんが遺留分侵害額請求権を行使する場合、長女Ｄさんの遺留分の額は、遺留分を算定するための財産の価額に（　①　）を乗じた額となります」<br>ⅱ）　『死亡保険金』<br>「妻Ｂさんが受け取る死亡保険金（4,000万円）のうち、相続税の課税価格に算入される金額は（　②　）万円です」<br>ⅲ）　『小規模宅地等についての相続税の課税価格の計算の特例』<br>「妻Ｂさんが自宅の敷地を相続により取得し、特定居住用宅地等として小規模宅地等についての相続税の課税価格の計算の特例の適用を受けた場合、相続税の課税価格に算入すべき価額は（　③　）万円となります」<br><br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"1ac2716d-c8df-4500-809f-b0b05c611994\" src='/img/20_14_1779257146633129.png'>",
    "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
    "choice2": "",
    "choice3": "",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続に関する計算",
    "important": "A"
  },
  {
    "id": 43014,
    "shikenId": 20,
    "no": 15,
    "answerType": 4,
    "groupId": 0,
    "answer": "6000,190,1300",
    "score": "1,1,1",
    "question1": "<img src='/img/setsu_43012.png'/>",
    "question2": "Ａさんの相続における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を答えなさい。なお、相続税の課税価格の合計額は１億5,600万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img data-image-id=\"I1\" data-asset-scope=\"content_extraction\" data-asset-id=\"ab1219fd-34cb-40ba-9e82-e4624a16fc7f\" src='/img/20_15_1779257146929566.png'><br><img data-image-id=\"I2\" data-asset-scope=\"content_extraction\" data-asset-id=\"892d2337-b94e-41ca-8057-09fb8fbd83d2\" src='/img/20_15_1779257147522706.png'>",
    "choice1": "万円",
    "choice2": "万円",
    "choice3": "万円",
    "choice4": "",
    "choice5": "",
    "categoryName": "相続",
    "rontenName": "相続税の計算",
    "important": "A"
  }
];
